/**
 * TR sözlük — YAPI KAYNAĞI.
 * `en.ts` bu nesnenin tipine (`Messages`) uymak zorundadır; bir anahtar eksik veya
 * fazla olursa TypeScript derlemesi kırılır (Story 0.3: "eksik anahtar varsa CI build'i kırılır").
 *
 * Marka adı ve domain metne GÖMÜLMEZ; `{brandName}` / `{appDomain}` yer tutucularıyla
 * gelir ve tasarım tokenlarından beslenir.
 */
export const tr = {
    common: {
        appTagline: 'Etkinlikten iş bağlantısıyla dön.',
        loading: 'Yükleniyor…',
        save: 'Kaydet',
        cancel: 'Vazgeç',
        close: 'Kapat',
        back: 'Geri',
        next: 'İleri',
        retry: 'Tekrar dene',
        search: 'Ara',
        delete: 'Sil',
        edit: 'Düzenle',
        confirm: 'Onayla',
        yes: 'Evet',
        no: 'Hayır',
        // Bulgu 5: URL alanı protokolsüz adresi kabul eder; kural yazıyla söylenir.
        urlHint: 'Örn. ornek.com',
        optional: 'İsteğe bağlı',
        required: 'Zorunlu',
        seeAll: 'Tümünü gör',
        /*
         * Uzun çip grubunun katlanması (mobil elle test · madde 7). Referans
         * (`Mobil Akış A` FİLTRE) altı çiplik AKIŞKAN bir grup çiziyor; taksonomi
         * 24'e çıkınca grup 12 satıra uzuyor ve şehir/biçim alanları ekranın
         * dışında kalıyordu. Sarma akışkan KALIR, uzunluk sınırlanır.
         */
        chipMore: '+{count} seçenek daha',
        chipMore_one: '+{count} seçenek daha',
        chipLess: 'Daha az göster',
        all: 'Tümü',
        empty: 'Burada henüz bir şey yok',
        // Hesabı silinmiş kişi için nötr etiket: API ad alanını `null` döndürür
        // (purge yer tutucusu ekrana sızmaz), istemci bu metni + monogram gösterir.
        deletedUser: 'Silinmiş kullanıcı',
        offlineNotice: 'Çevrimdışısın. Bağlantı gelince kaldığın yerden devam edersin.',
        // OfflineBanner kartı: bağlantı dönünce bant kalkar, bu bildirim bir kez çıkar.
        backOnline: 'Bağlantı geri geldi.',
        errorOffline: 'İnternet bağlantısı yok, içerik yüklenemedi. Bağlanınca tekrar dene.',
        somethingWentWrong: 'Bir şeyler ters gitti',
        // Hata kodu KULLANICI CÜMLESİ DEĞİLDİR; destek referansı olduğu yazılır.
        errorSupportCode: 'Destek kodu: {code}',
        sending: 'Gönderiliyor…',
        saving: 'Kaydediliyor…',
    },
    a11y: {
        skipToContent: 'İçeriğe atla',
        mainNavigation: 'Ana gezinme',
        closeDialog: 'Pencereyi kapat',
        loadingContent: 'İçerik yükleniyor',
        languageSelector: 'Dil seçimi',
    },
    /**
     * SİTE ALT BİLGİSİ (E2) — referans `LAND` satır 201-204 ve `PUB` 299-307.
     * Marka + gezinme bağlantıları + telif. Yasal belge rotaları HENÜZ YOK;
     * olmayan sayfaya bağlantı verilmez (uydurma hedef yasak).
     */
    /**
     * MARKA İMZASI (marka sözleşmesi §7 satır 8 ve 10).
     *
     * Kartvizit QR'ı ve public kart bağlantısı ürünün DIŞINA çıkar: karşı taraf
     * uygulamayı bilmiyor olabilir. İmza bloğu "bunu ne paylaştı" sorusunun tek
     * cümlelik cevabıdır. Marka adı ve alan adı GÖMÜLMEZ — yer tutucudan gelir.
     */
    brand: {
        sharedWith: '{brandName} ile paylaşıldı',
        sharedWithDomain: '{brandName} ile paylaşıldı · {publicDomain}',
    },
    /*
     * TARİH/SAAT SEÇİCİ (elle test 2 md. 12/17 · elle test 3).
     * Ay ve gün adları SÖZLÜKTEN gelir; `Intl` yerel verisine bırakılmaz —
     * Node/tarayıcı ICU paketi ortama göre değişir ve TR adları garanti değildir.
     * Gün adları 0 = Pazar sırasındadır; hafta başlangıcını `WEEK_STARTS_ON` verir.
     */
    datePicker: {
        openCalendar: 'Takvimi aç',
        calendarLabel: 'Tarih seç',
        previousMonth: 'Önceki ay',
        nextMonth: 'Sonraki ay',
        today: 'Bugün',
        clear: 'Temizle',
        timeLabel: 'Saat',
        timeListLabel: 'Saat seçenekleri',
        selected: 'Seçili',
        unparsable: 'Tarihi anlayamadım. Örnek: {example}',
        pastDisabled: 'Geçmiş tarih seçilemez.',
        timezoneNote: 'Saatler {timezone} diliminde',
        maskDay: 'GG',
        maskMonth: 'AA',
        maskYear: 'YYYY',
        maskHour: 'SS',
        maskMinute: 'dd',
        month1: 'Ocak',
        month2: 'Şubat',
        month3: 'Mart',
        month4: 'Nisan',
        month5: 'Mayıs',
        month6: 'Haziran',
        month7: 'Temmuz',
        month8: 'Ağustos',
        month9: 'Eylül',
        month10: 'Ekim',
        month11: 'Kasım',
        month12: 'Aralık',
        weekdayShort0: 'Paz',
        weekdayShort1: 'Pzt',
        weekdayShort2: 'Sal',
        weekdayShort3: 'Çar',
        weekdayShort4: 'Per',
        weekdayShort5: 'Cum',
        weekdayShort6: 'Cmt',
        weekdayLong0: 'Pazar',
        weekdayLong1: 'Pazartesi',
        weekdayLong2: 'Salı',
        weekdayLong3: 'Çarşamba',
        weekdayLong4: 'Perşembe',
        weekdayLong5: 'Cuma',
        weekdayLong6: 'Cumartesi',
    },
    footer: {
        label: 'Alt bilgi',
        navLabel: 'Alt bilgi bağlantıları',
        events: 'Etkinlikler',
        organizers: 'Organizatörler için',
        // Sık sorulan sorular (SiteFooter kartı, 04.11.2026): "İletişim"in solunda.
        faq: 'Sık sorulan sorular',
        contact: 'İletişim',
        copyright: '© {year} {brandName}',
        /*
         * Marka geçişi (2026-08-28): eski `brandNotice` "ürün adı geçicidir"
         * diyordu; ad KESİNLEŞTİ. Yerine sözleşme §7'nin alt bilgi satırı geldi —
         * telif şeridinin sağında VİTRİN alan adı durur (uygulama adresi değil).
         */
        domainNotice: '{publicDomain}',
    },
    /**
     * SIK SORULAN SORULAR (kullanıcı kararı 04.11.2026, kartlar SiteSSS ve MobilSSS).
     * Soru ve cevap metinleri kullanıcı onaylıdır, birebir kalır (`faq-text.spec.ts`
     * istek dosyasındaki metinle karşılaştırır). Katılımcılara "sen", organizatörlere
     * "siz". Bağlantılı cümlede `{link}` bağlantının yeridir, metni `…Link` anahtarıdır.
     */
    faq: {
        metaTitle: 'Sık sorulan sorular',
        metaDescription: 'Katılımcılar ve organizatörler için sık sorulan sorular ve cevapları.',
        title: 'Sık sorulan sorular',
        tabsLabel: 'Soru grupları',
        /* Mobil giriş grubu (kartlar MobilAyarlar ve MobilKurumHesap, 04.11.2026). */
        helpGroup: 'Yardım',
        tabs: {
            katilimcilar: 'Katılımcılar',
            organizatorler: 'Organizatörler',
        },
        participants: {
            whatIs: {
                question: '{brandName} nedir?',
                answer: '{brandName}, etkinliklere katılan profesyoneller için bir uygulama. Katıldığın etkinliğin programını, kimlerin geleceğini, görüşmelerini ve topladığın kartvizitleri tek bir yerden takip edersin.',
            },
            oneApp: {
                question: 'Her etkinlik için ayrı uygulama indirmem gerekiyor mu?',
                answer: "Hayır, {brandName}'i bir kez indirmen yeterli. Hangi etkinliğe kaydolursan kaydol, hepsini aynı uygulamadan takip edersin.",
            },
            attendeeList: {
                question: 'Katılımcı listesini kimler görebiliyor?',
                answer: 'Listeyi yalnızca o etkinliğe kaydolan kişiler görebilir. Sen de kaydolduğunda listede görünürsün. Listede telefon ya da e-posta gibi iletişim bilgileri bulunmaz. Listeden çıkmak istersen kaydını iptal etmen yeterli.',
            },
            cardExchange: {
                question: 'Kartvizit paylaşımı nasıl oluyor?',
                answer: 'Karşındaki kişi senin karekodunu okutur, ikiniz de onay verince kartvizitleriniz paylaşılır. Sen onay vermedikçe bilgilerin kimseye gitmez.',
            },
            meetingRequest: {
                question: 'Görüşme talebi ne işe yarıyor?',
                answer: 'Etkinlik başlamadan önce tanışmak istediğin bir katılımcıya görüşme isteği gönderip uygun saatleri önerebilirsin. Karşı taraf kabul ederse görüşme ajandana eklenir.',
            },
            recommendations: {
                question: 'Etkinlik önerileri neye göre yapılıyor?',
                answer: 'İlgi alanlarına ve daha önce katıldığın etkinliklere bakarak sana uygun etkinlikleri öneriyoruz. Her önerinin yanında neden önerildiğini de görebilirsin.',
            },
            entry: {
                question: 'Etkinliğe girerken ne göstermem gerekiyor?',
                answer: 'Kaydolduğun etkinliğin giriş karekodu uygulamanda hazır olur. Girişte görevliye bu karekodu göstermen yeterli.',
            },
            price: {
                question: 'Uygulamayı kullanmak ücretli mi?',
                answer: 'Hayır, katılımcılar için ücretsiz. İstediğin kadar kartvizit saklayabilirsin.',
            },
            export: {
                question: 'Kartvizitlerimi telefonuma ya da bilgisayarıma aktarabilir miyim?',
                answer: 'Evet. Cüzdanındaki kişileri vCard ya da CSV dosyası olarak indirip rehberine ya da bir tabloya aktarabilirsin.',
            },
            deleteAccount: {
                question: 'Hesabımı nasıl silebilirim?',
                answer: "Ayarlar'daki Veri bölümünden hesabını silebilirsin. Silme süreciyle ilgili ayrıntıları {link} bulabilirsin.",
                answerLink: 'hesap silme sayfasında',
            },
        },
        organizers: {
            openEvent: {
                question: "Etkinliğimizi {brandName}'te nasıl açabiliriz?",
                answer: 'Kurum hesabınızı kısa bir tanışma görüşmesinin ardından biz açıyoruz. "{link}" formunu doldurmanız yeterli, ekibimiz en kısa sürede size dönüş yapar.',
                answerLink: 'Bize ulaşın',
            },
            eventTypes: {
                question: '{brandName} hangi etkinlikler için uygun?',
                answer: 'Katılımcıların birbiriyle tanışmak istediği her etkinlik için uygun: kongre, zirve, sempozyum, kariyer günü, demo günü ya da sektör buluşması.',
            },
            audience: {
                question: 'Etkinliğimizi kimler görecek?',
                answer: 'Etkinliğiniz, ilgi alanları ve katılım geçmişi etkinliğinizle örtüşen kullanıcılara öneri olarak gösterilir.',
            },
            access: {
                question: 'Etkinliğimize kimlerin katılacağını belirleyebilir miyiz?',
                answer: 'Evet. Kaydı herkese açabilir, başvuruları tek tek onaylayabilir ya da yalnızca davet ettiğiniz kişilerin katılmasını sağlayabilirsiniz.',
            },
            announcements: {
                question: 'Katılımcılarımıza nasıl duyuru yapabiliriz?',
                answer: 'Yönetim panelinden kayıtlı katılımcılarınıza anlık bildirim gönderebilirsiniz.',
            },
            checkIn: {
                question: 'Girişleri nasıl kontrol edebiliriz?',
                answer: 'Görevliniz katılımcının giriş karekodunu telefonuyla okutur. Kimlerin geldiğini panelden anlık olarak takip edebilirsiniz.',
            },
            reports: {
                question: 'Etkinlik bittikten sonra hangi raporları alabiliriz?',
                answer: 'Kayıt, katılım ve katılımcı profiline dair raporları panelden görüntüleyip indirebilirsiniz. Katılımcılarınıza katılım belgesi ve anket de gönderebilirsiniz.',
            },
            pricing: {
                question: 'Ücretlendirme nasıl?',
                answer: 'İlk etkinliğiniz ücretsiz. Size uygun paketi tanışma görüşmesinde birlikte belirliyoruz.',
            },
            privacy: {
                question: 'Katılımcılarımızın verileri güvende mi?',
                answer: "Kişisel veriler KVKK'ya uygun şekilde işlenir ve hiçbir sponsora ya da üçüncü tarafa satılmaz.",
            },
        },
        /* Kapanış satırı sekmeye göre (kullanıcı kararı 04.11.2026), bağlantı son iki sözcükte. */
        closing: {
            participants: 'Sorunun cevabını bulamadın mı? {link}.',
            participantsLink: 'Bize ulaş',
            organizers: 'Sorunuzun cevabını bulamadınız mı? {link}.',
            organizersLink: 'Bize ulaşın',
        },
    },
    /**
     * İLETİŞİM (SiteIletisim kartı, kullanıcı onaylı metinler 04.11.2026). Metinler
     * birebir kalır (`contact-text.spec.ts`). Katılımcılar bloğu "sen", gerisi "siz".
     * Şirket bilgisi ve adresler sözlüğe yazılmaz: `DATA_CONTROLLER` ve marka katmanı.
     */
    contact: {
        metaTitle: 'İletişim',
        title: 'İletişim',
        intro: 'Sorunuza göre size en hızlı ulaşacak kanalı aşağıda bulabilirsiniz.',
        participants: {
            title: 'Katılımcılar',
            body: 'Uygulamayla ilgili sorularını ve yaşadığın sorunları destek ekibimize yazabilirsin.',
        },
        organizations: {
            title: 'Kurumlar',
            body: "Etkinliğinizi {brandName}'te düzenlemek isterseniz formu doldurun, ekibimiz size dönüş yapsın.",
            cta: 'Bize ulaşın',
        },
        personalData: {
            title: 'Kişisel veri talepleri',
            body: 'Kişisel verilerinizle ilgili taleplerinizi KVKK başvuru formuyla iletebilirsiniz.',
            link: 'KVKK başvuru formu',
        },
        faq: {
            title: 'Sık sorulan sorular',
            body: 'Birçok sorunun cevabını sık sorulan sorular sayfasında bulabilirsiniz.',
            link: 'Sık sorulan sorular',
        },
        company: {
            title: 'Şirket bilgileri',
            legalName: 'Unvan',
            address: 'Adres',
            tax: 'Vergi dairesi ve numarası',
            taxValue: '{taxOffice} V.D. {taxNumber}',
            email: 'E-posta',
        },
        social: {
            title: 'Bizi takip edin',
            instagram: 'Instagram ({handle})',
            linkedin: 'LinkedIn ({name})',
        },
    },
    /**
     * MAĞAZA ROZETLERİ (kullanıcı kararı 25.10.2026): ana sayfa üst bölümü, alt
     * bilgi ve etkinlik sayfası. Bağlantının erişilebilir adı `*Label`, görselin
     * alternatif metni rozetin kendi yazısıdır (`*Alt`).
     */
    appStores: {
        kicker: 'Uygulamayı indir',
        appStoreLabel: 'App Store’dan indir',
        googlePlayLabel: 'Google Play’den al',
        appStoreAlt: 'App Store’dan İndirin',
        googlePlayAlt: 'Google Play’den Alın',
    },
    /**
     * Bulunamadı durumu (QA Blok 16 P3): SSR rotasında Next'in çıplak İngilizce
     * 404'ü yerine markalı + i18n'li boş durum çizilir.
     */
    notFound: {
        /* Site404 organizatör yolu, organizatöre "siz" (Y13; kitin `stepMine`ı sen dilinde kalır). */
        siteMineTitle: 'Yönettiklerinize dönün',
        siteMineBody: 'Organizatörseniz etkinlik listenize dönün.',
        siteDiscoverLink: 'Etkinlik keşfine git',
        siteMineLink: 'Yönettiğiniz etkinlikler',
        kicker: 'Bulunamadı',
        title: 'Bu sayfa artık burada değil',
        body: 'Bağlantı eskimiş, etkinlik kaldırılmış ya da adres yanlış yazılmış olabilir.',
        stepDiscover: 'Etkinlikleri keşfet',
        stepDiscoverBody: 'Yaklaşan etkinliklere göz at.',
        stepMine: 'Yönettiklerine dön',
        stepMineBody: 'Kendi etkinliklerin burada duruyor.',
        action: 'Ana sayfaya dön',
        previewLabel: 'Örnek etkinlik kartı',
    },
    /*
     * GEÇİCİ HATA ekranı (QA 17B+17E P2). "Yetkin yok" ile "şu an karar
     * veremedim" AYNI ŞEY DEĞİLDİR: hız sınırı ya da 5xx alan organizatöre
     * "Sayfa bulunamadı" gösterilmez.
     */
    temporaryError: {
        kicker: 'Geçici sorun',
        title: 'Bu sayfa şu anda açılamadı',
        body: 'Yetkinde bir değişiklik yok. Sunucuya kısa sürede çok fazla istek gitti ya da geçici bir hata oluştu. Birkaç saniye sonra tekrar dene.',
        // Herkese açık okuma düştüğünde: ziyaretçinin oturumu olmayabilir, yetkiden söz edilmez.
        publicBody: 'Sayfa şu an yüklenemedi. Sunucu geçici olarak yanıt vermiyor. Birkaç saniye sonra tekrar dene.',
        stepRetry: 'Tekrar dene',
        stepRetryBody: 'Sayfayı yeniden yükle. Çoğu durumda ikinci deneme açılır.',
        stepMine: 'Yönettiklerine dön',
        stepMineBody: 'Etkinliklerin listesi buradan açılır.',
        action: 'Tekrar dene',
        previewLabel: 'Panel satırı önizlemesi',
    },
    theme: {
        light: 'Açık',
        dark: 'Karanlık',
        system: 'Sistem',
        current: 'Tema: {name}',
    },
    language: {
        tr: 'Türkçe',
        en: 'İngilizce',
        current: 'Dil: {name}',
    },
    nav: {
        home: 'Ana sayfa',
        events: 'Etkinlikler',
        // Manuel test bulgusu 3+6: "Etkinliklerim" kullanıcıya "kayıtlı olduklarım"
        // gibi okunuyordu. Yönetim listesi artık adıyla söylenir; kayıtlı olunan
        // etkinlikler ana sayfadaki "Katıldığın etkinlikler" bölümündedir.
        myEvents: 'Yönettiklerim',
        wallet: 'Cüzdan',
        profile: 'Profil',
        // B-35 (09.10): kurum ayarlarından ayrılsın diye adıyla söylenir.
        accountSettings: 'Hesap ayarları',
        signIn: 'Giriş yap',
        signOut: 'Çıkış yap',
        signOutRetry: 'Çıkışı tekrar dene',
        /*
         * HESAP MENÜSÜ DÜĞMESİNİN ERİŞİLEBİLİR ADI (sıra 39b): katlanmış kırılımda
         * sekmeler de bu menüdedir. Ad yalnız kişiyi söylerse menü işlevi duyulmaz.
         */
        accountMenu: 'Menü, {name}',
        // MobilWebKabuk: dar ekranda hesap menüsünü açan ikincil düğmenin görünür metni.
        menu: 'Menü',
        signOutFailed: 'Çıkış tamamlanamadı, hesabın hâlâ açık. Bağlantını kontrol edip tekrar dene.',
        createEvent: 'Etkinlik aç',
        createOrganization: 'Kurum oluştur',
        /*
         * BAĞLAM DEĞİŞTİRİCİ (madde 24 · 30.08). Menüdeki "Kurumum" öğesi kalktı;
         * kullanıcı hangi şapkayla çalıştığını üst sağdan seçiyor. Kimlik hep aynı
         * kişi, değişen yalnız bağlam.
         */
        context: 'Kimin adına',
        contextCurrent: '{name} adına',
        contextPersonal: 'Kişisel',
        contextPersonalHint: 'Kendi adına katıl ve tanış',
        contextOrganizations: 'Kurumların',
        contextVerified: 'Doğrulanmış',
        contextLoadError: 'Kurumların yüklenemedi',
        /*
         * KARTVİZİT SEKMESİ (kullanıcı kararı 31.08 · `docs/mobil-kararlar`
         * §2). Alt navigasyonun ortasındaki sekme artık iki yarımı birden
         * taşıyor: tanış (karekod) + sakla (cüzdan). `qr` anahtarı SEGMENTİN
         * adı olarak kalıyor; sekmenin adı `card`.
         */
        card: 'Kartvizit',
        qr: 'Karekod',
        cardWallet: 'Cüzdanım',
        cardSegmentLabel: 'Kartvizit görünümü',
        /*
         * ETKİNLİKLER SEKMESİNİN İKİ YARIMI (kullanıcı kararı 31.08 · §1).
         * İkinci yarımın adı `myEvents` anahtarından gelir ("Yönettiklerim");
         * bulgu 3+6'da kararlaştırılan ad odur ve burada TEKRAR EDİLMEZ.
         */
        eventsDiscover: 'Keşfet',
        eventsSegmentLabel: 'Etkinlik görünümü',
        requests: 'Talepler',
        participationHistory: 'Katılım geçmişim',
        // Rozet SAYIYI değil ANLAMI okur (ekran okuyucu); tavan dolduğunda "+" ile
        // gösterilir — sunucuda ayrı bir sayaç ucu yok, ilk sayfadan sayılır.
        pendingRequests: '{count} bekleyen talep',
        pendingRequests_one: '{count} bekleyen talep',
        pendingRequestsAtLeast: 'En az {count} bekleyen talep',
        pendingRequestsAtLeast_one: 'En az {count} bekleyen talep',
        agenda: 'Ajanda',
        myAgenda: 'Ajandam',
        notifications: 'Bildirimler',
    },
    /**
     * Oturum açmış kullanıcının ANA SAYFASI (tasarım ekran 3'ün web karşılığı).
     * `home.*` pazarlama sayfasının kopyasıdır; ikisi farklı ziyaretçiye gider.
     */
    dashboard: {
        kicker: 'Ana sayfa',
        greeting: 'Merhaba, {name}',
        // Sayfa başlığının alt satırı (KatilimciWebAnaSayfa): yalnız sıradaki etkinlik varken.
        greetingNext: 'Sıradaki etkinliğin {date}.',
        // Geri sayım — ekran 3'ün kicker'ı ("5 gün kaldı · Kaydın onaylı").
        countdownDays: '{days} gün kaldı',
        countdownToday: 'Bugün',
        // Başlangıç günü geçmiş, henüz bitmemiş çok günlü etkinlik.
        countdownOngoing: 'Devam ediyor',
        countdownTomorrow: 'Yarın',
        whoIsComing: 'Kimler geliyor',
        openEvent: 'Etkinlik',
        attendingTitle: 'Katıldığın etkinlikler',
        attendingCount: '{count} etkinlik',
        attendingCount_one: '{count} etkinlik',
        // Sayacın KENDİSİ katılım geçmişine gider (Story 20.1: bağlantısız sayaç kalmaz).
        attendingCountLink: 'Katılım geçmişini aç · {count} etkinlik',
        attendingCountLink_one: 'Katılım geçmişini aç · {count} etkinlik',
        attendingAll: 'Tümü',
        attendingUpcoming: 'Yaklaşan',
        attendingPast: 'Geçmiş',
        attendingUpcomingEmpty: 'Yaklaşan başka etkinliğin yok.',
        attendingPastEmpty: 'Henüz katıldığın bir etkinlik yok.',
        // B-30: bekleyen davetler katılım sayılmaz, aynı kartta ayrı alt grupta durur.
        pendingInvitationsTitle: 'Yanıt bekleyen davetler',
        respondInvitationCta: 'Daveti yanıtla',
        managedTitle: 'Yönettiğin etkinlikler',
        emptyPrimaryCta: 'Etkinlik keşfet',
        emptySecondaryCta: 'Profilini tamamla',
        emptyRailTitle: 'Talepler ve ajanda',
        emptyRailBody: 'Bir etkinliğe kaydolduğunda katılımcı listesi açılır. Görüşme talepleri ve ajandan bu panelde toplanır.',
        loadError: 'Katılımların yüklenemedi.',
        /*
         * --- ÜST ALAN · YÖN B (referans `docs/design/reference/anasayfa-uc-yon.dc.html`)
         * Tasarım metni SİZLİ yazılmıştı ("Katılımcı listesini açın", "size uygun");
         * sözlüğün baskın hitabı SEN olduğu için (ölçüm dev raporunda) hepsi senli
         * çevrildi. Ton değişimi ayrı ürün kararıdır; burada verilmedi.
         */
        topActionKicker: 'Şimdi yapılacak',
        // Etkinlik bandının ekran okuyucu ipucu (bant basılabilir; sağ ucunda dekoratif ok).
        topOpenEventHint: 'Etkinlik sayfasını açar',
        // Büyük sayı GÖRÜNÜR kişi sayısıdır (toplam kayıt uçta yok; uydurulmaz).
        topVisibleLabel: 'kişi katılımcı listesinde',
        topMatchCount: 'Sana uygun {count} kişi',
        topMatchCount_one: 'Sana uygun {count} kişi',
        // Liste sınırına ulaştıysa gerçek sayı daha büyük olabilir (sıra 130).
        topMatchCountAtLeast: 'Sana uygun en az {count} kişi',
        topMatchCountAtLeast_one: 'Sana uygun en az {count} kişi',
        // Yığın cümlesi ilk adları okur: "Ceren, Deniz ve 2 kişi daha".
        topCrowdOne: '{first}',
        topCrowdTwo: '{first} ve {second}',
        topCrowdMore: '{first}, {second} ve {count} kişi daha',
        topCrowdMore_one: '{first}, {second} ve {count} kişi daha',
        topOpenAttendees: 'Katılımcı listesini aç',
        topQrTitle: 'Karekodum',
        topQrBody: 'Salonda tanıştığın kişi kartını okutsun. Kart yalnızca iki taraf da onaylayınca değişir.',
        topQrCta: 'Karekodu aç',
        topRequestsKickerNone: 'Bekleyen yok',
        topRequestsTitle: 'Talepler',
        topRequestsBody: '{count} görüşme talebi yanıtını bekliyor. Kabul ettiğin saat ajandana eklenir.',
        topRequestsBody_one: '{count} görüşme talebi yanıtını bekliyor. Kabul ettiğin saat ajandana eklenir.',
        topRequestsBodyNone: 'Yanıt bekleyen talep yok. Katılımcı listesinden görüşme isteyebilirsin.',
        // Kalabalık satırı: kişi ucu düştüğünde iddia yok, dürüst cümle + yeniden dene (QA P2-1).
        topPeopleError: 'Kişi bilgisi alınamadı.',
        topRequestsCta: 'Talepleri gör',
        // B-31: bekleyen gelen talep varken kart referanstaki "Bekleyen talepler" bölümüne döner.
        topPendingTitle: 'Bekleyen talepler',
        topPendingIncoming: 'Yanıtını bekliyor',
        topPendingOutgoing: 'Gönderdiğin, yanıt bekliyor',
        topPendingReply: 'Yanıtla',
        // Mobil karoları (referans mobil artboard: "Kartınızı gösterin" · "2 talep bekliyor").
        topQrTileBody: 'Kartını göster',
        topRequestsTileBody: '{count} talep bekliyor',
        topRequestsTileBody_one: '{count} talep bekliyor',
        // Rol çipi (referans "KONUŞMACI") ROL yazar, katılım DURUMU değil: "Onaylı"
        // aynı ekranda satır rozetinde zaten var (tech-lead D4).
        topRoleAttendee: 'Katılımcı',
        topRoleSponsor: 'Sponsor',
        // Yaklaşan etkinliği olmayan (ama geçmişi ya da yönettiği etkinliği olan) kullanıcı.
        topNoEventBody: 'Yaklaşan etkinliğin yok. Kaydolduğunda kimlerin geldiğini burada görürsün.',
        // Boş durum — HİÇBİR ŞEYİ olmayan yeni kullanıcı (referans bölüm 04, sol kart).
        topEmptyKicker: 'Henüz etkinlik yok',
        topEmptyTitle: 'Bir etkinliğe kaydol, gerisi burada başlar',
        topEmptyBody: 'Önerileri katıldığın etkinliklere göre hazırlıyoruz. O zamana kadar tahmin yürütmek yerine bu ay en çok kayıt alan etkinlikleri gösteriyoruz.',
        // Kesik çizgi altındaki %45 opak önizleme — ürünün KENDİ kartı, illüstrasyon değil.
        topEmptyPreviewLabel: 'Kaydolduğunda burası böyle görünür',
        topEmptyPreviewTitle: 'İstanbul Ürün Konferansı 2026',
        topEmptyPreviewMeta: '27 kişi katılımcı listesinde · sana uygun 4 kişi',
        // Hata — üst alan yüklenemedi; ajanda ve karekod çalışmaya devam eder.
        topErrorKicker: 'Bir bölüm yüklenemedi',
        topErrorAlert: 'Etkinlik bilgisi yüklenemedi. İnternetin açıksa tekrar dene.',
        topErrorTitle: 'Ajandan ve karekodun çalışıyor',
        topErrorBody: 'Yaklaşan etkinlik kartı yüklenemedi ama ajandan ve karekodun çalışıyor. Salondaysan bir şey kaçırmazsın.',
        // Öneri bölümü meta satırı ("3 öneri · gerekçeleriyle").
        topRecsMeta: '{count} öneri · gerekçeleriyle',
        topRecsMeta_one: '{count} öneri · gerekçeleriyle',
        peopleMeta: 'Bu etkinlikten {count} kişi · gerekçeleriyle',
        peopleMeta_one: 'Bu etkinlikten {count} kişi · gerekçeleriyle',
        peopleAll: 'Kimler geliyor',
        peopleRequestCta: 'Görüşme iste',
        peopleSentBadge: 'Talep gönderildi',
        peopleMoreLabel: '{name} için diğer işlemler',
        agendaTitle: 'Bugünkü ajandan',
        /*
         * BAŞLIK KAPSAMINI SÖYLER (elle test 3 · defter §16). Eski hâli "En yakın
         * günün" idi ve sayfanın üstündeki en yakın etkinlikle çelişiyor GÖRÜNÜYORDU:
         * kullanıcı 31 Ağustos etkinliğine kayıtlıydı, ama o etkinliğin programı
         * yoktu; kart bu yüzden 12 Eylül'ü yazıyordu. Ajanda bir ETKİNLİK listesi
         * değil, oturum ve görüşme çizelgesidir — başlık artık bunu söylüyor.
         */
        agendaNextTitle: 'Planlı ilk günün · {day}',
        agendaScopeNote: 'Bu kart oturumları ve kabul ettiğin görüşmeleri listeler. Etkinliğin programı yayımlandığında burada görünür.',
        agendaAll: 'Ajandanın tamamı',
        agendaEmpty: 'Bugün planın yok.',
        agendaLoadError: 'Ajanda yüklenemedi.',
        managedPanelCta: 'Panel',
        // Bölüm 7 uyarı şeridi (referans `homeFull` managed[].warn).
        managedWarnUnverified: 'Kurumunuz doğrulanmadı. Etkinliğiniz keşifte ve önerilerde görünmüyor.',
        managedWarnNoMeetingArea: 'Görüşme alanı tanımlamadınız. Katılımcılar bu etkinlikte görüşme ayarlayamıyor.',
        managedWarnLoadError: 'Etkinlik uyarıları okunamadı.',
        profileTitle: 'Profil tamamlanma',
        profileStepCount: '{done} / {total} adım',
        profileNote: 'İlgi etiketlerin sana hangi etkinliklerin gösterileceğini belirler. Profilin yalnız kaydolduğun etkinliklerin katılımcılarına görünür.',
        profileStepIdentity: 'Ad, unvan, şirket',
        profileStepPhoto: 'Profil fotoğrafı',
        profileStepInterests: 'İlgi etiketleri',
        profileStepLinks: 'Bağlantılar',
        profileStepAttendance: 'İlk etkinlik kaydı',
        popularTitle: 'Bu ay öne çıkanlar',
        popularLead: 'Şehrinde en çok ilgi gören etkinlikler. Bu liste kayıt sayısına göre sıralanır. Senin geçmişine bakılarak hazırlanmaz.',
    },
    home: {
        heroSubtitle: '{brandName} ile etkinlikten önce kimlerin geleceğini gör, görüşme ayarla, buzu etkinlik başlamadan kır.',
        heroSecondaryCta: 'Etkinlik düzenliyorum',
        // --- Blok 8-3: landing panel / güven / fiyat / kapanış bölümleri ---
        closingCta: 'Ücretsiz hesap aç',
        /*
         * LANDING — DENETİM KALEMLERİ E3-E6 + KISMİ #2/#3.
         * Referans: `LAND` satır 48-56 (sayı şeridi) · 58-73 (dört zaman, DÖNGÜ
         * kartı dahil) · 75-93 (etkinlik öncesi) · 94-106 (etkinlik anı) ·
         * 108-130 (etkinlik sonrası) · 32-46 (hero görseli).
         *
         * SAYI ŞERİDİ: referansın örnek rakamları (24.812 profesyonel · %74 onay)
         * KULLANILMAZ — ürünün kendi doğrulanabilir durumu yazılır. İki kutu canlı
         * veriden (yayındaki etkinlik ve konu sayısı), iki kutu ürün kuralından
         * gelir. Uydurma sayı basılmaz.
         */
        statsTitle: 'Platformun bugünkü hâli',
        statsNote: 'Bu sayılar yayındaki etkinliklerden anlık okunur.',
        statEventsLabel: 'Yayında etkinlik',
        statTopicsLabel: 'Konu başlığı',
        navHowItWorks: 'Nasıl çalışır',
        navForOrganizers: 'Organizatörler',
        /*
         * YENİ GÖRÜNÜM ANA SAYFASI (SiteAnaSayfa kartı, Aşama 2a). Metinler onaylı
         * sayfadan aynen alındı; organizatöre "siz". Fiyat yok (09.10.2026).
         */
        siteNavContact: 'Bize ulaşın',
        heroTitleSite: 'Etkinliğinizi kayıttan rapora tek yerden yönetin.',
        heroLeadSite: 'Başvuruları tek panelden değerlendirir, katılımcılarınızı kapıda karekodla karşılarsınız. Etkinlik sona erdiği anda raporunuz hazır olur. Katılımcılarınız ise kimlerin geleceğini önceden görür ve görüşmelerini etkinlikten önce planlar.',
        heroEventsCta: 'Etkinlikleri görün',
        freeFirstEvent: 'İlk etkinliğiniz ücretsiz.',
        storyTitle: 'Bugün bir etkinlik böyle geçiyor.',
        storyRegistrationLead: 'Kayıt.',
        storyRegistrationBody: 'Başvurular bir formda birikir, onaylar e-posta yazışmalarında kaybolur.',
        storyGateLead: 'Kapı.',
        storyGateBody: 'Etkinlik sabahı kapıda kuyruk oluşur, görevli isimleri kâğıt listede tek tek arar.',
        storyAfterLead: 'Sonrası.',
        storyAfterBody: 'Etkinlik biter, kaç kişinin geldiğini anlatan düzgün bir rapor elinizde olmaz.',
        stepsTitle: 'Aynı etkinlik, {brandName} ile çok daha kolay.',
        step1Title: 'Başvuruları tek listede görür, onaylar ya da reddedersiniz.',
        step1Body: 'Onayladığınız kişiye bileti hemen ulaşır ve katılımcı listesinde yerini alır. Dilerseniz birden çok başvuruyu tek seferde değerlendirebilirsiniz.',
        step2Title: 'Katılımcı kapıda karekodunu gösterir, görevliniz girişi kendi telefonundan onaylar.',
        step2Body: 'Karekod okunmadığında katılımcıyı adıyla bulup içeri alabilirsiniz. Kayıtlı kişi sayısını ve içeri girenleri kapıda anlık olarak takip edersiniz. Kamera görüntüsü hiçbir şekilde kaydedilmez.',
        step3Title: 'Etkinlik biter, raporunuz hazırdır.',
        step3Body: 'Kaç kişinin katıldığını ve hangi sektörlerden geldiğini raporda görürsünüz. Raporu PDF olarak indirip kurumunuzla kolayca paylaşabilirsiniz.',
        /* Öneri döngüsü bölümü (SiteAnaSayfa bölüm 5, 04.11.2026): kullanıcı onaylı metin, birebir. */
        audienceTitle: 'Etkinliğiniz doğru kitleye ulaşır.',
        audience1Title: 'İlgi alanına göre öneri',
        audience1Body: 'Kullanıcılar ilgi alanlarına ve katıldıkları etkinliklere göre etkinlik önerisi alır.',
        audience2Title: 'Kitlenizi sıfırdan aramazsınız',
        audience2Body: 'Etkinliğinizi {brandName}’te açtığınızda, ilgi alanları ve katılım geçmişi etkinliğinizle örtüşen kullanıcılara öneri olarak ulaşır.',
        audience3Title: 'Gerekçeli öneri',
        audience3Body: 'Her önerinin yanında nedeni gösterilir. Sıralama ücrete göre değişmez, kullanıcıya gerçekten uygun olan etkinlik önerilir.',
        attendeesTitle: 'Katılımcılarınız salona girmeden tanışmaya başlar.',
        attendeesBody: 'Etkinliğinize kaydolanlar {brandName} uygulamasında birbirini görür ve etkinlikten önce tanışmaya başlar.',
        phoneListTitle: 'Kimler geliyor',
        phoneListBody: 'Etkinliğe kaydolan herkes katılımcı listesinde yer alır. Ortak ilgi alanı olan kişilerin yanında neden önerildikleri de yazar.',
        phoneMeetingTitle: 'Görüşme planı',
        phoneMeetingBody: 'Katılımcılar görüşme için saat ve masa seçer. Kabul edilen görüşme iki tarafın ajandasına da eklenir.',
        phoneCardTitle: 'Onaylı kartvizit',
        phoneCardBody: 'Kartvizitler karekodla paylaşılır. Karşı taraf onay vermeden hiçbir bilgi paylaşılmaz.',
        phoneWalletTitle: 'Cüzdan',
        phoneWalletBody: 'Tanışılan her kişi, hangi etkinlikte tanışıldığı bilgisiyle birlikte cüzdanda saklanır.',
        rulesTitle: 'Üç kuralımız var.',
        rule1: 'Kartvizit yalnızca iki taraf da onay verirse paylaşılır.',
        rule2: 'Katılımcı listesini yalnızca etkinliğe kaydolanlar görebilir.',
        rule3: 'Etkinliğinizin verilerini dilediğiniz an dışa aktarabilirsiniz.',
        rulesLink: 'Gizlilik ayrıntıları',
        closingLeadSite: 'Etkinliğinizi bize anlatın, size en kısa sürede dönelim.',
        closingAppsLabel: 'Katılımcılarınız için uygulama',
        shotApplicationsAlt: 'Organizatör panelinde başvurular ekranı',
        shotGateAlt: 'Kapı ekranında karekodla giriş',
        shotReportAlt: 'Organizatör panelinde etkinlik raporu',
        shotAttendeesAlt: 'Katılımcı listesi, neden bu kişi gerekçeleriyle',
        shotMeetingAlt: 'Görüşme talebi ekranı',
        shotCardAlt: 'Kartvizit değişimi karekodu',
        shotWalletAlt: 'Cüzdandaki kartvizitler',
        shotRecommendationsAlt: 'Önerilen etkinlikler, neden bu etkinlik gerekçesiyle',
        contactBody: 'İlk etkinliğiniz ücretsiz.',
    },
    event: {
        accessMode: {
            public: 'Herkese açık',
            approval: 'Başvurulu',
            inviteOnly: 'Yalnız davetli',
        },
        format: {
            inPerson: 'Yüz yüze',
            online: 'Çevrimiçi',
            hybrid: 'Hibrit',
        },
        status: {
            draft: 'Taslak',
            published: 'Yayında',
            cancelled: 'İptal edildi',
            archived: 'Arşivlendi',
        },
        statusEnded: 'Bitti',
        capacityRemaining: 'Son {count} kontenjan',
        capacityRemaining_one: 'Son {count} kontenjan',
        startsAt: 'Başlangıç',
        endsAt: 'Bitiş',
    },
    attendance: {
        /* QA 17B+17E P3: gerekçe cümlesi ekranda TEK YERDE — üst şerit "sona erdi"yi
           zaten söylüyor, buradaki satır yalnız düğmenin yokluğunu açıklar. */
        endedNotice: 'Katılım kaydın geçmişinde kalır ve kaldırılamaz.',
        listedNote: 'Kaydın olduğu için bu etkinliğin katılımcı listesinde görünüyorsun. Listeyi yalnız kaydolanlar görür, iletişim bilgilerin listede yer almaz. Listeden çıkmak için kaydını iptal edebilirsin.',
        listedPendingNote: 'Kaydın kesinleştiğinde bu etkinliğin katılımcı listesinde görünürsün. Listeyi yalnız kaydolanlar görür.',
        listedPreRegisterNote: 'Kaydolduğunda adın bu etkinliğin katılımcı listesinde görünür. Listeyi yalnız kaydolanlar görür, iletişim bilgilerin listede yer almaz.',
        listedPreApplyNote: 'Başvurun onaylandığında adın bu etkinliğin katılımcı listesinde görünür. Listeyi yalnız kaydolanlar görür.',
    },
    consent: {
        termsLabel: '{brandName} kullanım koşullarını kabul ediyorum',
        privacyLabel: 'Gizlilik politikasını okudum',
        /*
         * BİLGİLENDİRME DİLİ, BEYAN DİLİ DEĞİL (09.09.2026). Bu satırın onay kutusu
         * YOKTUR ve olmamalıdır: aydınlatma bir rıza değil, kanunun bize yüklediği
         * bilgilendirme ödevidir; kutuya bağlamak "açık rıza aydınlatmanın içine
         * gömülemez" kuralını çiğnerdi. Ama "okudum" demek kullanıcıya BEYAN
         * ettiriyordu ve kutusu olmadığı için ekranda eksik kutu gibi duruyordu.
         * Cümle artık ne söz veriyor ne beyan alıyor: neyi nerede açıkladığımızı
         * söylüyor.
         */
        kvkkLabel: 'Kişisel verilerini nasıl işlediğimizi burada açıkladık:',
        marketingLabel: 'Kampanya e-postaları almak istiyorum',
        analyticsLabel: 'Ürünü geliştirmek için kullanım verisi paylaşabilirim',
        marketingHint: 'Giriş kodu gibi işlemsel e-postalar bundan bağımsızdır.',
        analyticsHint: 'Hangi ekranların kullanıldığını ve sana gösterilen önerilere ne olduğunu ölçeriz.',
        termsHint: 'Hizmeti hangi kurallarla kullandığını anlatır.',
        privacyHint: 'Hangi verini neden işlediğimizi anlatır.',
        kvkkReadNote: 'Bu bir rıza değildir. Yalnızca okuduğun kayda geçer.',
        /*
         * BELGE BAĞLANTISI TÜRE GÖRE YAZILIR (sıra 41a). Eski tek kalıp
         * '{document} metnini aç' adı "metni" ile biten belgede "aydınlatma metni
         * metnini aç" üretiyordu. Türkçe belirtme hâli ada göre değiştiği için her
         * türün cümlesi tamdır; kapı: `consent-document-phrasing.spec`.
         */
        openDocumentByType: {
            terms_of_service: 'Kullanım koşullarını aç',
            privacy_policy: 'Gizlilik politikasını aç',
            kvkk_clarification: 'KVKK aydınlatma metnini aç',
            marketing_email: 'Pazarlama e-postaları metnini aç',
            analytics: 'Kullanım analitiği metnini aç',
            attendee_visibility: 'Katılımcı listesi görünürlüğü metnini aç',
            organization_account_notice: 'Kurum hesabı aydınlatma metnini aç',
        },
    },
    consentTypes: {
        terms_of_service: 'Kullanım koşulları',
        privacy_policy: 'Gizlilik politikası',
        kvkk_clarification: 'KVKK aydınlatma metni',
        marketing_email: 'Pazarlama e-postaları',
        analytics: 'Kullanım analitiği',
        attendee_visibility: 'Katılımcı listesi görünürlüğü (artık alınmıyor)',
        organization_account_notice: 'Kurum hesabı aydınlatma metni',
    },
    push: {
        /* Davet: GENEL metin. Etkinlik ve kurum adı kilit ekranına çıkmaz (invite_only sızmaz). */
        invitation: {
            title: 'Bir etkinliğe davet edildin',
            body: 'Daveti görmek için dokun.',
        },
        /* Başvuru sonucu: gövde etkinlik adı. Ret metni gerekçesizdir (organizatörün notu iletilmez). */
        applicationApproved: {
            title: 'Başvurun onaylandı',
            body: '{eventTitle}',
        },
        applicationRejected: {
            title: 'Başvurunla ilgili bir güncelleme var',
            body: '{eventTitle}',
        },
        organizationEventPublished: {
            title: 'Takip ettiğin kurumdan yeni etkinlik',
            body: '{orgName} yeni bir etkinlik yayınladı: {eventTitle}',
        },
        eventUpdated: {
            title: '{eventTitle} güncellendi',
            body: 'Tarih, saat veya konum bilgisi değişti. Yeni bilgileri kontrol et.',
        },
        eventCancelled: {
            title: '{eventTitle} iptal edildi',
            body: 'Etkinlik iptal edildi. Ayrıntılar için dokun.',
        },
        meetingRequestReceived: {
            title: '{requesterName} görüşme önerdi',
            body: '{eventTitle} · {durationMinutes} dakika. Talebi uygulamada aç.',
        },
        meetingRequestAccepted: {
            title: '{counterpartName} görüşmeyi kabul etti',
            body: '{eventTitle} · {durationMinutes} dakika. Görüşme ajandanda.',
        },
        meetingRequestDeclined: {
            title: '{counterpartName} görüşmeyi kabul etmedi',
            body: '{eventTitle} etkinliğindeki talebin yanıtlandı.',
        },
        meetingRequestCancelled: {
            title: '{counterpartName} görüşmeyi iptal etti',
            body: '{eventTitle} · görüşme ajandandan kaldırıldı.',
        },
        meetingAreaAssigned: {
            title: 'Görüşmene yer atandı',
            body: '{eventTitle} · görüşmenin yeri {areaName}. Ajandanda görebilirsin.',
        },
        cardExchangeOffered: {
            title: '{peerName} kartvizit değişmek istiyor',
            body: 'Onaylamadan hiçbir bilgi paylaşılmaz. Aç ve karar ver.',
        },
        cardExchangeConfirmed: {
            title: '{peerName} ile tanıştın',
            body: 'Kartvizit cüzdanına eklendi. Not eklemek için dokun.',
        },
        /* D6: gövdede kullanıcının KENDİ notu YOKTUR — yalnız kişi ve dönüş yolu. */
        followUpReminder: {
            title: '{name} ile ilgili takip zamanı',
            body: 'Cüzdanındaki notunu açmak için dokun.',
        },
        /*
         * Organizatör duyurusu (T4): "Kurum: Konu" ve metnin ilk 120 karakteri. Yer tutucular
         * sunucuda `announcementPushText` ile kısaltılır (başlık en çok 50, gövde en çok 150).
         */
        organizerAnnouncement: {
            title: '{orgName}: {subject}',
            body: '{body}',
        },
        /* Etkinlik sonrası iletisi (belge ve anket Story 6): üç içerik hâli, kişi adı yok. */
        postEventCertificateAndSurvey: {
            title: 'Katıldığın için teşekkürler',
            body: '{eventTitle} bitti. Katılım belgeni indirebilir, kısa anketi doldurabilirsin.',
        },
        postEventCertificate: {
            title: 'Katıldığın için teşekkürler',
            body: '{eventTitle} bitti. Katılım belgen hazır.',
        },
        postEventSurvey: {
            title: 'Katıldığın için teşekkürler',
            body: '{eventTitle} bitti. Kısa bir anketle görüşünü organizatöre iletebilirsin.',
        },
        /* Etkinlik hatırlatması (hatırlatma Story 1, kural 5): kilit ekranında görünür, kişi adı YOK. */
        upcomingEventReminderPeople: {
            title: 'Yarın: {eventTitle}',
            body: 'Başlangıç {startTime}. Tanışman gereken kişilere bak.',
        },
        upcomingEventReminder: {
            title: 'Yarın: {eventTitle}',
            body: 'Başlangıç {startTime}. Yer ve ayrıntılar için dokun.',
        },
    },
    email: {
        footerNote: 'Bu e-posta {brandName} tarafından {appDomain} üzerinden gönderildi.',
        /*
         * KVKK md. 10 — AYDINLATMA, HESABI OLMAYAN KİŞİYE DE ULAŞIR (14.09.2026).
         * Organizatör bir adrese davet gönderdiğinde o adresi işlemeye başlıyoruz;
         * kişi hiç kaydolmayabilir ve o zaman aydınlatma metnini HİÇ görmez. Veri
         * ilgili kişiden alınmadığında aydınlatma en geç İLK İLETİŞİM anında
         * yapılır — bizim ilk iletişimimiz gönderdiğimiz e-postanın kendisidir.
         * Bu yüzden satır tek bir şablona değil, altbilginin TAMAMINA konur.
         */
        footerLegalNote: 'Kişisel verilerini nasıl işlediğimizi aydınlatma metninde açıklıyoruz.',
        footerLegalLink: 'Aydınlatma metni',
        footerUnsubscribe: 'Bildirim tercihlerini değiştir',
        // Takvime ekle (17.10.2026): kayıt, onay, değişiklik ve iptal iletisinde `.ics` eki varken.
        calendarAttachmentNote: 'Takvim dosyası ektedir.',
        otp: {
            subject: '{brandName} giriş kodun',
            heading: 'Giriş kodun',
            body: 'Aşağıdaki kodu {minutes} dakika içinde kullan. Bu kodu kimseyle paylaşma.',
            cta: 'Girişe dön',
        },
        staffLoginCode: {
            subject: '{brandName} yönetim paneli giriş kodun',
            heading: 'Panel giriş kodun',
            body: 'Yönetim paneline girmek için aşağıdaki kodu {minutes} dakika içinde kullan. Bu kodu kimseyle paylaşma. Panel ekibi senden kod istemez.',
            cta: 'Panele dön',
        },
        staffInvitation: {
            subject: '{brandName} yönetim paneli davetin',
            heading: 'Panel hesabın hazır',
            body: 'Yönetim paneli hesabın açıldı. Şifreni belirlemek için aşağıdaki bağlantıyı {hours} saat içinde kullan. Bağlantı tek kullanımlıktır.',
            cta: 'Şifremi belirle',
        },
        registrationConfirmed: {
            subject: '{eventTitle} kaydın alındı',
            heading: 'Kaydın onaylandı',
            body: '{eventTitle} etkinliğine kaydın alındı. Etkinlik {eventDate} tarihinde başlıyor.',
            cta: 'Etkinliği görüntüle',
        },
        eventInvitation: {
            subject: '{eventTitle} etkinliğine davetlisin',
            heading: 'Davet aldın',
            body: '{organizerName}, seni {eventTitle} etkinliğine davet etti. Davet {expiresAt} tarihine kadar geçerli.',
            cta: 'Daveti görüntüle',
        },
        applicationResult: {
            subjectApproved: '{eventTitle} başvurun onaylandı',
            subjectRejected: '{eventTitle} başvurun hakkında',
            headingApproved: 'Başvurun onaylandı',
            headingRejected: 'Başvurun onaylanmadı',
            body: '{eventTitle} etkinliği için başvurunun sonucu belli oldu.',
            cta: 'Etkinliği görüntüle',
        },
        eventUpdated: {
            subject: '{eventTitle} güncellendi',
            heading: 'Etkinlik bilgileri değişti',
            body: '{eventTitle} etkinliğinde güncelleme var. Yeni bilgileri kontrol et.',
            cta: 'Etkinliği görüntüle',
        },
        eventCancelled: {
            subject: '{eventTitle} iptal edildi',
            heading: 'Etkinlik iptal edildi',
            body: '{eventTitle} etkinliği organizatör tarafından iptal edildi.',
            bodyPlatform: '{eventTitle} etkinliği iptal edildi ve artık düzenlenmeyecek.',
            cta: 'Etkinliği görüntüle',
        },
        teamInvitation: {
            subject: '{organizationName} ekibine davet edildin',
            heading: 'Ekip daveti',
            body: '{inviterName}, seni {organizationName} ekibine {role} olarak davet etti.',
            cta: 'Daveti görüntüle',
            /** Panelden açılan kurumun sahip davetinde davet eden (Story C1): marka ekibi. */
            staffInviter: '{brandName} ekibi',
        },
        claimOwnerNotice: {
            subject: '{eventTitle} için sahiplenme talebi var',
            heading: 'Etkinliğin için sahiplenme talebi',
            body: 'Açtığın {eventTitle} etkinliği için bir sahiplenme talebi alındı. {days} gün içinde itiraz edebilirsin.',
            cta: 'Talebi incele',
        },
        claimDecision: {
            subject: '{eventTitle} sahiplenme talebi sonuçlandı',
            heading: 'Sahiplenme kararı',
            body: '{eventTitle} etkinliği için verdiğin sahiplenme talebi sonuçlandı.',
            cta: 'Detayı görüntüle',
        },
        organizationVerificationDecision: {
            subject: '{organizationName} doğrulandı',
            heading: 'Kurumunuz doğrulandı',
            body: '{organizationName} doğrulama başvurunuz onaylandı. Artık herkese açık ve başvurulu etkinlik yayımlayabilir, keşifte ve arama sonuçlarında görünebilirsiniz.',
            cta: 'Etkinlik yayımla',
            subjectRejected: '{organizationName} doğrulama başvurusu reddedildi',
            headingRejected: 'Doğrulama başvurunuz reddedildi',
            bodyRejected: '{organizationName} doğrulama başvurunuz reddedildi. Gerekçe: {reason} Eksikleri tamamlayıp beklemeden yeniden başvurabilirsiniz.',
            ctaRejected: 'Yeniden başvur',
        },
        claimInfoRequest: {
            subject: '{eventTitle} sahiplenme talebin için ek bilgi gerekiyor',
            heading: 'Ek bilgi talebi',
            body: '{eventTitle} etkinliği için verdiğin sahiplenme talebini inceleyen ekibin sana notu: {message}',
            cta: 'Talebi görüntüle',
        },
        claimTransferred: {
            subject: '{eventTitle} devri tamamlandı',
            heading: 'Etkinlik devredildi',
            body: 'Açtığın {eventTitle} etkinliğinin yönetimi {newOrganizerName} tarafına geçti. Kaydın, verilerin ve cüzdanın etkilenmedi. Kurucu katkı kaydın kalıcı olarak sende.',
            cta: 'Etkinliği görüntüle',
        },
        dataExportReady: {
            subject: 'Veri dışa aktarman hazır',
            heading: 'Verin hazır',
            body: 'Talep ettiğin veri dışa aktarımı hazır. Bağlantı {hours} saat geçerlidir.',
            cta: 'İndir',
        },
        accountDeletionConfirmed: {
            subject: 'Hesabın silindi',
            heading: 'Hesabın silindi',
            body: 'Hesabın ve kişisel verilerin silindi. Bizi tercih ettiğin için teşekkürler.',
            cta: 'Yeniden başla',
        },
        invitationRequest: {
            subject: 'Süresi dolmuş davet için yeni davet talebi',
            heading: 'Bir davetli yeni davet istiyor',
            body: '{eventTitle} etkinliğine gönderdiğin davetin süresi doldu ve {email} adresi yeni bir davet istedi. Panelden yeni davet gönderebilir ya da yok sayabilirsin.',
            cta: 'Davetleri yönet',
        },
        speakerLinkRequest: {
            subject: 'Konuşmacı profili bağlama talebi',
            heading: 'Bir organizatör seni konuşmacı olarak bağlamak istiyor',
            body: '{eventTitle} etkinliğinin organizatörü, konuşmacı kartını profilinle bağlamak istiyor. Onaylayana kadar profilin kullanılmaz. Talebi ayarlarından onaylayabilir veya reddedebilirsin.',
            cta: 'Talebi incele',
        },
        meetingRequestReceived: {
            subject: '{requesterName} seninle görüşmek istiyor',
            heading: 'Yeni görüşme talebin var',
            body: '{requesterName}, {eventTitle} etkinliğinde {durationMinutes} dakikalık bir görüşme öneriyor. Önerilen saatleri ve mesajını uygulamada görebilir, kabul edebilir veya reddedebilirsin.',
            cta: 'Talebi incele',
        },
        meetingRequestAccepted: {
            subject: '{counterpartName} görüşme talebini kabul etti',
            heading: 'Görüşme ajandana eklendi',
            body: '{counterpartName}, {eventTitle} etkinliğindeki {durationMinutes} dakikalık görüşme talebini kabul etti. Saati uygulamadan görebilirsin.',
            cta: 'Ajandanı aç',
        },
        meetingRequestDeclined: {
            subject: '{counterpartName} görüşme talebini yanıtladı',
            heading: 'Talebin kabul edilmedi',
            body: '{counterpartName}, {eventTitle} etkinliğindeki görüşme talebini kabul etmedi. Gerekçe istenmez ve paylaşılmaz.',
            cta: 'Taleplerini aç',
        },
        meetingRequestCancelled: {
            subject: '{eventTitle} görüşmesi iptal edildi',
            heading: 'Görüşme iptal edildi',
            body: '{counterpartName}, {eventTitle} etkinliğindeki görüşmeyi iptal etti. Saat iki ajandadan da kaldırıldı. İstersen yeni bir talep gönderebilirsin.',
            cta: 'Taleplerini aç',
        },
        cardExchangeConfirmed: {
            // KONU SATIRI ADSIZDIR (Blok 21 tech-lead turu, Orta-5) — gerekçe renderer'da.
            subject: 'Kartvizit değişimi tamamlandı',
            heading: 'Yeni bir kartvizit cüzdanında',
            body: '{peerName} ile kartvizit değişimin iki tarafın da onayıyla tamamlandı. Kartı cüzdanında görüntüleyebilir, kısa bir not ekleyerek altı ay sonra kimi neden tanıdığını hatırlayabilirsin.',
            cta: 'Uygulamayı aç',
        },
        followUpReminder: {
            // KONU SATIRI ADSIZDIR — cardExchangeConfirmed ile aynı gerekçe.
            subject: 'Takip hatırlatman',
            heading: 'Takip zamanı',
            body: '{name} için kendine bir takip hatırlatması kurmuştun. Notun cüzdanında seni bekliyor. Notun kendisi bu e-postada yer almaz.',
            cta: 'Cüzdanı aç',
        },
        emailVerification: {
            subject: '{brandName} hesabını onayla',
            heading: 'Hesabını onayla',
            body: 'Aşağıdaki kodu {minutes} dakika içinde uygulamaya gir. Hesabın hemen aktifleşir. Bu kodu kimseyle paylaşma. Kaydı sen başlatmadıysan bu e-postayı yok sayabilirsin.',
            cta: 'Uygulamayı aç',
        },
        passwordReset: {
            subject: '{brandName} şifre sıfırlama kodun',
            heading: 'Şifreni sıfırla',
            body: 'Aşağıdaki kodu {minutes} dakika içinde kullanarak yeni şifreni belirle. Bu kod yalnızca şifre sıfırlamak içindir. Giriş yapmaya yaramaz. Sıfırlamayı sen istemediysen şifren değişmez, bu e-postayı yok sayabilirsin.',
            cta: 'Şifreni sıfırla',
        },
        accountExistsNotice: {
            subject: '{brandName} hesabın zaten var',
            heading: 'Bu adreste zaten bir hesap var',
            body: 'Bu e-posta adresiyle yeni bir hesap açılmaya çalışıldı. Hesabın zaten var. Şifrenle giriş yapabilirsin. Şifreni hatırlamıyorsan giriş ekranındaki "Şifremi unuttum" adımından yenisini belirleyebilirsin. Bu denemeyi sen yapmadıysan bir şey yapmana gerek yok. Hesabına dokunulmadı.',
            cta: 'Giriş yap',
        },
        eventCeilingWarning: {
            subject: '{eventTitle} katılımcı sınırına yaklaştı',
            heading: 'Katılımcı sınırının %80’ine ulaştın',
            body: '{eventTitle} etkinliğinin kayıt sayısı {used}, sınırı {ceiling}. Sınıra ulaşıldığında yeni kayıt, davet kabulü ve başvuru onayı kapanır. Kayıtlı katılımcıların check-in’i açık kalır. Sınırsız katılım için Kurumsal sözleşme hakkında bize ulaş.',
            cta: 'Kullanımı görüntüle',
        },
        /** "Rapor hazır" (organizatör raporu tasarım kare 3): dondurma anında, rapor kesin. */
        eventReportReady: {
            kicker: 'RAPOR HAZIR',
            subject: '{eventTitle} raporu hazır',
            heading: '{eventTitle} raporu hazır',
            body: 'Etkinliğin bitti ve raporun kesinleşti.',
            cta: 'Raporu gör',
            statRegistered: 'kesin kayıt',
            statAttendanceRate: 'check-in oranı',
            statSatisfaction: 'memnuniyet',
            ratePercent: '%{rate}',
            satisfactionValue: '{value} / 5',
            reason: 'Bu e-postayı {orgName} kurumunun etkinliğini yönettiğin için aldın.',
        },
        /**
         * Etkinlik sonrası iletisi (belge ve anket tasarım ekran 5). Gövde ve düğmeler
         * belge ve anket hâline göre seçilir; kapalı yetenek için düğme ve metin yok.
         */
        postEventMessage: {
            kicker: 'ETKİNLİK SONRASI',
            subject: '{eventTitle} için teşekkürler',
            heading: 'Katıldığın için teşekkürler',
            bodyCertificateAndSurvey: '{eventTitle} bitti. Katılım belgeni indirebilir, kısa anketle organizatöre görüşünü iletebilirsin.',
            bodyCertificate: '{eventTitle} bitti. Katılım belgen hazır.',
            bodySurvey: '{eventTitle} bitti. Kısa bir anketle görüşünü organizatöre iletebilirsin.',
            certificateCta: 'Belgeyi indir',
            surveyCta: 'Anketi doldur',
            surveyNote: 'Anket {surveyClosesOn} tarihinde kapanır. Cevapların anonimdir.',
            reason: 'Bu e-postayı {eventTitle} etkinliğine check-in yaptığın için aldın.',
            turnOff: 'Etkinlik sonrası e-postalarını kapat',
        },
        /**
         * Etkinlik hatırlatması (hatırlatma ve önerilen kişiler, tasarım H1). Başlık etkinlik adıdır;
         * gövde cümlesi gelen kutusu önizlemesidir. Kişi bloğu en çok 3 satır, iletişim bilgisi yok.
         */
        eventReminder: {
            kicker: 'YARIN',
            subject: 'Yarın: {eventTitle}',
            heading: '{eventTitle}',
            body: 'Etkinlik bilgileri, saat ve yer.',
            bodyPeople: 'Etkinlik bilgileri ve tanışman gereken {count} kişi.',
            bodyPeople_one: 'Etkinlik bilgileri ve tanışman gereken {count} kişi.',
            cta: 'Etkinliği aç',
            dateLabel: 'TARİH',
            placeLabel: 'YER',
            placeOnline: 'Çevrimiçi. Katılım bağlantısı etkinlik sayfasında.',
            placeHybrid: '{venue}. Çevrimiçi katılım bağlantısı da etkinlik sayfasında.',
            peopleTitle: 'Tanışman gereken kişiler',
            peopleIntro: 'Etkinliğe gelen ve seninle ortak noktası olan kişiler.',
            profileLink: 'Profili gör',
            profileLinkLabel: '{name} profilini gör',
            reason: 'Bu e-postayı {eventTitle} etkinliğine kayıtlı olduğun için aldın.',
            turnOff: 'Etkinlik hatırlatmalarını kapat',
        },
        organizerAnnouncement: {
            subject: '{subject}',
            heading: '{eventTitle}: {orgName} duyurusu',
            /** Tasarım kare 11: başlığın üstündeki kurum satırı ve etkinlik-tarih satırı. */
            kicker: '{orgName} duyurusu',
            meta: '{eventTitle} · {eventDate}',
            // Gövde organizatörün metnidir (tasarım kare 11); kimden geldiği altbilgide yazar.
            body: '{body}',
            cta: 'Etkinliği gör',
            /** Altbilgi (tasarım kare 11): neden aldın, gönderen, tek tık ret. */
            reason: {
                attendee: 'Bu e-postayı {eventTitle} etkinliğine katıldığın için aldın.',
                registered: 'Bu e-postayı {eventTitle} etkinliğine kayıtlı olduğun için aldın.',
                applicant: 'Bu e-postayı {eventTitle} etkinliğine başvurduğun için aldın.',
                follower: 'Bu e-postayı {orgName} kurumunu takip ettiğin için aldın.',
            },
            sender: 'Gönderen {orgName}, alıcı listesini görmez.',
            unsubscribe: 'Bu kurumdan duyuru alma',
            unsubscribeHint: 'Tek tıkla, giriş gerekmez.',
        },
    },
    // Takvim dosyasının içindeki metinler (`i18n/event-calendar.ts`).
    calendar: {
        eventPage: 'Etkinlik sayfası: {url}',
        // Web etkinlik sayfası düğmesi ve menüsü (Story 3, docs/design/takvime-ekle).
        addCta: 'Takvime ekle',
        downloadIcs: 'Takvim dosyası indir (.ics)',
        google: 'Google Takvim',
        outlook: 'Outlook',
        fileError: 'Takvim dosyası oluşturulamadı.',
        retry: 'Yeniden dene',
    },
    auth: {
        // --- Blok 8-3: Google / Apple ile giriş (ekran 1) ---
        oauthDivider: 'ya da',
        oauthGoogle: 'Google ile devam et',
        oauthApple: 'Apple ile devam et',
        oauthUnavailable: 'Bu giriş yöntemi şu an kullanılamıyor. E-posta adresin ve şifrenle giriş yapabilirsin.',
        oauthPending: 'Yönlendiriliyorsun…',
        oauthMergeNote: 'Bu e-postayla zaten hesabın varsa yeni hesap açılmaz, Google ya da Apple hesabın ona bağlanır. Oradan gelen ad ve fotoğraf, sen onaylamadan profiline yazılmaz.',
        oauthConsentHint: 'Devam etmek için zorunlu onayları işaretle.',
        emailLabel: 'E-posta adresin',
        codeSentBody: 'Bu adres kod almaya uygunsa {email} adresine 6 haneli bir kod gönderdik. Kod {minutes} dakika geçerli.',
        codeLabel: 'Doğrulama kodu',
        /** Kod adımının ÜST ŞERİT etiketi (referans `AUTH` 82) — düğme etiketi değil. */
        verifyStep: 'Doğrulama',
        resend: 'Yeni kod gönder',
        /**
         * Sayaç dk:sn biçimindedir. Referans `AUTH` 106 "Kodu yeniden gönder (0:42)"
         * diyordu; kullanıcı bunu kodun ömrüyle çelişki sandı (B-5, 22.09.2026).
         * Cümle beklemeyi adıyla söyler, kod ömrü `codeSentBody`de kalır.
         */
        resendIn: 'Yeni kod {time} sonra istenebilir',
        changeEmail: 'E-postayı değiştir',
        continueWithGoogle: 'Google ile devam et',
        continueWithApple: 'Apple ile devam et',
        orDivider: 'veya',
        /*
         * KIRMIZI ÇİZGİ #19 / #4 (denetim E13 · E16) — referans `AUTH` 405 ve
         * `PUB` 331. Kullanıcı hesabını AÇARKEN görünürlüğün kapalı doğduğunu
         * okur; bu cümle giriş ekranında ve kayıt panelinde aynı sözü verir.
         */
        privacyDefaultNote: 'Bir etkinliğe kaydolduğunda adın o etkinliğin katılımcı listesinde görünür. Listeyi yalnız kaydolanlar görür, iletişim bilgilerin listede yer almaz.',
        consentRequiredHint: 'Devam etmek için zorunlu onayları işaretle.',
        signOutConfirmBody: 'Bu cihazdaki oturumun kapanacak. Diğer cihazların açık kalır.',
        /*
         * KOYU EDİTORYAL PANEL (Giriş yönü — vaat, 07.09.2026): kicker + serif vaat
         * cümlesi + gövde. Marka adı SABİT YAZILMAZ, `{brandName}` ile gelir.
         */
        panel: {
            kicker: 'Neden {brandName}',
            promise: 'Etkinlik başlamadan kiminle konuşacağını bilirsin.',
            /* Yeni görünüm 2b (SiteGiris): petrol bandın üç maddesi (başlık `password.signInTitle`). */
            pointGuestsTitle: 'Kimler geliyor, önceden gör',
            pointGuestsBody: 'Kaydolduğun etkinliğin katılımcılarını görür, görüşme planlarsın.',
            pointCardTitle: 'Kartvizit çift onaylı',
            pointCardBody: 'Kartvizitin yalnız iki taraf onaylarsa paylaşılır.',
            pointWalletTitle: 'Tanıştıkların kaybolmaz',
            pointWalletBody: 'Tanıştığın herkes, hangi etkinlikte tanıştığınla cüzdanında kalır.',
        },
        // --- Blok B: ürün şifresi (kullanıcı kararı 05.09.2026 · K1–K4, K10) ---
        password: {
            registerTitle: 'Hesap oluştur',
            registerSubtitle: 'E-postanı ve şifreni yaz. Hesabını doğrulaman için e-postana 6 haneli bir kod göndereceğiz.',
            registerAction: 'Kaydol',
            invitedEmailLocked: 'Davet bu adrese gönderildi. Hesap bu adresle açılır.',
            signInLink: 'Giriş yap',
            passwordLabel: 'Şifre',
            newPasswordLabel: 'Yeni şifre',
            /*
             * CANLI KONTROL LİSTESİ (elle test B-29, 09.10.2026): tek kural cümlesi
             * yerine politikanın her kuralı bir madde. Maddeler politikadan üretilir
             * (`domain/password-policy.ts`); durum ikon + metinle yazılır, renkle değil.
             */
            ruleListLabel: 'Şifre kuralları',
            ruleMinLength: 'En az {min} karakter',
            ruleMaxLength: 'En fazla {max} karakter',
            ruleUppercase: 'En az bir büyük harf',
            ruleSymbol: 'En az bir özel karakter (örn. ! ? * #)',
            ruleMet: 'sağlandı',
            ruleUnmet: 'eksik',
            ruleAnnouncement: '{rule}, {state}',
            passwordTooShort: 'Şifren en az {min} karakter olmalı.',
            passwordTooLong: 'Şifren en fazla {max} karakter olabilir.',
            passwordNeedsUppercase: 'Şifrende en az bir büyük harf olmalı.',
            passwordNeedsSymbol: 'Şifrende en az bir özel karakter olmalı (örn. ! ? * #).',
            /* Boş gönderim sessiz değil: alan altı cümle + odak (QA düzeltme turu · P2). */
            emailRequired: 'E-posta adresini yaz.',
            passwordRequired: 'Şifreni yaz.',
            showPassword: 'Şifreyi göster',
            hidePassword: 'Şifreyi gizle',
            confirmTitle: 'E-postanı doğrula',
            /*
             * ELLE TEST 07.09.2026 (C): kayıt, adresin kayıtlı olup olmadığını
             * SIZDIRMAZ — kayıtlı adrese kod değil "zaten hesabın var" postası
             * gider. Eski cümle yalnız kod gönderildiğini söylüyordu ve kayıtlı
             * adresle gelen kullanıcıyı boş yere bekletiyordu. Cümle artık İKİ
             * durumu da anlatır; ayrım YİNE yapılmaz (aynı yanıt, aynı süre).
             */
            confirmSentBody: '{email} adresine bir e-posta gönderdik. Adres yeniyse içinde 6 haneli doğrulama kodu, zaten kayıtlıysa giriş bilgisi var. Kod {minutes} dakika geçerli.',
            confirmForgotHint: 'Kod yerine "Hesabın zaten var" e-postası geldiyse şifreni sıfırla.',
            confirmAction: 'Hesabı doğrula',
            confirmLost: 'Kayıt bilgilerin bu tarayıcıda kalmadı. Aynı e-postayla yeniden kaydol. Sana yeni bir kod göndeririz.',
            confirmRestart: 'Kayda dön',
            /* Vaat yönü (07.09.2026): giriş başlığı referans artboard'dan; açıklama satırı yok. */
            signInTitle: 'Kaldığın yerden devam et',
            signInAction: 'Giriş yap',
            /* Yeni görünüm 2b: yükleniyor yüzü, alt bağlantı satırları ve adım etiketi. */
            signingIn: 'Giriş yapılıyor',
            registerPrompt: 'Hesabın yok mu?',
            stepOf: 'Adım {current} / {total}',
            /* 2b QA: kartların "Boş" kareleri (kod gelmeyene çıkış; sayım yok). */
            codeMissingTitle: 'Kod gelmedi mi?',
            resetNoAccountTitle: 'Bu adresle hesap bulunamadı mı?',
            resetNoAccountBody: 'Güvenlik için hesap olup olmadığını söylemeyiz. Kod gelmezse adresi ve gereksiz klasörünü kontrol et.',
            forgotLink: 'Şifremi unuttum',
            registerLink: 'Hesap oluştur',
            forgotTitle: 'Şifreni sıfırla',
            forgotSubtitle: 'E-postanı yaz. Bu adrese kayıtlı bir hesap varsa 6 haneli bir sıfırlama kodu göndeririz.',
            forgotAction: 'Kod gönder',
            backToSignIn: 'Girişe dön',
            resetCodeTitle: 'Sıfırlama kodunu gir',
            resetCodeAction: 'Devam et',
            newPasswordTitle: 'Yeni şifreni belirle',
            newPasswordSubtitle: '{email} hesabın için yeni bir şifre seç.',
            newPasswordAction: 'Şifreyi kaydet',
            resetDone: 'Şifren güncellendi. Diğer cihazlardaki oturumların kapatıldı. Yeni şifrenle giriş yapabilirsin.',
            sessionUnverified: 'Oturumun doğrulanamadı. Devam etmek için yeniden giriş yap.',
            resetLost: 'Sıfırlama bilgilerin bu tarayıcıda kalmadı. Yeniden kod iste.',
            resetRestart: 'Yeniden kod iste',
            fixCode: 'Kodu düzelt',
            rateLimitedSeconds: 'Çok fazla deneme yaptın. {count} saniye sonra tekrar deneyebilirsin.',
            rateLimitedSeconds_one: 'Çok fazla deneme yaptın. {count} saniye sonra tekrar deneyebilirsin.',
            rateLimitedWindow: 'Çok fazla deneme yaptın. En geç {count} dakika sonra tekrar deneyebilirsin.',
            rateLimitedWindow_one: 'Çok fazla deneme yaptın. En geç {count} dakika sonra tekrar deneyebilirsin.',
        },
    },
    // --- İki katmanlı etiket seçici (Story 2.2, 155 etiket) ---
    interests: {
        searchLabel: 'Etiket ara',
        searchPlaceholder: 'Örn. sigortacılık, lojistik, mimarlık…',
        browseHint: 'Ara ya da bir alan aç ve içinden seç.',
        selectedLabel: 'Seçtiklerin',
        selectedCount: '{count} / {max} etiket seçildi',
        limitReached: 'En fazla {max} etiket seçebilirsin. Yeni bir tane için birini kaldır.',
        removeTag: '{label} etiketini kaldır',
        noResult: '"{query}" için etiket bulunamadı. Farklı bir kelime dene ya da alanlara göz at.',
        otherCategory: 'Diğer',
        categoryNotSelectable: 'Alan başlıkları seçilemez. Alanın içinden bir etiket seç.',
        taxonomyEmptyTitle: 'Etiket listesi şu an boş',
        taxonomyEmptyBody: 'Sunucu şu an hiç alan ve etiket döndürmedi. Biraz sonra listeyi yeniden isteyebilirsin.',
        taxonomyReload: 'Listeyi yenile',
    },
    onboarding: {
        title: 'Kartvizitini oluştur',
        stepLabel: 'Adım {current} / {total}',
        step1Title: 'Temel bilgiler',
        step2Title: 'İlgi alanların',
        step3Title: 'Bağlantıların',
        fullNameLabel: 'Ad Soyad',
        jobTitleLabel: 'Unvan',
        companyLabel: 'Şirket',
        professionHint: 'Kıdem ve sektör isteğe bağlıdır. Doldurursan katılımcı listelerinde doğru kişilerle eşleşirsin.',
        headlineLabel: 'Kısa tanıtım',
        // Adım 1 fotoğraf alanı (onboarding fotoğraf, 17.10.2026). İpucu ve görünürlük
        // cümlesi Profil ekranının `profile.photo*` anahtarlarından okunur. Web turu
        // `photoUpload` ve `photoUploadingPercent`i AYNI adla ve AYNI metinle ekler.
        photoLabel: 'Profil fotoğrafı (isteğe bağlı)',
        photoUpload: 'Fotoğraf yükle',
        photoUploadingPercent: 'Yükleniyor… %{percent}',
        step2Hint: 'En az 1, en fazla {max} etiket seç. Sana uygun etkinlikleri bunlara göre öneririz.',
        tagSearchPlaceholder: 'Etiket ara…',
        tagSelectedCount: '{count} etiket seçildi',
        tagSelectedCount_one: '{count} etiket seçildi',
        suggestTag: '"{label}" etiketini öner',
        suggestedTagPendingHint: 'Önerdiğin etiket onaya kadar yalnızca senin profilinde görünür.',
        linkedinLabel: 'LinkedIn',
        xLabel: 'X',
        websiteLabel: 'Web sitesi',
        phoneLabel: 'Telefon',
        contactEmailLabel: 'İletişim e-postası',
        skipStep: 'Bu adımı atla',
        finish: 'Kartvizitini oluştur',
        previewTitle: 'Kart önizlemesi',
        previewKicker: 'Kartvizit',
        previewHint: 'Kartın başkalarına böyle görünecek. Kartı oluşturmak onu paylaşmak demek değil. Kartvizit yalnız iki taraf da onaylarsa paylaşılır.',
        resumeHint: 'Kaldığın yerden devam ediyorsun.',
        // Adım 1 fotoğraf alanının yalnız webde kullanılan hata metinleri (17.10.2026).
        // Ortak anahtarlar `headlineLabel` altında, mobil dalla bayt bayt aynı blokta.
        photoTooLarge: 'Dosya {maxMb} MB’tan büyük. Daha küçük bir fotoğraf seç.',
        photoUploadFailed: 'Yükleme tamamlanamadı.',
        photoRetry: 'Yeniden dene',
        // KÇ #13 (AUTH 193): bağlantılar adımının güvence cümlesi.
        step3Hint: 'Bu bilgileri yalnız kartvizit paylaştığın kişiler görür. Hepsi isteğe bağlı.',
    },
    events: {
        discoverTitle: 'Etkinlikleri keşfet',
        discoverSearchPlaceholder: 'Etkinlik ara…',
        discoverEmpty: 'Aramana uygun etkinlik bulunamadı.',
        discoverEmptyTitle: 'Bu filtrelerle etkinlik yok',
        discoverEmptyHint: 'Birkaç filtreyi kaldırmayı dene. Kendi etkinliğini düzenliyorsan bize ulaş.',
        discoverLead: 'Yaklaşan etkinliklere göz at. Katıldığın etkinlik sayısı arttıkça sana daha uygun etkinlikler gösteririz.',
        // --- Blok 8-3: keşif anonime açık; kişiselleştirme oturumlu ---
        visitorRecoBody: 'Giriş yaptığında sana uygun etkinlikleri ve her biri için "neden bu etkinlik" açıklamasını gösteririz. Liste ve filtreler giriş yapmadan da çalışır.',
        /*
         * KEŞİF — DENETİM KALEMLERİ E18 (sıralama anahtarı) · E19 ("Kontrol sizde").
         * Referans `Akış A/B` 232-235 ve `B5` 268-272.
         */
        sortLabel: 'Sıralama',
        sortDate: 'Tarihe göre',
        sortMatch: 'Uyuma göre',
        sortClientNote: 'Uyuma göre sıralama şu an yalnızca listeye yüklenmiş etkinlikler arasında yapılır. Daha fazlası için önce "Daha fazla göster" ile listeyi uzat.',
        controlTitle: 'Kontrol sende',
        controlBody: 'Sana etkinlik önerirken ilgi alanlarına ve katılım geçmişine bakarız. İkisini de istediğin an değiştirebilir, önerileri tamamen kapatabilirsin.',
        controlCta: 'Öneri ayarları',
        filterTitle: 'Filtrele',
        filterCityLabel: 'Şehir',
        filterCityAny: 'Tüm şehirler',
        /* Mobil şehir seçici (elle test · madde 8): elle yazma yerine katalogdan seçim. */
        filterCityPick: 'Şehir seç',
        filterCitySearch: 'Şehir ara',
        filterCityNoMatch: 'Bu adla bir şehir bulamadık. Daha kısa yazmayı dene.',
        filterFormatLabel: 'Biçim',
        filterFormatAny: 'Tümü',
        filterTopicLabel: 'Konu',
        filterTopicHint: 'Konu filtresi giriş yaptığında açılır.',
        filterFromLabel: 'En erken tarih',
        filterClear: 'Filtreleri temizle',
        emptyStepClearFilters: 'Filtreleri azalt',
        emptyStepClearFiltersBody: 'En çok daraltan filtreyi kaldır. Liste hemen genişler.',
        /* Kurum satışla açılır (01.10): kişisel kullanıcıya "etkinliği aç" değil, talep yolu. */
        emptyStepContact: 'Etkinlik mi düzenliyorsun?',
        emptyStepContactBody: 'Bize ulaş, kurumunu biz açalım.',
        resultCount: '{count} etkinlik',
        resultCount_one: '{count} etkinlik',
        resultShown: '{shown} / {total} gösteriliyor',
        loadMore: 'Daha fazla göster',
        /* Yeni görünüm 2a (SiteEtkinlikler, KatilimciWebEtkinlikler, EventCard). */
        filtersHeading: 'Filtreler',
        filterFormatHint: 'Tümü, Yüz yüze, Çevrimiçi, Hibrit',
        resultSortedDate: 'tarihe göre',
        resultSortedMatch: 'uyuma göre',
        resultShownOf: '{total} etkinliğin {shown} tanesi gösteriliyor',
        badgeRegistered: 'Katılımcı',
        badgeApplied: 'Başvurdun',
        badgeInvited: 'Davetli',
        signalsVisitorIntro: 'Giriş yaptığında ilgi alanlarına ve katıldığın etkinliklere bakarak sana uygun etkinlikleri öne çıkarırız. Her önerinin yanında nedeni yazar.',
        signalsVisitorBoxTitle: 'Giriş yapınca',
        signalsVisitorBoxBody: 'Katılım geçmişin ve ilgi alanların burada görünür, istediğin an değiştirirsin.',
        emptyPreviewLabel: 'Bir etkinlik kartı böyle görünür',
        emptyPreviewTitle: 'Ürün Tasarımı Buluşması',
        emptyPreviewMeta: 'Ücretsiz · İstanbul · 120 katılımcı',
        signalsTitle: 'Önerileri neye göre hazırlıyoruz',
        signalsIntro: 'Sana etkinlik önerirken katılım geçmişine ve senin gibi kişilerin katıldığı etkinliklere bakarız. Şu an elimizde şunlar var.',
        signalAttendance: 'Katılım geçmişin',
        signalAttendanceValue: '{count} etkinliğe kayıtlısın',
        signalAttendanceValue_one: '{count} etkinliğe kayıtlısın',
        signalAttendanceEmpty: 'Henüz bir etkinliğe kaydolmadın',
        signalTags: 'İlgi etiketlerin',
        signalTagsEmpty: 'Henüz ilgi etiketi seçmedin',
        signalTagsAction: 'Etiketlerini düzenle',
        signalEncounters: 'Tanıştığın kişiler',
        signalEncountersSoon: 'Etkinlikte karekodla tanıştıkça burada sayılır.',
        signalsPrivacyNote: 'Yalnız davetli etkinlikler keşifte ve önerilerde hiçbir zaman görünmez.',
        whyRecoTitle: 'Neden bu liste?',
        whyRecoBody: 'Şu an yaklaşan herkese açık etkinliklerin tamamını görüyorsun. Katıldığın etkinlikler biriktikçe listeyi senin ilgi alanlarına ve benzer kişilerin katıldığı etkinliklere göre daraltacağız.',
        createTitle: 'Etkinlik oluştur',
        stepLabel: 'Adım {current} / {total}',
        step1Title: 'Temel bilgiler',
        step2Title: 'Tarih ve konum',
        step3Title: 'Erişim modu',
        step4Title: 'Bilet ve kontenjan',
        step5Title: 'Görsel ve etiketler',
        titleLabel: 'Etkinlik adı',
        summaryLabel: 'Kısa özet',
        summaryHint: 'Liste kartlarında, arama sonucunda ve paylaşım önizlemesinde görünen tek cümle. En fazla {max} karakter.',
        summaryCounter: '{count} / {max} karakter',
        descriptionLabel: 'Açıklama',
        descriptionHint: 'Bu metin yalnızca etkinlik sayfasında görünür. Programı, kimlerin katılmasını beklediğini ve ulaşımı burada anlatabilirsin. 20.000 karaktere kadar yazabilirsin.',
        formatLabel: 'Biçim',
        formatInPerson: 'Yüz yüze',
        formatOnline: 'Çevrimiçi',
        formatHybrid: 'Hibrit',
        startsAtLabel: 'Başlangıç',
        endsAtLabel: 'Bitiş',
        timezoneLabel: 'Saat dilimi',
        cityLabel: 'Şehir',
        cityPlaceholder: 'Şehir seç',
        onlineUrlLabel: 'Çevrimiçi bağlantı',
        venueNameLabel: 'Mekan adı',
        venueNameHint: 'Örn. "Fintek Kampüsü, B Blok". Yüz yüze ve hibrit etkinliklerde zorunludur.',
        venueAddressLabel: 'Açık adres',
        venueAddressHint: 'Sokak, kapı numarası, semt. Katılımcı yol tarifini bu satırdan alır.',
        capacityLabel: 'Toplam kapasite (boş bırakırsan sınırsız)',
        accessPublicTitle: 'Herkese açık',
        accessPublicDesc: 'Herkes doğrudan kaydolur. Sayfa arama motorlarına açıktır.',
        accessApprovalTitle: 'Başvurulu',
        accessApprovalDesc: 'Herkes başvurur, başvuruları sen onaylarsın. Sayfa yine herkese açık kalır.',
        accessInviteOnlyTitle: 'Yalnız davetli',
        accessInviteOnlyDesc: 'Yalnızca davet ettiğin kişiler katılabilir.',
        accessModeRequired: 'Bir erişim modu seç. Senin yerine hazır bir seçim yapılmaz.',
        ticketDefaultHint: 'Bilet türü tanımlamazsan tek bir "Tam katılım" türü kapasite kadar kontenjanla otomatik oluşur.',
        /* Web sihirbazı (yeni görünüm 4b, QA 4a P3-b): varsayılan türün adı satırla aynı kaynaktan. Mobil eski anahtarı okur. */
        ticketDefaultHintKind: 'Bilet türü eklemezsen tek bir "{kind}" türü kapasite kadar kontenjanla otomatik oluşur.',
        /* Kapasite × katılımcı sınırı (20.10.2026): sınır kredi türünden gelir, sayı parametreyle. */
        capacityCeilingHint: 'Bu etkinliğin katılımcı sınırı {limit}. Kapasite ve bilet kontenjanı bu sayıyı aşamaz.',
        ticketTypeName: 'Tür adı',
        ticketKindLabel: 'Bilet türü',
        ticketKindPlaceholder: 'Tür seç',
        ticketQuota: 'Kontenjan',
        addTicket: 'Bilet türü ekle',
        removeTicket: 'Bilet türünü sil',
        ticketKindRequired: 'Her bilet satırı için bir tür seç ya da satırı sil.',
        ticketQuotaOverflow: 'Bilet kontenjanlarının toplamı ({total}) kapasiteyi ({capacity}) aşıyor. Kapasiteyi yükselt ya da kontenjanları düşür.',
        tagsHint: 'En az 1 ilgi etiketi seç. Etkinliğin, bu etiketlerle ilgilenen kişilere önerilir.',
        tagsRequired: 'En az bir ilgi etiketi seç. Etiketsiz etkinlik yayınlanamaz.',
        next: 'İleri',
        back: 'Geri',
        saveDraft: 'Taslağı kaydet',
        publish: 'Yayınla',
        createdDraft: 'Etkinlik taslak olarak oluşturuldu.',
        published: 'Etkinlik yayınlandı.',
        pastDateError: 'Geçmiş tarihli etkinlik oluşturulamaz.',
        resumeHint: 'Kaldığın yerden devam ediyorsun.',
        draftResumedAt: '{time} tarihinde bıraktığın taslak geri yüklendi.',
        draftLifetimeHint: 'Taslak bir hafta saklanır, sonra kendiliğinden silinir.',
        draftClear: 'Taslağı temizle',
        draftCleared: 'Taslak temizlendi. Form sıfırdan başlıyor.',
        step1Desc: 'Etkinliğine bir ad ver ve ne hakkında olduğunu kısaca anlat.',
        step2Desc: 'Ne zaman, nerede? Saatler etkinliğin saat diliminde gösterilir.',
        step3Desc: 'Kim katılabilir? Senin yerine hazır bir seçim yapmıyoruz. Üç moddan birini kendin seçersin.',
        step4Desc: 'Kontenjanı belirle. Bilet türü tanımlamazsan tek tür otomatik oluşur.',
        step5Desc: 'En az bir ilgi etiketi seç. Etkinliğinin doğru kişilere ulaşması buna bağlı.',
        progressLabel: 'Etkinlik oluşturma ilerlemesi',
        accessPublicPageNote: 'Sayfa herkese açık olur ve arama motorlarında görünür.',
        accessApprovalPageNote: 'Sayfa herkese açık olur. Kayıt yerine başvuru alınır.',
        accessInviteOnlyPageNote: 'Sayfaya yalnızca davet bağlantısıyla ulaşılır. Etkinlik keşifte görünmez.',
        previewKicker: 'Canlı önizleme',
        previewHint: 'Etkinlik sayfan kabaca böyle görünecek.',
        previewTitleFallback: 'Etkinlik adı',
        previewDateFallback: 'Tarih henüz seçilmedi',
        previewVenueFallback: 'Konum henüz belirtilmedi',
        previewSummaryFallback: 'Kısa özet burada görünecek.',
        previewOrganizerFallback: 'Düzenleyen henüz seçilmedi',
        previewAccessFallback: 'Erişim modu seçilmedi',
        previewTagsCount: '{count} ilgi etiketi',
        previewTagsCount_one: '{count} ilgi etiketi',
        // Yeni görünüm 4a (PanelEtkinlikOlustur): önizleme çipi ve kredi notu. Geri bağlantısı
        // panelin `organizer.backToMyEvents` etiketidir (üst menüyle aynı kelime).
        previewTagsEmpty: 'Etiket eklenmedi',
        draftsFreeNote: 'Taslaklar kredi harcamaz.',
        // Yeni görünüm 4a QA: web şerit adları (kartla aynı; mobil `step*Title` okur, dokunulmaz).
        webStep2Title: 'Tarih ve yer',
        webStep4Title: 'Bilet',
        webStep6Title: 'Gözden geçir',
        descriptionCounter: '{count} / {max} karakter',
        ticketTypesLabel: 'Bilet türleri',
        ticketDefaultQuota: 'Kontenjan {quota} · Tür eklenmezse yayında bu tür oluşur.',
        ticketDefaultUnlimited: 'Kontenjan sınırsız · Tür eklenmezse yayında bu tür oluşur.',
        ticketKindAddLabel: 'Tür ekle',
        ticketKindNote: 'Tür bir etikettir. Fiyat ve para birimi yoktur, "Ücretli" de ödeme almaz.',
        reviewEmpty: 'Henüz girilmedi.',
        reviewTicketsDefault: 'Bilet türü eklenmedi. Yayında tek varsayılan tür oluşur.',
        reviewCoverYes: 'Kapak yüklendi',
        reviewCoverNo: 'Kapak yok, sistem kapağı kullanılacak',
        reviewDescriptionWritten: 'Yazıldı.',
        reviewDescriptionMissing: 'Henüz yazılmadı. Yayından önce yazılması önerilir.',
        checklistCreditNote: 'Taslak kaydı kredi harcamaz. Yayın {credit} düşürür, kurumsal sözleşmede kredi düşmez.',
        draftSaveFailed: 'Taslak kaydedilemedi. Girilen bilgiler bu cihazda duruyor.',
        /*
         * --- "Düzenleyen" alanı (madde 24 · 3. kalem, kullanıcı kararı 30.08) ---
         * Alanın adı artık "Kurum" değil "Düzenleyen": kullanıcı bir kurum
         * yönetmeye değil, etkinliği KİMİN adına açtığını söylemeye geliyor.
         */
        organizationLabel: 'Düzenleyen',
        organizationHint: 'Etkinlik bu kurumun adına yayınlanır. Kurumun yoksa listeden yeni kurum oluşturabilirsin.',
        organizationPlaceholder: 'Düzenleyen seç',
        organizationRequired: 'Düzenleyen alanından bir kurum seç.',
        organizationNoRightsTitle: 'Bu kurumda etkinlik açma yetkin yok',
        organizationNoRightsBody: '{organizationName} kurumunun üyesisin ama rolün etkinlik açmaya izin vermiyor. Kurum sahibinden rolünü yükseltmesini iste ya da yeni bir kurum oluştur.',
        organizationNoRightsCta: 'Kurumuma git',
        /*
         * BAĞLAM SEÇİLİ DEĞİLKEN ve kişi BİRDEN FAZLA kuruma üyeyken hiçbir kurum
         * ADLANDIRILMAZ: keyfi bir ad yazmak yanlış bilgi verir (tech-lead DÜŞÜK).
         */
        organizationNoRightsBodyMany: 'Üyesi olduğun kurumlarda rolün etkinlik açmaya izin vermiyor. Kurum sahibinden rolünü yükseltmesini iste ya da yeni bir kurum oluştur.',
        organizationNoRightsCtaMany: 'Kurumlarıma git',
        /* Alan içinde açılan kurum formunun başlığı ve gövdesi (ayrı sayfa YOK). */
        organizationFormTitle: 'Yeni kurum',
        organizationFormBody: 'Kurumunu burada oluştur. Etkinlik onun adına yayınlanır. Girdiğin etkinlik bilgileri kaybolmaz, aynı yerden devam edersin.',
        organizationCreateCta: 'Yeni kurum oluştur',
        organizationCreateCancel: 'Kurum oluşturmaktan vazgeç',
        organizationCreatedNotice: 'Kurumun oluşturuldu ve seçildi.',
        // --- Erişim modu değişiminin sonucu (tasarım: uyarı + bilgi satırı) ---
        accessWarningPublic: 'Herkese açığa çevirirsen etkinlik sayfası arama motorlarına açılır ve keşifte listelenir.',
        accessWarningApproval: 'Başvurulu moda geçersen sayfa herkese açık kalır ama kayıt yerine başvuru alınır. Her başvuruyu elle karara bağlarsın.',
        accessWarningInviteOnly: 'Yalnız davetliye çevirirsen etkinlik keşifte ve önerilerde hiç görünmez. Sayfaya yalnızca davet bağlantısıyla ulaşılır.',
        // Doğrulama YAYIN İZNİ DEĞİL, ayrıcalıktır (karar 31.08): dil "gerekli"
        // değil "kazandırır" olmalı; başvuru yolu görünür kalır.
        accessVerificationNote: 'Bu modda hemen yayımlayabilirsin. Kurumunu doğrulatırsan etkinliğin keşif listesinde ve önerilerde de çıkar, sayfasında “doğrulanmış kurum” rozeti görünür.',
        accessVerificationCta: 'Doğrulama başvurusu yap',
        // Sihirbazın son adımı: kayıt oldu ama yayın kapıya takıldı.
        createdButNotPublished: 'Etkinliğin taslak olarak kaydedildi ama yayımlanamadı. Taslak "Yönettiklerim" listende duruyor. Yukarıdaki gerekçeyi giderip panelden yayımlayabilirsin.',
        publishOutcomeUnknown: 'Etkinliğin taslak olarak kaydedildi. Yayının sonucunu doğrulayamadık. Durumu "Yönettiklerim" listende kontrol edebilirsin.',
        goToMyEvents: 'Yönettiklerime git',
        accessNoteVisibility: 'Erişim modu katılımcı listesini değiştirmez. Liste her modda yalnız etkinliğe kaydolanlara açıktır ve kaydolan listede görünür. Davet tek başına kimseyi listeye yazmaz.',
        // --- Yayın öncesi kontrol listesi (tasarım ekran 17, adım 4) ---
        checklistTitle: 'Yayın öncesi kontrol',
        checklistIntro: 'Yayınlamadan önce eksikleri gör. Düzenle seni eksik maddenin adımına götürür.',
        checkOk: 'Tamam',
        checkTodo: 'Eksik',
        checkOrganizationLabel: 'Kurum seçildi',
        checkOrganizationDesc: 'Etkinlik bu kurumun adına yayınlanır. Kimin yönetebileceği de kurumdaki rollerden belirlenir.',
        checkBasicsLabel: 'Ad ve özet yazıldı',
        checkBasicsDesc: 'Ad ve kısa özet arama sonuçlarında ve keşif kartında görünür.',
        checkScheduleLabel: 'Tarih ve saat dilimi girildi',
        checkScheduleDesc: 'Başlangıç ve bitiş, katılımcının ajandasına bu saat dilimiyle düşer.',
        checkPlaceLabel: 'Konum ya da bağlantı verildi',
        checkPlaceDesc: 'Yüz yüze etkinlikte şehir, mekan adı ve açık adres, çevrimiçi etkinlikte bağlantı gerekir.',
        checkAccessLabel: 'Erişim modu seçildi',
        checkAccessDesc: 'Kimin katılabileceğini kendin seçmelisin. Senin yerine hazır bir seçim yapılmaz.',
        checkTagsLabel: 'İlgi etiketi eklendi',
        checkTagsDesc: 'Etkinliğin, seçtiğin etiketlerle ilgilenen kişilere önerilir. Etiketsiz etkinlik önerilemez.',
        checkCoverLabel: 'Kapak görseli eklendi',
        checkCoverDesc: 'İsteğe bağlı. Yüklemezsen sistem kapağı kullanılır.',
        checklistBlocked: 'Zorunlu maddeler eksik. Tamamlanmadan etkinlik kaydedilemez ve yayınlanamaz.',
        step6Title: 'Yayın öncesi kontrol',
        step6Desc: 'Son bir kez bak. Eksik kalan varsa yayınlamadan önce tamamla.',
        // B1 bölüm 4 — kronolojik listenin başlığı.
        listHeading: '{count} yaklaşan etkinlik',
        listHeading_one: '{count} yaklaşan etkinlik',
        // B3 bölüm 4 — sonuç yokken "yakın konular" çip şeridi.
        nearTopicsTitle: 'Yakın konular',
        nearTopicsHint: 'Bir konuya dokun, liste o konuya göre değişir.',
        // B4 bölüm 1 + 5 — filtre AYRI TAM EKRANDIR ve altında sabit uygulama çubuğu vardır.
        filterScreenTitle: 'Filtre',
        filterApplyCta: '{count} etkinliği göster',
        filterApplyCta_one: '{count} etkinliği göster',
        filterApplyLoading: 'Sonuçlar sayılıyor…',
        // Öneri kipinde sunucu sayacı geçerli değil: sayı UYDURULMAZ, eylem yazılır.
        filterApplyGeneric: 'Sonuçları göster',
        filterOpenCta: 'Filtre',
    },
    myEvents: {
        /*
         * ETKİNLİKLERİM — DENETİM KALEMLERİ E23-E25 + KISMİ #8.
         * Referans `F2A` 77-121 (kart satırı) · 93-102 (kontenjan) · 110-116 (uyarı
         * şeridi) · 50-63 (üst şeritteki kurum seçici).
         */
        orgFilterLabel: 'Kurum',
        orgFilterAll: 'Tüm kurumlarınız',
        orgSelectorLabel: 'Kurum seçimi',
        quotaLabel: '{count} kontenjan',
        quotaLabel_one: '{count} kontenjan',
        quotaUnset: 'Kontenjan belirlenmedi',
        quotaCountUnavailable: 'Kayıt sayısı bu listede gösterilmiyor. Yönetim panelinde görebilirsiniz.',
        warnNoMeetingArea: 'Görüşme alanı tanımlamadınız. Katılımcılar bu etkinlikte görüşme ayarlayamaz.',
        warnNoMeetingAreaCta: 'Alan ekle',
        warnUnverified: 'Kurumunuz doğrulanmadı. Etkinliğiniz keşif listesinde ve önerilerde çıkmıyor.',
        warnUnverifiedCta: 'Doğrulamayı başlat',
        kicker: 'Organizatör',
        title: 'Yönettiğiniz etkinlikler',
        lead: 'Açtığınız ve yönettiğiniz etkinlikler. Buradan yönetim paneline geçersiniz.',
        segAll: 'Tümü',
        segDraft: 'Taslak',
        segPublished: 'Yayında',
        segPast: 'Geçmiş',
        countLabel: '{count} etkinlik',
        countLabel_one: '{count} etkinlik',
        manageCta: 'Yönet',
        viewCta: 'Sayfasını gör',
        attendeesCta: 'Katılımcılar',
        draftNotice: 'Taslak. Yalnızca siz görüyorsunuz.',
        cancelledNotice: 'İptal edildi.',
        // Tur V2: yalnız görüntüleyici rolündeyken liste salt okunurdur (yönetim eylemi yok).
        viewerTitle: 'Kurumunuzun etkinlikleri',
        viewerLead: 'Görüntüleyici rolüyle kurumunuzun etkinliklerini görürsünüz, değiştiremezsiniz. Yönetmek için kurum yöneticinizden Editör rolü isteyin.',
        viewerEmptyTitle: 'Kurumunuzun henüz etkinliği yok',
        viewerEmptyBody: 'Kurum yöneticileriniz bir etkinlik açtığında burada listelenir ve sayfasını buradan açarsınız.',
        draftNoticeReadOnly: 'Taslak. Yayınlandığında sayfası açılır.',
        emptyTitle: 'Henüz etkinliğiniz yok',
        emptyBody: 'Etkinliğinizi platformda açtığınızda kayıt, katılımcı listesi ve ajanda tek yerde toplanır.',
        emptyStep1: 'Kurumunuzu seçin ya da oluşturun',
        emptyStep1Body: 'Etkinlik her zaman bir kurum adına yayınlanır.',
        emptyStep2: 'Etkinliği açın ve erişim modunu seçin',
        emptyStep2Body: 'Herkese açık, onaylı ya da yalnızca davetli.',
        emptyStep3: 'Katılımcıları davet edin',
        emptyStep3Body: 'Davet listesi ve başvuru kuyruğu yönetim panelinde.',
        emptyAction: 'Etkinlik aç',
        emptyPreviewLabel: 'Bir etkinlik satırı böyle görünür',
        emptyPreviewTitle: 'Ürün Ekipleri Buluşması',
        emptyPreviewMeta: '12 Mart · İstanbul · 48 kayıtlı',
        filteredEmptyTitle: 'Bu sekmede etkinlik yok',
        filteredEmptyBody: 'Başka bir sekmeye bakın ya da yeni bir etkinlik açın.',
        loadError: 'Etkinlikleriniz yüklenemedi.',
    },
    profile: {
        editTitle: 'Profil ve kartvizit',
        visibilityPromise: 'Bu bilgiler kaydolduğun etkinliklerin katılımcı listesinde (yalnız o etkinliğe kaydolanlara) ve onayladığın kart değişimlerinde görünür.',
        visibilityShortcut: 'Gizlilik ayarlarına git',
        missingStepsHint: 'Kurulumun eksik adımları var.',
        // --- Blok 8-2: kalıcı profil + kartvizit ekranı (ekran 2'nin sürekli hali) ---
        kicker: 'Hesabın',
        title: 'Profil ve kartvizit',
        lead: 'Kartvizitin katılımcı listesinde ve kart değişimlerinde görünen yüzündür. İstediğin zaman güncelleyebilirsin.',
        accountTitle: 'Hesap',
        displayNameLabel: 'Görünen ad',
        displayNameHint: 'Uygulama içinde seni bu ad temsil eder.',
        emailLabel: 'Hesap e-postası',
        emailReadOnlyHint: 'Hesap e-postası buradan değiştirilmez.',
        photoLabel: 'Profil fotoğrafı',
        photoHint: '{formats} · en fazla {maxMb} MB. Fotoğraf yoksa adının baş harfleri gösterilir.',
        photoEmpty: 'Henüz fotoğraf eklemedin.',
        photoUploading: 'Yükleniyor…',
        photoSaved: 'Fotoğraf güncellendi.',
        photoRemoved: 'Fotoğraf kaldırıldı.',
        photoPick: 'Fotoğraf ekle',
        photoReplace: 'Fotoğrafı değiştir',
        photoRemove: 'Fotoğrafı kaldır',
        photoVisibility: 'Fotoğrafın yalnız kaydolduğun etkinliklerin katılımcılarına ve kart değişimi yaptığın kişilere görünür.',
        cardsTitle: 'Kartvizitin',
        cardsHint: 'Adın, unvanın ve doldurduğun alanlar katılımcı listesinde bu karttan okunur.',
        fullNameLabel: 'Ad soyad',
        jobTitleLabel: 'Unvan',
        companyLabel: 'Şirket',
        headlineLabel: 'Tek cümlelik tanıtım',
        bioLabel: 'Hakkında',
        professionTitle: 'Kıdem ve sektör',
        professionHint: 'Katılımcı listesinde bu iki alanla filtrelenirsin.',
        seniorityLabel: 'Kıdem',
        sectorLabel: 'Sektör',
        educationTitle: 'Eğitim',
        educationSchoolLabel: 'Okul',
        educationFieldLabel: 'Bölüm',
        educationYearLabel: 'Mezuniyet yılı',
        contactTitle: 'İletişim ve bağlantılar',
        contactHint: 'İletişim bilgilerin katılımcı listesinde GÖSTERİLMEZ. Yalnızca çift taraflı onayladığın kart değişimlerinde paylaşılır.',
        contactEmailLabel: 'Kartta görünecek e-posta',
        phoneLabel: 'Telefon',
        websiteLabel: 'Web sitesi',
        linkedinLabel: 'LinkedIn',
        xLabel: 'X',
        githubLabel: 'GitHub',
        interestsTitle: 'İlgi etiketlerin',
        interestsHint: 'Seçtiğin etiketler, sana kimlerin önerileceğini ve “neden bu kişi” gerekçelerinde ne yazacağını belirler.',
        interestsSelected: '{count} etiket seçili',
        interestsSelected_one: '{count} etiket seçili',
        interestsSearchLabel: 'Etiket ara',
        previewTitle: 'Kartın böyle görünüyor',
        previewHint: 'Kart oluşturmak paylaşmak değildir. Paylaşım her zaman çift taraflı onayla olur.',
        saveCta: 'Kaydet',
        savedNotice: 'Değişikliklerin kaydedildi.',
        savedNoticeAccount: 'Hesap bilgilerin kaydedildi.',
        savedNoticeCard: 'Kartvizitin kaydedildi.',
        savedNoticeInterests: 'İlgi etiketlerin kaydedildi.',
        cardUnsaved: 'Kartvizitte kaydedilmemiş değişiklik var',
        deleteCardCta: 'Kartı sil',
        deleteCardConfirmTitle: 'Kart silinsin mi?',
        deleteCardConfirmBody: 'Bu kart silinecek. Daha önce paylaştığın kart kayıtları karşı tarafın cüzdanında kalır.',
        deletingCard: 'Siliniyor…',
        cardsEmptyTitle: 'Henüz kartvizitin yok',
        cardsEmptyBody: 'Kartvizitin olmadan katılımcı listesinde adının dışında bir bilgi görünmez.',
        loadError: 'Profilin yüklenemedi.',
        yearRangeHint: '{min}–{max} arası',
    },
    sessions: {
        title: 'Oturumlar ve cihazlar',
        currentBadge: 'Bu cihaz',
        lastUsed: 'Son kullanım: {time}',
        revoke: 'Oturumu sonlandır',
        revokeAll: 'Tüm cihazlardan çık',
        revokeAllConfirm: 'Bu cihaz dahil tüm oturumlar kapatılacak. Emin misin?',
        empty: 'Aktif oturum yok.',
        unknownDevice: 'Bilinmeyen cihaz',
        // Ekran AUTH 3.9 bölüm 4 — "Oturumlar" (mobil veri ve hesap ekranı).
        intro: 'Hesabına açık cihazlar. Tanımadığın bir cihaz görürsen oturumunu kapat.',
        revokeOthers: 'Diğer oturumları kapat',
        revokeOthersConfirm: 'Bu cihaz dışındaki tüm oturumlar kapatılacak. Devam edilsin mi?',
        revokingOthers: 'Oturumlar kapatılıyor…',
        revokeOthersNone: 'Bu cihaz dışında açık oturum yok.',
        /** KatilimciAyarlarOturumlar "Boş" hâli: yalnız bu cihaz açık. */
        othersEmptyTitle: 'Başka oturum yok',
        othersEmptyBody: 'Yalnız bu cihazda giriş yapılı.',
        clientWeb: 'Tarayıcı',
        clientMobile: 'Mobil uygulama',
        clientUnknown: 'Bilinmeyen istemci',
        /*
         * OKUNUR CİHAZ ADI (mobil elle test · bulgu 11). Satırlar ham User-Agent
         * basıyordu (`okhttp/4.9.2`, `curl/8.7.1`); kullanıcı kendi cihazını
         * ayırt edemeyince "tanımadığın cihazı kapat" cümlesi karşılıksız kalıyordu.
         */
        deviceAndroidApp: 'Android · {brandName} uygulaması',
        deviceIosApp: 'iPhone · {brandName} uygulaması',
        deviceBrowserOnOs: '{browser} · {os}',
        deviceBrowserOnly: '{browser} tarayıcısı',
        deviceTool: '{tool} istemcisi',
    },
    consentSettings: {
        historyTitle: 'Rıza geçmişi',
        grantedAt: 'Verildi: {time}',
        withdrawnAt: 'Geri alındı: {time}',
        withdraw: 'Rızayı geri çek',
        grant: 'Rıza ver',
        version: 'Metin sürümü: {version}',
        title: 'Rızalarım',
        lead: 'Hangi metne hangi sürümüyle onay verdiğini burada görürsün. İsteğe bağlı rızaları istediğin an geri alabilirsin.',
        requiredGroup: 'Hizmetin şartı',
        optionalGroup: 'İsteğe bağlı, her an geri alınabilir',
        requiredLockHint: 'Hizmetin şartı olduğu için buradan geri alınamaz. Vazgeçmek istersen hesabını silebilirsin.',
        acknowledgedNote: 'Okundu olarak kayda geçti.',
        noRecord: 'Onay kaydı bulunamadı.',
        outdated: 'Bu metnin daha yeni bir sürümü yayımlandı.',
        historyGranted: 'Verildi',
        historyWithdrawn: 'Geri alındı',
        historyEmpty: 'Henüz bir rıza hareketi yok.',
        openDocument: 'Metni aç',
        downloadRecord: 'Kaydı indir',
        downloadHint: 'Rıza defterin veri indirme talebinin içinde gelir. Talebi tarayıcıda oluşturursun.',
        emptyTitle: 'Rıza kayıtların görünmüyor',
        emptyBody: 'Hesabını açarken verdiğin onaylar burada listelenir. Liste boşsa kayıtlar henüz alınmamış olabilir.',
        emptyStep1: 'Bağlantını kontrol et',
        emptyStep1Body: 'Çevrimdışıyken rıza defteri sunucudan alınamaz.',
        emptyStep2: 'Listeyi yeniden yükle',
        emptyStep2Body: 'Aşağıdaki düğme kayıtları baştan ister.',
        emptyStep3: 'Verini indir',
        emptyStep3Body: 'Sorun sürerse rıza defterin veri indirme talebinin içinde gelir.',
        reload: 'Listeyi yenile',
    },
    speakersSection: {
        title: 'Konuşmacılar',
        empty: 'Konuşmacılar yakında açıklanacak.',
        linkedBadge: 'Doğrulanmış profil',
        sessionsLabel: 'Oturumları',
    },
    agendaSection: {
        title: 'Ajanda',
        empty: 'Program yakında yayınlanacak.',
        locationLabel: 'Salon: {location}',
        daysLabel: 'Gün seçimi',
    },
    attendeeList: {
        title: 'Katılımcılar',
        counter: 'Toplam {total} kayıtlı',
        // --- Bulgu 7: ekran ERİŞİM GEREKÇESİNİ söyler (sessiz liste sızıntı sanıldı)
        accessReasonManager: 'Bu listeyi organizatör olarak görüyorsun.',
        accessReasonAttendee: 'Bu listeyi etkinliğe kayıtlı olduğun için görüyorsun.',
        requiresRegistration: 'Katılımcı listesini görmek için etkinliğe kaydol.',
        // --- Elle test 14.10: kapalı etkinlikte kayıt çağrısı yerine kapanış gerekçesi (`ATTENDEE_LIST_LOCK_COPY`)
        closedEndedTitle: 'Etkinlik sona erdi',
        closedCancelledTitle: 'Etkinlik iptal edildi',
        closedBody: 'Katılımcı listesi yalnız kaydolanlara açık.',
        closedEndedNote: 'Bu etkinlik sona erdi. Katılımcı listesi yalnız kaydolanlara açık.',
        closedCancelledNote: 'Bu etkinlik iptal edildi. Katılımcı listesi yalnız kaydolanlara açık.',
        closedMeta: 'Yalnız kaydolanlara açık',
        signInPrompt: 'Katılımcıları görmek için giriş yap.',
        empty: 'Henüz kimse kaydolmadı. Kaydolan herkes bu listede görünür.',
        emptyTitle: 'Listede henüz kimse yok',
        searchPlaceholder: 'İsme göre ara',
        companyPlaceholder: 'Şirket',
        titlePlaceholder: 'Unvan',
        filterCta: 'Filtrele',
        loadMore: 'Daha fazla göster',
        teaserCardTitle: 'Katılımcı',
        teaserCardMeta: 'Kaydolunca görünür',
        previewLabel: 'Bir katılımcı böyle görünür',
        visitorCtaTitle: 'Kimler geliyor, kaydolunca görürsün',
        visitorCtaBody: 'Kaydolunca katılımcıları görürsün ve görüşmeni etkinlik başlamadan ayarlarsın. Kaydolduğunda sen de listede yer alırsın.',
        visitorCtaAction: 'Kayda git',
        listHint: 'Bu listede etkinliğe kaydolan herkes yer alır ve listeyi yalnız kaydolanlar görür. İletişim bilgileri hiçbir koşulda gösterilmez.',
        // --- Blok 8-2: ayrı liste rotası + ekran 6b filtreleri ---
        /*
         * "FİLTRE", "Süzgeç" DEĞİL (22.09.2026, kullanıcı kararı: "filtre
         * kullanılsın"). Ürün iki sözcüğü birden taşıyordu; azınlık olan sözcük
         * TR sözlüğünden tamamen çıktı. Ekranın komşu metinleri de aynı sözcüğü
         * kullanır: `activeFiltersLabel` ("Etkin filtreler"), `removeFilter`,
         * `filterCta` ("Filtrele").
         *
         * Anahtar YALNIZ web dizininde tüketilir (`attendee-facet-rail.tsx`,
         * `attendee-directory.tsx`); mobil kendi düğmesi için `filterCta`
         * kullanır.
         */
        filtersTitle: 'Filtre',
        filterAny: 'Tümü',
        seniorityFilterLabel: 'Kıdem',
        sectorFilterLabel: 'Sektör',
        tagFilterLabel: 'İlgi alanı',
        clearFilters: 'Temizle',
        resultLabel: '{count} kişi listeleniyor',
        resultLabel_one: '{count} kişi listeleniyor',
        openFullList: 'Tüm katılımcıları gör',
        openProfile: '{name} profilini aç',
        // --- B-32: izleyicinin kendi satırı ---
        youBadge: 'Sen',
        openOwnPreview: 'Profil önizlemeni aç',
        selectPersonTitle: 'Bir kişi seç',
        selectPersonBody: 'Listeden birini seç. Profili burada açılır.',
        filteredEmptyTitle: 'Bu filtrelerle kimse yok',
        filteredEmptyBody: 'Birkaç filtreyi kaldırıp yeniden bak.',
        filteredEmptyAction: 'Filtreleri temizle',
        backToEvent: 'Etkinlik sayfasına dön',
        loadError: 'Katılımcı listesi yüklenemedi.',
        // --- Blok 8-3: filtre sayaçları (facet) ---
        facetLabel: '{label} ({count})',
        facetsNote: 'Sayaçlar katılımcı listesindeki herkesi kapsar.',
        // --- Katılımcı dizini yeniden tasarımı (bölüm 02 · 03 · 04 · 05 · 06 · 09)
        // Kaynak: docs/design/katilimci-dizini/"…Yeniden Tasarim.dc.html".
        /** Bölüm 02: güven cümlesi. Üç kırmızı çizgi ekranda BİR KEZ, burada geçer. */
        trustNote: 'Bu listede etkinliğe kaydolan herkes yer alır ve listeyi yalnız kaydolanlar görür. Kimsenin iletişim bilgisi gösterilmez. Görüşme talebi kartvizit paylaşımı değildir, kartvizit her zaman çift taraflı onayla değişir.',
        /** Bölüm 03: vaat şeridi. */
        promiseLabel: 'Liste görünümü',
        promiseAll: 'Tümü',
        promiseRecommended: 'Sana önerilen',
        promiseHint: 'Önerileri katılım geçmişine bakarak çıkarıyoruz. Her öneri nedenini yanında yazar.',
        /** Bölüm 04: etkin filtre çipleri. */
        activeFiltersLabel: 'Etkin filtreler',
        removeFilter: '{label} filtresini kaldır',
        /** Bölüm 05: filtre rayı başlıkları. */
        facetRatio: '{shown} / {total}',
        facetShowAll: 'Tümünü gör · {count} daha',
        facetShowAll_one: 'Tümünü gör · {count} daha',
        facetShowLess: 'Daha az göster',
        facetZeroNote: 'Listede eşleşen kimse olmadığı için {count} seçenek gizli.',
        facetZeroNote_one: 'Listede eşleşen kimse olmadığı için {count} seçenek gizli.',
        facetZeroRule: 'Sayılar bu etkinliğin katılımcı listesinden gelir. Sonuç vermeyen seçenekler gizlenir.',
        /** Bölüm 06: sonuç şeridi. */
        pageRange: '1–{shown} / {total}',
        /** Bölüm 08: dar ekranda detay katmanı. */
        detailClose: 'Kişi panelini kapat',
        /** Bölüm 09: kayıtsız ziyaretçi. */
        visitorCtaSecondary: 'Etkinliği gör',
    },
    personProfile: {
        kicker: 'Katılımcı',
        speakerBadge: 'Konuşmacı',
        organizerBadge: 'Ekip',
        aboutTitle: 'Hakkında',
        interestsTitle: 'İlgi alanları',
        contextTitle: 'Nerede görünüyor',
        contextBody: '{event} etkinliğinde katılımcı listesinde görünüyor.',
        professionTitle: 'Kıdem ve sektör',
        cardNote: 'Kartvizit bilgileri yalnızca çift taraflı onaydan sonra paylaşılır.',
        contactHidden: 'İletişim bilgisi gösterilmez.',
        notFoundTitle: 'Bu kişi listede görünmüyor',
        notFoundBody: 'Kişi kaydını iptal etmiş ya da kaydı değişmiş olabilir. Katılımcı listesine dönüp tekrar dene.',
        notFoundAction: 'Katılımcı listesine dön',
        // --- Blok 8-3: ortak etkinlikler ---
        sharedEventsTitle: 'Ortak etkinlikler',
        sharedEventsEmpty: 'Bu kişiyle ortak başka etkinlik görünmüyor.',
        sharedEventsNote: 'Yalnızca bu kişiyle birlikte kayıtlı olduğun etkinlikler listelenir.',
        // --- B-32: kendi satırının önizlemesi ---
        selfPreviewTitle: 'Diğer katılımcılar seni böyle görür',
        selfPreviewBody: 'Kendine görüşme talebi gönderemez, kartvizit paylaşamazsın. Görünen bilgileri profilinden değiştirebilirsin.',
        selfEditProfile: 'Profilini düzenle',
    },
    /**
     * BİLDİRME (Story 11.1 · `POST /reports`).
     *
     * Uç Faz 1'den beri canlı, izinli ve hız limitli; kullanıcı yüzeyi Blok
     * 19'da açıldı (tech-lead Y2 — "uç canlıyken yüzeyi olmaması kabul
     * edilemez"). Referans: `Faz 2 … Engelleme` ekranının ⋯ menüsündeki
     * "Bildirin" satırı. Bildiren kimliği karşı tarafa AÇILMAZ, bildirim
     * GİTMEZ — engelleme kuralının aynısı.
     */
    report: {
        menuLabel: 'Bildir',
        menuTitle: 'Bu kişi için',
        title: '{name} adlı kişiyi bildir',
        body: 'Bildirimin moderasyon ekibine gider. Karşı tarafa haber verilmez ve kimliğin paylaşılmaz.',
        reasonLabel: 'Sebep',
        reasons: {
            fake: 'Sahte hesap',
            spam: 'Spam veya reklam',
            inappropriate: 'Uygunsuz içerik veya davranış',
            personal_data: 'İzinsiz kişisel veri paylaşımı',
            other: 'Diğer',
        },
        descriptionLabel: 'Açıklama (isteğe bağlı)',
        descriptionPlaceholder: 'Ne olduğunu kısaca yazabilirsin.',
        submit: 'Bildir',
        receivedTitle: 'Bildirimin alındı',
        receivedBody: 'Moderasyon ekibi inceleyecek. Gerekli görülürse hesapla ilgili işlem yapılır. Bu kişiyi ayrıca engelleyebilirsin.',
        alreadyBody: 'Bu kişiyi zaten bildirmiştin. Yeni bir kayıt açılmadı.',
        close: 'Kapat',
        /* Organizatör duyurusu (tasarım kare 8): aynı diyalog, hedef duyurudur, kurumdur kişi değil. */
        announcementTitle: 'Duyuruyu bildir',
        announcementBody: 'Bildirimin moderasyon ekibine gider. Kuruma haber verilmez ve kimliğin paylaşılmaz.',
        announcementReceivedBody: 'Moderasyon ekibi duyuruyu inceleyecek.',
        announcementAlreadyBody: 'Bu duyuruyu zaten bildirmiştin. Yeni bir kayıt açılmadı.',
    },
    /**
     * Görüşme talebi (Epic 12 — ekran 10a/10b/10c + ekran 33).
     *
     * KIRMIZI ÇİZGİ 2: talep gönderilemeyen kişide SEBEP YAZILMAZ — nötr tek
     * cümle basılır ve hiç var olmayan kullanıcıdan ayırt edilemez.
     * KIRMIZI ÇİZGİ 1: talep kartvizit paylaşımı değildir; ayrım formda yazılıdır.
     */
    meetings: {
        title: 'Talepler',
        lead: 'Sana gelen ve gönderdiğin görüşme talepleri burada. Etkinlik başlamadan tanışabilirsin.',
        // --- Kişi paneli (ekran 10a) ---
        action: 'Görüşme talebi gönder',
        unavailable: 'Bu kişiye şu anda görüşme talebi gönderilemiyor.',
        // KIRMIZI ÇİZGİ 1 — kişi panelinde tek cümle; ikinci yarısı
        // `personProfile.cardNote` olarak zaten yazılıdır (tekrar edilmez).
        notCardExchange: 'Görüşme talebi kartvizit paylaşımı değildir.',
        // Modalda kişi paneli notu yoktur; iki cümle birlikte yazılır.
        cardShareNote: 'Kartvizit bilgileri yalnızca çift taraflı onaydan sonra paylaşılır.',
        pendingBadge: 'Talep gönderildi · yanıt bekleniyor',
        pendingNote: '{name} kabul edene kadar ajandana eklenmez.',
        remaining: 'Bu etkinlikte {count} açık talep hakkın kaldı.',
        // TR sayıdan sonra çoğullamaz; varyant EN ile ANAHTAR PARİTESİ için durur.
        remaining_one: 'Bu etkinlikte {count} açık talep hakkın kaldı.',
        blockedReason: {
            open_request_exists: 'Bu kişiye gönderdiğin ve hâlâ yanıt bekleyen bir talebin var.',
            declined_before: 'Bu kişi bu etkinlikteki talebini yanıtladı. Yeni talep gönderemezsin.',
            event_quota_reached: 'Bu etkinlikte açık talep hakkını doldurdun. Yanıt bekleyenlerden biri sonuçlanınca yeniden gönderebilirsin.',
            blocked_by_you: 'Bu kişiyi engellemişsin. Talep göndermek için önce engeli kaldırman gerekiyor.',
            event_closed: 'Bu etkinlik görüşme talebine kapalı. Yeni talep gönderilemez.',
        },
        blockedByYouAction: 'Engellenenler listesine git',
        // Yanıtlanmaya çalışılan talep aradan kalkmışsa (404) genel metin anlamsız kalır.
        errorGone: 'Bu talep artık listende değil. Sayfayı yenilediğinde güncel hâlini görürsün.',
        errorOffline: 'İnternet bağlantısı yok, gönderilemedi. Bağlanınca tekrar dene.',
        requiresAttendance: 'Görüşme talebi göndermek için etkinliğe kayıtlı olmalısın.',
        // --- Talep formu (ekran 10a modal) ---
        formTitle: 'Görüşme talebi',
        close: 'Kapat',
        durationLabel: 'Süre',
        durationOption: '{minutes} dakika',
        durationRequired: 'Bir süre seç.',
        slotsLabel: 'Önerdiğin saatler',
        proposedSlotsLabel: 'Önerilen saatler',
        slotsHint: 'En az 1, en fazla {max} saat seç.',
        slotsRequired: 'En az bir saat öner.',
        slotsFull: 'En fazla {max} saat önerebilirsin.',
        slotsEmpty: 'Bu etkinlikte önerebileceğin saat kalmadı.',
        /* Süre seçilmeden ızgara kurulamaz; bölüm boş kalmaz, ne yapılacağını söyler. */
        slotsNeedDuration: 'Önce görüşme süresini seç, uygun saatler burada çıksın.',
        slotsSelected: '{count} / {max} saat seçildi',
        // Mobil ızgarada seçili satırın etiketi (referans `isForm`).
        slotSelected: 'seçili',
        /*
         * Çağıranın KENDİ kabul edilmiş görüşmesiyle çakışan dilim (18.10.2026).
         * Karşı tarafın takvimi hiçbir metne girmez (Blok 11 Orta-3).
         */
        slotBusy: 'dolu',
        slotBusyA11y: '{time}, dolu. Ajandanda bu saatte kabul edilmiş bir görüşme var.',
        slotsBusyNote: 'Dolu görünen saatlerde ajandanda kabul edilmiş bir görüşme var.',
        areaLabel: 'Görüşme alanı',
        areaAny: 'Fark etmez',
        areaOption: '{name} · {hours}',
        areaHoursAll: 'etkinlik boyunca',
        areaDaysHint: 'Yalnızca şu günlerde açık: {days}',
        areaFilterNote: 'Yalnız seçtiğin alanın açık olduğu saatler görünüyor.',
        slotsAreaEmpty: 'Bu alanda önerebileceğin boş saat kalmadı. Başka bir alan ya da süre seç.',
        // Izgara tavanı SESSİZ kesmez (Blok 14 QA notu → Blok 16): kısıt yazılır.
        slotsTruncatedDays: 'Burada yalnız ilk {days} gün görünüyor. Sonraki günler için etkinlik yaklaşınca yeniden bak.',
        messageLabel: 'Mesaj (isteğe bağlı)',
        messagePlaceholder: 'Ne konuşmak istediğini bir cümlede yaz.',
        messageCounter: '{count} / {max}',
        messageTooLong: 'Mesaj en fazla {max} karakter olabilir.',
        footerNote: 'Talep, {name} kabul edene kadar ajandana eklenmez.',
        send: 'Talebi gönder',
        sending: 'Gönderiliyor…',
        offlineNote: 'İnternet bağlantın yok, talep gönderilemiyor. Bağlanınca tekrar dene.',
        // --- Gönderildi katmanı (ekran 10b) ---
        sentKicker: 'Talep gönderildi',
        sentTitle: '{name} yanıtı bekleniyor',
        // Ekran canlı (yoklama): başlık talep durumunu izler. Ret ayrıca söylenmez.
        sentTitleAccepted: '{name} talebini kabul etti',
        sentTitleAnswered: 'Talebin yanıtlandı',
        sentTitleClosed: 'Talebin sonuçlandı',
        backToList: 'Listeye dön',
        goToRequests: 'Taleplerime git',
        progressSent: 'Gönderildi',
        progressSentMeta: '{date} · {duration} dakika, {count} saat önerdin',
        progressSentMeta_one: '{date} · {duration} dakika, {count} saat önerdin',
        progressResponse: '{name} onayı',
        progressResponseWaiting: 'Bekleniyor',
        progressResponseAccepted: 'Kabul edildi',
        progressResponseDeclined: 'Yanıtlandı, gerekçe paylaşılmaz',
        progressResponseCancelled: 'Talep iptal edildi',
        progressResponseExpired: 'Önerilen saatler geçti',
        progressAgenda: 'Ajandaya eklenir',
        progressAgendaIdle: 'Kabul edilen saat iki ajandaya da eklenir',
        // --- Talepler ekranı (ekran 10c) ---
        incomingTitle: 'Gelen talepler',
        incomingLead: 'Kabul ettiğinde saat iki ajandaya da düşer. Reddedersen karşı tarafa gerekçe gönderilmez.',
        outgoingTitle: 'Gönderdiğin talepler',
        colPerson: 'Kişi',
        colTopic: 'Konu',
        colRequest: 'Talep',
        colStatus: 'Durum',
        colActions: 'Eylemler',
        noMessage: 'Mesaj yazılmamış.',
        accept: 'Kabul et',
        decline: 'Reddet',
        withdraw: 'Talebi geri çek',
        cancelMeeting: 'Görüşmeyi iptal et',
        block: 'Engelle',
        acceptTitle: 'Hangi saati kabul ediyorsun?',
        acceptBody: 'Seçtiğin saat iki ajandaya da eklenir. Kabul etmek kartvizit paylaşmak demek değil, iletişim bilgilerin paylaşılmaz.',
        acceptConfirm: 'Kabul et',
        conflictOwnMeeting: 'Ajandanda bu saatte zaten bir görüşme var: {slot} · {name}',
        declineTitle: '{name} talebini reddet',
        declineBody: 'Karşı tarafa gerekçe gitmez, yalnız talebini yanıtladığın bildirilir.',
        withdrawTitle: 'Talebi geri çek',
        withdrawBody: 'Talep karşı tarafın listesinde “İptal edildi” olarak görünür ve ona bildirim gider.',
        cancelMeetingTitle: 'Görüşmeyi iptal et',
        cancelMeetingBody: 'Görüşme iki ajandadan da silinir ve karşı tarafa bildirim gider. Başka bir saat için yeni talep gönderebilirsin.',
        blockTitle: '{name} adlı kişiyi engelle',
        blockBody: 'Bu kişi sana görüşme talebi gönderemez. Karşı tarafa bildirim gitmez ve kimliğin açık edilmez. Katılımcı listelerinde onu görmeye devam edersin, o da seni görür.',
        blockConfirm: 'Engelle',
        snapshotNote: 'Ad ve unvan talebin gönderildiği andaki hâliyle gösterilir.',
        requestedAt: 'Talep: {date}',
        durationValue: '{minutes} dakika',
        slotCount: '{count} saat önerildi',
        slotCount_one: '{count} saat önerildi',
        acceptedSlot: 'Kabul edilen saat: {slot}',
        incomingEmptyTitle: 'Sana gelen talep yok',
        incomingEmptyBody: 'Bir etkinliğe kaydolduğunda katılımcı listesinde görünürsün ve diğer katılımcılar sana görüşme talebi gönderebilir.',
        incomingEmptyVisibleBody: 'Kaydolduğun etkinliğin katılımcı listesinde görünüyorsun, katılımcılar sana talep gönderebilir. Beklemek yerine ilk adımı sen de atabilirsin.',
        incomingEmptyVisibleAction: 'Kimler geliyor, bak',
        /** Birden fazla etkinlikte açılan seçici (mobil test 23.09 · M2-02). */
        incomingPickTitle: 'Hangi etkinliğe bakalım?',
        incomingPickEmpty: 'Katılımcı listesine bakabileceğin yaklaşan bir etkinliğin yok.',
        incomingEmptyClosedBody: 'Görüşme talebi almayı kapattın. Açtığında katılımcılar sana talep gönderebilir. Katılımcı listesindeki yerin değişmez.',
        incomingEmptyClosedAction: 'Talep almayı aç',
        outgoingEmptyTitle: 'Henüz talep göndermedin',
        outgoingEmptyBody: 'Katılımcı listesinden birini seçip talep gönder. Görüşmeyi önceden ayarlamak, salonda karşılaşmayı beklemekten iyidir.',
        outgoingEmptyAction: 'Etkinliklere git',
        previewLabel: 'Bir talep böyle görünür',
        previewName: 'Katılımcı',
        previewMeta: 'Yanıt bekleniyor',
        loadError: 'Talepler yüklenemedi.',
        loadMore: 'Daha fazla göster',
        status: {
            pending: 'Yanıt bekleniyor',
            accepted: 'Kabul edildi',
            declined: 'Reddedildi',
            cancelled: 'İptal edildi',
            expired: 'Süresi doldu',
        },
        // --- Ayarlar › görüşme talepleri ve engellenenler (ekran 33) ---
        settingsTitle: 'Görüşme talepleri',
        receiveLabel: 'Görüşme talebi alma',
        receiveHint: 'Varsayılan olarak açık.',
        receiveNoteOn: 'Açıkken katılımcı listesinde seni gören kişiler sana görüşme talebi gönderebilir.',
        receiveNoteOff: 'Kapalıyken kimse sana talep gönderemez ve kimin denediği sana gösterilmez. Bu ayar seni katılımcı listesinden çıkarmaz.',
        notifyLabel: 'Talep geldiğinde bildirim',
        notifyLocked: 'Talep almayı seçtiysen haberdar olman gerekir. Bu bildirim kapatılamaz.',
        notifyDisabled: 'Talep almayı kapattığın için bu bildirim gönderilmiyor.',
        blockedTitle: 'Engellenenler',
        blockedLead: 'Bu kişiler sana görüşme talebi gönderemez. Katılımcı listelerinde onları görmeye devam edersin, onlar da seni görür. Engelleme kimseyi listeden çıkarmaz.',
        blockedEmptyTitle: 'Kimseyi engellemedin',
        blockedEmptyBody: 'Engellediğin kişi sana görüşme talebi gönderemez. Gelen bir talepteki “Engelle” düğmesiyle engelleyebilirsin, karşı taraf bunu öğrenmez.',
        blockedSince: '{date} tarihinde engellendi',
        unblock: 'Engeli kaldır',
        unblockTitle: '{name} için engeli kaldır',
        /* Kaldırmanın sonucu (yeni görünüm K2): engel diyaloğu engellemenin değil kaldırmanın ne yaptığını söyler. */
        unblockBody: 'Bu kişi sana yeniden görüşme talebi gönderebilir. Karşı tarafa bildirim gitmez. Gerekirse gelen talep satırındaki “Engelle” eylemiyle yeniden engelleyebilirsin.',
        blockedCount: '{count} kişi',
        blockedCount_one: '{count} kişi',
        // F2B 37/38 — engellenenler AYRI EKRANDIR; ayar satırı oraya götürür.
        blockedNone: 'Kimse engellenmedi',
        blockedOpenCta: 'Engellenenler',
        blockedScopeNote: 'Talep almayı kapatmak seni katılımcı listesinden çıkarmaz. Listeden çıkmanın yolu kaydını iptal etmektir.',
    },
    /**
     * Kişisel ajanda (ekran 10d). Saat dilimi notu YOK (kullanıcı kararı 24.09):
     * dilim `displayTimezoneFor` ile seçilir, ekranda açıklanmaz.
     * Görüşme satırı vurgu zeminlidir; oturum satırı nötr.
     */
    myAgenda: {
        title: 'Ajandam',
        lead: 'Oturumlar ve kabul edilmiş görüşmeler tek akışta.',
        meetingTag: 'Görüşme',
        sessionTag: 'Oturum',
        meetingTitle: 'Görüşme · {name}',
        meetingMeta: '{duration} dakika',
        meetingMetaWithArea: '{duration} dakika · {area}',
        meetingMetaNoArea: '{duration} dakika · yer atanacak',
        /*
         * BİTİŞ SAATİ VE ÇAKIŞMA (mobil elle test · bulgu 6). Ajanda yalnız
         * başlangıç saatini yazıyordu; bir görüşmenin bir oturumun tam içinde
         * durduğu ekrandan okunamıyordu.
         */
        timeRangeA11y: '{start} başlangıç, {end} bitiş',
        conflictNotice: 'Bu saatte ajandanda başka bir kayıt daha var',
        /** Grup başlığındaki etkinlik adı bağlantısı (tur 37). */
        openEventA11y: '{title}, etkinliğe git',
        dayToday: 'Bugün',
        dayTomorrow: 'Yarın',
        filterAll: 'Tüm etkinlikler',
        loadError: 'Ajanda yüklenemedi. Bağlantını kontrol edip yeniden dene.',
        retry: 'Yeniden dene',
        emptyKicker: 'Ajandam',
        emptyTitle: 'Ajandan henüz boş',
        emptyBody: 'Kayıtlı olduğun etkinliklerin oturumları ve kabul edilen görüşmelerin burada tek akışta görünür.',
        emptyStep1: 'Bir etkinliğe kaydol.',
        emptyStep1Body: 'Kayıt sonrası etkinliğin ajandası bu listeye düşer.',
        emptyStep2: 'Kimlerin geleceğini gör ve görüşme iste.',
        emptyStep2Body: 'Katılımcı listesinden bir kişi seçip görüşme talebi gönder.',
        emptyStep3: 'Kabul edilen görüşme buraya eklenir.',
        emptyStep3Body: 'Karşı taraf kabul ettiğinde satır iki ajandaya da düşer.',
        emptyAction: 'Etkinlikleri keşfet',
        previewLabel: 'Örnek · kabul edilen görüşme böyle görünür',
        previewTitle: 'Görüşme · Katılımcı',
        previewTime: '15:00',
        previewMeta: '30 dakika · Fuaye masa 3',
        /* B-33 Ajandam yenilemesi (`docs/design/ajandam/…dc.html`, metin tablosu). */
        nextKicker: 'Sıradaki',
        nextInMinutes: '{count} dakika sonra',
        nextInMinutes_one: '1 dakika sonra',
        nextToday: 'Bugün {time}',
        nextTomorrow: 'Yarın {time}',
        nextOn: '{day} {time}',
        viewProfile: 'Profili gör',
        placePending: 'Yer atanacak',
        placePendingHint: 'Yer, organizatör görüşme alanı açınca otomatik atanır.',
        kindFilterA11y: 'Kayıt türü',
        kindAll: 'Tümü',
        kindMeetings: 'Görüşmeler',
        kindSessions: 'Oturumlar',
        showPast: 'Geçmişi göster',
        goToEvent: 'Etkinliğe git',
        nowMarker: 'Şimdi',
        timeRange: '{start}–{end}',
        durationShort: '{duration} dk',
        gapHours: '{count} saat boşun var',
        gapHours_one: '1 saat boşun var',
        gapHoursMinutes: '{hours} sa {minutes} dk boşun var',
        gapMeta: '{range} · {event}',
        gapCta: 'Görüşme ayarla',
        noResultTitle: 'Bu filtreye uyan kayıt yok',
        noResultBodyMeetings: 'Görüşmeler filtresinde bugün ve sonrası için kabul edilmiş görüşmen yok. Filtreyi değiştirebilirsin.',
        noResultBodySessions: 'Oturumlar filtresinde bugün ve sonrası için oturum yok. Filtreyi değiştirebilirsin.',
        noResultBody: 'Seçtiğin filtreye uyan oturum ya da görüşme yok. Filtreyi değiştirebilirsin.',
        clearFilter: 'Filtreyi temizle',
        previewName: 'Katılımcı',
        previewSub: 'Unvan · Kurum',
        previewStart: '11:00',
        previewEnd: '11:30',
        previewPlace: 'Fuaye · Masa 3',
        /* B-33 mobil: çevrimdışı şeridi, etkinlik seçici yaprağı ve görüşme alt yaprağı. */
        offlineNotice: 'Çevrimdışısın. Ajanda son açtığın hâliyle gösteriliyor.',
        eventLabel: 'Etkinlik',
        meetingOpenA11y: '{name} ile görüşmenin detayını aç',
        sheetA11y: 'Görüşme detayı',
        sheetTime: 'Saat',
        sheetDuration: 'Süre',
        sheetPlace: 'Yer',
        sheetPlacePending: 'Yer atanacak. Organizatör görüşme alanı açınca otomatik atanır.',
    },
    /**
     * Katılım geçmişi ekranı (Story 20.1 — bulgu 14). Tam sayfa referansı YOKTUR;
     * metinler ana sayfadaki "Katıldığın etkinlikler" bölümünden TÜRETİLDİ
     * (`…Web Ana Sayfa….dc.html:137-167` + veri `:918-931`).
     */
    participationHistory: {
        title: 'Katıldığın etkinlikler',
        lead: 'Kaydolduğun, başvurduğun ve davet edildiğin etkinlikler tek listede. Bu liste yalnızca sana görünür.',
        loadError: 'Katılımların yüklenemedi.',
        emptyKicker: 'Katılım geçmişin',
        emptyTitle: 'Henüz bir katılımın yok',
        emptyBody: 'Bir etkinliğe kaydolduğunda satırı burada kalır. Check-in’in, kabul edilen görüşmelerin ve tanıştığın kişiler bu satırdan okunur.',
        emptyStep1: 'Etkinlik keşfet',
        emptyStep1Body: 'Yaklaşan etkinlikleri gez, sana uygun olanı seç.',
        emptyStep2: 'Kaydol',
        emptyStep2Body: 'Kayıt sonrası katılımcı listesi ve görüşme talebi açılır.',
        emptyStep3: 'Etkinlikten sonra buraya dön',
        emptyStep3Body: 'Katılımın, görüşmelerin ve tanıştığın kişiler burada birikir.',
        emptyAction: 'Etkinlik keşfet',
        previewLabel: 'Kaydolduğunda satırın böyle görünür',
        previewTitle: 'Veri Mühendisliği Buluşması',
        previewMeta: 'İzmir · yarım gün',
        previewResult: '3 kişiyle tanıştın · 1 görüşme',
    },
    /** Organizatör görüşme alanları (Story 13.2 — ekran `venuesFull`). */
    meetingAreas: {
        tab: 'Görüşme alanları',
        title: 'Görüşme alanları',
        /* TR sayıdan sonra çoğul eki almaz; parçalar EN ile aynı anahtarlardan gelir. */
        areaCount: '{count} alan',
        areaCount_one: '{count} alan',
        acceptedMeetingCount: '{count} kabul edilmiş görüşme',
        acceptedMeetingCount_one: '{count} kabul edilmiş görüşme',
        freeSlotCount: '{count} boş yer',
        freeSlotCount_one: '{count} boş yer',
        summary: '{areasLabel} · {meetingsLabel} · ≈ {freeLabel}',
        unplacedMeetingCount: 'Yer bekleyen {count} görüşme',
        unplacedMeetingCount_one: 'Yer bekleyen {count} görüşme',
        summaryWithUnplaced: '{summary} · {unplacedLabel}',
        curationNote: 'Katılımcılar buluşma yerini kendi yazamaz. Kabul edilen her görüşmeye buradaki alanlardan biri atanır. Serbest metin olmadığı için kimse özel bir konum paylaşamaz ya da karşı tarafı istemediği bir yere çağıramaz.',
        add: 'Alan ekle',
        edit: 'Düzenle',
        /* O-5: panelde yıkıcı etiket TEK kiptedir — sözlükte 2. tekil çoğunluk (161/52). */
        remove: 'Sil',
        capacityLabel: 'Kapasite',
        capacityValue: '{count} eşzamanlı',
        capacityHint: 'Aynı anda kaç görüşme yapılabilir.',
        availabilityLabel: 'Uygunluk',
        availabilityValue: '{from} – {to}',
        availabilityAll: 'Etkinlik boyunca',
        availabilityHint: 'Katılımcı yalnızca bu aralıktan saat önerebilir.',
        daysLabel: 'Açık günler',
        daysAll: 'Tüm günler',
        load: '≈ {used} / {total} yer dolu',
        loadHint: 'Tahmini doluluk, kapasite ile uygunluk saatinin çarpımıdır. Kabul sınırı saat saat işlediği için bu oran yalnızca gösterge.',
        free: '≈ {count} boş',
        // Yeni görünüm 4b (PanelGorusmeAlanlari): alan kartındaki doluluk bölümünün başlığı.
        loadTitle: 'Tahmini doluluk',
        // Blok 16 — GERÇEK ölçü: kapasite kapısının baktığı büyüklük.
        peak: 'En yoğun anda {peak} / {capacity} eşzamanlı görüşme',
        peakEmpty: 'Aynı anda çakışan kabul edilmiş görüşme yok.',
        tagActive: 'Aktif',
        tagFull: 'Dolu',
        nameLabel: 'Alan adı',
        nameHint: 'Katılımcı bu adı görecek. Kat, salon ya da masa numarası yazabilirsin.',
        namePlaceholder: 'Fuaye masa 4',
        draftTitle: 'Yeni görüşme alanı',
        editTitle: 'Görüşme alanını düzenle',
        save: 'Kaydet',
        cancel: 'Vazgeç',
        saving: 'Kaydediliyor…',
        nameRequired: 'Alan adı gerekli.',
        hoursPairRequired: 'Başlangıç ve bitiş saatini birlikte gir.',
        hoursOrder: 'Bitiş saati başlangıçtan sonra olmalı.',
        deleteTitleOne: 'Bu alanda 1 kabul edilmiş görüşme var',
        deleteTitleMany: 'Bu alanda {count} kabul edilmiş görüşme var',
        deleteTitleEmpty: '{name} alanını sil',
        deleteBody: '{name} silinirse bu görüşmeler yersiz kalır. Saatleri korunur. İstersen görüşmeleri başka bir alana taşıyabilirsin.',
        deleteBodyEmpty: 'Bu alana atanmış kabul edilmiş görüşme yok. Alan listeden kalkar.',
        affectedTitle: 'Etkilenen görüşmeler',
        affectedPrivacyNote: 'Kimin kiminle görüştüğü organizatöre gösterilmez. Panelde yalnızca saatler listelenir.',
        affectedMore: 've {count} görüşme daha',
        affectedMore_one: 've {count} görüşme daha',
        reassignLabel: 'Görüşmeleri taşı',
        reassignNone: 'Taşıma, yalnızca saatleri kalsın',
        reassignOption: '{name} · {capacity} eşzamanlı',
        deleteConfirm: 'Sil',
        deleteConfirmMove: 'Taşı ve sil',
        loadError: 'Görüşme alanları yüklenemedi.',
        retry: 'Tekrar dene',
        summaryUnknown: 'Alan özeti şu an okunamıyor',
        emptyBadge: 'Alan tanımlı değil',
        emptyTitle: 'Alan tanımlamadan görüşmeler yersiz kalır',
        emptyBody: 'Kabul edilen her görüşme bir alana atanır. Liste boş kaldığı sürece katılımcılar saat önerir ama görüşme yer bilgisi taşımaz.',
        emptyStep1: 'Alan adı yaz',
        emptyStep1Body: 'Katılımcının bulabileceği bir ad seç. Örneğin Fuaye masa 3, Kafe alanı ya da Stant B12.',
        emptyStep2: 'Kapasite belirle',
        emptyStep2Body: 'Aynı anda kaç görüşme yapılabileceğini yaz. Kabuller bu sayıya göre sınırlanır.',
        emptyStep3: 'Uygunluk saatlerini seç',
        emptyStep3Body: 'Katılımcı yalnızca bu aralıktan saat önerebilir.',
        emptyAction: 'İlk alanı ekle',
        previewLabel: 'Tanımlanmış bir alan böyle görünür',
        previewName: 'Fuaye masa 3',
        previewCapacity: '4 eşzamanlı',
        previewHours: '09:00 – 18:00',
    },
    seniority: {
        student: 'Öğrenci',
        entry: 'Yeni başlayan',
        mid: 'Orta seviye',
        senior: 'Kıdemli',
        lead: 'Takım lideri',
        manager: 'Yönetici',
        director: 'Direktör',
        executive: 'Üst yönetim',
        founder: 'Kurucu',
        freelance: 'Bağımsız çalışan',
    },
    sector: {
        software: 'Yazılım',
        telecom: 'Telekom',
        finance: 'Finans',
        insurance: 'Sigorta',
        healthcare: 'Sağlık',
        pharma: 'İlaç',
        education: 'Eğitim',
        research: 'Araştırma',
        manufacturing: 'Üretim',
        automotive: 'Otomotiv',
        construction: 'İnşaat',
        real_estate: 'Gayrimenkul',
        energy: 'Enerji',
        agriculture: 'Tarım',
        retail: 'Perakende',
        ecommerce: 'E-ticaret',
        logistics: 'Lojistik',
        tourism: 'Turizm',
        food_beverage: 'Yiyecek ve içecek',
        media: 'Medya',
        marketing: 'Pazarlama',
        consulting: 'Danışmanlık',
        legal: 'Hukuk',
        public_sector: 'Kamu',
        ngo: 'Sivil toplum',
        arts: 'Sanat',
        sports: 'Spor',
        other: 'Diğer',
    },
    organizations: {
        sectionTitle: 'Kurumlarım',
        sectionLead: 'Etkinliği nasıl yayımlayabileceğiniz, kurumunuzun doğrulama durumuna bağlıdır.',
        verificationCta: 'Doğrulama',
        statusUnverified: 'Doğrulanmamış',
        statusPending: 'İnceleniyor',
        statusVerified: 'Doğrulanmış',
        statusRejected: 'Reddedildi',
        nameLabel: 'Kurum adı',
        nameHint: 'Etkinlik sayfalarında düzenleyen olarak bu ad görünür.',
        emailLabel: 'İletişim e-postası (isteğe bağlı)',
        emailHint: 'Kurum alan adındaki bir adres doğrulamayı hızlandırır.',
        websiteLabel: 'Web sitesi (isteğe bağlı)',
        descriptionLabel: 'Kısa açıklama (isteğe bağlı)',
        descriptionHint: 'Kurum sayfasında ve etkinlik künyesinde okunur.',
        factWebsite: 'Web',
        factContact: 'İletişim',
        factEvents: 'Etkinlik',
        createCta: 'Kurumu oluştur',
        creating: 'Oluşturuluyor…',
        loadError: 'Kurumların yüklenemedi.',
        // --- MOBİL KURUM YÜZEYİ (kurum doğrulama turu · 08.09.2026) -------------
        // Kurumlarım listesi mobilde YENİ: kullanıcı kurumunu etkinlik açarken
        // yaratabiliyor ama sonra hiçbir yerden göremiyordu. Metinler web ile
        // ortak sözlükten okunur; ikinci bir cümle kümesi doğmaz.
        openCta: 'Kurumu aç',
        emptyTitle: 'Henüz bir kurumun yok',
        emptyBody: 'Etkinlik her zaman bir kurum adına açılır. Kurumunu üst köşedeki “+” ile hemen ya da etkinlik açarken oluşturursun. Doğrulamasını da buradan yürütürsün.',
        emptyStepsTitle: 'İki adımda başlarsın',
        emptyStep1Title: 'Etkinliğini aç',
        emptyStep1Body: '“Düzenleyen” alanında kurumunu oluştur. Etkinlik onun adına yayınlanır.',
        emptyStep2Title: 'Kurumunu doğrulat',
        emptyStep2Body: 'Doğrulanan kurumun etkinliği keşif listesinde ve önerilerde de çıkar.',
        emptyCta: 'Etkinlik aç',
        roleLine: 'Rolün {role}',
        verificationRowLabel: 'Doğrulama',
        detailMissing: 'Bu kurumu göremiyorsun. Listeye dönüp yeniden dene.',
        // --- KURUM OLUŞTURMA EKRANI (M2-03 · referans "Tek form, iki giriş") ----
        // Bağımsız girişin şerit, başlık, gövde ve düğmesi `orgCreate.*`ten okunur.
        // Referansın "Etkinlik sihirbazı duraklatıldı" şeridi BİLİNÇLİ SAPMAYLA
        // yazıldı: "sihirbaz" iç terimdir (`ui-copy-tone` K1), sözlük aynı akışa
        // "etkinlik kurulumu" diyor (`orgCreate.twoEntriesBody`).
        newCta: 'Yeni kurum oluştur',
        createScreenTitle: 'Yeni kurum',
        createWizardBadge: 'Etkinlik kurulumu duraklatıldı',
        createWizardTitle: 'Etkinliği açacak kurumu oluştur',
        createWizardBody: 'Her etkinlik bir kurum altında yayınlanır. Kurumu şimdi oluştur. Girdiğin etkinlik bilgileri korunuyor ve kaldığın yerden devam edeceksin.',
        createWizardCta: 'Kurumu oluştur ve devam et',
        createKeptTitle: 'Korunan etkinlik bilgileri',
        createKeptEmpty: 'Henüz bir etkinlik alanı doldurmadın. Kurumu oluşturunca etkinlik kurulumu kaldığın yerden açılır.',
        createKeptNote: 'Kurum oluşturulduğunda etkinlik kurulumu kaldığın adımdan devam eder. Hiçbir alan yeniden doldurulmaz.',
    },
    organizerPage: {
        pastPageSubtitle: '{org} · {count} etkinlik',
        pastPageSubtitle_one: '{org} · {count} etkinlik',
        appBarTitle: 'Organizatör',
        verified: 'Doğrulanmış kurum',
        logoAlt: '{org} logosu',
        showMore: 'Devamını gör',
        showLess: 'Daha az göster',
        upcomingTitle: 'Yaklaşan etkinlikler',
        accessPublic: 'Herkese açık',
        accessApproval: 'Başvurulu',
        registered: 'Kayıtlısın',
        coverLabel: 'Etkinlik kapağı',
        noUpcoming: 'Şu an planlanmış etkinlik yok. Geçmiş etkinliklerine göz atabilirsin.',
        emptyTitle: 'Henüz etkinlik yok',
        emptyBody: '{org} ilk etkinliğini açtığında burada görürsün.',
        pastTitle: 'Geçmiş etkinlikler',
        seeAll: 'Tümünü gör',
        errorTitle: 'Sayfa yüklenemedi',
        errorBody: 'Bağlantını kontrol edip yeniden dene.',
        retry: 'Yeniden dene',
        notFoundTitle: 'Bu kurum sayfası bulunamadı',
        notFoundBody: 'Kurum kaldırılmış ya da bağlantı değişmiş olabilir. İlgini çekecek başka etkinlikler var.',
        discover: 'Etkinlikleri keşfet',
        offline: 'Çevrimdışısın. Son görülen içerik gösteriliyor.',
        loading: 'Yükleniyor',
        organizedBy: 'Düzenleyen',
        organizedByLine: 'Düzenleyen: {org}',
        organizedByAria: '{org} tarafından düzenleniyor. Organizatör sayfasını aç',
        metaDescription: '{org} tarafından düzenlenen etkinlikler.',
        pastPageTitle: '{org} · Geçmiş etkinlikler',
        backToOrganizer: '{org} sayfasına dön',
        pastPrevious: 'Önceki sayfa',
        pastNext: 'Sonraki sayfa',
        pastPageStatus: 'Sayfa {page} / {pages}',
        pastLoadMore: 'Daha fazla göster',
        pastEmpty: 'Henüz geçmiş etkinlik yok.',
        /* Künye satırındaki etkinlik sayısı (15.10.2026: özet şeridi kalktı).
           0 ise çizilmez (`organizerOrganizedCountText`). */
        summaryOrganized: '{count} etkinlik düzenledi',
        summaryOrganized_one: '{count} etkinlik düzenledi',
        featuredLabel: 'En yakın etkinlik',
        pastYearCount: '{count} etkinlik',
        pastYearCount_one: '{count} etkinlik',
        cityLabel: 'Şehir',
        cityHint: 'İsteğe bağlı. Organizatör sayfanın künyesinde görünür, boş bırakırsan satır çizilmez.',
        cityReadOnly: 'Şehri yalnız kurum sahibi değiştirebilir.',
        /* v3 §1.5 takip düğmesi ve "Düzenleyen" satırının küçük düğmesi (14.10.2026).
           Takipçi SAYISI hiçbir metinde yoktur (kapsam kural 3). */
        followCta: 'Takip et',
        followingState: 'Takip ediliyor',
        unfollowCta: 'Takibi bırak',
        followingShort: 'Takipte',
        followRowAria: '{org} kurumunu takip et',
        followHelp: 'Yeni etkinlik yayınlandığında haber veririz.',
        unfollowedNotice: 'Takibi bıraktın.',
        unfollowUndo: 'Geri al',
        followError: 'Şu an takip edilemiyor. Tekrar dene.',
        unfollowError: 'Takip şu an bırakılamıyor. Tekrar dene.',
    },
    orgHome: {
        kicker: 'Kurum',
        editCta: 'Düzenle',
        descriptionMissing: 'Kurumu tanıtan bir açıklama henüz yok. Katılımcılar etkinlik sayfasında burayı okuyor.',
        inviteCta: 'Üye davet et',
        teamOpenCta: 'Ekibi gör',
        soloKicker: 'Tek kişilik kurum',
        soloTitle: 'Etkinlik günü tek başına yönetilmiyor',
        soloBody: 'Kapıda check-in yapan, kayıtları takip eden ve ajandayı güncelleyen kişiler farklı olabilir. Rolleri ayırmak, herkese tam yetki vermekten güvenli.',
        soloCta: 'Ekip arkadaşı davet et',
        pendingTitle: 'Bekleyen davetler',
        pendingEmpty: 'Bekleyen davet yok. Davet gönderdiğinde durumu burada izlersin.',
    },
    orgSettings: {
        pageTitle: 'Kurum ayarları',
        subtitle: 'Buradaki ayarlar kurumun tüm etkinliklerini etkiler. Bir etkinlik kendi markasını yüklerse bu ayarları ezer.',
        navHeading: 'Kurum',
        navBrand: 'Marka',
        navBrandDescription: 'Logo ve renk',
        navVerification: 'Doğrulama',
        navVerificationDescription: 'Kurum kimliği',
        navTeam: 'Ekip',
        navTeamDescription: 'Üyeler ve roller',
        badgeVerified: '✓ Doğrulanmış kurum',
        badgeUnverified: 'Doğrulanmamış kurum',
        loadError: 'Kurum bilgileri yüklenemedi.',
        openCta: 'Kurum ayarları',
    },
    orgCreate: {
        badge: 'Ayarlar · yeni kurum',
        title: 'Kurum oluştur',
        body: 'Kurumu oluşturan kişi sahibi olur. Ekibini davet eder, kurum adına etkinlik açarsın.',
        submitCta: 'Kurumu oluştur',
        afterTitle: 'Oluşturduktan sonra',
        ownerNote: 'Kurumu oluşturan kişi sahip olur. Sahip rolü sonradan devredilebilir.',
        twoEntriesTitle: 'Tek form, iki yol',
        twoEntriesBody: 'Alanlar iki yolda da aynı. Değişen tek şey nereden başladığın ve kaydettikten sonra nereye döndüğün. Etkinlik kurulumundan geldiysen kurulum kaldığı yerden sürer.',
    },
    orgTeam: {
        title: 'Üyeler',
        ownershipTitle: 'Sahiplik ve ayrılma',
        intro: 'Roller etkinlik yönetimindeki yetkiyi belirler. Kapıda check-in yapan, kayıtları takip eden ve ajandayı güncelleyen kişiler farklı olabilir. Rolleri ayırmak herkese tam yetki vermekten güvenlidir.',
        summaryMembers: '{count} üye',
        summaryMembers_one: '{count} üye',
        summaryPending: '{count} bekleyen davet',
        summaryPending_one: '{count} bekleyen davet',
        colMember: 'Üye',
        colRole: 'Rol',
        colPermission: 'Yetki',
        colActions: '',
        ownerLocked: '{role} · kilitli',
        ownerNote: 'Sahip rolü devredilebilir ama silinemez. Her kurumun tam olarak bir sahibi olur. Katılımcı verisi rolden bağımsız olarak dışa aktarılabilir ve sponsorlara satılmaz.',
        youBadge: 'Sen',
        youBadgeSite: 'Siz',
        invitedBadge: 'Davet bekliyor',
        /** Süresi geçmiş davet (12.10.2026 kararı): listede kalır, bekleyen sayısına girmez. */
        expiredBadge: 'Süresi doldu',
        joinedAt: '{date} tarihinde katıldı',
        inviteExpiresAt: 'Davet {date} tarihine kadar geçerli',
        inviteExpiredAt: 'Davetin süresi {date} tarihinde doldu',
        removeCta: 'Çıkar',
        removeTitle: 'Üyeyi çıkar',
        removeBody: '{name} kurumdan çıkarılacak ve erişimi ANINDA sona erecek. Kişi daha sonra yeniden davet edilebilir.',
        cancelInviteCta: 'Daveti iptal et',
        cancelInviteTitle: 'Daveti iptal et',
        cancelInviteBody: '{name} adresine gönderilen davet iptal edilecek ve bağlantı geçersiz olacak. Kişi henüz kuruma katılmadı. Erişimi hiç açılmamıştı. Aynı kişiyi sonra yeniden davet edebilirsiniz.',
        roleChangeLabel: '{name} için rol',
        /**
         * Satır düğmelerinin erişilebilir adı: görünen metin başta (WCAG 2.5.3),
         * ardından satırı ayıran kimlik. Kurum hesabı üyeler aynı adı taşır (B-18).
         */
        removeCtaFor: 'Çıkar: {name}',
        cancelInviteCtaFor: 'Daveti iptal et: {name}',
        // --- Davet ---
        inviteTitle: 'Üye davet edin',
        inviteIntro: 'Davet edilen kişinin hesabı yoksa önce kaydolur, varsa daveti doğrudan kabul eder. Rolü şimdi seçin. Sonradan değiştirebilirsiniz.',
        inviteEmailLabel: 'E-posta adresi',
        inviteEmailPlaceholder: 'ad@kurum.com',
        inviteRoleLabel: 'Rol',
        inviteDomainNote: 'Kurumsal alan adı dışındaki adresler kabul edilir, ama doğrulama başvurusunda sayılmaz.',
        inviteCta: 'Daveti gönder',
        inviteSent: 'Davet gönderildi. Bağlantı 14 gün geçerli ve tek kullanımlık.',
        inviteContentTitle: 'Davet e-postası ne içerir',
        inviteContentOrg: 'Kurum adı ve doğrulama durumu',
        inviteContentInviter: 'Davet eden kişinin adı ve rolü',
        inviteContentRole: 'Verilen rol ve o rolün yetkileri',
        inviteContentExpiry: '14 gün geçerli tek kullanımlık bağlantı',
        inviteEmailScopeNote: 'Davet edilen kişinin e-posta adresi yalnızca bu tabloda görünür. Katılımcı listelerinde yer almaz.',
        // --- Roller ne yapar ---
        rolesTitle: 'Roller ne yapar',
        rolePermOwner: 'Tam yetki, kurum ayarları ve rol yönetimi',
        rolePermAdmin: 'Etkinlik, kayıt, davet, ekip ve marka yönetimi',
        rolePermEditor: 'Etkinlik düzenleme, kayıt, check-in ve davet gönderme',
        rolePermViewer: 'Etkinlikleri ve ekibi görüntüleme',
        roleDescOwner: 'Kurumu yönetir, rolleri değiştirir, sahipliği devredebilir. Devredilebilir ama boş bırakılamaz.',
        roleDescAdmin: 'Etkinlik açar, kayıtları ve davetleri yönetir, kapıda check-in yapar. Ekibi ve markayı yönetir. Kurum bilgilerini ve doğrulamasını değiştiremez, sahipliği devredemez.',
        roleDescEditor: 'Etkinlikleri düzenler, kayıtları ve başvuruları yönetir, davet gönderir, kapıda check-in yapar. Etkinliği yayınlayamaz, silemez, erişim modunu değiştiremez.',
        roleDescViewer: 'Etkinlikleri ve ekibi görür, değişiklik yapmaz.',
        // --- Sahiplik devri ---
        transferTitle: 'Sahipliği devret',
        transferIntro: 'Sahiplik kurumdaki başka bir aktif üyeye geçer. Devirden sonra siz yönetici olursunuz ve isterseniz kurumdan ayrılabilirsiniz.',
        transferSelectLabel: 'Yeni sahip',
        transferCta: 'Sahipliği devret',
        transferConfirmTitle: 'Sahipliği devret',
        transferConfirmBody: 'Kurumun sahipliği {name} kişisine geçecek. Siz yönetici rolüne düşeceksiniz ve bu işlemi geri alamazsınız. Geri almak için yeni sahibin size devretmesi gerekir.',
        transferNoCandidate: 'Devredecek başka aktif üye yok. Önce bir üye davet edin ve daveti kabul etmesini bekleyin.',
        transferDone: 'Sahiplik devredildi. Artık yönetici rolündesiniz.',
        // --- Ayrılma ---
        leaveTitle: 'Kurumdan ayrıl',
        leaveIntro: 'Ayrıldığınızda kurumun etkinliklerine erişiminiz sona erer. Bir kullanıcı aynı anda yalnızca bir kuruma ait olabilir. Ayrıldıktan sonra başka bir kuruma davetle katılabilirsiniz.',
        leaveCta: 'Kurumdan ayrıl',
        leaveConfirmTitle: 'Kurumdan ayrıl',
        leaveConfirmBody: '{organizationName} kurumundan ayrılacaksınız ve erişiminiz anında sona erecek. Yeniden katılmak için davet edilmeniz gerekir.',
        leaveBlockedOwner: 'Sahip kurumdan ayrılamaz. Önce sahipliği kurumdaki başka bir aktif üyeye devredin. Devirden sonra ayrılabilirsiniz.',
        leaveBlockedSoleOwner: 'Sahip kurumdan ayrılamaz ve devredecek başka aktif üye yok. Bir üye davet edip sahipliği ona devrettikten sonra ayrılabilirsiniz.',
        leftTitle: 'Kurumdan ayrıldınız',
        leftBody: 'Bu kurumun ayarlarına artık erişiminiz yok.',
        leftCta: 'Etkinliklerime dön',
        // --- Durumlar ---
        empty: 'Ekip arkadaşlarınızı davet ederek etkinlikleri birlikte yönetin.',
        emptyTitle: 'Ekip henüz tek kişilik',
        loadError: 'Ekip listesi yüklenemedi.',
        readOnlyNote: 'Rolünüz ekip yönetimine izin vermiyor. Listeyi yalnızca görüntüleyebilirsiniz.',
    },
    orgBrand: {
        title: 'Marka',
        logoLabel: 'Logo',
        logoHint: '{formats} · en az 256×256 px. Logo yüklenmezse kurum adının baş harfleri kullanılır.',
        logoPick: 'Dosya seç',
        logoReplace: 'Logoyu değiştir',
        logoRemove: 'Logoyu kaldır',
        logoUploading: 'Yükleniyor…',
        logoUploaded: 'Yüklendi. Kaydettiğinde yayına girer.',
        logoUploadError: 'Logo yüklenemedi.',
        colorLabel: 'Kurum rengi',
        colorHint: 'Renk, yaka kartının üst şeridinde ve etkinliğin herkese açık sayfasındaki vurgularda kullanılır.',
        colorOption: '{color} rengini seç',
        colorNone: 'Renk seçilmedi',
        colorClear: 'Rengi kaldır',
        contrastWarning: 'Seçilen renk metin üzerinde AA kontrast vermezse sistem otomatik olarak koyu bir tonunu kullanır. Erişilebilirlik markanın önünde gelir.',
        contrastApplied: 'Bu ton AA kontrast vermiyor. Metin taşıyan alanlarda koyu tonu kullanılıyor.',
        previewLabel: 'Yaka kartı önizlemesi',
        previewNote: 'Girişte ve kartvizit değişiminde okutulur.',
        inheritTitle: 'Nereye uygulanır',
        inheritBody: 'Kaydettiğiniz an, kendi markasını yüklememiş tüm etkinlikleriniz bu değeri gösterir. Kopya saklanmaz. Etkinlik sayfası her açılışta güncel markayı okur.',
        save: 'Markayı kaydet',
        saving: 'Kaydediliyor…',
        saved: 'Marka kaydedildi. Etkinlik sayfaları güncellendi.',
        publishing: 'Marka kaydedildi. Etkinlik sayfaları güncelleniyor…',
        saveError: 'Marka kaydedilemedi.',
        readOnlyTitle: 'Bu sekmeyi kurumun sahibi ve yöneticileri değiştirebilir',
        readOnlyBody: 'Marka kurumun kimliğidir. Yalnızca sahip ve yöneticiler değiştirebilir. Sizin rolünüz {role}. Değerleri görebilir ama kaydedemezsiniz.',
        emptyLogoAlt: '{name} logosu',
        /*
         * KAPAK GÖRSELİ (organizatör sayfası v3, 14.10.2026). Sınır sayıları metne
         * ELLE yazılmaz: `{recommended}`, `{minimum}` ve `{maxMb}` `MEDIA_RULES`ten
         * gelir. Biçim listesi tasarımın metin tablosundandır, kapı türleri sayar.
         */
        coverLabel: 'Kapak görseli',
        coverIntro: 'Kurum sayfanın en üstünde görünür. Üstüne yazı ya da süs konmaz.',
        coverIntroSite: 'Kurum sayfanızın en üstünde görünür. Üstüne yazı ya da süs konmaz.',
        coverLabelSite: 'Kurum kapak görseli',
        coverHelp: 'Önerilen {recommended} px · en az {minimum} px · PNG, JPEG ya da WebP · en çok {maxMb} MB',
        coverMobileArea: 'Mobilde görünen alan',
        coverEmpty: 'Henüz kapak yok',
        coverPreviewAlt: 'Kapak önizlemesi',
        coverUpload: 'Görsel yükle',
        coverReplace: 'Değiştir',
        coverRemove: 'Kaldır',
        coverUploading: 'Yükleniyor · %{percent}',
        coverProgressLabel: 'Kapak yükleniyor',
        coverCancel: 'İptal',
        coverRetry: 'Yeniden dene',
        coverStillProcessing: 'Görsel hâlâ işleniyor. Biraz sonra Yeniden dene düğmesine bas.',
        coverTooLarge: 'Dosya çok büyük. En çok {maxMb} MB yükleyebilirsin.',
        coverWrongType: 'Bu dosya türü desteklenmiyor. PNG, JPEG ya da WebP yükle.',
        coverTooSmall: 'Görsel çok küçük. En az {minimum} px yükle.',
        coverSaved: 'Kapak kaydedildi. Sayfanda görünüyor.',
        coverRemoved: 'Kapak kaldırıldı. Sayfan kapaksız görünüyor.',
        coverReadOnly: 'Kapak yalnız sahip ve yöneticiler tarafından değiştirilebilir. Senin rolün {role}.',
        coverReadOnlySite: 'Kapak yalnız sahip ve yöneticiler tarafından değiştirilebilir. Sizin rolünüz {role}.',
        /* Organizatöre "siz" (marka ruhu 28.10): web kapak alanının sonuç ve hata cümleleri; mobil ortak anahtarı okur. */
        coverStillProcessingSite: 'Görsel hâlâ işleniyor. Biraz sonra Yeniden dene düğmesine basın.',
        coverTooLargeSite: 'Dosya çok büyük. En çok {maxMb} MB yükleyebilirsiniz.',
        coverWrongTypeSite: 'Bu dosya türü desteklenmiyor. PNG, JPEG ya da WebP yükleyin.',
        coverTooSmallSite: 'Görsel çok küçük. En az {minimum} px yükleyin.',
        coverSavedSite: 'Kapak kaydedildi. Sayfanızda görünüyor.',
        coverRemovedSite: 'Kapak kaldırıldı. Sayfanız kapaksız görünüyor.',
    },
    orgVerification: {
        navLabel: 'Kurum doğrulama',
        kicker: 'Kurum',
        pageTitle: 'Kurum doğrulama',
        // 15.10: başvuru sunucu ayarıyla kapalıyken doğrulama çağrılarının YERİNE
        // kurum talep formuna giden yol (çıkmaz sokak yok).
        contactCta: 'Doğrulama için bize ulaş',
        badgeUnverified: 'Doğrulanmamış kurum',
        badgePending: 'İnceleniyor',
        badgeVerified: '✓ Doğrulanmış kurum',
        badgeRejected: 'Reddedildi',
        titleUnverified: 'Kurumunu doğrula',
        titlePending: 'Başvurun platform ekibinde',
        titleVerified: '{name} doğrulandı',
        titleRejected: 'Başvuru onaylanmadı',
        bodyUnverified: 'Doğrulama, katılımcıya etkinliği kimin düzenlediğini kanıtlar. Kurumsal e-posta alan adın, web siten ve bir yetki belgesi yeterli.',
        bodyPending: 'Ortalama karar süresi iki iş günü. Bu sürede etkinlik açabilir ve yayımlayabilirsin. Yalnızca doğrulanmış rozeti henüz görünmez.',
        bodyVerified: 'Etkinlik sayfalarında ve kurum profilinde doğrulanmış rozeti görünüyor. Alan adı ya da yetkili değişirse belgeleri güncelle.',
        bodyRejected: 'Gerekçe aşağıda. Eksikleri tamamlayıp yeniden başvurabilirsin. Bekleme süresi uygulanmaz.',
        ctaUnverified: 'Başvuruyu gönder',
        ctaRejected: 'Yeniden başvur',
        later: 'Sonra',
        limitsTitle: 'Doğrulanmamış kurumda görünen sınırlar',
        limitDiscoveryTitle: 'Keşifte ve arama motorunda yok',
        limitDiscoveryBody: 'Etkinliğin keşif listesinde, önerilen etkinlikler arasında ve arama motoru sonuçlarında görünmez.',
        limitBadgeTitle: 'Doğrulanmış rozeti yok',
        limitBadgeBody: 'Etkinlik sayfasında ve kurum profilinde “doğrulanmamış kurum” yazar.',
        formTitle: 'Doğrulama başvurusu',
        domainLabel: 'Kurumsal e-posta alan adı',
        domainHint: 'Hesap e-postan bu alan adında olmalı.',
        domainMatched: '✓ Eşleşti',
        domainMismatch: 'Hesabının alan adıyla eşleşmiyor',
        domainPlaceholder: 'ornek.com',
        domainInvalid: 'Geçerli bir alan adı yaz (ornek.com).',
        websiteLabel: 'Web sitesi',
        websiteHint: 'Alan adıyla aynı olması başvuruyu hızlandırır.',
        documentLabel: 'Yetki belgesi',
        documentHint: 'Ticaret sicil kaydı, dernek tüzüğü ya da imza yetkisi beyanı. Belge yalnızca doğrulama için kullanılır ve karara bağlandıktan {days} gün sonra silinir.',
        documentChoose: 'PDF seç',
        documentReplace: 'Belgeyi değiştir',
        documentUploading: 'Yükleniyor…',
        documentRequired: 'Yetki belgesi zorunludur.',
        documentTypeError: 'Yalnızca PDF yükleyebilirsin.',
        documentSizeError: 'Belge en fazla {mb} MB olabilir.',
        documentUploadError: 'Belge yüklenemedi. Tekrar dene.',
        documentBadge: 'PDF',
        documentUploaded: '{size} · yüklendi',
        // Belge seçilmeden önceki satır: saklama notu ALTTAKİ ipucunda bir kez yazar.
        documentEmpty: 'PDF · en fazla {mb} MB',
        timelineTitle: 'Başvuru durumu',
        timelineSubmitted: 'Başvuru gönderildi',
        timelineSubmittedMeta: '{date} · alan adı ve belge iletildi',
        timelineReview: 'İnceleme sürüyor',
        timelineReviewMeta: 'Ortalama iki iş günü',
        timelineReviewDone: 'İnceleme tamamlandı',
        timelineReviewDoneMeta: '{date} · onaylandı',
        timelineBadge: 'Rozet yayında',
        timelineBadgeMeta: 'Onay sonrası otomatik açılır',
        timelineBadgeDoneMeta: 'Tüm etkinlik sayfalarında görünüyor',
        rejectTitle: 'Red gerekçesi',
        badgePreviewTitle: 'Rozet nerede görünür',
        previewVerifiedCaption: 'Herkese açık etkinlik sayfası · düzenleyen bölümü',
        previewUnverifiedCaption: 'Doğrulanmamış kurum · aynı bölüm',
        previewNote: 'Doğrulanmış kurum yeşil onay rozetiyle görünür. Doğrulanmamış kurumda uyarı çıkmaz, yalnızca sessiz gri bir etiket yazar.',
        flowTitle: 'Durum akışı',
        flowUnverified: 'Doğrulanmamış',
        flowPending: 'İnceleniyor · platform ekibi',
        flowVerified: 'Doğrulandı · rozet açık',
        flowRejected: 'Reddedildi · gerekçeli, tekrar denenebilir',
        flowNote: 'Kararı platform ekibi verir. Ortalama süre iki iş günü. Reddedilen başvuru gerekçesiyle döner ve tekrar denenebilir.',
        kvkkTitle: 'KVKK notu',
        kvkkBody: 'Yüklenen belgeler yalnızca doğrulama amacıyla işlenir, üçüncü tarafla paylaşılmaz ve karardan {days} gün sonra silinir. Kurum sahibi silinmeyi erkene alabilir.',
        readOnlyNotice: 'Başvuruyu yalnızca kurum sahibi ve yöneticisi gönderebilir.',
        loadError: 'Doğrulama durumu yüklenemedi.',
        retry: 'Tekrar dene',
        submitting: 'Gönderiliyor…',
        submitted: 'Başvurun alındı.',
        withdrawTitle: 'Başvurudan vazgeçmek istersen',
        withdrawBody: 'Karar verilmeden başvurunu geri çekebilirsin. Kurum doğrulanmamış duruma döner ve formu istediğin zaman yeniden doldurabilirsin.',
        withdrawCta: 'Başvuruyu geri çek',
        withdrawing: 'Geri çekiliyor…',
        // KARARA BAĞLANMIŞ başvuruda geri çekme yoktur; kalan tek iş belgedir.
        documentOnlyTitle: 'Yüklediğin yetki belgesi',
        documentOnlyBody: 'Başvurun karara bağlandı. Geri çekilecek bir talep kalmadı. Yetki belgeni saklama süresi dolmadan da silebilirsin.',
        documentDeleteCta: 'Belgeyi şimdi sil',
        documentDeleting: 'Siliniyor…',
        documentDeleteHint: 'Saklama süresinin dolmasını beklemeden silebilirsin. Karar bekleyen başvuru, belge olmadan değerlendirilir.',
        documentDeleteHintDecided: 'Saklama süresinin dolmasını beklemeden silebilirsin. Karara bağlanmış başvuru bundan etkilenmez.',
        documentDeleted: 'Belge silindi.',
        actionError: 'İşlem tamamlanamadı. Tekrar dene.',
        // MOBİLDE DOSYA SEÇİCİ YOK, sunucu ise yetki belgesini ZORUNLU tutuyor.
        // Kullanıcı çalışmayan bir düğmeyle değil, çalışan bir yolla karşılaşır.
        requirementsTitle: 'Başvuru için üç şey gerekiyor',
        documentWebOnly: 'Yetki belgesi bir PDF dosyasıdır ve telefondan seçilemiyor. Başvurunu web sitesindeki kurum ayarlarından tamamlarsın. Durumunu buradan izlemeye devam edersin.',
        webCta: 'Başvuruyu web sitesinde tamamla',
        // Hesabın alan adı KENDİ satırıdır: ipucunun sonuna yapıştırılınca
        // "…olmalı. icebreaker.local" gibi okunuyordu (cihaz karesinde görüldü).
        accountDomainLine: 'Hesabının alan adı {domain}',
    },
    orgVerificationAdmin: {
        navLabel: 'Kurum doğrulama',
        title: 'Kurum doğrulama kuyruğu',
        lead: 'Her başvuruyu bir insan inceler ve gerekçeli bir kararla sonuçlandırır.',
        segOpen: 'Bekleyen',
        segDecided: 'Karara bağlanan',
        colOrganization: 'Kurum',
        colDomain: 'Alan adı',
        colSubmitted: 'Gönderim',
        colWaiting: 'Bekleme',
        colDocument: 'Belge',
        colActions: 'Karar',
        waitingHours: '{count} saat',
        documentView: 'Belgeyi aç',
        documentDownload: 'Belgeyi indir',
        documentPreparing: 'Bağlantı hazırlanıyor…',
        documentMissing: 'Belge yok',
        documentError: 'Belge bağlantısı üretilemedi.',
        approve: 'Doğrula',
        reject: 'Reddet',
        approveTitle: 'Kurumu doğrula',
        rejectTitle: 'Başvuruyu reddet',
        approveBody: '{name} doğrulanmış olarak işaretlenecek ve rozeti açılacak.',
        rejectBody: 'Gerekçe başvurana AYNEN gösterilir. Kurum beklemeden yeniden başvurabilir.',
        reasonLabel: 'Gerekçe',
        reasonHint: 'En az 10 karakter. Yazdığın gerekçe başvurana aynen gösterilir.',
        reasonRequired: 'Red için gerekçe zorunludur.',
        confirm: 'Kararı kaydet',
        cancel: 'Vazgeç',
        deciding: 'Kaydediliyor…',
        emptyTitle: 'Bekleyen başvuru yok',
        emptyBody: 'Yeni bir kurum doğrulama başvurusu geldiğinde burada listelenir.',
        emptyDecidedTitle: 'Karara bağlanmış başvuru yok',
        loadError: 'Kuyruk yüklenemedi.',
        decidedApproved: 'Doğrulandı',
        decidedRejected: 'Reddedildi',
        submittedBy: 'Gönderen: {name}',
        submittedByUnknown: 'Gönderen bilinmiyor',
        headline: '{count} başvuru',
        headline_one: '{count} başvuru',
        auditNote: 'Belge yalnızca doğrulama için işlenir, üçüncü tarafla paylaşılmaz ve karardan 90 gün sonra silinir. Her belge görüntüleme denetim kaydına yazılır.',
    },
    settingsNav: {
        heading: 'Ayarlar',
        ariaLabel: 'Ayar bölümleri',
        /** Ayar ekranının kendi okuması düştüğünde (KatilimciAyarlar* "Hata" hâli). */
        loadError: 'Yüklenemedi. Bağlantını kontrol edip tekrar dene.',
    },
    settingsAppearance: {
        title: 'Görünüm',
        /* Yeni görünüm 3f (KatilimciAyarlarGorunum): "Tema" bölümü, iki seçenekli dilimli denetim. */
        themeSection: 'Tema',
        themeLight: 'Açık',
        themeDark: 'Koyu',
        themeHint: 'Seçim yapmadığın sürece açık tema uygulanır. Elle seçtiğinde tercihin bu tarayıcıda saklanır.',
        followingSystem: 'Şu an işletim sistemi tercihin uygulanıyor.',
        languageLabel: 'Arayüz dili',
    },
    settingsPrivacy: {
        title: 'Gizlilik',
        listTitle: 'Katılımcı listesi',
        listBody: 'Bir etkinliğe kaydolduğunda adın, unvanın ve profil fotoğrafın o etkinliğin katılımcı listesinde görünür. Listeyi yalnız o etkinliğe kaydolanlar görür, iletişim bilgilerin listede hiçbir zaman yer almaz. Ayrı bir görünürlük ayarı yoktur. Listeden çıkmak için kaydını iptal edebilirsin.',
        toggleOn: 'Açık',
        toggleOff: 'Kapalı',
        changeFailed: 'Tercih kaydedilemedi. Lütfen tekrar dene.',
        // KÇ #15 (AUTH 249): görünürlük ekranının güvence bandı.
        assuranceBand: 'Kartvizitini yalnız çift taraflı onayla kart değiştirdiğin kişiler görür. Katılımcı listesinde adın, unvanın ve fotoğrafın yer alır, iletişim bilgilerin yer almaz.',
    },
    /**
     * BİLDİRİM MERKEZİ (kapsam belgesi · K2 — ekran TÜRETİLMİŞTİR).
     *
     * Satır metni KAYITTAN gelen i18n ANAHTARIYLA çözülür (`item.*`); kayıt
     * çevrilmiş metin taşımaz, dolayısıyla kullanıcı dilini değiştirdiğinde eski
     * bildirimler de yeni dilde okunur. `{actor}` silinmiş hesapta yer tutucuya
     * düşer (`actorDeleted`) — 'deleted' dizgesi ekrana SIZMAZ.
     */
    /**
     * GÖRELİ ZAMAN — `Intl.RelativeTimeFormat` KULLANILMAZ (Hermes sağlamıyor;
     * bildirim satırı emülatörde çöküyordu). Cümle sözlükten gelir.
     */
    time: {
        now: 'şimdi',
        minutesAgo: '{count} dk önce',
        minutesAgo_one: '{count} dk önce',
        hoursAgo: '{count} sa önce',
        hoursAgo_one: '{count} sa önce',
        daysAgo: '{count} gün önce',
        daysAgo_one: '{count} gün önce',
        weeksAgo: '{count} hafta önce',
        weeksAgo_one: '{count} hafta önce',
        monthsAgo: '{count} ay önce',
        monthsAgo_one: '{count} ay önce',
        yearsAgo: '{count} yıl önce',
        yearsAgo_one: '{count} yıl önce',
        /** Oturum saat aralığı (`formatSessionTimeRange`); kısa çizgi, boşluksuz. */
        range: '{start}–{end}',
    },
    notifications: {
        title: 'Bildirimler',
        kicker: 'Hesabın',
        bellLabel: 'Bildirimler',
        bellLabelWithCount: 'Bildirimler, {count} okunmamış',
        bellLabelWithCount_one: 'Bildirimler, {count} okunmamış',
        unreadBadge: '{count} okunmamış',
        unreadBadge_one: '{count} okunmamış',
        unreadDot: 'Okunmadı',
        menuTitle: 'Son bildirimler',
        seeAll: 'Tümünü gör',
        markAllRead: 'Tümünü okundu işaretle',
        loading: 'Bildirimler yükleniyor',
        error: 'Bildirimler getirilemedi.',
        retry: 'Tekrar dene',
        loadMore: 'Daha eski bildirimler',
        /** Liste içi grup başlığı (KatilimciBildirimler): son 24 saatten eski satırlar. */
        olderGroup: 'Daha önce',
        actorDeleted: 'Silinmiş kullanıcı',
        /** Kurum öznesi kaldırılmışsa (kurum takibi Story 4): satır nötr çizilir ve bir yere gitmez. */
        organizationRemoved: 'Kaldırılmış kurum',
        emptyTitle: 'Henüz bildirimin yok',
        emptyBody: 'Davetler, görüşme talepleri, başvuru sonuçları ve etkinlik güncellemeleri burada birikir. Kaçırdığın bir şey yok.',
        emptyStepDiscover: 'Bir etkinliğe kaydol',
        emptyStepDiscoverBody: 'Kaydolduğun etkinlikteki her değişiklik buraya düşer.',
        emptyStepVisibility: 'Katılımcılarla tanış',
        emptyStepVisibilityBody: 'Kaydolduğun etkinliğin katılımcı listesinde görünürsün ve görüşme talebi alabilirsin.',
        emptyStepPreferences: 'Kanal tercihlerini ayarla',
        emptyStepPreferencesBody: 'E-posta ve push tercihleri ayarlardadır. Bu liste her zaman dolar.',
        emptyCta: 'Etkinlikleri keşfet',
        emptyPreviewLabel: 'Bildirim satırı böyle görünür',
        item: {
            invitationTitle: 'Etkinlik daveti',
            invitationBody: '{actor} seni "{eventTitle}" etkinliğine davet etti.',
            invitationAcceptedTitle: 'Davetin kabul edildi',
            invitationAcceptedBody: '{actor}, "{eventTitle}" etkinliğine davetini kabul etti.',
            invitationDeclinedTitle: 'Davetin yanıtlandı',
            invitationDeclinedBody: '"{eventTitle}" için gönderdiğin bir davet reddedildi.',
            meetingRequestReceivedTitle: 'Yeni görüşme talebi',
            meetingRequestReceivedBody: '{actor}, "{eventTitle}" etkinliğinde seninle görüşmek istiyor.',
            meetingRequestAcceptedTitle: 'Görüşme talebin kabul edildi',
            meetingRequestAcceptedBody: '{actor} "{eventTitle}" etkinliğindeki talebini kabul etti.',
            meetingRequestDeclinedTitle: 'Görüşme talebin yanıtlandı',
            meetingRequestDeclinedBody: '"{eventTitle}" etkinliğindeki talebin bu kez gerçekleşmiyor.',
            meetingRequestCancelledTitle: 'Görüşme iptal edildi',
            meetingRequestCancelledBody: '{actor}, "{eventTitle}" etkinliğindeki görüşmeyi iptal etti.',
            meetingAreaAssignedTitle: 'Görüşmene yer atandı',
            meetingAreaAssignedBody: '{actor} ile "{eventTitle}" etkinliğindeki görüşmenin yeri ajandanda.',
            applicationApprovedTitle: 'Başvurun onaylandı',
            applicationApprovedBody: '"{eventTitle}" etkinliğine kaydın tamamlandı.',
            applicationRejectedTitle: 'Başvurun sonuçlandı',
            applicationRejectedBody: '"{eventTitle}" etkinliğine bu kez katılamıyorsun.',
            cardExchangeOfferedTitle: 'Kartvizit değişimi teklifi',
            cardExchangeOfferedBody: '{actor} kartını paylaşmak istiyor. Değişim çift taraflı onayla tamamlanır.',
            cardExchangeConfirmedTitle: 'Kartvizit değişimi tamamlandı',
            cardExchangeConfirmedBody: '{actor} artık cüzdanında.',
            eventUpdatedTitle: 'Etkinlik güncellendi',
            eventUpdatedBody: '"{eventTitle}" etkinliğinde bir değişiklik var.',
            eventCancelledTitle: 'Etkinlik iptal edildi',
            eventCancelledBody: '"{eventTitle}" iptal edildi. Kaydın geçmişinde kalır.',
            followUpReminderTitle: 'Takip hatırlatması',
            followUpReminderBody: '{actor} ile iletişime geçmeyi planlamıştın.',
            recommendationTitle: 'Sana uygun bir etkinlik',
            recommendationBody: '"{eventTitle}" ilgi alanlarınla örtüşüyor.',
            organizationEventPublishedTitle: 'Takip ettiğin kurumdan yeni etkinlik',
            organizationEventPublishedBody: '{actor} yeni bir etkinlik yayınladı: {eventTitle}',
            organizerAnnouncementTitle: '{subject}',
            organizerAnnouncementBody: '{actor} · {eventTitle}',
            postEventTitle: 'Katıldığın için teşekkürler',
            postEventCertificateAndSurveyBody: '"{eventTitle}" bitti. Katılım belgen ve kısa anket seni bekliyor.',
            postEventCertificateBody: '"{eventTitle}" bitti. Katılım belgen hazır.',
            postEventSurveyBody: '"{eventTitle}" bitti. Kısa anketle görüşünü iletebilirsin.',
            eventReminderTitle: 'Etkinlik hatırlatması',
            eventReminderPeopleBody: '"{eventTitle}" yaklaşıyor. Tanışman gereken kişilere bak.',
            eventReminderBody: '"{eventTitle}" yaklaşıyor. Saat ve yer etkinlik sayfasında.',
        },
        /**
         * ALICININ DUYURU TAM METNİ (organizatör duyuruları T4a, tasarım kare 8).
         * Kapatma eylemi kurum bazlıdır (kullanıcı kararı K2, 22.10.2026).
         */
        announcement: {
            pageTitle: 'Duyuru',
            back: 'Bildirimlere dön',
            meta: '{date} · {kind}',
            viewEvent: 'Etkinliği gör',
            muteOrganization: 'Bu kurumdan duyuru alma',
            muting: 'Kapatılıyor…',
            mutedNote: '{orgName} duyuruları sana artık gelmeyecek.',
            unmute: 'Yeniden aç',
            unmuting: 'Açılıyor…',
            actionFailed: 'İşlem tamamlanamadı. Yeniden dene.',
            loading: 'Duyuru yükleniyor',
            loadErrorTitle: 'Duyuru yüklenemedi',
            loadErrorBody: 'Bağlantını kontrol edip yeniden dene.',
            retry: 'Yeniden dene',
            notFoundTitle: 'Bu duyuru bulunamadı',
            notFoundBody: 'Duyuru kaldırılmış olabilir ya da bu bağlantı senin hesabına ait değil.',
            organizationRemoved: 'Kaldırılmış kurum',
        },
        /**
         * TEK TIK RET SONUÇ SAYFASI (organizatör duyuruları Story 2, tasarım kare 10).
         * Oturumsuz açılır; kurum adı kişisel veri değildir ve cümlede ek almadan geçer.
         */
        unsubscribe: {
            pageTitle: 'Duyuru tercihi',
            processing: 'Bağlantı doğrulanıyor',
            appliedTitle: 'Bu kurumdan duyuru almayacaksın',
            appliedBody: '{orgName} duyuruları sana artık gelmeyecek. İstersen Ayarlar › Bildirimler’den yeniden açabilirsin.',
            undo: 'Geri al',
            undoing: 'Geri alınıyor…',
            undoneTitle: 'Duyurular yeniden açıldı',
            undoneBody: '{orgName} duyuruları sana yeniden gelecek.',
            browseEvents: 'Etkinliklere göz at',
            invalidTitle: 'Bu bağlantı artık geçerli değil',
            invalidBody: 'Duyuruları kapatmak için giriş yapıp Ayarlar › Bildirimler’e gidebilirsin.',
            signIn: 'Giriş yap',
            failedTitle: 'İşlem tamamlanamadı',
            failedBody: 'Bağlantını kontrol edip yeniden dene.',
            retry: 'Yeniden dene',
            undoUnavailable: 'Bu ret artık bu bağlantıdan geri alınamaz. Duyuruları yeniden açmak için giriş yapıp ayarlara gidebilirsin.',
            undoFailed: 'Geri alma tamamlanamadı. Bağlantını kontrol edip yeniden dene.',
            settingsLink: 'Ayarlar › Bildirimler',
            mandatoryNote: 'Etkinlik saatinin ya da yerinin değişmesi gibi zorunlu bilgiler kayıtlı olduğun etkinlik için gelmeye devam eder.',
        },
    },
    settingsNotifications: {
        title: 'Bildirimler',
        channelEmail: 'E-posta',
        channelPush: 'Push',
        lockedHint: 'Hesabının işleyişi için gereken bildirimler (davet, başvuru sonucu e-postası, görüşme talebi) kapatılamaz. Görüşme talebi ALMAYI tamamen kapatmak istersen gizlilik ayarlarındaki anahtarı kullan.',
        /*
         * KURUM HESABI KATILIMCI DEĞİLDİR (02.10 kararı · sıra 55a): başvuru
         * sonucu, görüşme talebi ve kartvizit değişimi bu hesaba gelmez, gizlilik
         * anahtarı da yoktur. DAVET GELİR (tech-lead): daveti gönderen kurum
         * hesabı kabul ve ret kaydını alır (`notifyInviterOfDecision`). Kayıt
         * uygulama içidir ve tercihe bakmaz, e-posta/push kanalı yoktur: satır
         * çizilmez ama cümle davetin gelmediğini SÖYLEMEZ.
         */
        lockedHintOrganization: 'Kurum hesabı etkinliklere katılımcı olarak katılmadığı için başvuru sonucu, görüşme talebi ve kartvizit değişimi bildirimleri bu hesapta yer almaz. Gönderdiğin davetlerin kabul ve ret haberleri uygulama içinde her zaman görünür, doğrulama kodu gibi hesabının işleyişi için gereken e-postalar da her zaman gönderilir.',
        /* Organizatöre "siz" (marka ruhu 28.10, yeni görünüm K2): web kurum hesabının kilit cümlesi; mobil ortak anahtarı okur. */
        lockedHintOrganizationSite: 'Kurum hesabı etkinliklere katılımcı olarak katılmadığı için başvuru sonucu, görüşme talebi ve kartvizit değişimi bildirimleri bu hesapta yer almaz. Gönderdiğiniz davetlerin kabul ve ret haberleri uygulama içinde her zaman görünür, doğrulama kodu gibi hesabınızın işleyişi için gereken e-postalar da her zaman gönderilir.',
        /*
         * SATIR ROZETİ KISADIR (mobil elle test · bulgu 9). Uzun gerekçe ekranın
         * ÜSTÜNDE bir kez yazılır; her kilitli satırın altına aynen basılınca
         * 28 kelimelik paragraf ekranda yedi kez tekrarlanıyordu.
         */
        lockedRowHint: 'Kapatılamaz',
        /* Yeni görünüm 3f (KatilimciAyarlarBildirimler): tür sütunu başlığı ve boş hâl. */
        colType: 'Bildirim türü',
        emptyTitle: 'Bildirim ayarı yüklenemedi',
        emptyBody: 'Tüm bildirimler varsayılan ayarda.',
        typeEventUpdate: 'Etkinlik güncellemeleri',
        typeInvitation: 'Davetler',
        typeApplicationResult: 'Başvuru sonuçları',
        typeProductNews: 'Ürün duyuruları',
        typeMeetingRequest: 'Görüşme talepleri',
        typeCardExchange: 'Kartvizit değişimi',
        typeFollowUpReminder: 'Takip hatırlatmaları',
        typeRecommendation: 'Etkinlik önerileri',
        typeFollowedOrganizationEvent: 'Takip ettiğin kurumların yeni etkinlikleri',
        typeOrganizerAnnouncement: 'Organizatör duyuruları',
        typeEventReminder: 'Etkinlik hatırlatmaları',
        followedOrganizationsHint: 'Takip ettiğin bir kurum yeni etkinlik yayınladığında haber veririz.',
        followedOrganizationsOn: 'Açık. Bildirim uygulama içinde ve telefon bildirimi olarak gelir.',
        followedOrganizationsOff: 'Kapalı. Takip ettiğin kurumlar listende kalır, yeni etkinlik bildirimi gelmez.',
        saved: 'Tercihlerin kaydedildi.',
        saving: 'Kaydediliyor…',
        saveFailed: 'Tercih kaydedilemedi. Lütfen tekrar dene.',
        /* Organizatör duyuruları (tasarım kare 9): satır açıklaması ve kurum bazlı kapatma listesi. */
        organizerAnnouncementHint: 'Kayıtlı olduğun etkinliklerin organizatörlerinden gelen bilgilendirmeler. Tanıtım içermez.',
        /* Belge ve anket Story 6: etkinlik sonrası iletisi bu türdedir. */
        eventReminderHint: 'Kayıtlı olduğun etkinlikten bir gün önce hatırlatma, katıldığın etkinlik bitince katılım belgesi ve anket bağlantısı.',
        mutedOrganizationsTitle: 'Kapatılan kurumlar',
        mutedOrganizationsHint: 'Bu kurumların duyuruları sana hiçbir kanaldan gelmez.',
        mutedOrganizationsError: 'Kapatılan kurumlar yüklenemedi.',
        mutedOrganizationsRetry: 'Yeniden dene',
        reopen: 'Yeniden aç',
        reopening: 'Açılıyor…',
        reopenAria: '{orgName} duyurularını yeniden aç',
        reopenFailed: 'Kurumun duyuruları yeniden açılamadı. Yeniden dene.',
    },
    settingsData: {
        title: 'Verin ve hesabın',
        otpLabel: 'E-postana gönderilen doğrulama kodu',
        otpSend: 'Kod gönder',
        otpSent: 'Kod e-postana gönderildi.',
        /** {email} oturumdaki adrestir. Adres okunamazsa `otpSent` çizilir. */
        otpSentTo: 'Kodu {email} adresine gönderdik.',
        /** Kod istenmeden alan ve talep düğmesi kapalıdır (B-22): alan e-posta onayı sanılıyordu. */
        otpSendFirst: 'Önce Kod gönder düğmesine bas. Ardından e-postana gelen 6 haneli kodu buraya yaz.',
        exportTitle: 'KVKK veri kopyam',
        exportHint: 'Hesabına ait bütün kişisel verilerin yasal kopyası. ZIP dosyasında her bölüm için Excel ile açılan bir tablo, kısa bir özet ve makine okunur JSON bulunur. Verin rehin alınmaz.',
        orgExportHint: 'Kendi hesap verinin yasal kopyası. ZIP dosyasında profilin, kurum üyeliklerin ve rıza kayıtların bölüm bölüm tablo olarak, kısa bir özet ve makine okunur JSON ile bulunur. Kurumun katılımcı verisi bu dosyada yoktur.',
        walletExportPointer: 'Tanıştığın kişileri telefon rehberine ya da Excel’e aktarmak için Cüzdan ekranındaki Kişilerimi dışa aktar düğmesini kullan.',
        attendeeExportPointer: 'Düzenlediğin bir etkinliğin katılımcı listesi Etkinlik yönetimi › Kayıtlar ekranındaki Katılımcı listesini indir düğmesiyle alınır.',
        exportCta: 'Dışa aktarma talebi oluştur',
        exportStatusQueued: 'Sırada',
        exportStatusProcessing: 'Hazırlanıyor…',
        exportStatusReady: 'Hazır',
        exportStatusFailed: 'Başarısız oldu',
        exportStatusExpired: 'Süresi doldu',
        exportExpiresAt: 'Bağlantı {time} tarihine kadar geçerli',
        downloadJson: 'JSON indir',
        downloadZip: 'Veri kopyasını indir (ZIP)',
        downloadVcard: 'vCard indir',
        downloadOnceHint: 'Her biçim bir kez indirilebilir. Bağlantı sürelidir.',
        /** KatilimciAyarlarVeri "Boş" hâli: hesabın hiç dışa aktarma talebi yok. */
        exportsEmptyTitle: 'Talep yok',
        exportsEmptyBody: 'Oluşturduğun dışa aktarma talepleri burada görünür.',
        /** KatilimciAyarlarVeri "Cüzdan ve kayıtlar" bölümü (yalnız kişisel hesap). */
        walletSectionTitle: 'Cüzdan ve kayıtlar',
        walletCta: 'Cüzdana git',
        deletionTitle: 'Hesabı sil',
        deletionHint: 'Hesabın ve kişisel verilerin kalıcı olarak silinir. 14 gün içinde giriş yapıp iptal edebilirsin. Rıza ve denetim kayıtları yasal zorunluluk gereği kimliksizleştirilerek saklanır. Karşılıklı onayla paylaştığın kartlar karşı tarafta kalabilir.',
        orgDeletionHint: 'Hesabın ve kişisel verilerin kalıcı olarak silinir. 14 gün içinde giriş yapıp iptal edebilirsin. Rıza ve denetim kayıtları yasal zorunluluk gereği kimliksizleştirilerek saklanır. Kurum adına yaptığın işlemlerin kayıtları kurumda kalır, adın bu kayıtlardan kaldırılır.',
        deletionDownloadFirst: 'Silmeden önce verini indirmeni öneririz.',
        deletionCta: 'Hesabımı sil',
        deletionPending: 'Hesabın {date} tarihinde kalıcı olarak silinecek.',
        deletionCancelCta: 'Silme talebini geri al',
        deletionCancelled: 'Silme talebin iptal edildi.',
        deletionBlockedSoleOwner: 'Tek sahibi olduğun kurumun aktif etkinliği var. Önce sahipliği devret veya etkinliği iptal et.',
        rateLimitedHours: 'Çok fazla deneme yaptın. En geç {count} saat sonra tekrar deneyebilirsin.',
        rateLimitedHours_one: 'Çok fazla deneme yaptın. En geç {count} saat sonra tekrar deneyebilirsin.',
        /** Yeniden gönderme beklemesi (sıra 113): kullanıcı çok deneme yapmadı, yalnız bekliyor. */
        resendWait: 'Yeni kodu {count} saniye sonra isteyebilirsin.',
        resendWait_one: 'Yeni kodu {count} saniye sonra isteyebilirsin.',
    },
    accountDeletion: {
        title: 'Hesabımı sil',
        deleting: 'Siliniyor…',
        warnTitle: 'Bu işlem {count} gün sonra geri alınamaz.',
        warnTitle_one: 'Bu işlem {count} gün sonra geri alınamaz.',
        warnBody: 'Talebi gönderdiğinde hesabın hemen askıya alınır. {count} gün içinde giriş yapıp talebi geri alabilirsin.',
        warnBody_one: 'Talebi gönderdiğinde hesabın hemen askıya alınır. {count} gün içinde giriş yapıp talebi geri alabilirsin.',
        deletedTitle: 'Silinir',
        deletedItem1: 'Adın soyadın, e-postan, şifren',
        deletedItem2: 'Kartvizitlerindeki telefon, unvan, kurum, eğitim ve sosyal medya adreslerin',
        deletedItem3: 'Kişi notların ve görüşme mesajların',
        deletedItem4: 'Cüzdanındaki kartlar',
        anonymizedTitle: 'Anonimleşir',
        anonymizedItem1: 'Etkinlik katılım sayıların',
        anonymizedItem2: 'Karşılaşma istatistiklerin',
        keptTitle: 'Kalır',
        keptItem1: 'Rıza kayıtların. KVKK ispat yükümlülüğü gereği kimliksizleştirilerek saklanır.',
        keptItem2: 'Güvenlik kayıtların. 5651 sayılı Kanun iki yıl saklamayı zorunlu kılar.',
        exportTitle: 'Önce verini indir',
        exportBody: 'Kartvizitlerin ve karşılaşmaların CSV ve vCard olarak iner.',
        exportCta: 'İndir',
        ackLabel: 'Verilerimin {count} gün sonra kalıcı olarak sileneceğini anladım.',
        ackLabel_one: 'Verilerimin {count} gün sonra kalıcı olarak sileneceğini anladım.',
        confirmSectionTitle: 'Silmeyi onayla',
        otpIntro: 'Hesabını silmek için e-postana gönderilen kodu gir. Böylece çalınmış bir oturumla hesabın silinemez.',
        pendingTitle: 'Silme talebin bekliyor',
        pendingBody: 'Hesabın {date} tarihinde kalıcı olarak silinecek. O tarihe kadar talebi geri alabilirsin.',
        pendingRestore: 'Talebi geri aldığında hesabın olduğu gibi geri döner.',
        openFromSettings: 'Hesabımı sil',
        openHint: 'Neyin silineceğini, neyin anonimleşeceğini ve neyin kalacağını okuyup karar verirsin.',
    },
    registerConsent: {
        step: 'Onaylar',
        title: 'Onayların',
        lead: 'Hepsini tek kutuda toplamadık. Zorunlu ve isteğe bağlı onaylar ayrı durur, ayrı kaydedilir.',
        requiredGroup: 'Devam etmek için gerekli',
        optionalGroup: 'İsteğe bağlı, reddetsen de hesabın açılır',
        note: 'Her onay, metnin sürümü ve tarihiyle birlikte kaydedilir. İstediğin zaman Ayarlar içindeki Rızalarım ekranından değiştirebilirsin.',
        cta: 'Hesabı oluştur',
        requiredMissing: 'Devam etmek için zorunlu onayları işaretle.',
        progress: '{step}/{total}',
        back: 'Bilgileri düzelt',
    },
    publicEvent: {
        inviteOnlyTitle: 'Bu etkinlik davetlilere özeldir',
        inviteOnlyBody: 'Bu etkinliğe yalnız davetle katılınır. Davet aldıysan e-postandaki bağlantıyı aç. Davetin yoksa organizatöre ulaşabilirsin.',
        attendeeCount: '{count} kişi katılıyor',
        attendeeCount_one: '{count} kişi katılıyor',
        attendeesVisitorLocked: 'Kaydolduğunda kimlerin geleceğini görebilirsin.',
        attendeesTitle: 'Katılımcılar',
        heroAgendaCta: 'Programı gör',
        metaDateLabel: 'Tarih',
        metaVenueLabel: 'Yer',
        metaTicketsLabel: 'Bilet',
        metaOnlineValue: 'Çevrimiçi',
        ticketSummaryCount: '{count} bilet türü',
        ticketSummaryCount_one: '{count} bilet türü',
        ticketSummaryOpen: 'Kayıt açık',
        aboutTitle: 'Bu etkinlik hakkında',
        aboutWebsite: 'Web sitesi',
        similarTitle: 'Benzer etkinlikler',
        similarBody: 'Katılım geçmişin arttıkça buradaki öneriler kişiselleşir.',
        similarDiscoverCta: 'Etkinlikleri keşfet',
        sponsorsTitle: 'Sponsorlar',
        sponsorsEmpty: 'Bu etkinliğin sponsorları henüz duyurulmadı.',
        sponsorsPrivacyNote: 'Katılımcı verisi sponsorlarla paylaşılmaz.',
        attendeesListNote: 'Listede etkinliğe kaydolan herkes yer alır ve listeyi yalnız kaydolanlar görür. İletişim bilgileri listede yer almaz.',
        /*
         * KIRMIZI ÇİZGİ METİNLERİ — denetim kalemleri E8-E12.
         * Referans: `ACC` 327 / 336 (kilitli sayfa) · `ACC` 396 / 404 (onaylı mod) ·
         * `PUB` 174-187 (konum ve ulaşım) · `Akış A` 157 (konuşmacı alt notu).
         */
        limitedNoindexNote: 'Bu sayfa arama motorlarına kapalıdır (noindex) ve etkinlik keşif listelerinde görünmez.',
        limitedBasicsNote: 'Yalnızca etkinlik adı, tarihi ve organizatörü gösterilir. Katılımcı sayısı da saklanır.',
        approvalListNote: 'Katılımcı listesi başvurun onaylandıktan sonra açılır. Sayfa arama motorlarına açıktır.',
        // QA B-15: davetli başvurmaz; liste daveti kabul edince açılır.
        invitedListNote: 'Katılımcı listesi daveti kabul ettiğinde açılır.',
        approvalDataNote: 'Başvuruda profil bilgilerin ve istersen kısa bir not gönderilir. Kartvizitin gönderilmez. Reddedilirse başvuru verileri {days} gün sonra silinir.',
        locationDirectionsTitle: 'Ulaşım',
        locationOnlineNote: 'Bu etkinlik çevrimiçi yapılır.',
        // G2: bağlantı yalnız katılımı kesinleşmiş kişiye ve organizatör ekibine görünür.
        onlineLinkLabel: 'Katılım bağlantısı',
        onlineLinkLocked: 'Katılım bağlantısı kaydın kesinleşince burada görünür.',
        onlineLinkOpen: 'Bağlantıyı aç',
        locationAddressMissing: 'Organizatör henüz açık adres girmedi. Adres eklendiğinde bu bölümde görünür.',
        speakersFootnote: 'Konuşmacı kartına tıkladığında o kişinin sayfası açılır. İletişim bilgisi gösterilmez, kartvizit değişimi her zaman çift taraflı onayla olur.',
        limitedHiddenTitle: 'Bu sayfada görünmeyenler',
        limitedHiddenIntro: 'Şu bölümler yalnızca davetli katılımcılara açılır:',
        tabGeneral: 'Genel',
        sectionNavLabel: 'Sayfa bölümleri',
        descriptionTitle: 'Etkinlik hakkında',
        dateTitle: 'Tarih ve saat',
        venueTitle: 'Konum',
        onlineTitle: 'Çevrimiçi etkinlik',
        organizerTitle: 'Organizatör',
        unverifiedBadge: 'Doğrulanmamış',
        founderCredit: 'Bu etkinliği platforma ekleyen: {name}',
        manageBarKicker: 'Senin yönetiminde',
        manageBarBody: 'Bu etkinliği yönetme yetkin var. Başvuruları, davetleri, katılımcıları, konuşmacıları ve ajandayı panelden düzenle.',
        manageBarCta: 'Yönetim paneli',
        remainingQuota: 'Son {count} kontenjan',
        remainingQuota_one: 'Son {count} kontenjan',
        unlimitedQuota: 'Sınırsız kontenjan',
        soldOut: 'Kontenjan doldu',
        cancelledNotice: 'Bu etkinlik iptal edildi.',
        /* QA 17B+17E P3-6: bitmiş etkinlikte "KAYDOL"/"Kontenjan doldu" yazılmaz. */
        endedKicker: 'Etkinlik sona erdi',
        endedTicketsValue: 'Kayıt kapandı',
        /* Blok 17B (bulgu D sınıfı): bitmiş etkinlikte yeni kayıt alınmaz. */
        endedNotice: 'Bu etkinlik sona erdi, yeni kayıt alınmıyor. Kayıtlıysan katılımın geçmiş etkinliklerinde görünür.',
        /* QA 17B+17E P2 sınıf taraması: bölüm okunamadığında "yok" YAZILMAZ. */
        sectionUnavailable: 'Bu bölüm şu anda yüklenemedi. Sayfayı yenileyip tekrar dene.',
        registerCta: 'Kaydol',
        applyCta: 'Başvur',
        signInToContinue: 'Devam etmek için giriş yap',
        manageCta: 'Katılımı yönet',
        posterTitle: 'Her etkinlik için ayrı uygulama indirme.',
        posterBody: 'Kaydol. Kimlerin geleceğini gör, görüşmeni önceden ayarla, tanıştığın kişileri kaybetme.',
        /* Yeni görünüm 2c: kayıt kartının başlığı katılım hâline göre. */
        registerCardApply: 'Başvuru',
        registerCardRegister: 'Kayıt',
        registerCardRegistered: 'Kaydın',
        registerCardEnded: 'Bilet',
        endedClosedBody: 'Etkinlik {date} tarihinde sona erdi.',
        similarCta: 'Benzer etkinlikleri gör',
    },
    participation: {
        statusRegistered: 'Bu etkinliğe kayıtlısın',
        statusPendingApproval: 'Başvurun organizatör onayı bekliyor',
        statusRejected: 'Başvurun onaylanmadı',
        statusCancelled: 'Kaydını iptal ettin',
        statusWaitlisted: 'Bekleme listesindesin',
        statusAttended: 'Bu etkinliğe katıldın',
        // --- Story 20.1: satır sonucu + geçmiş rozeti (referans `homeFull` e.result)
        outcomeEncounters: '{count} kişiyle tanıştın',
        outcomeEncounters_one: '{count} kişiyle tanıştın',
        outcomeMeetings: '{count} görüşme',
        outcomeMeetings_one: '{count} görüşme',
        outcomeNoCheckIn: 'Check-in yapılmadı',
        outcomeUnderReview: 'Başvuru değerlendiriliyor',
        // B-30: bekleyen davet satırının sonucu (referans "Davet 12 gün geçerli").
        invitationValidDays: 'Davet {count} gün geçerli',
        invitationValidDays_one: 'Davet {count} gün geçerli',
        invitationValidToday: 'Davet bugün sona eriyor',
        // Satır rozeti (108px hücre) — referans `myEvents[].badge` kısa etiketleri.
        rowBadgeRegistered: 'Onaylı',
        rowBadgePending: 'Beklemede',
        rowBadgeWaitlisted: 'Bekleme listesi',
        rowBadgeCancelled: 'İptal edildi',
        badgeAttended: 'Katıldın',
        badgeMissed: 'Katılmadın',
        // --- Manuel test 2 · bulgu 3: eylem düğmesi kullanıcının DURUMUNU okur ---
        organizerNoticeTitle: 'Bu etkinliği sen yönetiyorsun',
        organizerNoticeBody: 'Organizatör kendi etkinliğine başvurmaz. Kayıtları, başvuruları ve programı yönetim panelinden yürütürsün.',
        organizerNoticeCta: 'Yönetim paneline git',
        ticketLabel: 'Bilet türü',
        applicationNoteLabel: 'Başvuru notu (isteğe bağlı, en fazla {limit} karakter)',
        registerSuccess: 'Kaydın tamamlandı.',
        applySuccess: 'Başvurun alındı. Sonuç e-postana gelecek.',
        cancelCta: 'Kaydı iptal et',
        cancelConfirm: 'Kaydın iptal edilecek ve yerin başkasına açılacak. Emin misin?',
        cancelConfirmCta: 'Kaydı iptal et',
        cancelling: 'Kayıt iptal ediliyor…',
        cancelSuccess: 'Kaydın iptal edildi.',
        inviteOnlyRejoinHint: 'Bu etkinliğe yeniden katılmak için organizatörün yeni daveti gerekir.',
        // --- Ekran G6: başvuru sonucu (red) ---
        rejectedKicker: 'Başvurun onaylanmadı',
        rejectedTitle: 'Bu etkinliğe katılamıyorsun',
        rejectedBody: 'Organizatör kontenjan ya da profil gibi bir nedenle onay vermemiş olabilir. Gerekçe paylaşılmaz.',
        rejectedRetention: 'Profilin ve notun organizatörde {days} gün saklanır, sonra silinir. Bu süreçte kartvizitin hiç paylaşılmadı.',
        alternativesTitle: 'Benzer etkinlikler',
        alternativesEmpty: 'Şimdilik benzer bir etkinlik yok. Keşiften tüm etkinliklere göz atabilirsin.',
        alternativesCta: 'Etkinlikleri keşfet',
        // ACC 4.4 bölüm 3 — gönderilecek profil kartı (sonu KÇ #26).
        applyProfileTitle: 'Organizatöre gönderilecek bilgiler',
        applyProfileNote: 'Profilindeki bu bilgiler organizatöre gönderilir. Kartvizitin gönderilmez.',
        // ACC 4.4 bölüm 5 — onay kutusu. Üründe KAPATILAMAZ: onaylanan kayıt ajandaya girer.
        applyAgendaLabel: 'Onaylanırsam ajandama otomatik eklensin',
        /* D-5: kilitli anahtarın yerine geçen DURUM etiketi — karar zaten alınmıştır. */
        applyAgendaState: 'Her zaman açık',
        applyAgendaLocked: 'Bu seçenek hep açık. Başvurun onaylanınca kaydın oluşur, etkinlik ajandana eklenir.',
        // ACC 4.5 — beklemede ekranı.
        pendingKicker: 'Başvurun iletildi',
        pendingTitle: 'Organizatör yanıtı bekleniyor',
        pendingBody: 'Organizatör başvuruları tek tek değerlendirir. Sonuç bildirim ve e-posta ile gelir.',
        pendingBandLabel: 'Beklemede',
        pendingStepSubmitted: 'Başvuru gönderildi',
        pendingStepReview: 'Değerlendirme',
        pendingStepReviewBody: 'Organizatör başvurunu okuyor.',
        pendingStepRegistered: 'Kayıt oluşur',
        pendingStepRegisteredBody: 'Onaylanırsa biletin ve karekodun açılır.',
        pendingLimitNote: 'Başvuru beklemedeyken katılımcı listesi ve ajanda açılmaz. Yalnızca etkinliğin genel bilgileri görünür.',
        // ACC 4.6 — kabul sonucu (bölüm 3 KÇ #28).
        approvedKicker: 'Başvurun onaylandı',
        /*
         * KÇ #2 (görsel yeniden denetim Y-3): poster "Katılımcı listesindesiniz"
         * diyordu, 400px altındaki `approvedVisibilityReminder` ise "Görünürlüğünüz
         * hâlâ kapalı". Aynı ekran kırmızı çizgiyi hem anlatıp hem yalanlıyordu.
         * Poster artık KAYIT olgusunu söyler — referansın kendi kardeş ekranındaki
         * (`ACC` 108, davet kabulü) sözcük: "Kaydınız oluştu". Görünürlük satırı
         * aynen kalır; çelişki posterdeydi.
         *
         * İKİNCİ GELİŞ (mobil test 23.09 · M2-01): poster düzelmişti ama
         * `approvedVisibilityReminder` kutusu koşulsuz çiziliyordu ve görünürlüğü
         * AÇIK kullanıcıya da "hâlâ kapalı" diyordu. Metin değil KOŞUL düzeltildi:
         * kutu yalnız görünürlük kapalıyken çizilir (`ApplicationApprovedView`).
         */
        approvedPoster: 'Kaydın oluştu',
        approvedTicketNote: 'Biletin ve karekodun hazır. Ajanda ve katılımcı listesi açıldı.',
    },
    // --- Ekran 28b: yaka kartı / bilet QR kodu (check-in girdisi) ---
    badge: {
        openCta: 'Bilet karekodumu göster',
        title: 'Yaka kartın',
        kicker: 'Girişte okutulur',
        hint: 'Girişte görevliye okut. Kod yalnızca bu etkinlik için geçerlidir.',
        ticketLabel: 'Bilet',
        brightnessHint: 'Ekran parlaklığını yükseltmek okumayı hızlandırır.',
        offlineNote: 'Kod cihazına kaydedildi. Kapıda internet olmasa da görünür.',
        cachedNote: 'Çevrimdışısın. Kayıtlı kodun gösteriliyor.',
        checkedInLabel: 'Giriş',
        checkedInAt: '{time}',
        loading: 'Yaka kartın hazırlanıyor',
        errorTitle: 'Yaka kartı açılamadı',
        errorBody: 'Kod alınamadı. Bağlantını kontrol edip tekrar dene. Kapıda görevli seni isimle de bulabilir.',
        retryCta: 'Tekrar dene',
        screenTitle: 'Yaka kartı',
        dialogTitle: 'Biletin',
        eventLabel: 'Etkinlik',
    },
    invitations: {
        pageTitle: 'Etkinlik daveti',
        invitedBy: '{name} seni davet etti',
        expiresAt: 'Davet {time} tarihine kadar geçerli',
        acceptCta: 'Daveti kabul et',
        acceptFull: 'Etkinlik doldu, kayıt alınmıyor. Davetin geçerli kalır, yer açılırsa yeniden deneyebilirsin.',
        declineCta: 'Reddet',
        acceptedNotice: 'Daveti kabul ettin. Etkinlikte görüşmek üzere!',
        declinedNotice: 'Daveti reddettin. Sana tekrar hatırlatma gönderilmeyecek.',
        wrongAccountTitle: 'Bu davet başka bir e-posta adresine gönderildi',
        wrongAccountBody: 'Daveti kabul etmek için davetin gönderildiği e-posta adresiyle giriş yapmalısın. Davetler devredilemez.',
        switchAccountCta: 'Doğru hesapla giriş yap',
        invalidTitle: 'Davet geçerli değil',
        invalidBody: 'Bağlantının süresi dolmuş, davet iptal edilmiş veya daha önce kullanılmış olabilir. Organizatörle iletişime geçebilirsin.',
        // --- Blok 8-2 (G3): geçersizlik nedenleri AYRI ekranlar ---
        unusableKicker: 'Davet kullanılamıyor',
        expiredTitle: 'Bu davetin süresi dolmuş',
        expiredBody: 'Bu davet bağlantısının süresi doldu. Etkinlik yine de yapılacak olabilir, organizatörden yeni bir davet isteyebilirsin.',
        expiredScopeNote: 'Bağlantı geçersiz olduğu için etkinliğin ajandası, konuşmacıları ve katılımcı listesi görünmüyor.',
        revokedTitle: 'Bu davet iptal edilmiş',
        revokedBody: 'Organizatör bu daveti geri çekti. Yeni bir davet gönderilmesini isteyebilirsin.',
        alreadyUsedTitle: 'Bu davet daha önce kullanılmış',
        alreadyUsedBody: 'Davet bir kez kabul ya da reddedilince bağlantı yeniden açılmaz. Kaydın varsa etkinliklerinde görürsün.',
        requestNewTitle: 'Yeni davet nasıl istenir',
        requestNewStep1: 'Daveti gönderen kişiye yaz',
        requestNewStep1Body: 'Davet bağlantısını sana ileten kişi yeni bir davet oluşturabilir.',
        requestNewStep2: 'Aynı e-posta adresini iste',
        requestNewStep2Body: 'Davetler devredilemez. Yeni davet de aynı adrese gönderilmelidir.',
        requestNewStep3: 'Diğer etkinliklere göz at',
        requestNewStep3Body: 'Herkese açık etkinliklere davet olmadan katılabilirsin.',
        discoverCta: 'Etkinlikleri keşfet',
        myEventsCta: 'Etkinliklerime bak',
        signInToAcceptCta: 'Kabul etmek için giriş yap',
        // B-15 (09.10): hesabı olmayan davetli için birincil yol. Kayıt kabul ETTİRMEZ,
        // kişi dönüşte "Daveti kabul et"e kendisi basar (kullanıcı kararı 13.10.2026).
        createAccountToAcceptCta: 'Kabul etmek için hesap oluştur',
        haveAccountSignInCta: 'Hesabın varsa giriş yap',
        goToEventCta: 'Etkinliğe git',
        // QA B-15: davetlinin hero çağrısı ("Başvur" yerinde), karar bloğuna götürür.
        respondCta: 'Daveti yanıtla',
        visibilitySeparateNote: 'Davet almak seni katılımcı listesine eklemez. Daveti kabul edince kaydın oluşur ve adın listede görünür. Listeyi yalnız kaydolanlar görür.',
        // B-15/B-16 birleşimi: kabul SONRASI not. Kabul kaydı oluşturur, kişi artık listededir.
        acceptedListNote: 'Kaydın oluştu, katılımcı listesinde görünüyorsun. Listeyi yalnız kaydolanlar görür. Listeden çıkmak için kaydını iptal edebilirsin.',
        // --- Blok 8-3 (G3): etkinlik künyesi + "yeni davet iste" ---
        briefTitle: 'Davet edildiğin etkinlik',
        briefOrganizer: 'Organizatör: {name}',
        briefExpired: 'Davet {time} tarihinde geçerliliğini yitirdi',
        requestNewCta: 'Yeni davet iste',
        requestNewSuccess: 'Talebin {name} organizatörüne iletildi. Yeni davet aynı e-posta adresine gönderilir.',
        requestNewAlready: 'Bu davet için talebin zaten iletildi. Organizatörün yanıtını bekle.',
        requestNewUnavailable: 'Bu davet için yeni talep gönderilemez.',
        // ACC 4.1 bölüm 4 — "Kabul ederseniz" listesi (üçüncüsü KÇ #22).
        acceptEffectsTitle: 'Kabul edersen',
        acceptEffect1: 'Etkinliğin ajandası, konuşmacıları ve katılımcı listesi açılır.',
        acceptEffect2: 'Karekodlu biletin oluşur. Girişte okutursun.',
        acceptEffect3: 'Kabul edince kaydın oluşur ve katılımcı listesinde görünürsün. Listeyi yalnız kaydolanlar görür.',
        // ACC 4.2 bölüm 1-2 — kabul posteri ve bilet kartı.
        acceptedKicker: 'Kaydın oluştu',
        acceptedPoster: 'Listede yerini aldın',
        acceptedTicketNote: 'Biletini girişte okut. Ajanda ve katılımcı listesi artık açık.',
        acceptedWhoIsComingCta: 'Kimler geliyor',
        // KÇ #25 (ACC 157) — "yeni davet iste" eyleminin gizlilik notu.
        requestNewPrivacyNote: 'Talebin organizatöre iletilir. E-posta adresin paylaşılır, kartvizitin paylaşılmaz.',
    },
    // --- Ekip daveti (K5): kurum ekibine katılma ---
    teamInvitations: {
        pageTitle: 'Ekip daveti',
        heading: '{organizationName} ekibine davet edildin',
        invitedBy: '{name} seni davet etti',
        roleLine: 'Rolün: {role}',
        expiresAt: 'Davet {time} tarihine kadar geçerli',
        acceptCta: 'Daveti kabul et',
        declineCta: 'Reddet',
        signInToAcceptCta: 'Kabul etmek için giriş yap',
        acceptedNotice: 'Ekibe katıldın. Kurumun etkinliklerini artık yönetebilirsin.',
        declinedNotice: 'Daveti reddettin. Kuruma erişimin olmayacak.',
        scopeNote: 'Kabul edersen yalnızca bu kurumun etkinliklerini rolünün izin verdiği ölçüde yönetirsin. Kişisel profilin ve cüzdanın etkilenmez.',
        wrongAccountTitle: 'Bu davet başka bir e-posta adresine gönderildi',
        wrongAccountBody: 'Daveti kabul etmek için davetin gönderildiği e-posta adresiyle giriş yapmalısın. Ekip davetleri devredilemez.',
        switchAccountCta: 'Doğru hesapla giriş yap',
        unusableKicker: 'Davet kullanılamıyor',
        invalidTitle: 'Davet geçerli değil',
        invalidBody: 'Bağlantının süresi dolmuş, davet geri çekilmiş veya daha önce kullanılmış olabilir. Seni davet eden kişiyle iletişime geçebilirsin.',
        expiredTitle: 'Bu davetin süresi dolmuş',
        expiredBody: 'Ekip davet bağlantıları sürelidir ve bu bağlantının süresi doldu. Kurum yöneticisi yeni bir davet gönderebilir.',
        roleOwner: 'Sahip',
        roleAdmin: 'Yönetici',
        roleEditor: 'Editör',
        roleViewer: 'Görüntüleyici',
        // F2A 23 — mobil kurum daveti kabulü (jeton yapıştırma yolu + kabul ekranı).
        mobileTitle: 'Kurum daveti',
        validBadge: 'Kurum daveti · {time} tarihine kadar geçerli',
        /*
         * WEB DAVET SAYFASI (yeni görünüm 2b, SiteEkipDaveti): organizatöre "siz"
         * (Y13). Gönderim tarihi ve davet edenin rolü künyede yok, yazılmaz.
         */
        landingTitle: 'Ekibe katılmaya davetlisiniz',
        landingInvitedBy: '{name} sizi {organizationName} ekibine {role} olarak davet etti.',
        landingInvitedByOrganization: '{organizationName} sizi ekibine {role} olarak davet etti.',
        landingRoleBox: '{role} olarak',
        landingValidity: '{date} tarihine kadar geçerli, tek kullanımlık.',
        errorExpiredTitle: 'Davetin süresi doldu',
        errorExpiredBody: 'Davet bağlantıları {count} gün geçerlidir. Sizi davet eden kişiden yeni davet isteyin.',
        errorExpiredBody_one: 'Davet bağlantıları {count} gün geçerlidir. Sizi davet eden kişiden yeni davet isteyin.',
        errorRevokedTitle: 'Bu davet iptal edildi',
        errorRevokedBody: 'Kurum bu daveti geri aldı. Bir yanlışlık olduğunu düşünüyorsanız kurum yöneticinize yazın.',
        errorInvalidTitle: 'Davet bulunamadı',
        errorInvalidBody: 'Bağlantı eksik kopyalanmış ya da daha önce kullanılmış olabilir. Bağlantıyı e-postadaki davetten yeniden açın.',
        errorLoadFailed: 'Davet yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.',
        tokenLabel: 'Davet bağlantısındaki kod',
        tokenHint: 'E-postandaki bağlantının sonundaki kodu yapıştır. Ekip davetleri devredilemez.',
        lookupCta: 'Daveti getir',
        rowInvitedBy: 'Davet eden',
        rowRole: 'Verilen rol',
        rowValidity: 'Geçerlilik',
        capabilitiesTitle: '{role} rolü ne yapabilir',
        capabilityEvents: 'Etkinlik açar ve düzenler',
        capabilityAttendees: 'Kayıt, davet ve başvuruları yönetir',
        capabilityOrganization: 'Kurum künyesini ve faturalandırmayı yönetir',
        capabilityGranted: 'Yetki var',
        capabilityDenied: 'Yetki yok',
        organizerVerified: 'Doğrulanmış kurum',
        acceptedCta: 'Etkinliklerime git',
    },
    /*
     * KURUM HESABI (K4 · TW1-TW5, TW7 · kullanıcı kararı 02.10.2026). Kurum işi
     * ayrı hesapla yapılır; bu metinler kurum hesabının kabuğu, ana sayfası,
     * katılımcı yüzeyi yönlendirmesi, davetle hesap açma ve ayarlarıdır.
     */
    orgAccount: {
        tag: 'Kurum hesabı',
        tagWithOrganization: 'Kurum hesabı · {organizationName}',
        navHome: 'Kurum ana sayfası',
        navEvents: 'Etkinlikler',
        navOrganizationSettings: 'Kurum ayarları',
        yourOrganizations: 'Kurumların',
        onlyOrganizations: 'Kurum hesabı yalnız kurumlar arasında geçer.',
        switcherLabel: 'Kurum: {organizationName}',
        verified: 'Doğrulanmış',
        selected: 'Seçili',
        signInPersonal: 'Kişisel hesabınızla giriş yapın',
        signInPersonalNote: 'Bu oturum kapanır, giriş sayfası açılır.',
        accountSettings: 'Hesap ayarları',
        signOut: 'Çıkış',
        loadingNav: 'Gezinme yükleniyor',
        accessPublic: 'Herkese açık',
        accessApproval: 'Başvurulu',
        accessInviteOnly: 'Yalnız davetli',
        eventTime: '{start}–{end} · {venue}',
        eventTimeNoVenue: '{start}–{end}',
        today: 'Bugün',
        noToday: 'Bugün etkinlik yok.',
        noTodayNext: 'Bugün etkinlik yok. Sıradaki etkinlik {title}, {date}.',
        createEventCta: 'Etkinlik aç',
        manageEventFor: 'Yönet: {title}',
        registeredCount: '{count} kayıtlı',
        registeredCount_one: '{count} kayıtlı',
        /*
         * TAKİPÇİ SAYISI (kurum takibi Story 7, 14.10.2026): yalnız SAYI. Kim
         * olduğu hiçbir yüzeyde gösterilmez. Metinler takipçi kutusu referansının
         * "Kararlar ve metinler" tablosundan; sayı büyük değer olarak ayrı
         * biçimlenir, `followerUnit` yalnız birimdir (kredi kartı `unitRemaining`).
         */
        followers: 'Takipçiler',
        followerUnit: 'takipçi',
        followerUnit_one: 'takipçi',
        followersHint: 'Yeni etkinlik yayınladığında bu kişilere haber veririz.',
        followersEmpty: 'Şu an takipçin yok. Etkinlik sayfanı paylaştıkça takipçin olur.',
        /* Organizatöre "siz" (marka ruhu 28.10): web kurum ana sayfası, KurumAnaSayfa kartının metni. */
        followersHintSite: 'Yeni etkinlik yayınladığınızda bu kişilere haber veririz.',
        followersEmptySite: 'Şu an takipçiniz yok. Etkinlik yayınladığınızda kurum sayfanızı takip edenler burada görünür.',
        followersLoadError: 'Takipçi sayısı şu an yüklenemedi.',
        checkedInCount: '{count} giriş',
        checkedInCount_one: '{count} giriş',
        upcoming: 'Yaklaşan etkinlikler',
        allEvents: 'Tümü',
        upcomingEmpty: 'Yaklaşan etkinlik yok.',
        drafts: 'Taslaklar',
        editedAgo: 'Son düzenleme {time}',
        edit: 'Düzenle',
        pendingApplications: 'Bekleyen başvurular',
        pendingApplicationCount: '{count} bekleyen başvuru',
        pendingApplicationCount_one: '{count} bekleyen başvuru',
        review: 'İncele',
        team: 'Ekip',
        manageTeam: 'Ekibi yönet',
        newTitle: 'Henüz etkinliğiniz yok',
        newBody: 'İlk etkinliğinizi açın. Taslaklar kredi harcamaz.',
        newCta: 'İlk etkinliğinizi oluşturun',
        /*
         * B-36: canlı etkinlik ve taslak yok ama GEÇMİŞ etkinlik var. "Henüz
         * etkinlik yok" bu kuruma yanlış olurdu (etkinliği bitmiş kurum, elle test
         * 09.10). Web ana sayfa ve mobil Etkinlikler sekmesi ortak kullanır.
         */
        pastOnlyTitle: 'Yaklaşan etkinliğin yok',
        pastOnlyBody: 'Yeni bir etkinlik oluşturduğunda yaklaşan etkinlikler, taslaklar ve başvurular burada görünür.',
        pastOnlyCta: 'Yeni etkinlik oluştur',
        pastOnlyTitleSite: 'Yaklaşan etkinliğiniz yok',
        pastOnlyBodySite: 'Yeni bir etkinlik açtığınızda yaklaşan etkinlikler, taslaklar ve başvurular burada görünür.',
        pastEventsLink: 'Geçmiş etkinlikler ({count})',
        /* TW2 ve TW7 hata hâllerinin tek düğme metni (referans `f.L.retry`). */
        retry: 'Yeniden dene',
        eventsLoadError: 'Etkinlikler okunamadı.',
        teamLoadError: 'Ekip okunamadı.',
        organizationLoadError: 'Kurum bilgisi okunamadı.',
        orphanTitle: 'Şu an bir kurumun ekibinde değilsin',
        orphanBody: 'Bu kurum hesabı yalnız kurum işi içindir. Bir kurumun daveti gelince yeniden kullanabilirsin. Etkinliklere katılmak için kişisel hesabını kullan.',
        pendingInvitations: 'Bekleyen ekip davetleri',
        accept: 'Kabul et',
        downloadData: 'Verimi indir',
        deleteAccount: 'Hesabı sil',
        noConvert: 'Bu hesap kişisel hesaba dönüşmez.',
        invitationsLoadError: 'Davetler okunamadı.',
        gateTitle: 'Bu sayfa kişisel hesaplar için',
        gateWanted: 'Açmak istediğiniz sayfa:',
        gateBody: 'Kartvizit, kart değişimi, görüşme talepleri ve cüzdan kişilere aittir. {organizationName} kurum hesabıyla bu sayfaları açamazsınız. Katılımcı olarak işlem yapmak için kişisel hesabınızla giriş yapın.',
        gateBodyNoOrganization: 'Kartvizit, kart değişimi, görüşme talepleri ve cüzdan kişilere aittir. Kurum hesabıyla bu sayfaları açamazsınız. Katılımcı olarak işlem yapmak için kişisel hesabınızla giriş yapın.',
        backHome: 'Kurum ana sayfasına dönün',
        gateAfter: 'Giriş yapınca {page} açılır.',
        pageWallet: 'Cüzdan',
        pageCardExchange: 'Kart değişimi',
        pageMeetingRequests: 'Görüşme talepleri',
        pageAgenda: 'Ajanda',
        pageDiscover: 'Etkinlik keşfi',
        pageAttendees: 'Katılımcı listesi',
        pageProfile: 'Kartvizit profili',
        pageParticipation: 'Katılımlarım',
        pageVisibility: 'Gizlilik ayarları',
        pageSpeakerLinks: 'Konuşmacı bağlantıları',
        pageOnboarding: 'Profil kurulumu',
        pageCardLink: 'Kartvizit bağlantısı',
        pageSurvey: 'Etkinlik anketi',
        blockRegion: 'Kayıt',
        blockJoinTitle: 'Kurum hesabıyla etkinliğe katılamazsın.',
        blockJoinBody: 'Katılmak için kişisel hesabınla giriş yap.',
        blockApplyTitle: 'Kurum hesabıyla başvuramazsın.',
        blockApplyBody: 'Başvurmak için kişisel hesabınla giriş yap.',
        blockOwnBody: 'Bu etkinlik {organizationName} kurumunun. Katılmak için kişisel hesabınla giriş yap.',
        manage: 'Yönet',
        viewAttendees: 'Katılımcıları gör',
        blockInviteTitle: 'Bu davete kurum hesabıyla katılamazsın.',
        blockInviteBody: 'Bu davet {email} adresine geldi ve bu bir kurum hesabı. Kişisel hesabınla katılmak için organizatörden kişisel adresine davet iste.',
        declineInvite: 'Daveti reddet',
        staleRegistration: 'Kayıt tamamlanmadı. Bu sekmede kurum hesabın açık.',
        teamInvite: 'Ekip daveti',
        validUntil: '{date} tarihine kadar geçerli',
        createTitle: 'Kurum hesabı oluştur',
        createNote: 'Bu hesap yalnız {organizationName} işini yönetmek içindir. Etkinliklere katılmak ve tanışmak için kişisel hesabını kullanırsın.',
        emailLabel: 'E-posta',
        emailHint: 'Davet bu adrese geldi. Değiştirilemez.',
        locked: 'Kilitli',
        nameLabel: 'Ad soyad',
        methodLabel: 'Giriş yöntemi',
        methodEmail: 'E-posta koduyla devam et',
        consentSentence: '{terms} ve {notice} okudum.',
        consentTerms: 'Kullanım koşullarını',
        consentNotice: 'kurum hesabı aydınlatma metnini',
        create: 'Kurum hesabı oluştur',
        creating: 'Oluşturuluyor…',
        codeTitle: 'E-postanı doğrula',
        codeBody: 'Kodu {email} adresine gönderdik. Kodu gir ve şifreni belirle.',
        codeLabel: 'Doğrulama kodu',
        passwordLabel: 'Şifre',
        confirmCreate: 'Hesabı oluştur',
        conflict: 'Bu adres kişisel bir hesapta kullanılıyor. Kurumundan başka bir iş adresine davet iste.',
        otherAddress: 'Bu davet {email} adresine geldi.',
        otherNowPersonal: 'Şu an {email} kişisel hesabındasın.',
        otherNowOrganization: 'Şu an {email} kurum hesabındasın.',
        otherCta: 'O adresle kurum hesabı oluştur',
        otherNote: 'Bu oturum kapanır, davet sayfası yeniden açılır.',
        expiredTitle: 'Bu davetin süresi doldu',
        expiredBody: 'Yeni davet için kurum yöneticine yaz.',
        revokedTitle: 'Bu davet iptal edildi',
        revokedBody: 'Kurum bu daveti geri aldı. Bir yanlışlık olduğunu düşünüyorsan yöneticine yaz.',
        invalidTitle: 'Bu davet bağlantısı geçersiz',
        invalidBody: 'Bağlantıyı e-postadaki davetten yeniden aç.',
        goHome: 'Ana sayfaya git',
        doneTitle: '{organizationName} ekibine katıldın',
        doneBody: 'Kurum ana sayfası açılıyor…',
        pendingOptionLine: '{organizationName} kurumundan bu adrese davet var.',
        pendingOptionLink: 'Kurum hesabı olarak devam et',
        pendingOptionBack: 'Kişisel hesap olarak devam et',
        pendingOptionNote: 'Kurum hesabı yalnız {organizationName} işini yönetmek içindir. Kişisel hesabın ayrı kalır.',
        // B-35: menüdeki "Hesap ayarları" ile aynı ad.
        settingsTitle: 'Hesap ayarları',
        /* Yeni görünüm 5b (KurumHesapAyarlari): web kurum hesabı ayarları organizatöre "siz" der. */
        settingsLeadSite: 'Kurum hesabınızın tercihleri ve verileri.',
        organizationNameLabel: 'Kurum adı',
        sectionProfile: 'Profil',
        sectionPreferences: 'Tercihler',
        sectionOrganizations: 'Kurumlarım',
        sectionData: 'Verim',
        sectionAccount: 'Hesap',
        sectionType: 'Hesap türü',
        workEmail: 'İş e-postası',
        emailNote: 'E-posta değiştirilemez.',
        identityNote: 'Kurum hesabı kurumun adı ve logosuyla görünür, ayrı profil fotoğrafı yoktur.',
        logoNoteLink: 'Kurum logosunu değiştir',
        saving: 'Kaydediliyor…',
        saved: 'Kaydedildi',
        nameRequired: 'Ad soyad gerekli.',
        settingsLoadError: 'Ayarlar okunamadı.',
        language: 'Dil',
        theme: 'Tema',
        timezone: 'Saat dilimi',
        themeLight: 'Açık',
        themeDark: 'Koyu',
        themeSystem: 'Sistem',
        leave: 'Kurumdan ayrıl',
        joinedOn: 'Katılma {date}',
        soloLeave: 'Tek sahipsin. Önce sahipliği devret.',
        soloLeaveSite: 'Tek sahipsiniz. Önce sahipliği devredin.',
        leaveTitle: 'Kurumdan ayrılıyor musun?',
        leaveTitleSite: 'Kurumdan ayrılıyor musunuz?',
        leaveBodySite: '{organizationName} kurumundaki yetkiniz hemen sona erer. Yeniden katılmak için yeni bir davet gerekir.',
        leaveBody: '{organizationName} kurumundaki yetkin hemen sona erer. Yeniden katılmak için yeni bir davet gerekir.',
        leaving: 'Kurumdan ayrılıyorsun…',
        dataNote: 'Kendi hesap verinin KVKK kopyasını ZIP olarak indirirsin. Kurumun katılımcı verisi bu dosyada yoktur, etkinliğin katılımcı listesi Kayıtlar ekranındaki Katılımcı listesini indir düğmesiyle alınır.',
        dataNoteSite: 'Kendi hesap verinizin KVKK kopyasını ZIP olarak indirirsiniz. Kurumun katılımcı verisi bu dosyada yoktur, etkinliğin katılımcı listesi Kayıtlar ekranındaki Katılımcı listesini indir düğmesiyle alınır.',
        consentRecords: 'Rıza kayıtlarım',
        notificationSettings: 'Bildirimler',
        soloDelete: 'Önce sahipliği devret.',
        soloDeleteSite: 'Önce sahipliği devredin.',
        deleteNoteSite: 'Silme adımı e-postanıza gelen kodla onaylanır.',
        transferOwnership: 'Sahipliği devret',
        transferOwnershipSite: 'Sahipliği devredin',
        typeNote: 'Bu bir kurum hesabıdır. Etkinliklere katılmak için kişisel hesabını kullan.',
        typeNoteSite: 'Bu bir kurum hesabıdır. Etkinliklere katılmak için kişisel hesabınızı kullanın.',
        backToSettings: 'Ayarlara dön',
    },
    manage: {
        title: 'Katılım yönetimi',
        // Blok 16: yükleme HATASINDA boş durum çizilmez, bu satır + "Tekrar dene" gelir.
        loadError: 'Yönetim verileri yüklenemedi.',
        tabApplications: 'Başvurular',
        tabInvitations: 'Davetler',
        tabAttendees: 'Katılımcılar',
        applicationsEmpty: 'Bekleyen başvuru yok',
        applicationsEmptyBody: 'Başvurular geldikçe burada listelenir.',
        approve: 'Onayla',
        reject: 'Reddet',
        approveSelected: 'Seçilenleri onayla ({count})',
        rejectSelected: 'Seçilenleri reddet ({count})',
        // Toplu karar onay penceresi (kullanıcı kararı 01.11.2026).
        bulkApproveTitle: '{count} başvuruyu onayla?',
        bulkApproveTitle_one: '{count} başvuruyu onayla?',
        bulkRejectTitle: '{count} başvuruyu reddet?',
        bulkRejectTitle_one: '{count} başvuruyu reddet?',
        decisionTicketLabel: 'Onay için bilet türü',
        contactHiddenNote: 'Başvuranın ve katılımcının iletişim bilgileri gizlidir. Yazışma platform üzerinden yürür.',
        rejectionNotSentNote: 'Ret gerekçesi başvurana iletilmez. Not yalnızca ekip içindir.',
        invitationsEmpty: 'Henüz davet göndermedin',
        invitationsEmptyBody: 'E-posta adreslerini girerek ilk davetini gönderebilirsin.',
        /*
         * DAVETLER — DENETİM KALEMİ E21 + KISMİ #10.
         * Referans `ORG` 479-488 (4 durum filtresi) · 526-535 (CSV yükleme + kural
         * notu) · 536-543 (kontenjan göstergesi + görünürlük notu).
         */
        inviteFilterAll: 'Tümü',
        inviteFilterAccepted: 'Kabul edenler',
        inviteFilterPending: 'Yanıt bekleyenler',
        inviteFilterClosed: 'Kapananlar',
        inviteFilterEmpty: 'Bu durumda davet yok.',
        inviteCsvCta: 'CSV yükle',
        inviteCsvRule: 'Dosyada e-posta kolonu zorunlu, ad ve şirket isteğe bağlı. En çok {limit} satır okunur ve aynı adres iki kez davet edilmez. Dosya sunucuya YÜKLENMEZ. Adresler tarayıcında okunup yukarıdaki alana yazılır, gönderimi sen onaylarsın.',
        inviteCsvLoaded: 'Dosyadan {count} adres alındı. Göndermeden önce listeyi gözden geçir.',
        inviteCsvLoaded_one: 'Dosyadan {count} adres alındı. Göndermeden önce listeyi gözden geçir.',
        inviteCsvEmpty: 'Dosyada geçerli e-posta adresi bulunamadı.',
        inviteQuotaTitle: 'Bilet kontenjanı',
        inviteQuotaRemaining: '{count} yer kaldı',
        inviteQuotaRemaining_one: '{count} yer kaldı',
        inviteQuotaFilled: '{total} kişilik kontenjanda {count} kayıt var.',
        inviteQuotaFilled_one: '{total} kişilik kontenjanda {count} kayıt var.',
        inviteQuotaUnlimited: 'Kontenjan sınırsız',
        inviteQuotaUncappedCeiling: 'Bir bilet türünün kontenjanı yok, kayıt etkinlik tavanında kapanır. {count} kayıt var.',
        inviteQuotaUncappedCeiling_one: 'Bir bilet türünün kontenjanı yok, kayıt etkinlik tavanında kapanır. {count} kayıt var.',
        inviteQuotaUncapped: 'Bir bilet türünün kontenjanı yok. {count} kayıt var.',
        inviteQuotaUncapped_one: 'Bir bilet türünün kontenjanı yok. {count} kayıt var.',
        inviteQuotaExplain: 'Gönderilen davetler yer tutmaz. Daveti kabul edip kaydolan kişi yer alır.',
        inviteCeiling: 'Etkinlik tavanı {count} katılımcı',
        inviteCeiling_one: 'Etkinlik tavanı {count} katılımcı',
        inviteCeilingNone: 'Etkinlik tavanı yok',
        inviteCeilingBinds: 'Bilet kontenjanı etkinlik tavanından büyük. Kayıt tavanda kapanır, en fazla {count} kişi kaydolabilir.',
        inviteCeilingBinds_one: 'Bilet kontenjanı etkinlik tavanından büyük. Kayıt tavanda kapanır, en fazla {count} kişi kaydolabilir.',
        inviteOverflowNote: 'Kalan yer {count}. Davetlerin hepsi gider, ilk kabul eden {count} kişi kaydolabilir.',
        inviteOverflowNote_one: 'Kalan yer {count}. Davetlerin hepsi gider, ilk kabul eden {count} kişi kaydolabilir.',
        inviteOverflowNoteFull: 'Kalan yer yok. Davetlerin hepsi gider ama yer açılmadıkça kimse kaydolamaz.',
        inviteQuotaAccepted: '{count} kabul',
        inviteQuotaAccepted_one: '{count} kabul',
        inviteQuotaUnset: 'Bilet kontenjanı belirlenmedi. Davet sayısı sınırsız.',
        inviteQuotaPartial: 'Kabul sayısı yalnızca yüklenen davetleri kapsar.',
        inviteVisibilityNote: 'Davet tek başına kimseyi katılımcı listesine yazmaz. Daveti kabul edip kaydolan kişi listede görünür. Listeyi yalnız kaydolanlar görür.',
        inviteEmailsLabel: 'E-posta adresleri (her satıra bir adres)',
        inviteTicketLabel: 'Davetin bağlanacağı bilet türü',
        inviteMessageLabel: 'Davet mesajı (opsiyonel)',
        sendInvites: 'Davetleri gönder',
        inviteParseReport: '{valid} geçerli · {invalid} geçersiz · {duplicate} tekrar eden',
        inviteSentReport: '{count} davet gönderildi.',
        inviteSentReport_one: '{count} davet gönderildi.',
        inviteSkippedReport: '{count} adres işlenmedi (zaten davetli veya kayıtlı).',
        inviteSkippedReport_one: '{count} adres işlenmedi (zaten davetli veya kayıtlı).',
        quotaWarning: 'Davet sayısı seçilen bilet türünün kalan kontenjanını aşıyor.',
        remainingQuota: 'Kalan kontenjan: {count}',
        resend: 'Yeniden gönder',
        revoke: 'İptal et',
        revokeConfirm: 'Davet iptal edilecek ve bağlantı geçersiz olacak. Emin misin?',
        revokeConfirmCta: 'Daveti geri al',
        invitationStatusSent: 'Gönderildi',
        invitationStatusOpened: 'Açıldı',
        invitationStatusAccepted: 'Kabul edildi',
        invitationStatusRejected: 'Reddedildi',
        invitationStatusExpired: 'Süresi doldu',
        invitationStatusRevoked: 'İptal edildi',
        attendeesEmpty: 'Henüz katılımcı yok.',
        removeAttendee: 'Katılımcıyı çıkar',
        removeAttendeeConfirmCta: 'Çıkar',
        removeConfirm: 'Katılımcı listeden çıkarılacak ve bilgilendirilecek. Emin misin?',
        changeTicket: 'Bilet türünü değiştir',
        filterStatusLabel: 'Durum',
        filterTicketLabel: 'Bilet türü',
        searchPlaceholder: 'İsim ara…',
        sourceLabel: 'Kaynak',
        kicker: 'Organizatör paneli',
        colPerson: 'Kişi',
        colNote: 'Başvuru notu',
        colStatus: 'Durum',
        colDate: 'Tarih',
        colActions: 'İşlemler',
        colEmail: 'E-posta',
        colSent: 'Gönderim',
        colExpires: 'Son geçerlilik',
        colTicket: 'Bilet',
        colCompany: 'Şirket',
        downloadAttendeesCta: 'Katılımcı listesini indir',
        sourceRegistration: 'Kayıt',
        sourceApplication: 'Başvuru',
        sourceInvitation: 'Davet',
        /*
         * Karar 2 (Story 17.4): etkinliği açanın otomatik kaydı LİSTELENİR ama
         * kontenjana ve "N kayıt" özetine SAYILMAZ. QA 17B+17E P3-3: satır
         * "Kaynak: Kayıt" göründüğü için özetle çelişiyordu — satır artık kendini
         * söylüyor ve liste altında dipnot var.
         */
        sourceOrganizerAuto: 'Organizatör (sayım dışı)',
        organizerAutoBadge: 'Organizatör',
        registrationSummary: '{count} kayıt · {remaining} kontenjan kaldı',
        registrationSummary_one: '{count} kayıt · {remaining} kontenjan kaldı',
        registrationSummaryNoCapacity: '{count} kayıt',
        registrationSummaryNoCapacity_one: '{count} kayıt',
        registrationOrganizerNote: 'Organizatörün kendi kaydı listede görünür. Bu kayıt, "kayıt" sayısına ve kontenjana dahil edilmez.',
        /*
         * YENİ GÖRÜNÜM 4c (PanelKayitlar, PanelDavetler, BasvurularEkrani), yalnız
         * web. Sayfa alt başlıkları ürünün gerçek davranışını söyler (kayıt onayı,
         * başvuru sonucu e-postası, davet bağlantısı); sayı içermeyen metinler.
         */
        registrationsIntro: 'Etkinliğe kaydı kesinleşen kişiler.',
        invitationsIntro: 'Davet edilen kişi e-postadaki bağlantıyla daveti kabul edip kaydolur.',
        applicationsIntro: 'Onaylanan kişi e-postayla bilgilendirilir ve katılımcı listesine girer.',
        statOccupancy: 'Doluluk',
        statRemaining: '{count} kontenjan kaldı',
        statRemaining_one: '{count} kontenjan kaldı',
        statPendingApplications: 'Bekleyen başvuru',
        statApprovedApplications: 'Onaylanan',
        statRejectedApplications: 'Reddedilen',
        invitationsSentSummary: '{count} davet gönderildi',
        invitationsSentSummary_one: '{count} davet gönderildi',
        inviteSendTitle: 'Davet gönder',
        inviteListTitle: 'Gönderilen davetler',
        noteEmpty: 'Not yok',
        pagerNavigation: 'Sayfalar',
        pagerPrevious: 'Önceki sayfa',
        pagerNext: 'Sonraki sayfa',
        pagerPage: 'Sayfa {page}',
        registrationsPagerInfo: '{count} satırın {from}-{to} arası gösteriliyor',
        registrationsPagerInfo_one: '{count} satırın {from}-{to} arası gösteriliyor',
        registrationsPagerInfoSplit: '{count} satırın ({registered} kayıtlı, {cancelled} iptal) {from}-{to} arası gösteriliyor',
        registrationsPagerInfoSplit_one: '{count} satırın ({registered} kayıtlı, {cancelled} iptal) {from}-{to} arası gösteriliyor',
        applicationsPagerInfo: '{count} başvurunun {from}-{to} arası gösteriliyor',
        applicationsPagerInfo_one: '{count} başvurunun {from}-{to} arası gösteriliyor',
        invitationsPagerInfo: '{count} davetin {from}-{to} arası gösteriliyor',
        invitationsPagerInfo_one: '{count} davetin {from}-{to} arası gösteriliyor',
        registrationsSearchEmpty: 'Aramayla eşleşen kayıt yok.',
        registrationsFilterEmpty: 'Bu durumda kayıt yok.',
        applicationsSelectedBar: '{count} başvuru seçildi',
        applicationsSelectedBar_one: '{count} başvuru seçildi',
        searchClear: 'Aramayı temizle',
        colRegisteredDate: 'Kayıt tarihi',
        noActions: 'İşlem yok',
        removeAttendeeConfirmWebCta: 'Katılımcıyı çıkar',
        /*
         * BÖLÜM İPUÇLARI (Tur T1) — `MANAGE_SECTIONS.hintKey`. Mobil hub satırı
         * adın altında bunu yazar; sayı İÇERMEZ (uydurma veri yok · md. 9), ne
         * yapıldığını söyler.
         */
        hintSetup: 'Temel bilgiler, erişim modu ve yayın',
        hintProgram: 'Oturumlar ve konuşmacılar',
        hintRegistrations: 'Katılımcı listesi ve kayıt işlemleri',
        hintInvitations: 'Davet gönderme, durum ve iptal',
        hintApplications: 'Karar bekleyen başvuru kuyruğu',
        hintAnnouncements: 'Katılımcılara bilgilendirme iletisi',
        hintTickets: 'Bilet türleri ve kontenjan',
        hintAreas: 'Görüşme alanları ve saat aralıkları',
        hintReport: 'Canlı kayıt takibi, sonuçlar ve PDF',
        hintSponsor: 'Stant karekodu ve lead raporu',
        hintBrand: 'Logo, kapak ve renk',
        hintPostEvent: 'Katılım belgesi ve etkinlik sonrası anket',
        hintBilling: 'Kredi, katılımcı sınırı ve kullanım',
        kpiPendingApplications: 'Bekleyen başvuru',
        kpiInvitationsSent: 'Gönderilen davet',
        kpiAttendees: 'Kayıtlı katılımcı',
        // Referans `appSummary` (satır 858): bekleyen · onaylı · red — LİSTEYLE aynı sorgudan.
        applicationSummary: '{pending} bekleyen · {approved} onaylı · {rejected} red',
        applicationStatusSubmitted: 'Bekliyor',
        applicationStatusApproved: 'Onaylandı',
        applicationStatusRejected: 'Reddedildi',
        applicationStatusWithdrawn: 'Geri çekildi',
        attendeeStatusPendingApproval: 'Onay bekliyor',
        attendeeStatusRegistered: 'Kayıtlı',
        attendeeStatusWaitlisted: 'Bekleme listesinde',
        attendeeStatusRejected: 'Reddedildi',
        attendeeStatusCancelled: 'İptal etti',
        attendeeStatusAttended: 'Katıldı',
        tabProgram: 'Konuşmacılar ve ajanda',
        inviteTicketDefault: 'Varsayılan tür',
        // --- Blok 8-3: toplu işlem şeridi (ekran 19) ---
        tabTickets: 'Biletler',
        tabAnalytics: 'Analitik',
        selectAll: 'Tümünü seç',
        selectRow: '{name} kaydını seç',
        selectedCount: '{count} kayıt seçili',
        selectedCount_one: '{count} kayıt seçili',
        clearSelection: 'Seçimi kaldır',
        bulkRemove: 'Seçilenleri çıkar',
        bulkChangeTicket: 'Bilet türünü değiştir',
        bulkReasonLabel: 'Gerekçe (denetim kaydına yazılır)',
        bulkReasonHint: 'Bu işlem geri alınamaz. Gerekçe zorunludur ve denetim kaydında saklanır.',
        bulkRemoveConfirm: '{count} kayıt iptal edilecek, katılımcılar bilgilendirilecek ve işlem denetim kaydına yazılacak. Bu işlem geri alınamaz.',
        bulkRemoveConfirm_one: '{count} kayıt iptal edilecek, katılımcılar bilgilendirilecek ve işlem denetim kaydına yazılacak. Bu işlem geri alınamaz.',
        bulkTicketConfirm: '{count} kaydın bilet türü değiştirilecek ve katılımcılar bilgilendirilecek.',
        bulkTicketConfirm_one: '{count} kaydın bilet türü değiştirilecek ve katılımcılar bilgilendirilecek.',
        bulkResult: '{succeeded} kayıt işlendi · {failed} kayıt işlenemedi.',
        bulkPartialNote: 'İşlenemeyen kayıtlar sen bakarken değişmiş ya da kontenjanı dolmuş olabilir.',
        // T5 QA P2: toplu başvuru kararında düşen kalemler (uç 200 + `failed`).
        decisionPartialDone: '{count} başvuru işlendi.',
        decisionPartialDone_one: '{count} başvuru işlendi.',
        decisionFailedCeiling: 'Katılımcı sınırına ulaşıldı, {count} başvuru onaylanamadı.',
        decisionFailedCeiling_one: 'Katılımcı sınırına ulaşıldı, başvuru onaylanamadı.',
        decisionFailedOther: '{count} başvuru işlenemedi. {reason}',
        decisionFailedOther_one: 'Başvuru işlenemedi. {reason}',
        bulkTicketTargetLabel: 'Hedef bilet türü',
        // --- Blok 8-3: bilet düzenleme (Story 3.8) ---
        ticketsIntro: 'Yayın sonrası da bilet türü ekleyebilir, kontenjan değiştirebilir ve satışa kapatabilirsin.',
        ticketsEmpty: 'Henüz bilet türü yok',
        ticketsEmptyBody: 'Yayında varsayılan tür otomatik oluşturulur.',
        ticketNameLabel: 'Tür adı',
        ticketDescriptionLabel: 'Açıklama (opsiyonel)',
        ticketQuotaLabel: 'Kontenjan (boş = sınırsız)',
        ticketStatusLabel: 'Durum',
        ticketStatusActive: 'Satışta',
        ticketStatusHidden: 'Gizli',
        ticketStatusClosed: 'Kapalı',
        ticketDefaultLabel: 'Varsayılan tür',
        /* Yeni görünüm 4b (PanelBiletler): kullanım sütunu, tablo altı özeti, form. Fiyat yok. */
        ticketRemaining: '{count} yer kaldı',
        ticketRemaining_one: '{count} yer kaldı',
        ticketsCaptionQuota: 'toplam kontenjan {count}',
        ticketsCaptionQuota_one: 'toplam kontenjan {count}',
        ticketsCaptionCapacity: 'etkinlik kapasitesi {count}',
        ticketsCaptionCapacity_one: 'etkinlik kapasitesi {count}',
        ticketKindHelp: 'Tür bir etikettir. "Ücretli" de ödeme almaz.',
        ticketEditTitle: 'Bilet türünü düzenle',
        ticketAdd: 'Bilet türü ekle',
        ticketSave: 'Kaydet',
        ticketEdit: 'Düzenle',
        ticketDelete: 'Sil',
        ticketDeleteConfirm: 'Bu bilet türü silinecek. Kaydı olan tür silinemez.',
        ticketReserved: '{count} kayıt bu türde',
        ticketReserved_one: '{count} kayıt bu türde',
        ticketUnlimited: 'Sınırsız',
        ticketColUsage: 'Kullanım',
        ticketCancel: 'Vazgeç',
        ticketQuotaHint: 'Kontenjan mevcut kayıt sayısının altına indirilemez.',
        ticketQuotaShort: 'Kontenjan',
    },
    /**
     * Organizatör paneli KABUĞU + referanstaki dört eksik bölüm (Blok 17E).
     * Kaynak: "Icebrkr Organizatör - Panel ve Check-in.dc.html" — üst çubuk (46-54),
     * 232px yan menü (56-67), bölüm başına adres (784-789).
     */
    organizer: {
        brandSuffix: 'Organizatör',
        navHeading: 'Etkinlik',
        navSetup: 'Etkinlik kurulumu',
        navProgram: 'Konuşmacı ve ajanda',
        navRegistrations: 'Kayıtlar',
        navInvitations: 'Davetler',
        navApplications: 'Başvurular',
        navAnnouncements: 'Duyurular',
        navTickets: 'Biletler',
        navAreas: 'Görüşme alanları',
        navReport: 'Rapor',
        navSponsor: 'Sponsor lead',
        navBrand: 'Marka ayarları',
        navBilling: 'Ödeme ve kredi',
        navPostEvent: 'Belge ve anket',
        // Yan menü rozeti ekran okuyucuya bölüm adıyla birlikte okunur (rozetin kendisi aria-hidden).
        navPendingLabel: '{section}, {count} bekleyen',
        navPendingLabel_one: '{section}, {count} bekleyen',
        // Üst gezinmedeki `nav.myEvents` ile AYNI kelime olmalı — kullanıcı
        // panelden çıkarken tanıdığı etiketi arar (bulgu: çıkışı bulamadı).
        backToMyEvents: 'Yönettiklerim',
        // OrganizerShell: 1024 px altında yan menüyü çekmece olarak açan düğme.
        openNavMenu: 'Menüyü aç',
        viewPublicPage: 'Etkinlik sayfasını gör',
        gateLoading: 'Panel açılıyor…',
        setup: {
            title: 'Etkinlik kurulumu',
            stepCounter: 'Adım {step}/4',
            step1: 'Temel bilgiler',
            step2: 'Erişim ve bilet',
            step3: 'Ajanda',
            step4: 'Yayın',
            basicsTitle: 'Temel bilgiler',
            accessTitle: 'Erişim modu',
            accessIntro: 'Kimin katılabileceğini belirler. Sonradan değiştirebilirsin. Değişikliğin sonucu aşağıda yazılı.',
            ticketsTitle: 'Kayıt ve bilet',
            ticketsHint: 'Bilet türleri ve kontenjan ayrı bölümde yönetilir.',
            agendaTitle: 'Ajanda ve konuşmacılar',
            agendaIntro: 'Oturum ekledikçe etkinliğin herkese açık sayfası ve katılımcı ajandası otomatik güncellenir.',
            agendaCta: 'Ajanda bölümüne git',
            checklistTitle: 'Yayın öncesi kontrol',
            checkBasics: 'Temel bilgiler tamam',
            checkBasicsOk: 'Ad, tarih ve yer girildi.',
            checkBasicsMissing: 'Ad, tarih veya yer eksik.',
            checkTickets: 'Bilet ve kontenjan tanımlı',
            checkTicketsOk: '{count} bilet türü tanımlı.',
            checkTicketsOk_one: '{count} bilet türü tanımlı.',
            checkTicketsMissing: 'Yayında varsayılan tür otomatik oluşturulur.',
            checkAgenda: 'Ajanda hazır',
            checkAgendaOk: '{count} oturum tanımlı.',
            checkAgendaOk_one: '{count} oturum tanımlı.',
            checkAgendaMissing: 'Henüz oturum eklenmedi.',
            checkPublished: 'Yayın durumu',
            checkPublishedOk: 'Etkinlik yayında.',
            checkPublishedMissing: 'Etkinlik taslak durumunda. Henüz yayınlanmadı.',
            // Yayın kapısı (Karar 1) kontrol listesinde GÖRÜNÜR: 403 sürprizi olmaz.
            checkBrand: 'Marka logosu',
            checkBrandMissing: 'Logo yüklenmedi. Yaka kartı ve herkese açık sayfa varsayılan tipografiyle yayınlanır.',
            checkBrandOwn: 'Bu etkinliğin kendi logosu yüklendi.',
            checkBrandInherited: 'Kurumunun logosu devralındı. Ayrıca yüklemene gerek yok.',
            checkVerification: 'Kurum doğrulama',
            checkVerificationOk: 'Kurum doğrulandı. Rozet görünüyor ve etkinlik keşifte listeleniyor.',
            checkVerificationMissing: 'Kurum doğrulanmadı. Bu durum yayını engellemez. Doğrulanınca rozet görünür ve etkinlik keşifte listelenir.',
            checkVerificationUnknown: 'Kurum doğrulama durumu okunamadı. Bu durum yayını engellemez. Durum yenilenince burada görünür.',
            // Kontrol işaretinin KARARI ekran okuyucuya da geçer (yalnız renk değil).
            checkStateOk: 'tamam',
            checkStateMissing: 'eksik',
            publish: 'Yayınla',
            preview: 'Önizleme',
            previewKicker: 'Herkese açık sayfa önizlemesi',
            previewNote: 'Bu sayfa arama motorlarına açıktır. Başlık ve açıklama SEO için kullanılır.',
            saved: 'Değişiklikler kaydedildi.',
            savedPublishing: 'Değişiklikler kaydedildi. Sayfalar güncelleniyor…',
            save: 'Kaydet',
            titleLabel: 'Etkinlik adı',
            summaryLabel: 'Özet',
            descriptionLabel: 'Açıklama',
            venueLabel: 'Yer',
            venueAddressLabel: 'Açık adres',
            websiteLabel: 'Web sitesi',
            capacityLabel: 'Kapasite (boş = sınırsız)',
            startsAtLabel: 'Başlangıç',
            endsAtLabel: 'Bitiş',
            // Yeni görünüm 4a (PanelKurulum kartları). Hitapsız: organizatöre "siz" kararı (28.10)
            // K5'in kurum yüzeylerine ayrılmasını bekliyor; o güne kadar kurum metni hitap kurmaz.
            subtitle: 'Etkinlik sayfasında görünen bilgiler ve katılım kuralları.',
            timezoneNote: 'Saatler {timezone} diliminde.',
            ticketsSummary: '{count} bilet türü',
            ticketsSummary_one: '{count} bilet türü',
            ticketsQuotaTotal: '{count} kontenjan',
            ticketsQuotaTotal_one: '{count} kontenjan',
            // Kayıt ve bilet özeti (yeni görünüm 4b): sayı analitiğin sunucu sayımından, bilinmiyorsa yazılmaz.
            ticketsRegistered: '{count} kayıt',
            ticketsRegistered_one: '{count} kayıt',
            ticketUsage: '{used} / {quota} kullanıldı',
            ticketUsageUnlimited: '{used} kullanıldı · sınırsız',
            manageTickets: 'Biletleri yönet',
            programTitle: 'Program',
            programCount: '{count} oturum',
            programCount_one: '{count} oturum',
            programEmpty: 'Henüz oturum eklenmedi.',
            programSpeakersNote: 'Konuşmacılar Konuşmacı ve ajanda ekranından yönetilir. Oturumlar orada da aynıdır.',
            addSession: 'Oturum ekle',
            colTime: 'Saat',
            colSession: 'Oturum',
            colRoom: 'Salon',
            colSpeakers: 'Konuşmacılar',
            noSpeakers: 'Konuşmacı yok',
            // Yalnızca davetli etkinliğin sayfası arama motorlarına kapalıdır (erişim modu tablosu).
            previewNoteInviteOnly: 'Bu sayfa arama motorlarına kapalıdır. Yalnız davet bağlantısıyla açılır.',
        },
        brand: {
            title: 'Marka ayarları',
            intro: 'Etkinlik markan, etkinliğin herkese açık sayfasında ve yaka kartında görünür. Uygulamanın kimliğinin önüne geçmez, çünkü platform çerçevesi sabit kalır ve etkinlik markası yalnızca içerik alanında görünür.',
            logoLabel: 'Logo',
            logoHint: '{formats} · en az 240×80 · şeffaf zemin',
            logoPick: 'Dosya seç',
            logoReplace: 'Logoyu değiştir',
            logoUploading: 'Yükleniyor…',
            logoUploaded: 'Yüklendi. Kaydettiğinde yayına girer.',
            coverLabel: 'Kapak görseli',
            coverHint: '{formats} · 16:9 · en çok {megabytes} MB',
            coverNote: 'Kapak yüklemezsen etkinlik sayfasında ve listelerde sistem kapağı görünür. Kapak isteğe bağlıdır.',
            coverSystemBadge: 'Sistem kapağı',
            coverPick: 'Kapak yükle',
            coverReplace: 'Kapağı değiştir',
            coverRemove: 'Kapağı kaldır',
            coverUploading: 'Kapak yükleniyor…',
            coverUploaded: 'Kapak yüklendi. Kaydettiğinde yayına girer.',
            coverUploadedDraft: 'Kapak yüklendi. Etkinliği kaydettiğinde kapak olarak eklenir.',
            coverRemovedPending: 'Kapak kaldırılacak. Kaydettiğinde sistem kapağına döner.',
            coverErrorType: 'Bu dosya türünü kabul etmiyoruz. {formats} biçimlerinden birini seç.',
            coverErrorSize: 'Dosya {megabytes} MB sınırını aşıyor. Daha küçük bir görsel seç.',
            colorLabel: 'Etkinlik rengi',
            colorHint: 'Renk, yaka kartının üst şeridinde ve etkinliğin herkese açık sayfasındaki vurgularda kullanılır.',
            colorOption: '{color} rengini seç',
            colorNone: 'Renk seçilmedi',
            colorClear: 'Rengi kaldır',
            contrastWarning: 'Seçtiğin renk metin üzerinde AA kontrast vermezse sistem otomatik olarak koyu bir tonunu kullanır. Erişilebilirlik markanın önünde gelir.',
            contrastApplied: 'Bu ton AA kontrast vermiyor. Metin taşıyan alanlarda koyu tonu kullanılıyor.',
            inheritedTitle: 'Bu etkinlik kurum markasını kullanıyor',
            inheritedBody: 'Kurumunun logosu ve rengi burada geçerli. Kurum markasını değiştirdiğinde bu etkinlik de anında değişir.',
            inheritedEmptyBody: 'Kurumunun henüz logosu ve rengi yok. Yaka kartı ve herkese açık sayfa platformun varsayılan tonuyla yayınlanır.',
            overriddenTitle: 'Bu etkinlik kurumun markasını eziyor',
            overriddenBody: 'Aşağıdaki değerler yalnızca bu etkinlikte geçerli. Temizlersen kurum markasına geri dönersin.',
            orgBrandLink: 'Kurum markası',
            clearCta: 'Kuruma geri dön',
            save: 'Markayı kaydet',
            saving: 'Kaydediliyor…',
            saved: 'Marka kaydedildi. Etkinlik sayfası güncellendi.',
            publishing: 'Marka kaydedildi. Etkinlik sayfası güncelleniyor…',
            badgePreviewLabel: 'Yaka kartı önizleme',
            // Yaka kartı önizlemesinin ÖRNEK katılımcısı (B-18): oturum sahibinin adı çizilmez.
            previewPersonName: 'Ad Soyad',
            previewPersonHeadline: 'Ürün Yöneticisi',
            previewPersonCompany: 'Örnek Şirket',
            badgeScanNote: 'Girişte ve kartvizit değişiminde okutulur.',
            goToSetup: 'Etkinlik kurulumuna git',
        },
        sponsor: {
            title: 'Sponsor lead modülü',
            intro: 'Her stant kendi karekodunu alır. Katılımcı kodu okuttuğunda kartvizitini paylaşmayı onaylar. Onay olmadan lead oluşmaz.',
            emptyTitle: 'Sponsor lead modülü henüz açılmadı',
            emptyBody: 'Stant, lead ve onay oranı verisi henüz toplanmıyor. Bu bölüm açılana kadar sıfır ya da örnek sayı göstermeyiz.',
            step1: 'Kartvizit değişimi çift taraflıdır',
            step1Body: 'Onaysız okutma sayıya girer, kimlik taşımaz.',
            step2: 'Katılımcı verisi sponsora satılmaz',
            step2Body: 'Lead yalnızca katılımcının açık onayıyla açılır.',
            step3: 'Modül ilerleyen bir sürümde açılır',
            step3Body: 'Açıldığında stant listesi ve pano belgesi bu bölümde olur.',
            privacyNote: 'Lead verisi sponsora yalnızca katılımcı onayıyla açılır. Onaysız okutmalar sayıya girer, kimlik taşımaz.',
            goToRegistrations: 'Kayıtlara git',
        },
    },
    /**
     * PAKET VE FATURALANDIRMA — referans ekran 24 (Blok 28).
     *
     * P4: ücretsiz katmanın adı "Başlangıç"tır. Referansın "Gölge etkinlikler
     * ücretsizdir" cümlesi GEÇERSİZDİR (gölge etkinlik üründen kaldırıldı) ve
     * hiçbir anahtarda geçmez.
     * A4: fiyatlar gösterilir + "KDV hariç" notu.
     * A11: fatura bölümü BOŞ DURUMLA çizilir — uydurma satır yoktur.
     */
    /**
     * WEB KAPI EKRANI (K3 · TW6 · H11). Kapıdaki dizüstü ya da tabletten
     * tarayıcı kamerasıyla okutma, isimle arama ve sayaç. Mobil kapının
     * metinleri `mobile.checkin` altındadır; sonuç eşlemesi `check-in-gate.ts`.
     */
    gate: {
        title: 'Kapı',
        navLabel: 'Kapı',
        openCta: 'Kapıyı aç',
        registered: 'kayıtlı',
        checkedIn: 'giriş',
        checkedIn_one: 'giriş',
        counterA11y: '{registered} kayıtlı, giriş yapan {checkedIn}',
        noCheckIns: 'Henüz giriş yok',
        counterNoneA11y: '{registered} kayıtlı, henüz giriş yok',
        countError: 'Sayaç okunamadı.',
        retry: 'Yeniden dene',
        soundOn: 'Ses açık',
        soundOff: 'Ses kapalı',
        cameraPick: 'Kamera',
        cameraFallbackName: 'Kamera {index}',
        exit: 'Çıkış',
        camLive: 'Canlı kamera görüntüsü',
        hold: 'Yaka kartındaki kodu çerçeveye tut',
        liveNote: 'Görüntü kaydedilmez.',
        cameraOff: 'Kamerayı kapat',
        ok: 'Giriş yaptı',
        duplicate: 'Zaten giriş yaptı · {time}',
        duplicateAction: 'Yine de kaydet',
        forcedSub: 'Kayıt tutuldu. İlk giriş saati değişmedi.',
        cancelled: 'Kayıt iptal edilmiş',
        cancelledSub: 'Bu kişinin bu etkinlikte geçerli kaydı yok.',
        otherEvent: 'Bu kod başka bir etkinliğin',
        otherEventSub: 'Katılımcıdan bu etkinliğin yaka kartını iste ya da isimle ara.',
        unknown: 'Kod tanınmadı',
        unknownSub: 'Kodu yeniden okut ya da isimle ara.',
        queued: 'Kuyruğa alındı',
        queuedSub: 'Bağlantı gelince doğrulanır.',
        queuedShort: 'Kuyrukta',
        queuedPerson: 'Okutulan kod',
        failed: 'Giriş kaydedilemedi',
        failedSub: 'Bağlantını kontrol edip yeniden okut.',
        sending: 'Kaydediliyor…',
        waiting: 'Kodu kameraya tut. Sonuç burada görünür.',
        searchLabel: 'İsimle ara',
        searchPlaceholder: 'Ad ya da soyad',
        searchHint: 'En az 2 harf yaz, satıra basınca giriş kaydedilir.',
        searchEmpty: 'Bu adla kayıtlı katılımcı yok.',
        searchError: 'Arama yapılamadı.',
        hitIn: 'Giriş {time}',
        hitNo: 'Gelmedi',
        hitCancelled: 'İptal edilmiş',
        hitPending: 'Onay bekliyor',
        hitWaitlisted: 'Bekleme listesinde',
        ticketNone: 'Bilet türü yok',
        recent: 'Son girişler',
        recentEmpty: 'Henüz giriş yok.',
        recentError: 'Son girişler okunamadı.',
        failedListTitle: 'Gönderilemedi · {count}',
        failedListTitle_one: 'Gönderilemedi · {count}',
        mobileNote: 'Kapıda mobil uygulamayı kullanabilirsin.',
        preTitle: 'Kod okumak için kamerayı kullanırız',
        preBody: 'Görüntü kaydedilmez. Tarayıcı izin isteyecek.',
        preCta: 'Kamerayı aç',
        deniedTitle: 'Kamera izni kapalı',
        deniedBody: 'Adres çubuğundaki kilit simgesine bas, Kamera iznini aç ve sayfayı yenile. Bu sırada isimle arama çalışıyor.',
        noneTitle: 'Kamera bulunamadı',
        noneBody: 'Kamera bağlı değil ya da başka bir uygulama kullanıyor. Diğer uygulamayı kapatıp yeniden dene. Bu sırada isimle arama çalışıyor.',
        insecureTitle: 'Kamera bu bağlantıda açılamaz',
        insecureBody: 'Tarayıcı kamerayı yalnız güvenli bağlantıda (HTTPS) açar. Bu sırada isimle arama çalışıyor.',
        closedTitle: 'Kapı {date} günü açılır',
        closedOverTitle: 'Kapı {date} günü kapandı',
        closedBody: 'Giriş kaydı yalnız etkinlik günü yapılır. Kayıtlı katılımcıları isimle görebilirsin.',
        offlineBar: 'Çevrimdışısın. Okutma sürüyor, girişler bu sekmede bekliyor.',
        offlineChip: '{count} giriş gönderilmeyi bekliyor',
        offlineChip_one: '{count} giriş gönderilmeyi bekliyor',
        syncBar: 'Bağlantı geldi. Bekleyen girişler gönderiliyor.',
        syncChip: '{sent} / {total}',
        noPermissionTitle: 'Kapıda giriş kaydetme yetkin yok',
        noPermissionBody: 'Görüntüleyici rolü kapıyı açamaz. Kurum yöneticinden Editör rolü iste.',
        noPermissionCta: 'Kurum ana sayfasına dön',
        accountKindTitle: 'Kapı kurum hesabıyla açılır',
        accountKindBody: 'Bu hesap kişisel hesap. Girişleri kurumunun sana açtığı kurum hesabıyla kaydedebilirsin.',
        accountKindCta: 'Kurum hesabınla giriş yap',
    },
    billing: {
        title: 'Ödeme ve kredi',
        intro: 'Bu etkinliğin kredi durumu ve katılımcı kullanımı. Ödeme sitede alınmaz. Krediyi kurumunuza ekibimiz yükler.',
        eventKicker: 'Bu etkinlik',
        eventDraftTag: 'Kredi kullanılmadı',
        eventDraftBody: 'Yayınladığınızda 1 kredi düşer.',
        eventDraftBodyCeiling: 'Yayınladığınızda 1 kredi düşer. Sınır {ceiling} olur.',
        eventDraftBodyContract: 'Yayınladığınızda Kurumsal sözleşme kapsamında yayınlanır. Kredi düşmez.',
        /* Yeni görünüm 5b (PanelOdemeKredi): "Bu etkinlik" kartının satırları. */
        draftEmptyTitle: 'Bu etkinlik henüz yayınlanmadı',
        rowStatus: 'Yayın durumu',
        rowCreditUsed: 'Kullanılan kredi',
        creditUsedNone: 'Kredi düşmedi',
        rowCeiling: 'Katılımcı sınırı',
        rowSource: 'Düştüğü paket',
        sourcePack: '12’li paket',
        sourceSingle: 'Tekli',
        sourceTrial: 'Hoş geldin kredisi',
        sourceContract: 'Kurumsal sözleşme',
        rowPublishedBy: 'Yayınlayan',
        rowPublishedAt: 'Yayın tarihi',
        publishedByValue: '{name}, {date}',
        usageCountsNote: 'Kayıt, davet kabulü ve başvuru onayı birlikte sayılır.',
        eventTagUnlimited: 'Sınırsız',
        eventBodyNone: 'Bu etkinlik için kredi kaydı yok.',
        usageSectionKicker: 'Katılımcı kullanımı',
        usageRegisteredContract: 'Kayıtlı · sözleşmeli',
        alertCounts: '{used} / {ceiling}.',
        usageLeft: '{count} yer kaldı.',
        usageLeft_one: '{count} yer kaldı.',
        usageWarnNote: '%80 aşıldı. Organizatöre bir kez uyarı e-postası gönderilir.',
        usageFullNote: 'Sınır doldu. Yeni kayıt, davet kabulü ve başvuru onayı kapalı. Kayıtlıların check-in’i açık.',
        usageFullLocks: 'Davet gönderme, toplu işlem, sektör ve kıdem dağılımları kilitli.',
        usageContractNote: 'Kurumsal sözleşme. Katılımcı sınırı yok.',
        creditKicker: 'Kurum kredisi',
        refundTitle: 'İade kuralı',
        refundBody: 'İlk katılımcı kaydından önce iptal edilen etkinliğin kredisi, hoş geldin kredisi dahil, kurumunuza geri yüklenir. İlk kayıttan sonra kredi iade edilmez.',
        contactLine: 'Kredi yüklemek ya da Kurumsal sözleşme için ekibimizle görüşün.',
        contactCta: 'Bize ulaşın',
        trustLine: '{brandName} katılımcılar için ücretsizdir. Kredi yalnız organizatör kurumundan düşer.',
        plansKicker: 'Paketler',
        planNameFree: 'Başlangıç',
        planNamePro: 'Pro',
        planNameEnterprise: 'Kurumsal',
        fundingTrial: 'Hoş geldin kredisiyle yayınlandı',
        fundingSingle: 'Tekli krediyle yayınlandı',
        fundingPack12: '12’li paketten bir krediyle yayınlandı',
        fundingContract: 'Kurumsal sözleşme kapsamında yayınlandı',
        fundingNone: 'Bu etkinlik için kredi kaydı yok',
        currentTag: 'Mevcut',
        currentPlanAction: 'Kullanımdaki paket',
        priceFree: 'Ücretsiz',
        priceQuote: 'Teklife göre',
        pricePerEvent: '{amount} ₺/etkinlik',
        pricePerYear: '{amount} ₺/yıl',
        vatNote: 'Tutarlar KDV hariçtir.',
        limitAttendees: 'Etkinlik başına {count} katılımcı',
        limitAttendees_one: 'Etkinlik başına {count} katılımcı',
        limitUnlimited: 'Sınırsız katılımcı',
        featureInvites: 'Etkinlik başına {count} davet',
        featureInvites_one: 'Etkinlik başına {count} davet',
        featureInvitesUnlimited: 'Sınırsız davet',
        featureTeam: '{count} ekip üyesi',
        featureTeam_one: '{count} ekip üyesi',
        featureTeamUnlimited: 'Sınırsız ekip üyesi',
        featureBreakdownsUntilCeiling: '{count} katılımcıya kadar sektör ve kıdem dağılımı',
        featureBreakdownsUntilCeiling_one: '{count} katılımcıya kadar sektör ve kıdem dağılımı',
        featureBreakdownsAlways: 'Sınırsız sektör ve kıdem dağılımı',
        featureWalletFree: 'Cüzdan, kartvizit ve CSV/vCard dışa aktarımı her pakette ücretsiz ve sınırsız',
        ctaUpgradePro: 'Pro’ya geç',
        ctaContactSales: 'Görüşme ayarla',
        ctaPlanChange: 'Paket değişikliği',
        invoicesKicker: 'Faturalar',
        invoiceColDate: 'Tarih',
        invoiceColDescription: 'Açıklama',
        invoiceColAmount: 'Tutar',
        invoiceColStatus: 'Durum',
        invoicesEmptyTitle: 'Henüz fatura yok',
        invoicesEmptyBody: 'Ödeme alma açık olmadığı için fatura kesilmiyor. Açıldığında bu tabloda tarih, açıklama, tutar, durum ve PDF bağlantısı olacak. Örnek satır göstermiyoruz.',
        invoicesEmptyStep1: 'Bugün ödeyeceğin bir tutar yok',
        invoicesEmptyStep1Body: 'Ödeme alma açık olmadığı için bugün hiçbir pakette tahsilat yapılmıyor.',
        invoicesEmptyStep2: 'Kullanımını kullanım panelinden izle',
        invoicesEmptyStep2Body: 'Paneldeki katılımcı sayısı, faturaya esas alınacak sayının aynısıdır.',
        invoicesEmptyStep3: 'Ödeme açıldığında faturaların buraya düşer',
        invoicesEmptyStep3Body: 'Geçmişe dönük belge kaybolmaz.',
        usageKicker: 'Bu etkinlik',
        usageMeta: 'Paket limiti {ceiling} · %{percent} kullanıldı',
        usageMetaUnlimited: 'Bu pakette katılımcı tavanı yok.',
        usageBarLabel: 'Katılımcı kullanımı',
        usageUnavailable: 'Paket durumu okunamadı.',
        paymentMethodCta: 'Ödeme yöntemini güncelle',
        statusOk: 'Sınırın altındasın',
        statusWarning: 'Sınıra yaklaştın',
        statusExceeded: 'Sınır aşıldı',
        bannerWarning: '{ceiling} kişilik katılımcı sınırının %{percent} kadarındasın ({used}/{ceiling}).',
        bannerExceeded: 'Katılımcı sınırını aştın ({used}/{ceiling}). Şu an {capabilities} kilitli.',
        bannerExceededExempt: 'Katılımcı sınırını aştın ({used}/{ceiling}).',
        bannerGrandfathered: 'Bu etkinlik eski kurala bağlı. {date} tarihine kadar kilit uygulanmaz.',
        bannerLink: 'Paket ve faturalandırma',
        bannerDismiss: 'Şeridi gizle',
        capabilityInvitationsSend: 'davet gönderimi ve yeniden gönderimi',
        capabilityAttendeesBulk: 'toplu katılımcı işlemi',
        capabilityAnalyticsBreakdowns: 'analitikte sektör ve kıdem dağılımı',
        lockedNoticeTitle: 'Sınır aşıldığı için kilitli',
        lockUnknownTitle: 'Sınır durumu okunamadı',
        lockStatusUnknown: 'Sayılar şu an okunamadı. Paket durumu alınamadığı için sınırın neresinde olduğunu yazamıyoruz. Bu etkinlik sınırın üstündeyse sunucu işlemi yine reddedebilir. Yukarıdaki “Tekrar dene” ile tazele.',
        shellLoadError: 'Paket durumu okunamadı. Tavan şeridi ve kilit bilgisi bu ekranda gösterilemiyor. Sınırlar sunucuda geçerliliğini korur.',
        lockInvitationsSend: 'Katılımcı sınırı aşıldı ({used}/{ceiling}). Yeni davet gönderimi ve yeniden gönderim kilitli. Daveti iptal etmek ve listeyi görmek açık. Sınırsız katılım için Kurumsal sözleşme hakkında bize ulaş.',
        lockInvitationsResend: 'Katılımcı sınırı aşıldı ({used}/{ceiling}). Yeniden gönderim de kilitli, çünkü eski daveti iptal edip YENİ bir davet satırı yazar ve sunucu bunu da reddeder. Daveti iptal etmek ve listeyi görmek açık. Sınırsız katılım için Kurumsal sözleşme hakkında bize ulaş.',
        lockAttendeesBulk: 'Katılımcı sınırı aşıldı ({used}/{ceiling}). Toplu işlem kilitli. Tek tek katılımcı çıkarma ve bilet değiştirme açık. Sınırsız katılım için Kurumsal sözleşme hakkında bize ulaş.',
        lockAnalyticsBreakdowns: 'Katılımcı sınırı aşıldı ({used}/{ceiling}). Sektör ve kıdem dağılımı kilitli. Kayıt sayıları, saat dağılımı ve bilet dağılımı açık. Sınırsız katılım için Kurumsal sözleşme hakkında bize ulaş.',
        lockAnalyticsBreakdownsNoCount: 'Katılımcı sınırı aşıldığı için sektör ve kıdem dağılımı kilitli. Kayıt sayıları, saat dağılımı ve bilet dağılımı açık. (Sayılar şu an okunamadı.)',
        lockedPreviewTitle: 'Dağılım kilitli',
        lockedPreviewCollected: 'Bu etkinlikte {count} kişi sektör ve kıdem bilgisini paylaştı.',
        lockedPreviewCollected_one: 'Bu etkinlikte {count} kişi sektör ve kıdem bilgisini paylaştı.',
        registrationsNoticeTitle: 'Liste kısaltılmadı',
        registrationsNoticeBody: 'Katılımcı sınırı doldu ({used}/{ceiling}). Tüm kayıtlar görünür ve aranabilir. Kilitlenen yalnız toplu işlemdir.',
        dialogTitle: 'Satın alma henüz açık değil',
        dialogBody: 'Paketi kendi başına yükseltme bu sürümde kapalı. Ödeme sağlayıcısı bağlantısı henüz tamamlanmadı. Bu yüzden çalışmayan bir ödeme adımı göstermiyoruz.',
        dialogCeilingNote: '{plan} paketinde etkinlik başına {ceiling} katılımcıya kadar kayıt, davet gönderimi, toplu işlem ve analitik dağılımları açıktır. Tavana ulaşılınca yeni kayıt, davet kabulü ve başvuru onayı kapanır. Kayıtlı katılımcıların check-in’i açık kalır.',
        dialogFreeNote: 'Cüzdan, kartvizit ve dışa aktarım her pakette ücretsiz ve sınırsızdır. Bunlar hiçbir zaman kilitlenmez.',
        dialogClose: 'Kapat',
    },
    /*
     * KURUM SATIŞLA AÇILIR · WEB (T5 · W1-W7). Satış başvurusu formu, kurum
     * oluşturmanın yerine geçen yönlendirmeler, kurum kredi kartı, yayın onay
     * diyaloğu ve katılımcı sınırı şeridi. Ödeme alanı YOK: kredi panelden
     * yüklenir, satış sistem dışında yürür.
     */
    salesInquiry: {
        metaTitle: 'Bize ulaş',
        pageTitle: 'Etkinliğini {brandName} ile düzenle',
        fieldCompany: 'Firma adı',
        fieldEventType: 'Etkinlik türü',
        eventTypePlaceholder: 'Etkinlik türünü seç',
        eventTypeConference: 'Konferans',
        eventTypeSummit: 'Zirve',
        eventTypeMeetup: 'Meetup',
        eventTypeFair: 'Fuar',
        eventTypeInternal: 'Kurum içi',
        eventTypeTraining: 'Eğitim / atölye',
        eventTypeOther: 'Diğer',
        fieldAttendees: 'Tahmini katılımcı',
        fieldDate: 'Tahmini tarih',
        fieldContact: 'İletişim kişisi',
        fieldEmail: 'Kurum hesabının açılacağı iş e-postası',
        fieldPhone: 'Telefon · isteğe bağlı',
        fieldNote: 'Not · isteğe bağlı',
        noticeLink: 'KVKK aydınlatma metnini',
        noticeSentence: '{link} okudum.',
        submit: 'Görüşme talep et',
        submitting: 'Gönderiliyor…',
        stepsTitle: 'Ne olacak?',
        step1: 'Başvurun bize ulaşır.',
        step2: 'Seninle iletişime geçeriz.',
        step3: 'Kurumunu biz açarız ve sana davet göndeririz.',
        valueLine: 'Katılımcılar etkinlik başlamadan tanışır.',
        sentTitle: 'Talebin bize ulaştı',
        sentBody: 'En kısa sürede dönüş yapacağız.',
        sentCompany: 'Firma',
        sentEmail: 'E-posta',
        sentHome: 'Ana sayfaya dön',
        errorRateLimited: 'Çok fazla deneme. Bilgilerin korundu. Birkaç dakika sonra tekrar dene.',
        errorUnknown: 'Talebinin bize ulaşıp ulaşmadığını doğrulayamadık. Bilgilerin korundu. Yeniden gönderebilirsin.',
        errorRejected: 'Talebin gönderilemedi. Bilgilerin korundu.',
        retry: 'Yeniden dene',
        /* Yeni görünüm 2a (SiteBizeUlasin): web site formu organizatöre "siz" der. */
        siteTitle: 'Etkinliğinizi {brandName} ile düzenleyin.',
        siteLead: 'Formu doldurun, ekibimiz size uygun düzeni birlikte kursun.',
        siteEventTypePlaceholder: 'Seçin',
        siteEventTypeHint: 'Konferans, Zirve, Meetup, Fuar, Kurum içi, Eğitim veya atölye, Diğer',
        sitePlaceholderContact: 'Ad soyad',
        siteFieldEmail: 'İş e-postası',
        siteEmailHint: 'Kurum hesabı bu adresle açılır.',
        sitePlaceholderEmail: 'ad@firma.com',
        siteFieldPhone: 'Telefon',
        sitePlaceholderPhone: '+90',
        siteFieldNote: 'Not',
        siteOptional: '(isteğe bağlı)',
        siteSubmit: 'Görüşme talep edin',
        siteStep1: 'Başvurunuz bize ulaşır.',
        siteStep2: 'Sizinle iletişime geçeriz.',
        siteStep3: 'Kurumunuzu biz açarız ve iş e-postanıza davet göndeririz.',
        siteSentTitle: 'Teşekkürler, talebiniz bize ulaştı',
        siteSentBody: 'Sizinle iletişime geçeriz.',
        siteErrorRateLimited: 'Çok fazla deneme. Bilgileriniz korundu. Birkaç dakika sonra tekrar deneyin.',
        siteErrorUnknown: 'Talebinizin bize ulaşıp ulaşmadığını doğrulayamadık. Bilgileriniz korundu. Bağlantınızı kontrol edip yeniden gönderebilirsiniz.',
        siteErrorRejected: 'Talebiniz gönderilemedi. Bilgileriniz korundu.',
    },
    orgRequest: {
        metaTitle: 'Bize ulaşın',
        pageTitle: 'Bize ulaş',
        /* Yeni görünüm 5b (KurumBizeUlasin): web talep formu organizatöre "siz" der. */
        pageTitleSite: 'Bize ulaşın',
        pageLeadSite: 'Kredi yükleme, kurumsal sözleşme ya da destek için ekibimize yazın.',
        identityOrganizationSite: 'Kurum adı',
        pricesTitleSite: 'Kredi paketleri',
        savingRowSite: 'Etkinlik başına tasarruf',
        summaryOrganization: 'Kurum',
        summaryEmail: 'E-posta',
        fieldTopic: 'Konu',
        topicPlaceholder: 'Konu seç',
        topicCreditTopup: 'Kredi yükleme',
        topicEnterpriseContract: 'Kurumsal sözleşme',
        topicSupport: 'Destek ve sorun bildirimi',
        topicOther: 'Diğer',
        fieldPackage: 'Paket',
        fieldReferralCode: 'Referans kodu',
        referralCodeHint: 'Harf ve rakam, boşluksuz, Türkçe karakter olmadan. {min} ile {max} karakter.',
        packageSingle: 'Tekli',
        packagePack: '12’li paket',
        packageEnterprise: 'Kurumsal',
        priceValue: '{amount} USD',
        priceEnterprise: 'Sözleşmeyle belirlenir',
        saving: 'yaklaşık %{percent}',
        priceNote: 'Fiyatlar USD, vergiler hariç ve bilgi amaçlıdır. Sitede satın alma yoktur.',
        fieldPhone: 'Telefon · isteğe bağlı',
        fieldNote: 'Not · isteğe bağlı',
        noticeSentence: 'Talebin {link} kapsamında işlenir.',
        noticeSentenceSite: 'Talebiniz {link} kapsamında işlenir.',
        noticeLink: 'KVKK aydınlatma metni',
        submit: 'Talebi gönder',
        stepsTitle: 'Ne olacak?',
        step1: 'Talebiniz ekibimize ulaşır.',
        step2: 'Sizinle e-postayla iletişime geçeriz.',
        step3: 'Kredi ya da sözleşme kurumunuza tanımlanır.',
        sentBack: 'Kurum ana sayfasına dön',
        sentTitleSite: 'Talebiniz alındı',
        sentBodySite: 'Sizinle e-postayla iletişime geçeriz.',
        sentReferralCode: 'Referans kodunuz talebinizle birlikte iletildi. Geçerliyse ekibimiz kredinizi yüklerken ekler.',
        loadError: 'Kurum bilgisi okunamadı.',
        pricesLoadError: 'Paket bilgisi şu an yüklenemedi. Talep yine de gönderilebilir.',
    },
    orgEntry: {
        pageTitle: 'Kurumlarım',
        emptyTitle: 'Henüz bir kurumda değilsin',
        emptyBody: 'Etkinliğini {brandName} ile düzenlemek için bize ulaş, kurumunu biz açalım.',
        emptyCta: 'Bize ulaş',
        emptyInviteHint: 'Bir kurumun ekibindeysen yöneticinden davet iste.',
        menuContact: 'Etkinliğini bizimle düzenle',
        organizerOnlyManageable: 'Yalnız yönetebildiğin kurumlar listelenir.',
        organizerViewerRole: '{organizationName} kurumunda rolün {role}.',
        organizerViewerRoleMany: 'Üyesi olduğun kurumlarda etkinlik açma yetkin yok.',
        organizerNoOrganization: 'Etkinlik açabileceğin bir kurum yok.',
        organizerContactSentence: 'Yeni etkinliğin için {link}.',
        organizerContactLink: 'bize ulaş',
        organizerHint: 'Etkinlik bu kurumun adına yayınlanır.',
        myEventsStep1: 'Kurumunuzu seçin',
        myEventsStep1Body: 'Etkinlik her zaman bir kurum adına yayınlanır. Kurumunuz yoksa bize ulaşın, kurumunuzu biz açalım.',
    },
    credits: {
        kicker: 'Kredi',
        unitRemaining: 'kredi kaldı',
        unitRemaining_one: 'kredi kaldı',
        unitTrial: 'hoş geldin kredisi',
        unitContract: 'Kurumsal sözleşme',
        numberUnlimited: 'Sınırsız',
        rowTrial: 'Hoş geldin',
        rowSingle: 'Tekli',
        rowPack: '12’li paket',
        rowExpiry: '12’li paket yanma',
        expiryValue: '{count} kredi · {date}',
        expiryValue_one: '{count} kredi · {date}',
        rowCeiling: 'Katılımcı sınırı',
        ceilingNone: 'Yok',
        ceilingPerEvent: '{ceiling} / etkinlik',
        moreCredits: 'Daha fazla kredi için bize ulaş',
        rowContract: 'Sözleşme',
        contractUntil: '{date} tarihine kadar',
        rowPublishedThisYear: 'Bu yıl yayınlanan',
        publishedThisYearValue: '{count} etkinlik',
        publishedThisYearValue_one: '{count} etkinlik',
        rowPublishedThisMonth: 'Bu ay yayınlanan',
        publishedThisMonthValue: '{count} etkinlik',
        publishedThisMonthValue_one: '{count} etkinlik',
        rowLive: 'Yayındaki etkinlikler',
        liveUnaffected: 'Etkilenmez',
        noteCeiling: '1 kredi 1 etkinlik yayınlar. Katılımcı sınırı {ceiling}.',
        notePublish: 'Kredi yayınlarken düşer, taslaklar kredi harcamaz.',
        noteRefund: 'Kayıt gelmeden iptal ettiğin etkinliğin kredisi geri döner.',
        noteOrder: 'Önce yanacak krediler kullanılır, hoş geldin kredisi en sona kalır.',
        noteTrialCeiling: 'Hoş geldin kredisiyle yayınlanan etkinlik {ceiling} katılımcıda kayda kapanır.',
        noteTrialMore: 'Daha büyük etkinlikler için ekibimiz kredi yükler.',
        noteContract: 'Sözleşme süresince yayın kredi harcamaz.',
        noteContractRenew: 'Yenileme için hesap yöneticin seninle iletişime geçer.',
        exhaustedAlert: 'Kredi bitti. Yeni etkinlik yayınlamak için bize ulaşın. Taslaklarınız korunur.',
        exhaustedCta: 'Bize ulaşın',
        /* Kredi varken kurum ana sayfası kartındaki ikincil talep girişi (KurumAnaSayfa, 5a). */
        requestCta: 'Bize ulaşın',
        /* Organizatöre "siz" (marka ruhu 28.10): web kredi kartının notları; panel ve mobil ortak anahtarı okur. */
        noteRefundSite: 'Kayıt gelmeden iptal ettiğiniz etkinliğin kredisi geri döner.',
        noteContractRenewSite: 'Yenileme için hesap yöneticiniz sizinle iletişime geçer.',
        loadErrorSite: 'Kredi bilgisi okunamadı. Yayınlanmış etkinlikleriniz etkilenmez.',
        loadError: 'Kredi bilgisi okunamadı. Yayınlanmış etkinliklerin etkilenmez.',
        retry: 'Yeniden dene',
        inlineExpiry: '12’li paketten {count} kredi {date} tarihinde yanar',
        inlineExpiry_one: '12’li paketten {count} kredi {date} tarihinde yanar',
    },
    publishDialog: {
        title: 'Etkinliği yayınla',
        leadCredit: 'Yayınlandığında etkinlik sayfası açılır ve kayıtlar başlar.',
        leadTrial: 'Hoş geldin kredin bu etkinlikte kullanılır.',
        leadContract: 'Kurumsal sözleşmen kapsamında yayınlanır. Kredi düşmez.',
        rowUse: 'Kullanılacak',
        valueOneCredit: '1 kredi',
        valueTrial: 'Hoş geldin kredisi',
        rowRemaining: 'Kalan kredi',
        rowRemainingTrial: 'Kalan hoş geldin kredisi',
        valueTransition: '{from} → {to}',
        rowCeiling: 'Katılımcı sınırı',
        ceilingUnlimited: 'Sınırsız',
        rowCredit: 'Kredi',
        valueNotUsed: 'Kullanılmaz',
        rowContract: 'Sözleşme',
        contractUntil: '{date} tarihine kadar',
        capacityInfo: 'Kapasiteyi {capacity} girdin. Bu kredinin katılımcı sınırı {ceiling}. Yayınlamak için kapasiteyi {ceiling} ya da altına indir.',
        confirm: 'Yayınla',
        publishing: 'Yayınlanıyor…',
        exhaustedTitle: 'Yayınlamak için kredi gerekiyor',
        exhaustedLead: 'Etkinliğini taslak olarak kaydedebilirsin. Bilgilerin kaybolmaz.',
        exhaustedAlert: 'Kurumunun kredisi bitti.',
        exhaustedPrimary: 'Bize ulaş',
        exhaustedSecondary: 'Taslak olarak kaydet',
        raceLead: 'Yayınlamak için kurumuna kredi yüklenmesi gerekiyor. Bilgilerin kaybolmaz.',
        raceAlert: 'Son kredi başka bir yayında kullanıldı. Etkinliğin taslak olarak kaydedildi.',
        raceSecondary: 'Taslağa dön',
        rowEvent: 'Etkinlik',
        valueDraft: 'Taslak',
        errorRejected: 'Yayınlanamadı, kredi düşmedi. Yeniden dene.',
        errorUnknown: 'Yayının sonucunu doğrulayamadık. Etkinliğin ve kredin yeniden okunuyor. Durumu kontrol edip yeniden deneyebilirsin.',
        creditLoadError: 'Kredi bilgisi okunamadı. Yayınlarsan kredi sunucuda yine denetlenir.',
        retry: 'Yeniden dene',
    },
    announcements: {
        // Organizatör duyuruları Story 3 (web, etkinlik yönetimi › Duyurular).
        title: 'Duyurular',
        listIntro: 'Kurum alıcıların adını ve e-postasını görmez, yalnız sayıyı görür.',
        write: 'Duyuru yaz',
        colTitle: 'Başlık',
        colAudience: 'Alıcılar',
        colChannels: 'Kanallar',
        colStatus: 'Durum',
        colDate: 'Tarih',
        channelsLabel: 'Kanallar: {list}',
        channel: {
            email: 'E-posta',
            push: 'Mobil bildirim',
            inApp: 'Uygulama içi',
        },
        status: {
            draft: 'Taslak',
            scheduled: 'Zamanlandı',
            sending: 'Gönderiliyor',
            sent: 'Gönderildi',
            cancelled: 'İptal edildi',
            failed: 'Gönderilemedi',
        },
        audience: {
            registered: 'Kayıtlılar',
            pending_applicants: 'Başvurusu bekleyenler',
            checked_in: 'Check-in yapanlar',
            attended: 'Etkinliğe katılanlar',
            invitees: 'Davet edilenler',
            followers: 'Takipçiler',
        },
        kind: {
            informational: 'Bilgilendirme',
            promotional: 'Tanıtım',
        },
        people: '{count} kişi',
        people_one: '{count} kişi',
        draftEdited: 'Son düzenleme {date}',
        emptyTitle: 'Henüz duyuru yok',
        emptyBody: 'Katılımcılara saat, yer ya da ajanda değişikliğini buradan duyurursun. Kurum alıcıların adını görmez, yalnız sayıyı görür.',
        loadError: 'Duyurular yüklenemedi',
        loadErrorBody: 'Bağlantını kontrol edip yeniden dene.',
        composeTitle: 'Duyuru yaz',
        fieldSubject: 'Başlık',
        fieldBody: 'Metin',
        bodyCounter: '{used} / {max}',
        audiencesLegend: 'Alıcılar',
        channelsLegend: 'Kanallar',
        kindLegend: 'Tür',
        opensAfterEvent: 'Etkinlik bitince açılır',
        summaryKicker: 'Özet',
        summaryCount: '{count} kişiye gidecek',
        summaryCount_one: '{count} kişiye gidecek',
        audienceLoadError: 'Alıcı sayısı yüklenemedi',
        noAttendeesTitle: 'Bu etkinlikte henüz katılımcı yok',
        noAttendeesBody: 'İlk kayıt geldiğinde alıcı sayısı burada görünür. Taslağını şimdiden yazabilirsin.',
        preview: 'Önizle',
        sendTest: 'Kendime test gönder',
        saveDraft: 'Taslağı kaydet',
        complianceNote: 'Bu ileti etkinlikle ilgili bilgilendirme amaçlıdır. Tanıtım ve reklam içeriği gönderilemez.',
        saved: 'Taslak kaydedildi.',
        testSent: 'Test iletisi hesabının e-posta adresine gönderildi.',
        previewTitle: 'Önizleme',
        previewIntro: 'Sabit metinler alıcının dilinde gider.',
        previewLanguage: 'Önizleme dili',
        previewChannel: 'Kanal',
        pushHint: 'Bildirimde metnin ilk {count} karakteri görünür.',
        pushHint_one: 'Bildirimde metnin ilk {count} karakteri görünür.',
        now: 'şimdi',
        unread: 'Okunmadı',
        notOnChannel: 'Bu duyuru bu kanaldan gönderilmeyecek.',
        previewLoadError: 'Önizleme yüklenemedi',
        backToEdit: 'Düzenlemeye dön',
        backToList: 'Duyurulara dön',
        // Story 4 (T3b): gönder, zamanla, iptal ve gönderim durumu.
        sendNow: 'Şimdi gönder',
        scheduleAction: 'Zamanla',
        // Kullanıcı kararı 21.10.2026: "Şimdi gönder" onay alır (tasarımda yok, iptal onayının deseni).
        sendConfirmTitle: 'Duyuru şimdi gönderilsin mi?',
        sendConfirmAudience: '{count} kişiye gider.',
        sendConfirmAudience_one: '{count} kişiye gider.',
        sendConfirmReach: '{count} kişiye {channels} ile gider.',
        sendConfirmReach_one: '{count} kişiye {channels} ile gider.',
        sendConfirmChannels: '{channels} ile gider.',
        sendConfirmIrreversible: 'Gönderim hemen başlar, giden iletiler geri alınamaz.',
        // Kanal adları dizisinin son bağlacı ("e-posta ve mobil bildirim"); `Intl.ListFormat` yoksa.
        listAnd: 've',
        sendConfirmSubmit: 'Gönder',
        sendConfirmCancel: 'Vazgeç',
        sendClosedNote: 'Duyuru gönderimi henüz açılmadı. Taslağın kayıtlı kalır, gönderim açılınca buradan gönderebilir ya da zamanlayabilirsin.',
        sendSettingError: 'Gönderim bilgisi yüklenemedi.',
        scheduleTitle: 'Duyuruyu zamanla',
        scheduleDate: 'Tarih',
        scheduleTime: 'Saat',
        scheduleZone: 'Saat, etkinliğin saat dilimi olan {zone} saatine göredir.',
        scheduleWhen: '{count} kişiye {when} itibarıyla gider.',
        scheduleWhen_one: '{count} kişiye {when} itibarıyla gider.',
        scheduleSubmit: 'Zamanla',
        scheduleCancel: 'Vazgeç',
        scheduleRequired: 'Tarih ve saat seç.',
        schedulePast: 'Geçmiş bir saat seçtin. Şimdiden sonraki bir saat seç.',
        scheduleSaveError: 'Zamanlama kaydedilemedi',
        cancelAction: 'İptal et',
        cancelActionLabel: '“{title}” duyurusunu iptal et',
        cancelTitle: 'Duyuru iptal edilsin mi?',
        cancelBodyScheduled: 'Zamanlanan saatte gönderilmez. Bu işlem geri alınamaz.',
        cancelBodySending: 'Henüz ulaşmamış alıcılara gönderilmez. Gitmiş iletiler geri alınmaz. Bu işlem geri alınamaz.',
        cancelConfirm: 'Duyuruyu iptal et',
        cancelKeep: 'Vazgeç',
        cancelled: 'Duyuru iptal edildi.',
        colActions: 'İşlem',
        statusMeta: '{audience} · {date}',
        statusSender: 'Gönderen: {name}',
        statusTarget: 'kişi hedeflendi',
        statusQueued: 'ileti kuyrukta',
        statusSent: 'ileti gönderildi',
        statusFailed: 'ileti başarısız',
        statusTotalsLabel: 'Gönderim toplamları',
        statusChannelsLabel: 'Kanallara göre dağılım',
        statusColChannel: 'Kanal',
        statusColQueued: 'Kuyrukta',
        statusColSent: 'Gönderildi',
        statusColFailed: 'Başarısız',
        statusColQueuedShort: 'Kuyr.',
        statusColSentShort: 'Gönd.',
        statusColFailedShort: 'Başar.',
        statusPrivacyNote: 'Yalnız sayılar gösterilir. Başarısız gönderimlerin kime ait olduğu kuruma açılmaz. Mobil bildirimi kapatan katılımcılar bu kanalın sayısına girmez.',
        statusChannelsHidden: 'Kanallara göre dağılım, her kanalda en az {count} ileti olduğunda gösterilir. Toplamlar yukarıda.',
        statusChannelsHidden_one: 'Kanallara göre dağılım, her kanalda en az {count} ileti olduğunda gösterilir. Toplamlar yukarıda.',
        statusEmptyTitle: 'Bu duyuru henüz gönderilmedi',
        statusEmptyBody: 'Zamanlanan saatte gönderim başlar, sayılar burada görünür.',
        statusLoadError: 'Gönderim durumu yüklenemedi',
        statusNotFound: 'Duyuru bulunamadı',
        statusForbidden: 'Bu duyurunun durumunu görme yetkin yok',
        /*
         * YENİ GÖRÜNÜM 4d (PanelDuyurular, PanelDuyuruYaz, PanelDuyuruOnizleme,
         * PanelDuyuruDurum), yalnız web. Kartın "siz"li metinleri hitapsız
         * yazıldı: arayüz dili kapısı TR'de sizli kipi reddeder, kurum hesabı tonu
         * ayrı turun işidir. Mobil ortak anahtarlar değişmez.
         */
        listSubtitle: 'Katılımcılara e-posta ve mobil bildirimle giden etkinlik bilgileri.',
        emptyBodyOrg: 'Saat, yer ya da ajanda değişikliği kayıtlı katılımcılara buradan duyurulur.',
        rowView: 'Görüntüle',
        rowEditLabel: '“{title}” taslağını düzenle',
        rowViewLabel: '“{title}” duyurusunu görüntüle',
        bodyHelp: 'Katılımcılara “sen” diye hitap edilir.',
        audienceGroupsLegend: 'Alıcı grupları',
        summaryLine: '{audience} · {channels}',
        statusSectionChannels: 'Kanallar',
    },
    ceiling: {
        warnLead: 'Bu etkinlik {ceiling} katılımcı sınırının %{percent}{suffix}.',
        warnRest: 'Sınıra ulaşınca yeni kayıt kapanır. Uyarı e-postası da gönderildi.',
        fullLead: '{ceiling} katılımcı sınırı doldu.',
        fullRest: 'Yeni kayıt, davet kabulü ve başvuru onayı kapandı, kayıtlı katılımcıların check-in’i açık. Davet gönderme, toplu işlem ve sektör/kıdem dağılımları kilitli.',
        trialLine: 'Hoş geldin kredisiyle yayınlandı',
        cta: 'Kurumsal için bize ulaş',
        progressLabel: 'Katılımcı sınırı kullanımı',
        errorLine: 'Paket durumu okunamadı. Sınır ve kilitler gösterilmiyor. İşlemler sunucuda yine denetlenir.',
        retry: 'Yeniden dene',
        lockInvite: 'Sınır doldu, yeni davet gönderilemez.',
        lockBulk: 'Toplu işlem sınır dolunca kilitlenir. Satırları tek tek yönetebilirsin.',
        lockBreakdown: 'Sınır dolunca dağılımlar kilitlenir. Kayıt sayıları, saat ve bilet dağılımı açık.',
        exemptLine: 'Bu etkinlik eski kurala bağlı. {date} tarihine kadar kilit uygulanmaz.',
    },
    analytics: {
        kicker: 'Analitik',
        title: 'Analitik',
        subtitle: 'Sayılar canlı. Her sayfa açılışında yeniden hesaplanır.',
        privacyNote: 'Analitik yalnızca toplu sayı gösterir. Hiçbir dağılımda kişi adı, e-posta veya telefon yer almaz. Dağılımlar katılımcı listesindeki kişilerden hesaplanır.',
        kpiRegistered: 'Kayıt',
        kpiRegisteredDelta: 'son 7 günde +{count}',
        kpiApplications: 'Bekleyen başvuru',
        kpiInvitations: 'Davet',
        kpiInvitationsDelta: '{accepted} kabul edildi',
        kpiCheckedIn: 'Check-in',
        kpiCheckedInDelta: 'kayıtların %{percent} kadarı',
        kpiCancelled: 'İptal',
        kpiCapacity: 'Kalan kontenjan',
        kpiCapacityUnlimited: 'Sınırsız kapasite',
        hourlyTitle: 'Saatlik kayıt dağılımı',
        hourlyHint: 'Saatler etkinliğin saat diliminde ({timezone}).',
        hourlyEmpty: 'Henüz kayıt yok. Dağılım ilk kayıtla oluşur.',
        hourLabel: '{hour}:00',
        hourBarLabel: '{hour}:00 · {count} kayıt',
        hourBarLabel_one: '{hour}:00 · {count} kayıt',
        sectorTitle: 'Sektör dağılımı',
        seniorityTitle: 'Kıdem dağılımı',
        ticketTitle: 'Bilet türü dağılımı',
        unknownBucket: 'Belirtilmemiş',
        otherBucket: 'Diğer (eşik altı)',
        percentValue: '%{percent}',
        suppressedTitle: 'Dağılımlar henüz açılmadı',
        suppressedBody: 'Dağılımlar, katılımcı listesinde en az {min} kişi olduğunda gösterilir. Daha az kişide yüzdeler tek bir kişinin profil verisini ele verir.',
        breakdownBaseHint: 'Dağılımlar katılımcı listesindeki {count} kişiye dayanır.',
        breakdownBaseHint_one: 'Dağılımlar katılımcı listesindeki {count} kişiye dayanır.',
        bucketSuppressedTitle: 'Bu dağılım gizlendi',
        bucketSuppressedBody: 'Kalan gruplar {min} kişilik eşiği tutmuyor. Yayınlanmaları tek bir kişinin sektör veya kıdem bilgisini ele verirdi.',
        emptyTitle: 'Analitik ilk kayıtla başlar',
        emptyBody: 'Etkinliğin yayına alındıktan sonra kayıtlar geldikçe sayılar ve dağılımlar burada dolar.',
        emptyStep1: 'Etkinliği yayınla',
        emptyStep2: 'Davet gönder veya bağlantıyı paylaş',
        emptyStep3: 'Kayıtları buradan izle',
        emptyAction: 'Davet gönder',
        loadError: 'Analitik yüklenemedi.',
        report: {
            kicker: 'ETKİNLİK SONU RAPORU',
            kickerLive: 'ARA RAPOR · CANLI',
            badgeFinal: 'Kesin',
            badgePreliminary: 'Ön rapor',
            organizedBy: 'Düzenleyen: {name}',
            metaDate: 'TARİH',
            metaFormat: 'BİÇİM',
            metaAccess: 'ERİŞİM MODU',
            metaGenerated: 'OLUŞTURULMA',
            statusFinal: 'Rapor {date} tarihinde donduruldu. Sayılar artık değişmez.',
            statusPreliminary: 'Rapor {date} tarihinde kesinleşene kadar güncellenir. Son güncelleme {updated}.',
            sectionAttendance: 'Katılım',
            sectionCheckIn: 'Check-in',
            sectionMeetings: 'Görüşme talepleri',
            sectionSurvey: 'Anket özeti',
            registered: 'Kesin kayıt',
            cancelled: 'İptal',
            applicationsReceived: 'Gelen başvuru',
            applicationsApproved: 'Onaylanan',
            applicationsApprovedSub: 'Başvuruların {rate}{suffix}',
            invitationsSent: 'Gönderilen davet',
            invitationsAccepted: 'Kabul edilen davet',
            fillRate: 'Doluluk',
            fillRateSub: '{registered} / {limit} kapasite',
            checkedIn: 'Check-in yapan',
            attendanceRate: 'Katılım oranı',
            attendanceRateSub: '{checkedIn} / {registered} kesin kayıt',
            noShows: 'Gelmeyen',
            attendanceRateLive: 'Şu ana kadar katılım',
            noShowsLive: 'Henüz gelmeyen',
            hourlyTitle: 'Saatlik check-in',
            meetingsTotal: 'Toplam talep',
            meetingsAccepted: 'Kabul edilen',
            meetingsUnresolved: 'Sonuçlanmayan',
            meetingsUnresolvedSub: 'Reddedilen, yanıtsız ya da geri çekilen',
            meetingsParticipants: 'Görüşme ayarlamaya çalışan',
            meetingsParticipantsSub: 'katılımcı',
            meetingsHiddenNote: 'Bir sayı {min}’ten az olduğu için ondan türeyen sayı gösterilmez.',
            meetingsBothHiddenNote: 'En az biri {min}’ten az olduğu için kabul edilen ve sonuçlanmayan sayılar gösterilmez.',
            fewerThanMin: '{min}’ten az',
            countHidden: 'Gösterilmez',
            /** Bastırılmış anket özeti, her yüzeyde aynı metin (kullanıcı kararı 30.10.2026 akşam). */
            summaryFewResponses: 'Az yanıt, gösterilmez',
            surveyNone: 'Bu etkinlikte anket yapılmadı.',
            surveyResponses: 'Cevap',
            surveyResponseRateSub: '{rate} cevap oranı',
            surveySatisfaction: 'Genel memnuniyet',
            surveySatisfactionSub: '5 üzerinden',
            surveyRecommendation: 'Tavsiye skoru',
            surveyRecommendationSub: '−100 ile +100 arası',
            surveyAllResults: 'Tüm sonuçlar',
            overviewLabel: 'Künye',
            downloadPdf: 'PDF indir',
            downloadingPdf: 'PDF hazırlanıyor',
            share: 'Paylaş',
            pdfError: 'PDF oluşturulamadı.',
            retry: 'Yeniden dene',
            loading: 'Rapor yükleniyor',
            loadErrorTitle: 'Rapor yüklenemedi',
            loadErrorBody: 'Bağlantını kontrol edip yeniden dene.',
            notEndedTitle: 'Etkinlik henüz bitmedi',
            draftTitle: 'Etkinlik taslakta',
            draftBody: 'Rapor etkinliği yayınladığında açılır ve canlı güncellenir.',
            draftAction: 'Kuruluma dön',
            refresh: 'Yenile',
            refreshing: 'Yenileniyor',
            notEndedBody: 'Rapor {date} tarihinde açılır.',
            cancelledTitle: 'Etkinlik iptal edildi',
            cancelledBody: 'İptal edilen etkinlik için rapor oluşturulmaz.',
            hourColumn: 'Saat aralığı',
            countColumn: 'Check-in',
            thresholdNote: 'Katılımcıların gizliliği için {min}’ten küçük sayılar gösterilmez.',
            pdfGenerated: 'Oluşturulma {date}',
            pdfPage: 'Sayfa {page} / {total}',
            pdfLiveStatus: 'Canlı, {date} itibarıyla. Sayılar etkinlik bitene kadar güncellenir.',
            fileName: 'etkinlik-raporu',
            badgeLive: 'Canlı',
            metaUpdated: 'SON GÜNCELLEME',
            statusLiveBefore: 'Rapor canlı. Sayılar etkinlik bitene kadar güncellenir. Son güncelleme {time}.',
            statusLiveDuring: 'Etkinlik sürüyor. Sayılar canlı güncellenir. Son güncelleme {time}.',
            privacyNote: 'Rapor toplu sayılardan oluşur. Kişi adı, görüşme çiftleri ve duyuru içerikleri yer almaz.',
            checkInStartsOnEventDay: 'Check-in etkinlik günü başlar.',
            checkInOngoing: 'Check-in sürüyor. {hour} çubuğu {time} itibarıyla.',
            offlineNotice: 'Çevrimdışısın. Sayılar {time} itibarıyla gösteriliyor.',
            listAnd: ' ve ',
            live: {
                title: 'Canlı özet',
                registeredDelta: 'Son 7 günde +{count}',
                registeredDelta_one: 'Son 7 günde +{count}',
                checkedIn: 'Check-in',
                checkInPending: 'Etkinlik günü başlar',
                checkInSub: '{rate} · {registered} kesin kayıt',
                invitationsSub: '{accepted} kabul',
                capacity: 'Kalan kontenjan',
                capacitySub: '{capacity} kapasite',
                capacityUnlimited: 'Sınırsız',
                pending: 'Bekleyen başvuru',
                pendingSub: 'İncelemeni bekliyor',
                emptyTitle: 'Henüz kayıt ve davet yok',
                emptyBody: 'Rapor canlı. İlk kayıtla birlikte sayılar burada görünür.',
                emptyStepShare: 'Etkinlik bağlantını paylaş',
                emptyStepInvite: 'Davet gönder',
                emptyStepFill: 'Kayıtlar geldikçe canlı özet ve zaman çizelgesi dolar',
                emptyStepEnd: 'Etkinlik bitince rapor ön rapora geçer',
                emptyActionShare: 'Etkinliği paylaş',
                emptyActionInvite: 'Davet gönder',
                linkCopied: 'Bağlantı kopyalandı',
            },
            preEvent: {
                title: 'Etkinlik öncesi tanışma',
                acceptanceRate: 'Kabul oranı',
                acceptanceRateSub: '{accepted} / {count} talep',
                acceptanceRateSub_one: '{accepted} / {count} talep',
                sentBefore: 'Etkinlik gününden önce gönderilen',
                sentBeforeSub: '{sent} / {count} talep',
                sentBeforeSub_one: '{sent} / {count} talep',
                notStarted: 'Etkinlik henüz başlamadı',
                leadTitle: 'Talebin gönderilme zamanı',
                leadDays14Plus: '14+ gün önce',
                leadDays7To13: '7–13 gün önce',
                leadDays1To6: '1–6 gün önce',
                leadEventDay: 'Etkinlik günü ve sırasında',
                leadEventDayPending: 'Etkinlik günü başlar',
                leadValue: '{value} · {share}',
                leadHiddenNote: '{count} kovada {min}’ten az talep var ya da sayı toplamdan bulunabilirdi. Bu kovaların oranı gösterilmez.',
                leadHiddenNote_one: 'Bir kovada {min}’ten az talep var. O kovanın oranı gösterilmez.',
                hourlyTitle: 'Kabul edilen görüşmelerin saati',
                peakCaption: 'En yoğun saat {range} · {count} görüşme (turuncu çubuk).',
                peakCaption_one: 'En yoğun saat {range} · {count} görüşme (turuncu çubuk).',
                countColumn: 'Görüşme',
            },
            timeline: {
                title: 'Kayıt zaman çizelgesi',
                daily: 'Günlük kayıt',
                weekly: 'Haftalık kayıt',
                weekLabel: '{week}. hafta',
                weekLabelShort: 'H{week}',
                weeklyCaption: '{range} · {count} hafta. Kayıt penceresi 6 haftadan uzun olduğu için haftalık gösterilir.',
                weeklyCaption_one: '{range} · {count} hafta. Kayıt penceresi 6 haftadan uzun olduğu için haftalık gösterilir.',
                dailyCaption: '{range} · günlük',
                markLegend: 'Duyuru gönderilen gün. Sayı aynı gün giden duyuru sayısıdır.',
                markSuffix: '{count} duyuru',
                markSuffix_one: '{count} duyuru',
                honestyNote: 'İşaret duyurunun gönderildiği günü gösterir, kayıtlara etkisini kanıtlamaz.',
                noAnnouncements: 'Bu etkinlik için duyuru gönderilmedi.',
                empty: 'Henüz kayıt yok. Çizelge ilk kayıtla oluşur.',
                dayColumn: 'Gün',
                weekColumn: 'Hafta',
                countColumn: 'Kayıt',
                hourlyTitle: 'Kayıtların günün saatine göre dağılımı',
            },
            profile: {
                title: 'Katılımcı profili',
                heading: 'Sektör ve kıdem',
                sector: 'Sektör',
                seniority: 'Kıdem',
                tickets: 'Bilet türüne göre doluluk',
                other: 'Diğer',
                otherNote: '{min}’ten az kişili gruplar “Diğer” içinde gösterilir.',
                suppressed: 'Şu an listede {min}’ten az kişi var. Sektör ve kıdem dağılımı {min}. kişiyle görünür.',
                bucketHidden: 'Kalan gruplar eşiği tutmadığı için bu dağılım gösterilmez.',
            },
            comparison: {
                title: 'Önceki etkinliklerle karşılaştırma',
                firstEvent: 'İlk etkinliğin olduğu için karşılaştırılacak önceki etkinlik yok.',
                colMetric: 'GÖSTERGE',
                colThis: 'BU ETKİNLİK',
                colAverage: 'ÖNCEKİ ORTALAMA',
                colDelta: 'FARK',
                registered: 'Kesin kayıt',
                attendanceRate: 'Check-in oranı',
                satisfaction: 'Memnuniyet',
                noSurvey: 'Anket yok',
                noCheckIn: 'Check-in yok',
                points: '{delta} puan',
                satisfactionBasis: '{count} etkinlikten',
                satisfactionBasis_one: '{count} etkinlikten',
                basisNote: 'Son {count} etkinliğinin ortalamasına göre.',
                basisNote_one: 'Son {count} etkinliğinin ortalamasına göre.',
                rateExcludedNote: 'Check-in kullanılmayan {count} etkinlik check-in oranı ortalamasına katılmadı.',
                rateExcludedNote_one: 'Check-in kullanılmayan {count} etkinlik check-in oranı ortalamasına katılmadı.',
                repeatTitle: 'Tekrar gelenler',
                repeatSub: '{rate} · önceki bir etkinliğinde check-in yapmış',
                repeatRateHidden: 'Oran gösterilmez',
                repeatHidden: 'Gösterilmez',
                repeatCurrentUnused: 'Bu etkinlikte check-in kullanılmadığı için tekrar gelenler hesaplanmadı.',
                repeatPreviousUnused: 'Önceki etkinliklerinde check-in kullanılmadığı için tekrar gelenler hesaplanmadı.',
                repeatExcludedNote: 'Check-in kullanılmayan {count} önceki etkinlik tekrar gelen hesabına katılmadı.',
                repeatExcludedNote_one: 'Check-in kullanılmayan {count} önceki etkinlik tekrar gelen hesabına katılmadı.',
            },
            supplement: {
                note: 'Bu rapor {frozen} tarihinde kesinleşti. {sections}, {date} tarihinde ek bölüm olarak eklendi.',
                tag: 'Ek bölüm · {date}',
                sectionRegistrations: '§6',
                sectionProfile: '§7',
                sectionMeetingTiming: '§4’teki “Etkinlik öncesi tanışma”',
                sectionComparison: '§8',
            },
        },
    },
    speakerPage: {
        kicker: 'Konuşmacı',
        breadcrumbLabel: 'Sayfa yolu',
        breadcrumbEvents: 'Etkinlikler',
        breadcrumbSpeakers: 'Konuşmacılar',
        aboutTitle: 'Hakkında',
        sessionsTitle: 'Bu etkinlikteki oturumu',
        sessionsEmpty: 'Oturum bilgisi henüz yayınlanmadı.',
        pastTalksTitle: 'Geçmiş konuşmaları',
        pastTalksEmpty: 'Platformdaki ilk konuşması.',
        cardTitle: 'Kartvizit',
        cardBody: 'Bu bilgiler etkinlik sayfasında herkese açık yayınlanan konuşmacı künyesidir. Kişisel iletişim bilgisi içermez.',
        cardDownload: 'vCard olarak indir',
        cardWalletNote: 'Cüzdana ekleme, karekodla çift taraflı onaydan sonra açılır.',
        linksTitle: 'Bağlantılar',
        linkWebsite: 'Web sitesi',
        linkLinkedin: 'LinkedIn',
        linkX: 'X',
        backToEvent: 'Etkinlik sayfasına dön',
        notFoundTitle: 'Konuşmacı bulunamadı',
        fieldName: 'Ad',
        fieldTitle: 'Unvan',
        fieldCompany: 'Şirket',
    },
    program: {
        linkConsentNote: 'Bağlantı, kullanıcı onaylayana kadar kurulmaz. O ana kadar etkinlik sayfasında senin girdiğin bilgiler görünür.',
        speakersKicker: 'Konuşmacılar',
        speakersLabel: 'Konuşmacılar · {count}',
        speakersEmptyTitle: 'Henüz konuşmacı yok',
        speakersEmptyBody: 'Konuşmacı ekle. Etkinliğin herkese açık sayfası ve katılımcı ajandası otomatik güncellenir.',
        addSpeaker: 'Konuşmacı ekle',
        fullNameLabel: 'Ad soyad',
        jobTitleLabel: 'Unvan',
        companyLabel: 'Kurum',
        bioLabel: 'Biyografi',
        websiteLabel: 'Web sitesi',
        linkedinLabel: 'LinkedIn',
        xUrlLabel: 'X (Twitter)',
        photoLabel: 'Fotoğraf',
        photoUploading: 'Fotoğraf yükleniyor…',
        photoUploaded: 'Fotoğraf yüklendi.',
        saveSpeaker: 'Konuşmacıyı kaydet',
        statusDraft: 'Taslak',
        moveUp: 'Yukarı taşı',
        moveDown: 'Aşağı taşı',
        speakerSessions: 'Oturumları: {sessions}',
        deleteSpeakerTitle: 'Konuşmacıyı sil',
        deleteSpeakerBody: 'Bu konuşmacı etkinlik sayfasından kaldırılacak. Emin misin?',
        deleteSpeakerBoundBody: 'Bu konuşmacı {count} oturuma bağlı ({sessions}). Silersen oturumlardaki bağlantısı da kaldırılır.',
        deleteSpeakerBoundBody_one: 'Bu konuşmacı {count} oturuma bağlı ({sessions}). Silersen oturumdaki bağlantısı da kaldırılır.',
        linkCta: 'Kullanıcıya bağla',
        linkEmailLabel: 'Kullanıcının e-posta adresi',
        linkEmailHint: 'Talep, kullanıcıya e-postayla gider. Yanıt, hesabın var olup olmadığını göstermez.',
        linkSend: 'Bağlama talebi gönder',
        linkPending: 'Onay bekliyor',
        linkLinked: 'Bağlı profil',
        linkWithdraw: 'Talebi geri çek',
        linkRemove: 'Bağlantıyı kaldır',
        agendaKicker: 'Ajanda',
        agendaLabel: 'Program',
        /* Yeni görünüm 4b (PanelKonusmaciAjanda): sayfa başı, program tablosu, form başlıkları. */
        pageSub: 'Etkinlik sayfasındaki konuşmacılar ve program.',
        colDay: 'Gün',
        colTime: 'Saat',
        colSession: 'Oturum',
        noSpeakers: 'Konuşmacı yok',
        editSpeakerTitle: 'Konuşmacıyı düzenle',
        editSessionTitle: 'Oturumu düzenle',
        agendaEmptyTitle: 'Program henüz boş',
        agendaEmptyBody: 'Oturum ekle. Gün görünümü otomatik oluşur.',
        addSession: 'Oturum ekle',
        sessionTitleLabel: 'Başlık',
        sessionDescriptionLabel: 'Açıklama',
        sessionTypeLabel: 'Oturum türü',
        typeTalk: 'Konuşma',
        typePanel: 'Panel',
        typeWorkshop: 'Atölye',
        typeBreak: 'Ara',
        typeNetworking: 'Tanışma',
        typeOther: 'Diğer',
        startsAtLabel: 'Başlangıç',
        endsAtLabel: 'Bitiş',
        locationLabel: 'Salon',
        sessionSpeakersLabel: 'Konuşmacılar',
        saveSession: 'Oturumu kaydet',
        deleteSessionTitle: 'Oturumu sil',
        deleteSessionBody: 'Bu oturum ajandadan kaldırılacak. Emin misin?',
        endBeforeStart: 'Bitiş saati başlangıçtan önce olamaz.',
        outsideEventRange: 'Oturum etkinlik tarihlerinin içinde olmalı ({start} ile {end} arası).',
        outsideEventBadge: 'Etkinlik tarihlerinin dışında',
        outsideEventNote: '{count} oturum etkinlik tarihlerinin dışında kaldı ve etkinlik sayfasında görünmüyor. Saatlerini düzenle ya da oturumları sil.',
        outsideEventNote_one: 'Bu oturum etkinlik tarihlerinin dışında kaldı ve etkinlik sayfasında görünmüyor. Saatini düzenle ya da oturumu sil.',
        conflictTitle: 'Zaman çakışması',
        conflictBody: 'Aynı salonda zaman çakışan bir oturum var. Onaylarsan oturum yine de kaydedilir ve katılımcı ajandası ikisini de gösterir.',
        conflictConfirm: 'Yine de kaydet',
        conflictBox: '“{a}” ve “{b}” oturumları aynı salonda aynı saatte. Katılımcı ajandası bu çakışmayı gösterir.',
        dayLabel: '{index}. gün · {date}',
        timezoneNote: 'Saatler etkinlik saat diliminde ({timezone}) gösterilir.',
    },
    speakerLinks: {
        title: 'Konuşmacı bağlantıları',
        intro: 'Bir organizatör seni etkinliğinde konuşmacı profili olarak bağlamak istediğinde talep burada görünür. Profilin, sen onaylamadan konuşmacı olarak yayınlanmaz.',
        emptyTitle: 'Bekleyen bağlantı talebi yok',
        emptyBody: 'Bir organizatör seni konuşmacı olarak bağlamak istediğinde talep burada listelenir ve e-postayla haber verilir.',
        statusPending: 'Onay bekliyor',
        statusLinked: 'Bağlı',
        approve: 'Onayla',
        reject: 'Reddet',
        remove: 'Bağlantıyı kaldır',
        /* Web kaldırma onayı (yeni görünüm K2): kaldırma organizatöre bildirim göndermez, kart organizatörün girdisine döner. */
        removeTitle: '{event} için konuşmacı bağlantısını kaldır',
        removeBody: 'Profilin bu etkinliğin konuşmacı kartından ayrılır. Kart, organizatörün girdiği bilgilerle görünmeye devam eder. Yeniden bağlanmak için organizatörün yeni bir talep göndermesi gerekir.',
        visibilityNote: 'Konuşmacı olmak katılımcı listesine yazılmak değildir. Katılımcı listesinde yalnız etkinliğe kaydolanlar yer alır.',
        // F2A 21/22/24 — mobil konuşmacı onayı, liste ve "onaylandı" ekranı.
        mobileTitle: 'Onay bekliyor',
        reviewBadge: 'Konuşmacı bağlantısı onayı',
        reviewTitle: 'Bir etkinlikte konuşmacı olarak gösterilmek üzeresin',
        reviewBody: 'Onaylamazsan adın ve profilin etkinlik sayfasında yer almaz.',
        rowEvent: 'Etkinlik',
        rowSession: 'Oturum',
        rowDate: 'Tarih',
        rowListedName: 'Listelenen ad',
        rowRequestedAt: 'Talep tarihi',
        organizerVerified: 'Doğrulanmış kurum',
        organizerUnverified: 'Doğrulanmamış kurum',
        consequenceNote: 'Kabul edersen profilinde "konuşmacı" işareti çıkar ve katılımcılar oturumunu görür. Katılımcı listesindeki durumun değişmez.',
        listIntro: 'Konuşmacı olarak gösterildiğin etkinlikler. Bağlantıyı kaldırırsan adın etkinlik sayfasından çıkar ve organizatöre bildirilir.',
        reviewCta: 'İncele',
        doneKicker: 'Bağlantı kuruldu',
        donePoster: 'Konuşmacı olarak onaylandın',
        doneRoleTag: 'Konuşmacı',
        doneCta: 'Bağlantılarımı gör',
        rejectedNotice: 'Bağlantıyı reddettin. Adın etkinlik sayfasında konuşmacı olarak yer almaz.',
        removedNotice: 'Bağlantı kaldırıldı. Organizatöre bildirildi.',
        sessionUnknown: 'Oturum bilgisi bu etkinlikte yayınlanmamış.',
    },
    admin: {
        brandSuffix: 'Admin',
        queueBadge: 'Kuyrukta {count} iş',
        queueBadge_one: 'Kuyrukta {count} iş',
        account: 'platform@{appDomain}',
        nav: {
            heading: 'Yönetim',
            overview: 'Genel görünüm',
            users: 'Kullanıcılar',
            moderation: 'Moderasyon',
            reports: 'Raporlar',
            emailDeliveries: 'E-posta gönderimleri',
            staff: 'Personel',
            salesInquiries: 'Satış adayları',
            organizations: 'Kurumlar',
            referralCodes: 'Referans kodları',
        },
        /*
         * SATIŞ ADAYLARI · KURUMLAR · KREDİ (kurum satışla açılır · P1-P6).
         * Panelde tutar, fiyat ya da ödeme metni YOKTUR: kredi panelden yüklenir,
         * satış ve fatura sistem dışında yürür.
         */
        sales: {
            title: 'Satış adayları',
            total: 'Toplam {count} başvuru',
            total_one: 'Toplam {count} başvuru',
            tabsLabel: 'Durum filtresi',
            all: 'Tümü',
            statuses: {
                new: 'Yeni',
                contacted: 'İletişime geçildi',
                won: 'Kazanıldı',
                lost: 'Kaybedildi',
                spam: 'Spam',
            },
            eventTypes: {
                conference: 'Konferans',
                summit: 'Zirve',
                meetup: 'Buluşma',
                fair: 'Fuar',
                internal: 'Kurum içi',
                training: 'Eğitim ve atölye',
                other: 'Diğer',
            },
            topics: {
                credit_topup: 'Kredi talebi',
                enterprise_contract: 'Sözleşme talebi',
                support: 'Destek talebi',
                other: 'Kurum talebi',
            },
            packages: {
                single: 'Tekli',
                pack_12: '12’li paket',
                enterprise: 'Kurumsal',
            },
            searchLabel: 'Firma adı',
            searchPlaceholder: 'Firma adında ara',
            auditNote: 'Detayı açmak kişisel veriye erişimdir ve adınla denetim defterine yazılır.',
            table: {
                date: 'Başvuru',
                company: 'Firma',
                type: 'Tür',
                attendees: 'Tahmini kat.',
                estimatedDate: 'Tahmini tarih',
                contact: 'İletişim kişisi',
                status: 'Durum',
                organization: 'Bağlı kurum',
            },
            hiddenColumns: '{count} kolon gizli',
            hiddenColumns_one: '{count} kolon gizli',
            anonymized: 'anonimleştirildi',
            range: '{from}–{to} / {total}',
            loading: 'Başvurular yükleniyor',
            emptyTitle: 'Henüz başvuru yok',
            emptyBody: 'Başvurular web sitesindeki kurumsal sayfadan ve mobil uygulamadaki iletişim formundan gelir.',
            filterEmptyTitle: 'Bu filtrede başvuru yok',
            filterEmptyBoth: '“{status}” durumunda “{q}” geçen firma yok.',
            filterEmptyStatus: '“{status}” durumunda başvuru yok.',
            filterEmptyQuery: '“{q}” geçen firma yok.',
            clearFilter: 'Filtreyi temizle',
            errorTitle: 'Başvurular yüklenemedi',
            errorBody: 'Sunucuya ulaşılamadı. Hiçbir başvuru silinmedi. Yeniden denediğinde liste gelir.',
            retry: 'Yeniden dene',
            detail: {
                label: 'Satış adayı detayı',
                kicker: 'Satış adayı · {date}',
                close: 'Kapat',
                contactRole: 'İletişim kişisi',
                contactLinked: 'İletişim kişisi · hesaba bağlı',
                fields: {
                    company: 'Firma adı',
                    eventType: 'Etkinlik türü',
                    attendees: 'Tahmini katılımcı',
                    estimatedDate: 'Tahmini tarih',
                    email: 'E-posta',
                    phone: 'Telefon',
                    note: 'Not',
                    locale: 'Başvuru dili',
                    createdAt: 'Başvuru tarihi',
                    linkedUser: 'Hesaba bağlı',
                    notice: 'KVKK metni',
                    organization: 'Bağlı kurum',
                    referralCode: 'Referans kodu',
                },
                referral: {
                    none: 'Girilmedi',
                    statuses: {
                        valid: 'Aktif',
                        not_found: 'Bulunamadı',
                        inactive: 'Pasif',
                        not_started: 'Başlamadı',
                        expired: 'Süresi doldu',
                        cap_reached: 'Tavan doldu',
                        already_used: 'Bu kurum kullandı',
                        no_organization: 'Kuruma bağlı değil',
                    },
                    usedOn: 'Bu kurum kullandı · {date}',
                    reasons: {
                        not_found: 'Bu kod tanımlı değil. Hediye eklenmez.',
                        inactive: 'Kod kapatıldı. Hediye eklenmez.',
                        not_started: 'Kodun başlangıç günü henüz gelmedi.',
                        notStartedOn: 'Kod {date} tarihinde başlıyor.',
                        expired: 'Kodun süresi doldu.',
                        expiredOn: 'Kodun süresi {date} tarihinde doldu.',
                        cap_reached: 'Kodun kullanım tavanı doldu.',
                        capOf: 'Kod {used} / {cap} kullanıldı.',
                        already_used: '{org} bu kodu daha önce kullandı. Her kurum bir kodu bir kez kullanabilir.',
                        usedOn: '{org} bu kodu {date} tarihinde kullandı. Her kurum bir kodu bir kez kullanabilir.',
                        no_organization: 'Aday bir kuruma bağlı değil. Hediye eklenmez.',
                    },
                },
                notProvided: 'verilmedi',
                copy: 'Kopyala',
                copied: 'Kopyalandı',
                linkedYes: 'Evet · {name}',
                linkedNo: 'Hayır',
                removedAccount: 'Silinmiş hesap',
                noticeValue: 'Sürüm {version} · onay {date}',
                organizationNone: 'Yok',
                statusLabel: 'Durum',
                openOrganization: 'Bu adaydan kurum aç',
                historyTitle: 'Geçmiş · denetim izi',
                historyViewed: 'detayı görüntüledi',
                historyStatus: 'durumu değiştirdi · {from} → {to}',
                historyCreated: 'başvuruyu kaydetti · form, {locale}',
                system: 'Sistem',
                saving: 'Durum kaydediliyor…',
                saveError: 'Durum kaydedilemedi. Eski durum ({status}) geri yüklendi.',
                notFound: 'Bu başvuru bulunamadı. Silinmiş ya da bağlantı hatalı olabilir.',
                backToList: 'Listeye dön',
                loadError: 'Başvuru yüklenemedi. Sunucuya ulaşılamadı.',
                loading: 'Başvuru yükleniyor',
                anonymizedBanner: 'Müşteriye dönüşmediği için {date} tarihinde anonimleştirildi.',
            },
        },
        orgs: {
            title: 'Kurumlar',
            total: 'Toplam {count} kurum',
            total_one: 'Toplam {count} kurum',
            create: 'Kurum aç',
            searchLabel: 'Kurum adı',
            searchPlaceholder: 'Kurum adında ara',
            auditNote: 'Kurum açma ve kredi işlemleri adınla denetim defterine yazılır.',
            table: {
                organization: 'Kurum',
                verification: 'Doğrulama',
                owner: 'Sahip',
                credits: 'Kalan kredi',
                contractEnd: 'Sözleşme bitişi',
                source: 'Kaynak',
                createdAt: 'Açılış',
            },
            verification: {
                verified: 'Doğrulanmış',
                unverified: 'Doğrulanmamış',
                pending: 'Doğrulama bekliyor',
                rejected: 'Doğrulama reddedildi',
            },
            sources: {
                panel: 'Panel',
                self_serve: 'Kendi başına açılmış, eski',
            },
            owner: {
                invited: 'Sahip daveti bekliyor',
                expired: 'Sahip davetinin süresi doldu',
                declined: 'Sahip daveti reddedildi',
                revoked: 'Sahip daveti iptal edildi',
                none: 'Sahip yok',
                removedAccount: 'Silinmiş hesap',
            },
            loading: 'Kurumlar yükleniyor',
            emptyTitle: 'Henüz kurum yok',
            emptyBody: 'Kurumlar yalnız panelden açılır. Satış kapanınca kurumu buradan aç.',
            searchEmptyTitle: '“{q}” adında kurum yok',
            searchEmptyLead: 'Satış adaylarında {name} var.',
            searchEmptyLeadAction: 'Adayı aç',
            errorTitle: 'Kurumlar yüklenemedi',
            errorBody: 'Sunucuya ulaşılamadı. Yeniden denediğinde liste gelir. Kurum açmak listeden bağımsız çalışır.',
            auditLine: 'Bu işlem {name} adına, gönderildiği anda denetim defterine yazılır.',
            cancel: 'Vazgeç',
            retry: 'Yeniden dene',
            optional: '· isteğe bağlı',
            createDialog: {
                title: 'Kurum aç',
                fromLead: 'Satış adayı · {name}',
                name: 'Kurum adı',
                namePlaceholder: 'Kurumun görünen adı',
                ownerEmail: 'Kurum hesabının açılacağı iş e-postası',
                ownerEmailPlaceholder: 'ad@kurum.com',
                website: 'Kurum web sitesi',
                contactEmail: 'İletişim e-postası',
                contactEmailPlaceholder: 'iletisim@kurum.com',
                lead: 'İlişkili satış adayı',
                leadNone: 'Seçilmedi',
                leadOption: '{name} · {date}',
                info: 'Kurum doğrulanmış olarak açılacak · Sahibe davet gönderilecek · 1 hoş geldin kredisi tanımlanacak',
                submit: 'Kurumu aç ve davet gönder',
                submitting: 'Açılıyor…',
                nameRequired: 'Kurum adı gerekli.',
                nameShort: 'Kurum adı en az 2 karakter olmalı.',
                emailRequired: 'Sahip e-postası gerekli.',
                emailInvalid: 'Geçerli bir e-posta adresi gir.',
                websiteInvalid: 'Geçerli bir web adresi gir.',
                nameClash: 'Bu ad doğrulanmış bir kurumun adına çok yakın. Farklı bir ad gir.',
                nameClashNamed: 'Bu ad doğrulanmış bir kurumun adına çok yakın: {name}',
                serverError: 'Kurum açılamadı. Hiçbir şey kaydedilmedi, davet gönderilmedi. Girdiğin bilgiler duruyor.',
                successTitle: '{name} açıldı',
                successVerified: 'Kurum doğrulanmış olarak açıldı',
                successInvited: 'Davet gönderildi',
                successTrial: '1 hoş geldin kredisi tanımlandı',
                successAudit: 'Denetim defterine {name} adına yazıldı · {date}',
                goDetail: 'Kurum detayına git',
                goGrant: 'Kredi yükle',
            },
            detail: {
                back: 'Kurumlar',
                openedAt: 'Açılış {date}',
                openedBy: 'Açan · {name}',
                members: '{count} üye',
                members_one: '{count} üye',
                notFound: 'Bu kurum bulunamadı. Silinmiş ya da bağlantı hatalı olabilir.',
                backToList: 'Kurumlara dön',
                loadError: 'Kurum bilgisi yüklenemedi.',
                loading: 'Kurum bilgisi yükleniyor',
                ownerTitle: 'Sahip',
                ownerActive: 'Aktif',
                ownerPendingKicker: 'Sahip daveti bekliyor',
                ownerExpiredKicker: 'Sahip davetinin süresi doldu',
                ownerDeclinedKicker: 'Sahip daveti reddedildi',
                ownerNoneKicker: 'Kurumun etkin sahibi yok',
                ownerStepsLabel: 'Davet durumu',
                stepSent: 'Gönderildi',
                stepAccepted: 'Kabul',
                stepDeclined: 'Red',
                stepExpired: 'Süresi doldu',
                invitedTo: 'Davet edilen adres',
                sentAt: 'Gönderildi {date}',
                expiresAt: 'Son geçerlilik {date}',
                resend: 'Daveti yeniden gönder',
                replace: 'Daveti iptal et ve başka adrese gönder',
                inviteNew: 'Yeni sahip daveti gönder',
                resent: 'Davet yeniden gönderildi. Eski bağlantı artık çalışmaz.',
                replaced: 'Yeni sahip daveti gönderildi.',
                replaceTitle: 'Sahip davetini başka adrese gönder',
                inviteTitle: 'Yeni sahip daveti',
                currentEmail: 'Mevcut davet adresi',
                currentEmailNote: 'Eski davet geçersiz olur.',
                inviteInfo: 'Davet edilen kişi kabul edince kurumun sahibi olur.',
                sendInvite: 'Daveti gönder',
                sending: 'Gönderiliyor…',
                actionError: 'İşlem tamamlanamadı. Sahip daveti değişmedi.',
            },
            /** Etkinlik raporları bölümü (organizatör raporu tasarım kare 5): salt okunur özet. */
            reports: {
                title: 'Etkinlik raporları',
                colEvent: 'ETKİNLİK',
                colDate: 'TARİH',
                colRegistered: 'KESİN KAYIT',
                colRate: 'CHECK-IN ORANI',
                colSatisfaction: 'MEMNUNİYET',
                colStatus: 'DURUM',
                statusFinal: 'Kesin',
                statusPreliminary: 'Ön rapor',
                fewerThanMin: '{min}’ten az',
                hidden: 'Gösterilmez',
                ratePercent: '%{rate}',
                thresholdNote: 'Katılımcıların gizliliği için {min}’ten küçük sayılar gösterilmez.',
                emptyTitle: 'Bitmiş etkinlik yok',
                emptyBody: 'Kurumun bir etkinliği bittiğinde raporu burada listelenir.',
                loading: 'Raporlar yükleniyor',
                loadError: 'Raporlar yüklenemedi.',
                retry: 'Yeniden dene',
            },
            /*
             * ETKİNLİK SONRASI bölümü (belge ve anket Story 8, tasarım kare 11): belge ve anket
             * durumu, cevap sayısı (5'in katı), "Anketi kapat". Cevap içeriği gösterilmez.
             */
            postEvent: {
                title: 'Etkinlik sonrası',
                colEvent: 'ETKİNLİK',
                colDate: 'TARİH',
                colCertificate: 'BELGE',
                colSurvey: 'ANKET',
                colResponses: 'CEVAP',
                colAction: 'Eylem',
                certificateOn: 'Açık',
                certificateOff: 'Kapalı',
                survey: {
                    none: 'Anket yok',
                    draft: 'Taslak',
                    open: 'Açık',
                    closed: 'Kapandı',
                    disabled_by_staff: 'Personel kapattı',
                },
                surveyOpen: 'Açık · {count} gün kaldı',
                surveyOpen_one: 'Açık · {count} gün kaldı',
                fewerThanMin: '{min}’ten az',
                noResponses: 'Cevap sayısı yok',
                note: 'Personel kişi bazlı cevap görmez. Cevap sayısı {min}’ten azsa “{min}’ten az” yazar.',
                emptyTitle: 'Bitmiş etkinlik yok',
                emptyBody: 'Kurumun bir etkinliği bittiğinde belge ve anket durumu burada listelenir.',
                loading: 'Etkinlik sonrası yükleniyor',
                loadError: 'Bu bölüm yüklenemedi.',
                retry: 'Yeniden dene',
                close: 'Anketi kapat',
                closeAria: '{eventTitle} anketini kapat',
                closedNotice: '{eventTitle} anketi kapatıldı.',
                dialogTitle: 'Anket kapatılsın mı?',
                dialogBody: '{eventTitle} anketi hemen kapanır. Katılımcılar artık cevap veremez. Gelen cevaplar ve sonuçlar kalır. Bu işlem geri alınamaz.',
                reason: 'Gerekçe',
                reasonRequired: '(zorunlu)',
                reasonHint: 'Gerekçe denetim defterine adınla yazılır.',
                reasonEmpty: 'Kapatma gerekçesini yaz.',
                reasonShort: 'Gerekçe en az {count} karakter olmalı.',
                reasonShort_one: 'Gerekçe en az {count} karakter olmalı.',
                cancel: 'Vazgeç',
                submit: 'Anketi kapat',
                submitting: 'Kapatılıyor…',
                serverError: 'Anket kapatılamadı. Bir şey değişmedi.',
                reloaded: 'Etkinlik sonrası listesi yeniden yüklendi.',
            },
            /*
             * KAPAK GÖRSELİ (kurum kapağı · Story P1): önizleme ve gerekçeli kaldırma.
             * Kuruma bildirim gitmez (kapsam dışı); gerekçe deftere özet olarak yazılır,
             * okunur hâli kartta "Son kaldırma" bölümünde durur (karar 14.10.2026).
             */
            cover: {
                title: 'Kapak görseli',
                previewAlt: '{name} kapak görseli',
                previewPending: 'Önizleme hazırlanıyor. Görsel işlenince burada görünür.',
                previewError: 'Önizleme yüklenemedi. Kapak yine de kaldırılabilir.',
                none: 'Bu kurumun kapak görseli yok.',
                remove: 'Kapağı kaldır',
                dialogTitle: 'Kapağı kaldır',
                dialogSub: '{name} sayfasındaki kapak kaldırılır ve dosya depodan silinir. Geri alınamaz.',
                reason: 'Gerekçe',
                reasonHint: 'Neden kaldırdığını kısaca yaz.',
                warn: 'Kurum sahibine bildirim gitmez. Sahip, Marka ayarlarından yeni bir kapak yükleyebilir.',
                submit: 'Kapağı kaldır',
                submitting: 'Kaldırılıyor…',
                removed: 'Kapak kaldırıldı.',
                changed: 'Kapak bu arada değişti. Güncel hâli yüklendi, kaldırmadan önce yeniden bak.',
                notSet: 'Bu kurumun kapağı zaten kaldırılmış.',
                serverError: 'Kapak kaldırılamadı. Kapak yerinde duruyor.',
                lastRemovalTitle: 'Son kaldırma',
                lastRemovalBy: '{name} kaldırdı',
            },
            /*
             * İŞ ADRESİ UYARISI (KH8 · Story H7 · TP1): sahip adresi bir kişisel
             * hesaptaysa alan bekleme rengine geçer, gönderim ikinci onay ister.
             * Hesabın sahibi, adı ya da türü söylenmez.
             */
            ownerCheck: {
                checking: 'Adres kontrol ediliyor…',
                unavailable: 'Bu adres şu an kontrol edilemedi.',
                retry: 'Tekrar kontrol et',
                warn: 'Bu adres kişisel bir hesapta kullanılıyor. Sahip daveti bu adresle kabul edilemez. Müşteriden başka bir iş adresi iste.',
                confirmTitle: 'Davet yine de gönderilsin mi?',
                confirmBody: 'kişisel bir hesapta kullanılıyor. Sahip daveti bu adresle kabul edilemez.',
                confirmAudit: 'Karar denetim defterine {name} adına yazılır.',
                sendAnyway: 'Yine de gönder',
                change: 'Adresi değiştir',
            },
        },
        /*
         * REFERANS (HEDİYE) KODLARI (P7 · referans kodu kapsamı 12.10.2026).
         * Kod yalnız "N hediye kredi" verir: tutar, fiyat ya da indirim metni YOK.
         */
        referralCodes: {
            title: 'Referans kodları',
            lead: 'Kurum kodu kredi talep formuna yazar. Kredi yüklerken hediye krediyi sen eklersin.',
            create: 'Kod oluştur',
            edit: 'Düzenle',
            editCode: '{code} kodunu düzenle',
            retry: 'Yeniden dene',
            tabsLabel: 'Durum filtresi',
            tabs: {
                all: 'Tümü',
                active: 'Aktif',
                inactive: 'Pasif',
            },
            table: {
                code: 'Kod',
                gift: 'Hediye',
                valid: 'Geçerlilik',
                usage: 'Kullanım',
                status: 'Durum',
                actions: 'Eylem',
            },
            statuses: {
                active: 'Aktif',
                inactive: 'Pasif',
                not_started: 'Başlamadı',
                expired: 'Süresi doldu',
                cap_reached: 'Tavan doldu',
            },
            gift: '+{count} kredi',
            gift_one: '+{count} kredi',
            validOpen: 'Süresiz',
            validRange: '{from} – {to}',
            validFrom: '{date} itibarıyla',
            validUntil: '{date} tarihine kadar',
            usage: '{used} / {cap}',
            usageUnlimited: '{used} / sınırsız',
            rowHint: 'Satıra tıklayınca kullanım detayı açılır.',
            loading: 'Referans kodları yükleniyor',
            emptyTitle: 'Henüz referans kodu yok',
            emptyBody: 'İlk kodu oluşturduğunda burada listelenir. Kurum bu kodu kredi talep formuna yazınca hediye krediyi kredi yüklerken eklersin.',
            filterEmptyTitle: 'Bu sekmede kod yok',
            filterEmptyBody: 'Bütün kodlar Tümü sekmesinde görünür.',
            showAll: 'Tümünü göster',
            listError: 'Referans kodları okunamadı.',
            created: 'oluşturuldu.',
            dialog: {
                createTitle: 'Kod oluştur',
                editTitle: 'Kodu düzenle',
                usedBy: '{count} kurum kullandı',
                usedBy_one: '{count} kurum kullandı',
                notUsed: 'Henüz kullanılmadı',
                code: 'Kod',
                gift: 'Hediye kredi sayısı',
                start: 'Başlangıç günü',
                end: 'Bitiş günü',
                cap: 'Toplam kullanım tavanı',
                note: 'İç not',
                required: 'zorunlu',
                optional: 'isteğe bağlı',
                codeHint: '4–32 karakter. Yalnız harf ve rakam. Büyük/küçük harf fark etmez.',
                giftHint: '1 ile 12 arasında.',
                capHint: 'Boşsa sınırsız.',
                noteHint: 'Yalnız personel görür.',
                savedAs: 'Kaydedilecek:',
                codePlaceholder: 'ör. originn100',
                giftPlaceholder: 'ör. 1',
                capPlaceholder: 'Sınırsız',
                notePlaceholder: 'Kodun nereden geldiğini yaz',
                locked: 'Kilitli',
                lockNote: 'Kullanılmış bir kodun anlamı değişmesin diye kod ve hediye sonradan değişmez.',
                giftInfo: 'Hediye kredi tekli kredi gibidir. Süresizdir ve etkinlik başına 1.000 katılımcı taşır.',
                active: 'Aktif',
                activeHint: 'Kapalıyken kod kredi talep formunda kabul edilmez. Kod silinmez.',
                audit: 'Bu işlem adınla denetim defterine yazılır.',
                save: 'Kaydet',
                cancel: 'Vazgeç',
                close: 'Kapat',
                creating: 'Oluşturuluyor…',
                saving: 'Kaydediliyor…',
                codeRequired: 'Kod gerekli.',
                codeFormat: 'Yalnız harf ve rakam kullan. 4–32 karakter olmalı.',
                codeTaken: 'Bu kod zaten var. Büyük/küçük harf fark etmez.',
                giftRange: '1 ile 12 arasında bir sayı gir.',
                endBeforeStart: 'Bitiş günü başlangıç gününden önce olamaz.',
                capInvalid: '1 ya da daha büyük bir tam sayı gir.',
                createError: 'Kod oluşturulamadı. Hiçbir şey kaydedilmedi. Girdiğin bilgiler duruyor.',
                updateError: 'Kod kaydedilemedi. Hiçbir şey değişmedi. Girdiğin bilgiler duruyor.',
                refresh: 'Listeyi yenile',
            },
            drawer: {
                label: 'Kullanım detayı',
                close: 'Kapat',
                gift: 'Hediye',
                valid: 'Geçerlilik',
                usage: 'Kullanım',
                remaining: '{count} kullanım kaldı',
                remaining_one: '{count} kullanım kaldı',
                noCap: 'Tavan yok',
                note: 'İç not',
                uses: 'Kullanımlar',
                emptyTitle: 'Henüz kullanılmadı',
                emptyBody: 'Bir kurum bu kodu kredi talep formuna yazıp kredisi yüklenince burada görünür.',
                by: 'Yükleyen',
                usedAt: 'Kullanım',
                usesLoading: 'Kullanımlar yükleniyor',
                usesError: 'Kullanım listesi okunamadı.',
                removedStaff: 'Silinmiş kullanıcı',
                once: 'Her kurum bu kodu bir kez kullanabilir.',
                notFound: 'Bu kod bulunamadı. Bağlantı hatalı olabilir.',
                backToList: 'Listeye dön',
            },
        },
        /*
         * SONUCU BİLİNMEYEN YAZMA (T4 QA P2-1): yanıt gelmediğinde "kaydedilmedi"
         * gibi kesin bir cümle kurulmaz. Ne yeniden yüklendiği ve aynı bilgilerle
         * göndermenin güvenli olup olmadığı söylenir.
         */
        write: {
            unknown: 'Sonuç doğrulanamadı. İşlem sunucuda kaydedilmiş olabilir.',
            reloadedLedger: 'Kredi özeti ve defter yeniden yüklendi, arkadaki defteri kontrol et. Aynı bilgilerle yeniden gönderirsen ikinci kayıt oluşmaz.',
            reloadedContracts: 'Sözleşmeler yeniden yüklendi, arkadaki kartı kontrol et. Aynı bilgilerle yeniden gönderirsen ikinci kayıt oluşmaz.',
            reloadedTermination: 'Sözleşmeler yeniden yüklendi, arkadaki kartı kontrol et.',
            reloadedOrganizations: 'Kurum listesi yeniden yüklendi. Aynı bilgilerle yeniden gönderirsen ikinci kurum açılmaz.',
            reloadedOwner: 'Sahip durumu yeniden yüklendi, kartı kontrol et.',
            reloadedCover: 'Kurum bilgisi yeniden yüklendi, kapak kartını kontrol et.',
            reloadedStatus: 'Başvuru yeniden yüklendi, durumu kontrol et.',
            reloadedReferralCodes: 'Liste yeniden yüklendi. Yeniden göndermeden önce listeyi kontrol et, kod listede varsa yeniden oluşturma.',
        },
        credit: {
            summaryTitle: 'Kredi özeti',
            remainingLabel: 'kalan kredi',
            remainingLabel_one: 'kalan kredi',
            kinds: {
                trial: 'Hoş geldin',
                single: 'Tekli',
                pack_12: '12’li paket',
            },
            kindDesc: {
                trial: '{ceiling} katılımcı · kurum açılışında 1',
                single: '{ceiling} katılımcı · süresiz',
                pack_12: '{ceiling} katılımcı · satın almadan 1 yıl',
            },
            burnTitle: '12’li paket · yanma',
            burnBought: 'Alındı {date}',
            burnExpires: 'Yanar {date}',
            burnLeft: '{count} kaldı',
            burnLeft_one: '{count} kaldı',
            grant: 'Kredi yükle',
            exhaustedTitle: 'Kredi bitti',
            exhaustedBody: 'Kurum yeni etkinlik yayınlayamaz. Yayındakiler etkilenmez.',
            contractCovers: 'Sözleşme etkin. {date} gün sonuna kadar yayınlar kredi harcamaz.',
            loading: 'Kredi özeti yükleniyor',
            loadError: 'Kredi özeti yüklenemedi.',
            contract: {
                title: 'Kurumsal sözleşme',
                active: 'Etkin',
                start: 'Başlangıç',
                end: 'Bitiş',
                reference: 'Referans',
                createdBy: 'Oluşturan',
                terminatedAt: 'Sonlandırıldı {date}',
                none: 'Bu kurumun sözleşmesi yok.',
                define: 'Sözleşme tanımla',
                terminate: 'Sözleşmeyi sonlandır',
                blockedNote: 'Etkin sözleşme varken yenisi tanımlanmaz.',
                loadError: 'Sözleşmeler yüklenemedi.',
            },
            ledger: {
                title: 'Kredi defteri',
                immutable: 'Defter silinemez ve değiştirilemez. Düzeltme yalnız ters kayıtla yapılır.',
                at: 'Tarih',
                kind: 'Tür',
                amount: 'Miktar',
                event: 'Etkinlik',
                actor: 'Aktör',
                reference: 'Referans',
                reason: 'Gerekçe',
                actions: 'İşlem',
                kinds: {
                    grant: 'Yükleme',
                    consume: 'Harcama',
                    consume_contract: 'Sözleşme kapsamında',
                    refund: 'İade',
                    expire: 'Yanma',
                    reversal: 'Ters kayıt',
                },
                reasons: {
                    trialProvision: 'Hoş geldin kredisi · kurum açılışı',
                    consume: 'Yayın',
                    consume_contract: 'Sözleşme süresinde yayın',
                    refund: 'Kayıt gelmeden iptal',
                    expire: '12’li paket süresi doldu',
                },
                system: 'Sistem',
                removedActor: 'Silinmiş hesap',
                reverse: 'Ters kaydet',
                range: '{from}–{to} / {total} kayıt',
                empty: 'Bu kurumun defterinde hareket yok.',
                onlyTrial: 'Başka hareket yok',
                giftTag: 'Hediye · {code}',
                loading: 'Kredi defteri yükleniyor',
                loadError: 'Kredi defteri yüklenemedi.',
            },
            grantDialog: {
                title: 'Kredi yükle',
                packLabel: 'Paket',
                single: 'Tekli',
                singleDesc: '1 kredi · etkinlik başına {ceiling} katılımcı · süresiz',
                pack: '12’li paket',
                packDesc: '{credits} kredi · satın almadan itibaren 1 yıl',
                giftOnly: 'Yalnız hediye',
                giftOnlyDesc: 'Ödenen kredi yazılmaz, yalnız hediye kredi.',
                giftOnlyOff: 'Geçerli bir kod gerekir.',
                sourceLead: '{org} · satış adayından',
                sourceOrganization: '{org} · kurum detayından',
                giftBlock: 'Hediye kodu',
                giftValue: '+{count} hediye kredi',
                giftValue_one: '+{count} hediye kredi',
                addGift: 'Hediyeyi ekle',
                giftFromLead: 'Kod satış adayının kredi talep formundan geldi.',
                giftNoCode: 'Adayın formunda hediye kodu yok.',
                giftField: 'Hediye kodu',
                giftFieldPlaceholder: 'ör. originn100',
                giftFieldHint: 'Yazılan kod gönderimde doğrulanır.',
                giftCodeFormat: 'Yalnız harf ve rakam kullan. 4–32 karakter olmalı.',
                giftCodeNotFound: 'Bu kod bulunamadı. Kodu düzelt ya da alanı boş bırak.',
                purchaseDay: 'Satın alma tarihi',
                purchaseHint: 'Gelecek tarih ve 1 yıldan eski tarih seçilemez.',
                reference: 'Sözleşme ya da teklif no',
                reason: 'Gerekçe ya da not',
                confirmSingle: '{org} kurumuna 1 tekli kredi yüklenecek. Süresizdir.',
                confirmPack: '{org} kurumuna {count} kredi yüklenecek. Satın alma {buy}, {burn} gün sonunda yanacak.',
                confirmPack_one: '{org} kurumuna {count} kredi yüklenecek. Satın alma {buy}, {burn} gün sonunda yanacak.',
                confirmSingleGift: '{org} kurumuna 1 tekli kredi ve {count} hediye kredi ({code}) yüklenecek. İkisi de süresizdir.',
                confirmSingleGift_one: '{org} kurumuna 1 tekli kredi ve {count} hediye kredi ({code}) yüklenecek. İkisi de süresizdir.',
                confirmPackGift: '{org} kurumuna {credits} kredi ve {count} hediye kredi ({code}) yüklenecek. 12’li paket {burn} gün sonunda yanar. Hediye kredi süresizdir.',
                confirmPackGift_one: '{org} kurumuna {credits} kredi ve {count} hediye kredi ({code}) yüklenecek. 12’li paket {burn} gün sonunda yanar. Hediye kredi süresizdir.',
                confirmGiftOnly: '{org} kurumuna yalnız {count} hediye kredi ({code}) yüklenecek.',
                confirmGiftOnly_one: '{org} kurumuna yalnız {count} hediye kredi ({code}) yüklenecek.',
                confirmTypedGift: '{code} kodunun hediyesi de aynı işlemde eklenir, kod gönderimde doğrulanır.',
                confirmTypedGiftOnly: '{org} kurumuna yalnız {code} kodunun hediye kredisi yüklenecek. Kod gönderimde doğrulanır.',
                conflict: 'Hediye eklenemedi, {reason}. Hiçbir kredi yüklenmedi.',
                conflictReasons: {
                    not_found: 'kod bulunamadı',
                    inactive: 'kod bu arada kapatıldı',
                    not_started: 'kodun başlangıç günü henüz gelmedi',
                    expired: 'kodun süresi doldu',
                    cap_reached: 'kodun tavanı bu arada doldu',
                    already_used: 'bu kurum kodu daha önce kullandı',
                },
                continueWithoutGift: 'Hediyesiz devam et',
                inquiryMismatch: 'Satış adayı bu kurumla ya da bu kodla eşleşmiyor. Hiçbir kredi yüklenmedi. Pencereyi kapatıp adayı yeniden aç.',
                reloadedUnknown: 'Kredi defteri yeniden yüklendi. Yeniden göndermeden önce defteri kontrol et, kayıt varsa yeniden yükleme.',
                openLedger: 'Kredi defterini aç',
                goOrganization: 'Kurum detayına git',
                successPaidSingle: '{count} tekli kredi yüklendi',
                successPaidSingle_one: '{count} tekli kredi yüklendi',
                successPaidPack: '{count} kredi yüklendi · 12’li paket',
                successPaidPack_one: '{count} kredi yüklendi · 12’li paket',
                successGift: '{count} hediye kredi eklendi ({code})',
                successGift_one: '{count} hediye kredi eklendi ({code})',
                successUsage: 'Kod kullanımı {org} adına kaydedildi',
                successAudit: 'Denetim defterine yazıldı · {name} · {date}',
                submit: 'Yükle',
                submitting: 'Yükleniyor…',
                referenceRequired: 'Referans gerekli (sözleşme ya da teklif numarası).',
                purchaseRequired: 'Satın alma tarihi gerekli.',
                purchaseFuture: 'Satın alma tarihi gelecekte olamaz.',
                purchaseOld: 'Satın alma tarihi 1 yıldan eski olamaz.',
                serverError: 'Kredi yüklenemedi. Hiçbir şey kaydedilmedi. Girdiğin bilgiler duruyor.',
            },
            reverseDialog: {
                title: 'Ters kaydet',
                sub: '{date} · {kind} · yükleyen {name}',
                amount: 'Miktar',
                amountHint: '{total} kredinin {used} tanesi harcandı. En fazla {count} kredi ters kaydedilebilir.',
                amountHint_one: '{total} kredinin {used} tanesi harcandı. En fazla {count} kredi ters kaydedilebilir.',
                amountHintReversed: '{total} kredinin {used} tanesi harcandı, {reversed} tanesi daha önce ters kaydedildi. En fazla {count} kredi ters kaydedilebilir.',
                amountHintReversed_one: '{total} kredinin {used} tanesi harcandı, {reversed} tanesi daha önce ters kaydedildi. En fazla {count} kredi ters kaydedilebilir.',
                reason: 'Gerekçe',
                warn: 'İlk kayıt silinmez, defterde ters kayıt satırı oluşur.',
                submit: '{count} krediyi ters kaydet',
                submit_one: '{count} krediyi ters kaydet',
                submitPlain: 'Ters kaydet',
                submitting: 'Kaydediliyor…',
                amountMax: 'En fazla {count} kredi ters kaydedilebilir.',
                amountMax_one: 'En fazla {count} kredi ters kaydedilebilir.',
                amountMin: 'Miktar en az 1 olmalı.',
                reasonRequired: 'Gerekçe gerekli.',
                serverError: 'Ters kayıt yazılamadı. Deftere satır düşmedi, kalan kredi değişmedi.',
            },
            contractDialog: {
                title: 'Kurumsal sözleşme tanımla',
                start: 'Başlangıç',
                end: 'Bitiş',
                reference: 'Referans',
                info: 'Sözleşme süresince bu kurum kredi harcamadan sınırsız etkinlik yayınlar ve kurumun tüm etkinliklerinde katılımcı sınırı kalkar.',
                submit: 'Sözleşmeyi tanımla',
                submitting: 'Kaydediliyor…',
                startRequired: 'Başlangıç tarihi gerekli.',
                endRequired: 'Bitiş tarihi gerekli.',
                endBeforeStart: 'Bitiş, başlangıçtan önce olamaz.',
                serverError: 'Sözleşme kaydedilemedi. Kurumun kredi durumu değişmedi.',
            },
            terminateDialog: {
                title: 'Sözleşmeyi sonlandır',
                sub: '{reference} · {start} ile {end} arası',
                reason: 'Sonlandırma gerekçesi',
                info: 'Sonlandırma anından sonra yayınlar krediye düşer. Yayındaki etkinlikler etkilenmez.',
                submit: 'Sonlandır',
                submitting: 'Sonlandırılıyor…',
                reasonRequired: 'Sonlandırma gerekçesi gerekli.',
                serverError: 'Sözleşme sonlandırılamadı. Sözleşme etkin kalıyor.',
                alreadyTerminated: 'Bu sözleşme zaten sonlandırılmış (önceki deneme işlemiş olabilir). Sözleşmeler yeniden yüklendi, arkadaki kartı kontrol et.',
            },
            conflict: 'Bu istek başka bilgilerle zaten gönderilmiş. Diyaloğu kapatıp yeniden aç.',
        },
        /*
         * E-POSTA GÖNDERİM GÖRÜNÜMÜ — SALT OKUNUR.
         *
         * Metinler ekranın NE OLMADIĞINI da söyler: gövde saklanmaz, adres
         * saklanmaz, yeniden gönderme yoktur. Personel bunu ekranda okur; aksi
         * hâlde olmayan bir yeteneği arar.
         */
        emailDeliveries: {
            title: 'E-posta gönderimleri',
            lead: 'İşlemsel e-postaların gönderim kaydı. E-posta gövdesi ve alıcı adresi saklanmaz. Alıcı yalnız kısaltılmış bir özetle görünür. Kayıtlar salt okunurdur, buradan yeniden gönderim yapılmaz.',
            headline: '{count} kayıt',
            headline_one: '{count} kayıt',
            loading: 'Gönderim kayıtları yükleniyor',
            filters: {
                heading: 'Filtreler',
                status: 'Durum',
                template: 'Şablon',
                locale: 'Dil',
                from: 'Başlangıç',
                to: 'Bitiş',
                all: 'Tümü',
                reset: 'Filtreleri temizle',
            },
            statuses: {
                queued: 'Kuyrukta',
                sent: 'Gönderildi',
                failed: 'Başarısız',
                dead: 'Vazgeçildi',
            },
            table: {
                template: 'Şablon',
                recipient: 'Alıcı',
                locale: 'Dil',
                status: 'Durum',
                queued: 'Sıraya alındı',
                result: 'Sonuç',
                reason: 'Sebep',
            },
            recipientHint: 'Alıcı adresi saklanmaz. Burada görünen, adresin özetinin ilk 8 karakteridir.',
            recipientShort: '{prefix}…',
            copyRecipient: 'Alıcı özetini kopyala: {prefix}',
            copied: 'Kopyalandı',
            attempts: '{count} deneme',
            attempts_one: '{count} deneme',
            notYet: 'Henüz yok',
            reasonNone: 'Sağlayıcı sebep bildirmedi',
            maskNote: 'Sağlayıcı metnindeki e-posta adresleri otomatik maskelenir.',
            providerMessageId: 'Sağlayıcı iz no: {id}',
            relatedUser: 'Kullanıcıyı aç',
            emptyTitle: 'Bu filtreye uyan gönderim yok',
            emptyBody: 'Filtreleri genişlet. Platformdan çıkan her işlemsel e-posta bu listede görünür.',
            emptyStepReset: 'Filtreleri temizleyip tüm kayıtlara dön',
            emptyStepRange: 'Tarih aralığını genişlet',
            emptyAllTitle: 'Henüz e-posta gönderilmedi',
            emptyAllBody: 'İlk işlemsel e-posta çıktığında (giriş kodu, kayıt onayı, davet) satır burada belirir.',
            templates: {
                otp_login: 'Giriş kodu',
                registration_confirmed: 'Kayıt onayı',
                event_invitation: 'Etkinlik daveti',
                application_result: 'Başvuru sonucu',
                event_updated: 'Etkinlik güncellendi',
                event_cancelled: 'Etkinlik iptal edildi',
                team_invitation: 'Ekip daveti',
                claim_owner_notice: 'Sahiplenme bildirimi',
                claim_decision: 'Sahiplenme kararı',
                claim_transferred: 'Sahiplenme devri',
                claim_info_request: 'Sahiplenme ek bilgi isteği',
                data_export_ready: 'Veri dışa aktarımı hazır',
                account_deletion_confirmed: 'Hesap silme onayı',
                speaker_link_request: 'Konuşmacı eşleme isteği',
                invitation_request: 'Davet isteği',
                meeting_request_received: 'Görüşme talebi geldi',
                meeting_request_accepted: 'Görüşme talebi kabul edildi',
                meeting_request_declined: 'Görüşme talebi reddedildi',
                meeting_request_cancelled: 'Görüşme talebi iptal edildi',
                organization_verification_decision: 'Kurum doğrulama kararı',
                card_exchange_confirmed: 'Kartvizit değişimi onaylandı',
                follow_up_reminder: 'Takip hatırlatması',
                staff_login_code: 'Panel giriş kodu',
                staff_invitation: 'Panel daveti',
                email_verification: 'E-posta doğrulama',
                password_reset: 'Şifre sıfırlama',
                account_exists_notice: 'Hesabın zaten var bildirimi',
                event_ceiling_warning: 'Katılımcı sınırı uyarısı',
                organizer_announcement: 'Organizatör duyurusu',
                event_report_ready: 'Rapor hazır',
                post_event_message: 'Etkinlik sonrası iletisi',
                event_reminder: 'Etkinlik hatırlatması',
            },
        },
        /*
         * PERSONEL HESAPLARI (panel kimliği ayrımı · Karar 4c). Panelde "şifremi
         * unuttum" YOKTUR; kilitlenen personelin tek dönüş yolu buradaki yeniden
         * davettir. Metinler bunu açıkça söyler.
         */
        staff: {
            title: 'Personel',
            headline: '{total} hesap · {admins} yönetici',
            lead: 'Panele girebilen personel hesapları. Yeni personel yalnız davetle açılır. Panelde şifre sıfırlama yoktur, kilitlenen personeli buradan yeniden davet edersin.',
            loading: 'Personel listesi yükleniyor',
            invite: 'Personel davet et',
            table: {
                person: 'Personel',
                role: 'Rol',
                status: 'Durum',
                lastLogin: 'Son giriş',
                createdAt: 'Eklenme',
            },
            roles: { admin: 'Yönetici', moderator: 'Moderatör' },
            statuses: { active: 'Etkin', suspended: 'Askıda', disabled: 'Kapalı' },
            passwordNotSet: 'Şifre kurulmadı',
            you: 'Sen',
            selfNote: 'Kendi hesabın',
            neverLoggedIn: 'Hiç girmedi',
            reinvite: 'Yeniden davet et',
            cancelInvitation: 'Daveti iptal et',
            suspend: 'Askıya al',
            unsuspend: 'Askıyı kaldır',
            invitationSent: '{email} adresine davet gönderildi. Bağlantı {hours} saat geçerli ve tek kullanımlık.',
            invitationCancelled: '{name} için bekleyen davet iptal edildi.',
            emptyTitle: 'Henüz personel hesabı yok',
            emptyBody: 'İlk hesabı davetle aç. Davet edilen kişi e-postasındaki bağlantıyla şifresini belirler ve panele girer.',
            inviteDialog: {
                kicker: 'Yeni personel hesabı',
                title: 'Personel davet et',
                body: 'Hesap hemen açılır. Kişiye {hours} saat geçerli, tek kullanımlık bir kurulum bağlantısı gider. Şifreyi kişi kendisi belirler.',
                emailLabel: 'Şirket e-postası',
                emailHint: 'Yalnız izinli alan adlarındaki adresler personel hesabı olabilir.',
                nameLabel: 'Görünen ad',
                roleLabel: 'Rol',
                roleAdminHint: 'Yönetici personel hesaplarını da yönetir.',
                roleModeratorHint: 'Moderatör yalnız moderasyon ekranlarını kullanır.',
                submit: 'Davet gönder',
            },
            reinviteTitle: 'Yeniden davet et: {name}',
            reinviteBody: 'Kişiye {hours} saat geçerli yeni bir kurulum bağlantısı gider. Önceki bağlantı geçersiz olur. Şifresini unutan personelin tek dönüş yolu budur.',
            reinviteDomainNote: 'Adres izinli alan adlarının dışındaysa davet gönderilemez. O zaman izinli bir adresle yeni hesap açman gerekir.',
            cancelTitle: 'Daveti iptal et: {name}',
            cancelBody: 'Bekleyen kurulum bağlantısı geçersiz olur. İstersen daha sonra yeniden davet edebilirsin.',
            suspendTitle: 'Hesabı askıya al: {name}',
            suspendBody: 'Açık oturumları anında sonlanır ve bekleyen daveti düşer. Askıyı kaldırdığında aynı şifresiyle geri döner.',
            unsuspendTitle: 'Askıyı kaldır: {name}',
            unsuspendBody: 'Hesap yeniden etkinleşir. Personel mevcut şifresiyle girer, yeni davet gerekmez.',
            auditNote: 'Davet, askı ve iptal kararları denetim kaydına yazılır.',
        },
        overview: {
            title: 'Genel görünüm',
            lead: 'Kaç etkinlik var, kim katılıyor, hangi şehirde ne oluyor. Sayıların hepsi canlı sorgudan gelir.',
            statsHeading: 'Platform sayıları',
            stats: {
                eventsTotal: 'Etkinlik',
                eventsTotalNote: '{count} tanesi yayında',
                eventsTotalNote_one: '{count} tanesi yayında',
                users: 'Kayıtlı kullanıcı',
                usersNote: 'Silinmiş ve anonimleştirilmiş hesaplar hariç',
                attendances: 'Katılım kaydı',
                attendancesNote: 'İptal ve reddedilenler hariç',
                exchanges: 'Kartvizit değişimi',
                exchangesNote: 'Yalnız çift taraflı onaylananlar',
                pendingModeration: 'Bekleyen moderasyon',
                pendingModerationNote: 'Açık ve ek bilgi bekleyen kalemler',
                pendingVerifications: 'Bekleyen kurum doğrulaması',
                pendingVerificationsNote: 'Gönderildi ve incelemede olan başvurular',
            },
            citiesTitle: 'Şehre göre etkinlik',
            citiesNote: 'Şeritler şehir taşıyan etkinliklerin payını gösterir. Çevrimiçi etkinliklerin şehri yoktur.',
            cityEvents: '{count} etkinlik',
            cityEvents_one: '{count} etkinlik',
            onlineRow: 'Çevrimiçi (şehirsiz)',
            citiesEmptyTitle: 'Henüz şehirli etkinlik yok',
            citiesEmptyBody: 'Yüz yüze veya karma bir etkinlik açıldığında şehir dağılımı burada belirir.',
            eventsTitle: 'Etkinlikler',
            statusFilterLabel: 'Etkinlik durumu',
            statuses: {
                all: 'Tümü',
                draft: 'Taslak',
                published: 'Yayında',
                cancelled: 'İptal',
                archived: 'Arşiv',
            },
            table: {
                event: 'Etkinlik',
                city: 'Şehir',
                date: 'Tarih',
                status: 'Durum',
                attendees: 'Katılımcı',
            },
            noCity: 'Çevrimiçi',
            noOrganization: 'Kurumsuz',
            checkedIn: '{count} check-in',
            checkedIn_one: '{count} check-in',
            attendeesCta: 'Katılımcılar',
            eventsEmptyTitle: 'Bu filtreye uyan etkinlik yok',
            eventsEmptyBody: 'Durum filtresini genişlet. Platformdaki her etkinlik bu listede görünür.',
            eventsEmptyStepFilter: '"Tümü" filtresine dön',
            eventsEmptyStepWait: 'Organizatör etkinliği açtığında satır burada belirir',
            eventsEmptyResetCta: 'Filtreyi sıfırla',
            pageStatus: 'Sayfa {page} / {pageCount}',
            prevPage: 'Önceki',
            nextPage: 'Sonraki',
            attendees: {
                kicker: 'Katılımcı dökümü',
                summary: '{total} kayıt · {checkedIn} check-in',
                table: {
                    person: 'Kişi',
                    role: 'Rol',
                    status: 'Durum',
                    registered: 'Kayıt',
                    checkedIn: 'Check-in',
                },
                roles: {
                    attendee: 'Katılımcı',
                    speaker: 'Konuşmacı',
                    staff: 'Ekip',
                    sponsor: 'Sponsor',
                },
                statuses: {
                    pending_approval: 'Onay bekliyor',
                    registered: 'Kayıtlı',
                    waitlisted: 'Yedek listede',
                    rejected: 'Reddedildi',
                    cancelled: 'İptal',
                    attended: 'Katıldı',
                },
                notCheckedIn: '—',
                emptyTitle: 'Bu etkinliğe henüz kimse kaydolmadı',
                emptyBody: 'İlk kayıt geldiğinde katılımcılar burada listelenir.',
                auditNote: 'Bu dökümü açman denetim kaydına yazıldı. Buradaki liste yönetim içindir, katılımcıya açılmaz.',
            },
        },
        users: {
            title: 'Kullanıcılar',
            headline: '{total} kayıtlı · {recent} son 7 günde',
            searchPlaceholder: 'E-posta, isim veya şirket',
            searchLabel: 'Kullanıcı ara',
            filterLabel: 'Kullanıcı filtresi',
            filters: { all: 'Tümü', organizers: 'Organizatörler', flagged: 'İşaretliler' },
            table: {
                user: 'Kullanıcı',
                role: 'Rol',
                events: 'Etkinlik',
                wallet: 'Cüzdan',
                lastSeen: 'Son görülme',
                status: 'Durum',
            },
            roles: {
                user: 'Katılımcı',
                organizer: 'Organizatör',
                speaker: 'Konuşmacı',
                moderator: 'Moderatör',
                admin: 'Yönetici',
            },
            statuses: {
                active: 'Aktif',
                pending: 'Beklemede',
                suspended: 'Askıda',
                flagged: 'İnceleniyor',
                deleted: 'Silinmiş',
            },
            neverSeen: 'Hiç girmedi',
            detail: 'Detay',
            detailKicker: 'Kullanıcı kaydı',
            detailFields: {
                email: 'E-posta',
                role: 'Rol',
                status: 'Durum',
                events: 'Etkinlik',
                wallet: 'Cüzdan',
                lastSeen: 'Son görülme',
                registered: 'Kayıt tarihi',
                suspendedAt: 'Askıya alındı',
            },
            detailNote: 'Bu kayda her erişim denetim kaydına yazılır. Panelde yalnız hesap yönetimi için gereken alanlar görünür.',
            suspend: 'Askıya al',
            unsuspend: 'Askıyı kaldır',
            suspendTitle: 'Hesabı askıya al: {name}',
            suspendBody: 'Oturumları anında sonlanır, yeni içerik oluşturamaz. Gerekçe denetim kaydına yazılır ve itiraz görünümünde gösterilir.',
            unsuspendTitle: 'Askıyı kaldır: {name}',
            unsuspendBody: 'Hesap yeniden etkinleşir. Gerekçe denetim kaydına yazılır.',
            reasonLabel: 'Gerekçe (zorunlu)',
            reasonPlaceholder: 'Kararını kısaca yaz. Denetim kaydına aynen geçer.',
            reasonTooShort: 'Gerekçe en az 20 karakter olmalı.',
            emptyTitle: 'Bu ölçütlere uyan kullanıcı yok',
            emptyBody: 'Aramayı temizle veya filtreyi değiştir. Kayıt olan herkes bu listede görünür.',
            emptyStepSearch: 'Aramayı temizle',
            emptyStepFilter: '"Tümü" filtresine dön',
            emptyResetCta: 'Aramayı ve filtreyi sıfırla',
        },
        moderation: {
            title: 'Moderasyon kuyruğu',
            lead: 'Sahiplenme talepleri, şüpheli etkinlikler ve raporlanan içerik tek kuyrukta. Karar verirken hem organizatör hem katılımcı tarafı görünür.',
            types: {
                report: 'Rapor',
                suspicious_event: 'Şüpheli etkinlik',
                appeal: 'İtiraz',
                claim: 'Sahiplenme',
            },
            statuses: {
                all: 'Tümü',
                open: 'Açık',
                info_requested: 'Ek bilgi istendi',
                resolved: 'Onaylandı',
                dismissed: 'Reddedildi',
            },
            statusFilterLabel: 'Kuyruk durumu',
            sources: { user_report: 'Katılımcı', auto_signal: 'Otomatik uyarı', system: 'Sistem' },
            reasons: {
                fake: 'Sahte',
                spam: 'Spam',
                inappropriate: 'Uygunsuz içerik',
                personal_data: 'Kişisel veri ihlali',
                other: 'Diğer',
            },
            priorityHigh: 'Öncelikli',
            reportCount: '{count} bildirim',
            reportCount_one: '{count} bildirim',
            facts: {
                reportCount: 'Bildirim',
                eventStatus: 'Durum',
                eventOrigin: 'Köken',
                attendanceCount: 'Kayıt',
                creatorAccountAge: 'Hesap açılışı',
                hiddenAt: 'Gizlendi',
                accountCreatedAt: 'Hesap açılışı',
                eventCount: 'Etkinlik',
                walletCount: 'Cüzdan',
                suspendedAt: 'Askıya alındı',
                suspensionReason: 'Askı gerekçesi',
                claimStatus: 'Talep durumu',
                evidenceCount: 'Kanıt',
                claimantName: 'Talep eden',
                objectionWindowEndsAt: 'İtiraz penceresi bitişi',
                objectedAt: 'İtiraz tarihi',
            },
            origins: { organizer: 'Organizatör', shadow: 'Gölge etkinlik' },
            reportNotes: 'Bildirim notları',
            decisionLabel: 'Karar gerekçesi (zorunlu)',
            decisionPlaceholder: 'Kararını kısaca yaz. İki tarafa da gönderilir.',
            approve: 'Onayla',
            reject: 'Reddet',
            requestInfo: 'Ek bilgi iste',
            deciding: 'Kaydediliyor…',
            auditNote: 'Her karar kimin verdiği, ne zaman verildiği ve gerekçesiyle denetim kaydına yazılır.',
            // --- Sahiplenme karar panosu (Blok 6 dikişi: karar bu panodan verilir) ---
            claimPanel: {
                claimant: 'Talep eden',
                founder: 'Gölge etkinliği açan',
                reason: 'Talep gerekçesi',
                evidences: 'Kanıtlar',
                evidenceTypes: {
                    corporate_email: 'Kurumsal e-posta',
                    website_match: 'Etkinlik sayfası',
                    document: 'Yetki belgesi (PDF)',
                    other: 'Diğer kanıt',
                },
                windowOpen: 'İtiraz penceresi {date} tarihine kadar açık. Sahibin açık onayı olmadan onay verilemez. Red her zaman mümkün.',
                windowEnded: 'İtiraz penceresi {date} tarihinde doldu. Sahip yanıt vermedi.',
                consented: 'Gölge sahibi devri açıkça onayladı ({date}).',
                objected: 'Gölge sahibi {date} tarihinde itiraz etti. Gerekçesi “{reason}”.',
                infoRequestedSent: 'Ek bilgi isteği talep sahibine e-postayla iletildi.',
                noteTooShort: 'Gerekçe en az 10 karakter olmalı.',
                loadError: 'Talep ayrıntısı yüklenemedi.',
            },
            decidedNote: 'Karar verildi: {decision} · {date}',
            emptyTitle: 'Kuyruk temiz',
            emptyBody: 'Şu an bekleyen bildirim, şüpheli etkinlik veya itiraz yok.',
            emptyStepSignals: 'Otomatik uyarıları değerlendir',
            emptyStepReports: 'Rapor ekranındaki göstergeleri gözden geçir',
            selectPrompt: 'İncelemek için soldan bir kalem seç',
        },
        reports: {
            title: 'Raporlar ve kötüye kullanım',
            lead: 'Spam kartvizit talebi, taciz bildirimi ve toplu tarama şüphesi. Otomatik uyarılar karar vermez, yalnızca kalemi kuyruğa taşır.',
            kpiOpen: 'Açık bildirim',
            kpiOpenNote: '{count} tanesi 24 saatten yeni',
            kpiAvg: 'Ortalama yanıt',
            kpiAvgValue: '{hours} sa',
            kpiAvgNote: 'hedef 12 saat',
            kpiSuspended: 'Askıya alınan',
            kpiSuspendedNote: 'son 30 gün',
            kpiAppeals: 'İtiraz',
            kpiAppealsNote: 'inceleniyor',
            table: {
                kind: 'Bildirim',
                about: 'Hakkında',
                signal: 'Uyarı',
                source: 'Geldiği yer',
                status: 'Durum',
            },
            review: 'İncele',
            dismiss: 'Kapat',
            dismissTitle: 'Bildirimi kapat',
            dismissBody: 'Kalem kuyruktan düşer ve bildirene işlem tamamlandı olarak döner. Gerekçe denetim kaydına aynen yazılır.',
            signalSummary: '{count} bildirim · {reason}',
            signalSummary_one: '{count} bildirim · {reason}',
            signalsTitle: 'Otomatik uyarılar',
            runSignals: 'Uyarıları değerlendir',
            runningSignals: 'Değerlendiriliyor…',
            runResult: '{count} kalem kuyruğa taşındı',
            runResult_one: '{count} kalem kuyruğa taşındı',
            signals: {
                new_account_event_burst: {
                    name: 'Yeni hesap + yüksek hacim',
                    desc: '7 günden yeni hesapta 3+ yayınlanmış etkinlik kuyruğa taşınır.',
                },
                report_threshold: {
                    name: 'Bildirim eşiği',
                    desc: 'Aynı hedefe 3+ bildirim gelen kalem yüksek önceliğe çekilir.',
                },
                one_sided_request_rate: {
                    name: 'Tek taraflı talep hızı',
                    desc: 'Kart değişimi açılınca saatlik talep eşiği kuyruğa taşınacak.',
                },
                device_fingerprint_match: {
                    name: 'Cihaz parmak izi eşleşmesi',
                    desc: 'Aynı cihazda çok hesap. Yalnızca uyarı üretir, otomatik karar vermez.',
                },
            },
            signalStates: { active: 'Açık', monitor: 'İzleme' },
            healthTitle: 'Platform sağlığı · son 30 gün',
            health: {
                encounter_accept_rate: 'Kartvizit değişimi onay oranı',
                meeting_accept_rate: 'Görüşme talebi kabul oranı',
                checkin_completion_rate: 'Check-in tamamlama',
                shadow_claim_rate: 'Gölge etkinliklerin sahiplenilme oranı',
            },
            healthNote: 'Kartvizit değişimi onay oranı düşerse akışta bir sorun var demektir. Bu oran ürün sağlığının ana göstergesi.',
            noData: 'Henüz veri yok',
            emptyTableTitle: 'Henüz bildirim yok',
            emptyTableBody: 'Bildirimler geldikçe burada gruplanır. Otomatik uyarılar da bu tabloya düşer.',
        },
        /*
         * AYRI PANEL UYGULAMASI (`apps/admin`). Anahtarlar `admin` bölümünün
         * içinde kaldı: panel web'deki `/admin` ile aynı ürün alanıdır ve arayüz
         * dili kapısı (`ui-copy-tone`) bu bölümü zaten tarıyor.
         */
        panel: {
            signIn: {
                title: 'Yönetim paneline giriş',
                body: 'Şirket e-postan ve şifrenle devam et. Ardından e-postana bir kod gönderilir.',
                emailLabel: 'E-posta',
                emailPlaceholder: 'ad@{appDomain}',
                passwordLabel: 'Şifre',
                continueWithPassword: 'Devam et',
                sendCode: 'Kod gönder',
                codeTitle: 'Kodu gir',
                codeBody: '{email} adresine 6 haneli bir kod gönderdik.',
                codeLabel: 'Doğrulama kodu',
                verify: 'Giriş yap',
                changeEmail: 'E-postayı değiştir',
                reenterPassword: 'Şifreni yeniden gir',
                restricted: 'Panel yalnızca yetkili hesaplara açık.',
                haveInvitation: 'Davetim var',
            },
            /*
             * İLK KURULUM — DAVET (panel kimliği ayrımı · Karar 4c). Panelde
             * "şifremi unuttum" YOKTUR; metinler bunu açıkça söyler ve kullanıcıyı
             * var olmayan bir kurtarma yoluna göndermez.
             */
            setup: {
                title: 'Panel şifreni belirle',
                body: 'Davet e-postandaki bağlantıyı kullan. Şifreni belirlediğinde panele doğrudan girersin.',
                tokenLabel: 'Davet kodu',
                tokenHint: 'Davet e-postandaki bağlantıda yer alır. Bağlantı kırpıldıysa kodu elle yapıştır.',
                submit: 'Şifreyi belirle ve gir',
                backToSignIn: 'Girişe dön',
                emptyTitle: 'Davet kodu gerekiyor',
                emptyBody: 'Panelde şifre sıfırlama yoktur. Kodun yoksa bir yöneticiden yeni davet iste.',
            },
            /*
             * ŞİFRE EKRANLARI (kullanıcı kararı 02.09.2026 · §2). Ürün uygulaması
             * parolasız kalır; bu metinler YALNIZ panelde görünür.
             */
            password: {
                changeTitle: 'Şifreyi değiştir',
                changeAction: 'Şifreyi değiştir',
                currentLabel: 'Mevcut şifre',
                newLabel: 'Yeni şifre',
                repeatLabel: 'Yeni şifre (tekrar)',
                /* Taban artık kontrol listesinde (B-29); ipucu yalnız tavsiyeyi taşır. */
                hint: 'Büyük harf ya da sembol zorunlu değil. En güvenlisi uzun bir cümle.',
                repeatMismatch: 'İki şifre birbirini tutmuyor.',
                save: 'Kaydet',
                cancel: 'Vazgeç',
                close: 'Kapat',
                saved: 'Şifren güncellendi. Diğer cihazlardaki oturumların kapatıldı.',
            },
            /*
             * YETKİ YÜZEYİ (QA S2/S3 · P2-1). Personel adresi bilinen bir ekrana
             * doğrudan gidebilir; o zaman "geçici hata + tekrar dene" DEĞİL, kalıcı
             * ve dürüst bir cevap görür. "Tekrar dene" yoktur çünkü tekrar denemek
             * hiçbir zaman işe yaramaz.
             */
            permission: {
                title: 'Bu ekran için yetkin yok',
                body: 'Bu ekranı kullanmak için gereken yetki hesabında tanımlı değil. Gerekiyorsa bir panel yöneticisinden iste.',
                action: 'Kullanabileceğin bir ekrana git',
                signOut: 'Başka hesapla gir',
                surfaceNote: 'Bu karar için yetkin yok.',
            },
            /*
             * OTURUMLAR (hesap eylemi, şifre değiştirmeyle aynı bölge). Personel
             * yalnız KENDİ oturumlarını görür; başkasınınki bu yüzeye hiç gelmez.
             */
            sessions: {
                action: 'Oturumlar',
                kicker: 'Hesap',
                title: 'Açık oturumlar',
                body: 'Bu hesapla açık panel oturumları. Tanımadığın bir cihaz görürsen oturumu sonlandır ve şifreni değiştir.',
                loading: 'Oturumlar yükleniyor',
                table: {
                    device: 'Cihaz',
                    time: 'Zaman',
                    openedAt: 'Açıldı',
                    lastUsedAt: 'Son kullanım',
                },
                current: 'Bu cihaz',
                unknownDevice: 'Bilinmeyen tarayıcı',
                neverUsed: 'Henüz kullanılmadı',
                revoke: 'Sonlandır',
                revokeAll: 'Tümünü sonlandır',
                revokeTitle: 'Oturumu sonlandır',
                revokeBody: 'O cihazdaki panel oturumu anında kapanır. Yeniden girmek için şifre ve kod gerekir.',
                revokeAllTitle: 'Tüm oturumları sonlandır',
                revokeAllBody: 'Bu cihaz dahil bütün panel oturumların kapanır ve giriş ekranına dönersin.',
                emptyTitle: 'Açık oturum yok',
                emptyBody: 'Bu hesabın şu an açık bir panel oturumu görünmüyor.',
            },
            loading: 'Panel yükleniyor',
            signOut: 'Çıkış yap',
            account: 'Açık hesap',
        },
    },
    claims: {
        // Blok 8-2: sahiplenme kullanıcı yüzeyi kaldırıldı. Kalan anahtarlar
        // YALNIZCA admin moderasyon panosu içindir (tarihsel talepler okunur ve
        // karara bağlanır — denetlenebilirlik).
        decisionNoteLabel: 'Karar gerekçesi',
        statusSubmitted: 'Taslak, kanıt bekleniyor',
        statusEvidenceAdded: 'Kanıt eklendi',
        statusOwnerNotified: 'Sahip bilgilendirildi',
        statusObjectionWindow: 'İtiraz penceresi açık',
        statusObjected: 'İtiraz edildi',
        statusApproved: 'Onaylandı',
        statusRejected: 'Reddedildi',
        statusWithdrawn: 'Geri çekildi',
        statusTransferred: 'Devredildi',
    },
    errors: {
        INTERNAL_ERROR: 'Bir şeyler ters gitti. Tekrar dene.',
        VALIDATION_FAILED: 'Girdiğin bilgilerde hata var. Kontrol edip tekrar dene.',
        NOT_FOUND: 'Aradığın kayıt bulunamadı.',
        CONFLICT: 'Durum değişti. Sayfayı yenileyip tekrar dene.',
        RATE_LIMITED: 'Çok fazla deneme yaptın. Biraz sonra tekrar dene.',
        PAYLOAD_TOO_LARGE: 'Gönderdiğin içerik çok büyük.',
        UNSUPPORTED_MEDIA_TYPE: 'Bu dosya türü desteklenmiyor.',
        AUDIT_UNAVAILABLE: 'Görüntüleme kaydı şu an yazılamıyor, bu yüzden kişisel bilgiler gösterilmiyor. Biraz sonra tekrar dene.',
        SERVICE_OVERLOADED: 'Şu an çok yoğun. Birkaç saniye sonra tekrar dene.',
        UNAUTHENTICATED: 'Devam etmek için giriş yapmalısın.',
        TOKEN_EXPIRED: 'Oturumun sona erdi. Yeniden giriş yap.',
        TOKEN_INVALID: 'Oturumun geçersiz. Yeniden giriş yap.',
        SESSION_REVOKED: 'Oturumun kapatıldı. Yeniden giriş yap.',
        FORBIDDEN: 'Bu işlem için yetkin yok.',
        ACCOUNT_SUSPENDED: 'Hesabın askıya alınmış.',
        ACCOUNT_DELETED: 'Bu hesap silinmiş.',
        ACCOUNT_KIND_NOT_ALLOWED: 'Bu işlem bu hesap türüyle yapılamaz. Etkinliğe katılım kişisel hesapla, etkinlik yönetimi kurum hesabıyla yapılır.',
        STAFF_CREDENTIALS_INVALID: 'E-posta veya şifre hatalı.',
        STAFF_CODE_INVALID: 'Kod hatalı. Tekrar dene.',
        STAFF_CODE_NETWORK_CHANGED: 'Bu kod artık geçerli değil ya da ağın değişti. Şifreni yeniden gir.',
        STAFF_CODE_EXPIRED: 'Kodun süresi doldu. Yeni bir kod iste.',
        STAFF_CODE_ATTEMPTS_EXCEEDED: 'Çok fazla hatalı deneme yapıldı. Yeni bir kod iste.',
        STAFF_INVITATION_INVALID: 'Bu davet bağlantısı geçerli değil. Bir yöneticiden yeni davet iste.',
        STAFF_PASSWORD_MISMATCH: 'Mevcut şifren doğru değil.',
        STAFF_PASSWORD_REUSED: 'Yeni şifren mevcut şifrenle aynı olamaz.',
        STAFF_ACCOUNT_SUSPENDED: 'Personel hesabın askıya alınmış.',
        STAFF_EMAIL_TAKEN: 'Bu adres için zaten bir personel hesabı var.',
        STAFF_EMAIL_DOMAIN_NOT_ALLOWED: 'Bu adres personel hesabı için izinli alan adında değil.',
        STAFF_UNAUTHENTICATED: 'Panele devam etmek için personel hesabınla giriş yap.',
        STAFF_SESSION_EXPIRED: 'Panel oturumunun süresi doldu. Yeniden giriş yap.',
        STAFF_FORBIDDEN: 'Bu panel işlemi için yetkin yok.',
        CREDENTIALS_INVALID: 'E-posta veya şifre hatalı.',
        EVENT_NOT_FOUND: 'Etkinlik bulunamadı.',
        EVENT_NOT_PUBLISHED: 'Bu etkinlik henüz yayında değil.',
        EVENT_CANCELLED: 'Bu etkinlik iptal edildi.',
        EVENT_ACCESS_MODE_INVALID: 'Bu erişim modu bu etkinlik için geçerli değil.',
        EVENT_CAPACITY_EXCEEDED: 'Etkinlik kontenjanı doldu.',
        EVENT_ATTENDEE_CEILING_REACHED: 'Bu etkinliğin kontenjanı doldu.',
        EVENT_REPORT_NOT_READY: 'Rapor etkinlik bitince hazırlanır.',
        EVENT_REPORT_EVENT_CANCELLED: 'İptal edilen etkinlik için rapor oluşturulmaz.',
        EVENT_REPORT_SPONSOR_FORBIDDEN: 'Etkinlik raporu yalnız düzenleyen kuruma açıktır.',
        CREDIT_EXHAUSTED: 'Yayınlamak için etkinlik kredin kalmadı. Yayındaki etkinliklerin etkilenmez. Yeni kredi ya da Kurumsal sözleşme için bize ulaş.',
        REFERRAL_CODE_NAME_TAKEN: 'Bu adla bir referans kodu zaten var.',
        REFERRAL_CODE_NOT_FOUND: 'Bu kod bulunamadı. Kodu düzelt ya da alanı boş bırak.',
        REFERRAL_CODE_INACTIVE: 'Kod kapatıldığı için hediye eklenemedi. Hiçbir kredi yüklenmedi.',
        REFERRAL_CODE_NOT_STARTED: 'Kodun başlangıç günü gelmediği için hediye eklenemedi. Hiçbir kredi yüklenmedi.',
        REFERRAL_CODE_EXPIRED: 'Kodun süresi dolduğu için hediye eklenemedi. Hiçbir kredi yüklenmedi.',
        REFERRAL_CODE_CAP_REACHED: 'Kodun tavanı bu arada dolduğu için hediye eklenemedi. Hiçbir kredi yüklenmedi.',
        REFERRAL_CODE_ALREADY_USED: 'Bu kurum kodu daha önce kullandığı için hediye eklenemedi. Hiçbir kredi yüklenmedi.',
        EVENT_INVALID_STATE: 'Etkinlik bu işlem için uygun durumda değil.',
        EVENT_DATE_IN_PAST: 'Geçmiş tarihli etkinlik oluşturulamaz.',
        EVENT_HAS_ATTENDEES: 'Kayıtlı katılımcısı olan etkinlik silinemez. Yalnızca iptal edilebilir.',
        EVENT_SHADOW_MODE_LOCKED: 'Katılımcının açtığı etkinlik yalnızca herkese açık olabilir.',
        EVENT_ORGANIZATION_REQUIRED: 'Bu etkinlik bir kuruma bağlı değil. Herkese açık ya da başvurulu yayın için doğrulanmış bir kurum gerekir. Davetli olarak yayımlayabilirsin.',
        EVENT_VENUE_GEO_REQUIRED: 'Haritada konumu seç.',
        VENUE_SEARCH_UNAVAILABLE: 'Şu an aranamıyor, biraz sonra tekrar dene.',
        VENUE_SEARCH_DISABLED: 'Adres araması şu an kapalı. Etkinliği haritada konum seçmeden kaydedebilirsin.',
        EMAIL_NOT_VERIFIED: 'Bu işlem için e-postanı doğrulamalısın.',
        TICKET_QUOTA_EXCEEDED: 'Bu bilet türünün kontenjanı doldu.',
        TICKET_CLOSED: 'Bu bilet türü kayıta kapalı.',
        TICKET_NOT_FOUND: 'Bilet türü bulunamadı.',
        TICKET_QUOTA_BELOW_RESERVED: 'Kontenjan mevcut kayıt sayısının altına indirilemez.',
        TICKET_CAPACITY_EXCEEDED: 'Bilet kontenjanları toplamı etkinlik kapasitesini aşıyor.',
        ALREADY_REGISTERED: 'Bu etkinliğe zaten kayıtlısın.',
        REGISTRATION_NOT_FOUND: 'Kayıt bulunamadı.',
        CHECK_IN_NOT_OPEN: 'Check-in yalnızca etkinlik günü yapılabilir.',
        CHECK_IN_REGISTRATION_CANCELLED: 'Kayıt iptal edilmiş.',
        CHECK_IN_OTHER_EVENT: 'Bu kod başka bir etkinliğin.',
        EVENT_ALREADY_ENDED: 'Bu etkinlik sona erdi. Katılım kaydın artık değiştirilemez.',
        EVENT_ORGANIZER_CANNOT_JOIN: 'Bu etkinliği sen yönetiyorsun. Organizatör kendi etkinliğine kaydolamaz veya başvuramaz.',
        APPLICATION_ALREADY_SUBMITTED: 'Bu etkinliğe zaten başvurdun.',
        APPLICATION_NOT_FOUND: 'Başvuru bulunamadı.',
        APPLICATION_ALREADY_DECIDED: 'Bu başvuru zaten karara bağlanmış.',
        INVITATION_NOT_FOUND: 'Davet bulunamadı.',
        INVITATION_EXPIRED: 'Davetin süresi dolmuş.',
        INVITATION_REVOKED: 'Bu davet iptal edilmiş.',
        INVITATION_EMAIL_MISMATCH: 'Bu davet başka bir e-posta adresi için gönderilmiş.',
        INVITATION_EMAIL_IN_PERSONAL_ACCOUNT: 'Bu adres kişisel bir hesapta kullanılıyor. Kurumundan başka bir iş adresine davet iste.',
        INVITATION_ALREADY_USED: 'Bu davet daha önce kullanılmış.',
        CLAIM_INVALID_TRANSITION: 'Sahiplenme talebi bu duruma geçemez.',
        CLAIM_ALREADY_OPEN: 'Bu etkinlik için açık bir sahiplenme talebi zaten var.',
        CLAIM_NOT_FOUND: 'Sahiplenme talebi bulunamadı.',
        CLAIM_EVENT_NOT_CLAIMABLE: 'Bu etkinlik sahiplenilebilir değil.',
        CLAIM_SELF_CLAIM: 'Kendi açtığın etkinliği sahiplenemezsin. Yönetimi zaten sende.',
        CLAIM_EVIDENCE_REQUIRED: 'Talebi göndermeden önce en az bir kanıt eklemelisin.',
        CLAIM_OBJECTION_WINDOW_CLOSED: 'İtiraz penceresi kapandı.',
        CLAIM_OBJECTION_WINDOW_OPEN: 'İtiraz penceresi hâlâ açık. Sahibin onayı olmadan talep onaylanamaz.',
        CARD_NOT_FOUND: 'Kartvizit bulunamadı.',
        ENCOUNTER_CONSENT_REQUIRED: 'Kartvizit değişimi için iki tarafın da onayı gerekir.',
        ENCOUNTER_NOT_FOUND: 'Bu cüzdan kaydı bulunamadı.',
        CARD_EXCHANGE_SELF: 'Kendi kartını okutamazsın.',
        CARD_EXCHANGE_UNAVAILABLE: 'Bu değişim artık açık değil. Kodu yeniden okut.',
        MEDIA_TYPE_NOT_ALLOWED: 'Bu görsel türü desteklenmiyor.',
        MEDIA_TOO_LARGE: 'Görsel boyutu çok büyük.',
        MEDIA_DIMENSIONS_TOO_SMALL: 'Seçtiğin görsel çok küçük. Alanın altında yazan en küçük ölçüyü karşılayan bir dosya seç.',
        MEDIA_UPLOAD_INCOMPLETE: 'Görsel hâlâ işleniyor. Birkaç saniye sonra tekrar kaydet.',
        MEDIA_NOT_FOUND: 'Görsel bulunamadı.',
        MEDIA_IN_USE: 'Bu görsel bir sayfada kullanılıyor. Önce oradan değiştir ya da kaldır.',
        MEDIA_UPLOAD_FAILED: 'Görsel yüklenemedi. Tekrar dene.',
        CONSENT_REQUIRED: 'Devam etmek için gerekli onayları vermelisin.',
        OTP_INVALID: 'Kod hatalı. Kontrol edip tekrar dene.',
        OTP_EXPIRED: 'Kodun süresi doldu. Yeni kod iste.',
        OTP_ATTEMPTS_EXCEEDED: 'Çok fazla hatalı deneme yaptın. Yeni bir kod iste.',
        OAUTH_TOKEN_INVALID: 'Giriş doğrulanamadı. Tekrar dene.',
        OAUTH_EMAIL_UNVERIFIED: 'Google ya da Apple bu e-postayı doğrulamamış. E-posta adresin ve şifrenle giriş yap.',
        OAUTH_PROVIDER_NOT_CONFIGURED: 'Bu giriş yöntemi şu anda kullanılamıyor.',
        SESSION_NOT_FOUND: 'Oturum bulunamadı.',
        IDENTITY_NOT_FOUND: 'Bağlı hesap bulunamadı.',
        IDENTITY_LAST_LOGIN_METHOD: 'Son giriş yöntemini kaldıramazsın. Önce başka bir yöntem ekle.',
        IDENTITY_ALREADY_LINKED: 'Bu sağlayıcı hesabı başka bir hesaba bağlı. E-posta koduyla giriş yap.',
        TAG_NOT_FOUND: 'Etiket bulunamadı.',
        TAG_MERGE_INVALID: 'Bu etiketler birleştirilemez.',
        CARD_LIMIT_EXCEEDED: 'En fazla {limit} kartvizit oluşturabilirsin.',
        CARD_DEFAULT_REQUIRED: 'Varsayılan kartvizitini silemezsin. Önce başka bir kartı varsayılan yap.',
        ORGANIZATION_NOT_FOUND: 'Kurum bulunamadı.',
        ORGANIZATION_MEMBER_NOT_FOUND: 'Ekip üyesi bulunamadı.',
        ORGANIZATION_MEMBER_EXISTS: 'Bu kişi zaten ekipte veya davetli.',
        ORGANIZATION_OWNER_REQUIRED: 'Bu işlemi yalnızca kurum sahibi yapabilir.',
        ORGANIZATION_OWNER_CANNOT_LEAVE: 'Kurumun sahibi ayrılamaz. Önce sahipliği kurumdaki başka bir aktif üyeye devret. Devirden sonra normal üye olursun ve ayrılabilirsin.',
        ORGANIZATION_MEMBER_SELF_REMOVE: 'Kendini ekipten çıkaramazsın. Kurumdan ayrılmak istiyorsan "Kurumdan ayrıl" bölümünü kullan.',
        ORGANIZATION_COVER_NOT_SET: 'Bu kurumun kapak görseli yok.',
        ORGANIZATION_COVER_CHANGED: 'Kapak bu arada değişti. Sayfayı yenileyip yeniden bak.',
        ORGANIZATION_INVITATION_ALREADY_ACCEPTED: 'Bu davet az önce kabul edildi, kişi artık ekipte. Liste yenilendi. Ekipten çıkarmak istiyorsan satırındaki "Çıkar" düğmesini kullan.',
        ORGANIZATION_TRANSFER_TARGET_UNAVAILABLE: 'Sahiplik bu üyeye devredilemez, çünkü hesabı artık kullanılmıyor. Kurumda aktif bir üyeye devret. Uygun üye yoksa önce birini davet et.',
        ORGANIZATION_MEMBER_PERSONAL_ACCOUNT: 'Bu adres kurumda kişisel bir hesapla bağlı. Kişisel hesaba kurum rolü ya da sahiplik verilemez. Kişiyi kurum hesabının iş adresiyle davet et.',
        ORGANIZATION_SELF_SERVE_DISABLED: 'Kurumlar artık kısa bir görüşmeden sonra ekibimiz tarafından açılıyor. Etkinliğini düzenlemek için bize ulaş, kurumunu doğrulanmış olarak açıp sana davet gönderelim.',
        ORGANIZATION_OWNER_INVITATION_CONFLICT: 'Bu kurumun sahip daveti bu işleme uygun değil. Davet zaten kabul edilmiş ya da bekleyen bir sahip daveti var.',
        ORGANIZATION_NAME_CONFLICT: 'Bu ad, doğrulanmış bir kurumun adına çok yakın. Kurumun kayıtlı kalır. Yayına çıkmak için ya adı ayırt edici hâle getir ya da kurum doğrulaması başvurusu gönder. Başvuruda kurumsal e-posta adresin, web siten ve yetki belgen isteniyor.',
        ORGANIZATION_VERIFICATION_ALREADY_OPEN: 'Bu kurum için karar bekleyen bir başvuru zaten var.',
        ORGANIZATION_VERIFICATION_REQUEST_NOT_FOUND: 'Doğrulama başvurusu bulunamadı.',
        ORGANIZATION_VERIFICATION_ALREADY_DECIDED: 'Bu başvuru karara bağlanmış.',
        ORGANIZATION_VERIFICATION_DOCUMENT_UNAVAILABLE: 'Belge artık erişilebilir değil (saklama süresi dolmuş olabilir).',
        SPEAKER_NOT_FOUND: 'Konuşmacı bulunamadı.',
        SPEAKER_HAS_SESSIONS: 'Bu konuşmacı ajanda oturumlarına bağlı. Silmek için oturum bağlantılarını onayla.',
        SPEAKER_LINK_NOT_PENDING: 'Bekleyen bir bağlama talebi yok.',
        SPEAKER_ALREADY_LINKED: 'Bu konuşmacı zaten bir kullanıcıya bağlı.',
        AGENDA_SESSION_NOT_FOUND: 'Oturum bulunamadı.',
        AGENDA_TIME_CONFLICT: 'Aynı salonda zaman çakışan bir oturum var. Onaylarsan yine de kaydedilir.',
        AGENDA_SESSION_OUTSIDE_EVENT: 'Oturum etkinlik tarihlerinin içinde olmalı.',
        ATTENDEE_LIST_REQUIRES_REGISTRATION: 'Katılımcı listesi yalnız etkinliğe kaydolanlara açık.',
        EXPORT_NOT_FOUND: 'Veri dışa aktarma talebi bulunamadı.',
        EXPORT_NOT_READY: 'Dışa aktarma henüz hazır değil. Lütfen biraz sonra tekrar dene.',
        EXPORT_LINK_EXPIRED: 'İndirme bağlantısının süresi doldu. Yeni bir dışa aktarma talebi oluştur.',
        EXPORT_LINK_USED: 'Bu dosya daha önce indirildi. Yeni bir dışa aktarma talebi oluştur.',
        DELETION_ALREADY_REQUESTED: 'Zaten bekleyen bir hesap silme talebin var.',
        DELETION_NOT_REQUESTED: 'Bekleyen bir hesap silme talebin yok.',
        DELETION_BLOCKED_SOLE_OWNER: 'Tek sahibi olduğun bir kurum var. Hesabını silmeden önce sahipliği ekipten birine devret.',
        USER_NOT_FOUND: 'Kullanıcı bulunamadı.',
        SUSPEND_NOT_ALLOWED: 'Bu hesap panelden askıya alınamaz.',
        USER_ALREADY_SUSPENDED: 'Bu hesap zaten askıda.',
        USER_NOT_SUSPENDED: 'Bu hesap askıda değil.',
        MODERATION_ITEM_NOT_FOUND: 'Kuyruk kalemi bulunamadı.',
        MODERATION_ALREADY_DECIDED: 'Bu kalem zaten karara bağlanmış.',
        MODERATION_CLAIM_DECIDED_IN_CLAIM_FLOW: 'Sahiplenme talepleri bu kuyruktan değil, sahiplenme karar akışından sonuçlandırılır.',
        MEETING_REQUIRES_ATTENDANCE: 'Görüşme talebi göndermek için etkinliğe kayıtlı olmalısın.',
        MEETING_REQUEST_NOT_FOUND: 'Görüşme talebi bulunamadı.',
        MEETING_REQUEST_ALREADY_OPEN: 'Bu kişiye gönderdiğin ve hâlâ yanıt bekleyen bir talebin var.',
        MEETING_REQUEST_DECLINED_BEFORE: 'Bu kişi bu etkinlikteki talebini yanıtladı. Yeni talep gönderemezsin.',
        MEETING_OPEN_REQUEST_LIMIT_REACHED: 'Bu etkinlikte açık talep hakkını doldurdun. Yanıt bekleyenlerden biri sonuçlanınca yeniden gönderebilirsin.',
        MEETING_INVALID_TRANSITION: 'Bu talep artık bu işleme uygun değil.',
        // Blok 12 (tech-lead Blok 11 Orta-3): kısıt GÖNDERENİN meşguliyetinde de
        // patlar ve etkinlik kapsamlı DEĞİLDİR — eski metin kabul edene yanlış bilgi
        // verip karşı tarafın BAŞKA etkinlikteki takvimini ele veriyordu. Mesaj artık
        // hangi tarafın dolu olduğunu SÖYLEMEZ.
        MEETING_SLOT_CONFLICT: 'Bu saat artık uygun değil. Başka bir saat için yeni talep gerekiyor.',
        MEETING_SLOT_INVALID: 'Önerilen saat etkinlik aralığının dışında.',
        MEETING_SLOT_NOT_FOUND: 'Seçtiğin saat bu talebe ait değil.',
        MEETING_BLOCK_INVALID: 'Bu kişi engellenemez.',
        MEETING_BLOCKED_BY_YOU: 'Bu kişiyi engellemişsin. Talep göndermek için ayarlardan engeli kaldırman gerekiyor.',
        MEETING_AREA_NOT_FOUND: 'Görüşme alanı bulunamadı.',
        MEETING_AREA_NAME_TAKEN: 'Bu etkinlikte aynı adlı bir alan zaten var.',
        MEETING_AREA_UNAVAILABLE: 'Seçilen saat bu alanın uygunluk aralığının dışında.',
        MEETING_AREA_FULL: 'Bu alan o saatte dolu. Başka bir saat ya da alan seçilmeli.',
        MEETING_AREA_CAPACITY_CONFLICT: 'Kabul edilmiş görüşmeler bu kapasiteye sığmıyor. Kapasiteyi artır ya da başka bir alan seç.',
        MEETING_AREA_WINDOW_CONFLICT: 'Kabul edilmiş görüşmelerden bazıları bu uygunluk aralığının dışında kalıyor.',
        PLAN_LIMIT_EXCEEDED: 'Bu etkinlik, kurumunun paketindeki katılımcı sınırını aştı. Bu işlem daha yüksek bir paket gerektiriyor.',
        ANNOUNCEMENT_NOT_FOUND: 'Duyuru bulunamadı.',
        ANNOUNCEMENT_AUDIENCE_UNAVAILABLE: 'Seçtiğin alıcı grubu bu etkinlikte kullanılamıyor. Listeden seçilebilir bir grup seç.',
        ANNOUNCEMENT_KIND_DISABLED: 'Tanıtım duyuruları şimdilik kapalı. Bu etkinlikle ilgili bilgilendirme duyurusu gönderebilirsin.',
        ANNOUNCEMENT_NOT_EDITABLE: 'Bu duyuru artık taslak değil, değiştirilemez. Yeni bir duyuru yazabilirsin.',
        ANNOUNCEMENT_EVENT_UNAVAILABLE: 'Etkinlik yayında olmadığı için duyuru gönderilemez.',
        ANNOUNCEMENT_NO_RECIPIENTS: 'Seçtiğin gruplarda şu an kimse yok. Başka bir grup seç ya da daha sonra yeniden dene.',
        ANNOUNCEMENT_DAILY_LIMIT: 'Kurumun son 24 saatte 10 duyuru gönderdi. Bir sonraki duyuruyu daha sonra gönderebilirsin.',
        ANNOUNCEMENT_AUDIENCE_LIMIT: 'Bu gruba son 24 saatte 2 duyuru gitti. Yeni duyuruyu daha sonra gönderebilirsin.',
        ANNOUNCEMENT_LINK_SHORTENER: 'Kısaltılmış bağlantı kullanılamaz. Bağlantının tam adresini yaz.',
        ANNOUNCEMENT_EMAIL_PAUSED: 'Kurumunun e-posta duyuruları şu an durduruldu. Mobil bildirim kanalını seçebilir ya da bize ulaşabilirsin.',
        ANNOUNCEMENT_SEND_DISABLED: 'Duyuru gönderimi henüz açılmadı. Taslağın kayıtlı, gönderim açılınca gönderebilirsin.',
        ANNOUNCEMENT_SCHEDULE_TOO_SOON: 'Duyuru en erken 10 dakika sonrasına zamanlanabilir. Daha ileri bir saat seç.',
        ANNOUNCEMENT_SCHEDULE_TOO_LATE: 'Duyuru en geç etkinlik bitişinden 30 gün sonrasına zamanlanabilir. Daha erken bir saat seç.',
        ANNOUNCEMENT_NOT_CANCELLABLE: 'Bu duyuru iptal edilemez. Yalnız zamanlanmış ya da gönderilmekte olan duyuru iptal edilir.',
        ANNOUNCEMENT_UNSUBSCRIBE_INVALID: 'Bu bağlantı artık geçerli değil. Duyuruları kapatmak için giriş yapıp Ayarlar › Bildirimler’e gidebilirsin.',
        ANNOUNCEMENT_UNSUBSCRIBE_UNDO_UNAVAILABLE: 'Bu ret artık bu bağlantıdan geri alınamaz. Duyuruları yeniden açmak için giriş yapıp Ayarlar › Bildirimler’e gidebilirsin.',
        EMAIL_FEEDBACK_REJECTED: 'İstek doğrulanamadı.',
        POST_EVENT_NOT_ELIGIBLE: 'Katılım belgesi ve anket, etkinlik bittikten sonra check-in yapmış katılımcılara açılır.',
        EVENT_SURVEY_NOT_FOUND: 'Bu etkinliğin anketi yok.',
        EVENT_SURVEY_EXISTS: 'Bu etkinliğin zaten bir anketi var.',
        EVENT_SURVEY_CLOSED: 'Anket kapandı, cevap gönderilemez.',
        EVENT_SURVEY_ALREADY_SUBMITTED: 'Bu anketi zaten doldurdun. Gönderilen cevap değiştirilemez.',
        EVENT_SURVEY_ANSWER_INVALID: 'Cevaplardan biri bu ankete uymuyor. Sayfayı yenileyip yeniden dene.',
        EVENT_SURVEY_STATE_CONFLICT: 'Anketin durumu bu işleme izin vermiyor. Sayfayı yenile.',
        EVENT_SURVEY_PUBLISH_WINDOW_CLOSED: 'Anket en geç etkinlik bitişinden 7 gün sonrasına kadar yayınlanabilir.',
        EVENT_SURVEY_QUESTION_LIMIT: 'Ankete en çok 10 soru ekleyebilirsin.',
        EVENT_SURVEY_QUESTION_INVALID: 'Soru listesi değişmiş. Sayfayı yenileyip yeniden dene.',
        EVENT_CERTIFICATE_DISABLED: 'Bu etkinlik için katılım belgesi düzenlenmiyor.',
    },
    recommendation: {
        kicker: 'Neden bu',
        sharedTagsOne: '"{sample}" ilgi alanınla eşleşiyor.',
        sharedTagsMany: '"{sample}" dahil {count} ilgi alanınla eşleşiyor.',
        sameCity: 'Daha önce {city} etkinliklerine katıldın.',
        startingSoon: '{days} gün içinde başlıyor. Kayıt hâlâ açık.',
        startingToday: 'Bugün başlıyor.',
        startingTomorrow: 'Yarın başlıyor.',
        speaker: 'Bu etkinlikte konuşuyor.',
        none: 'Kişisel öneriler katılım geçmişin arttıkça netleşir.',
        // --- Blok 9-1: motorun ürettiği, veriye dayalı gerekçeler ----------------
        // Cümlelerde KİŞİ ADI geçmez; sayı toplulaştırmadır ve k-anonimlik eşiğinin
        // altında yazılmaz.
        coAttendance: 'Birlikte kayıtlı olduğun {event} etkinliğindeki {count} kişi buraya da kayıtlı.',
        coAttendance_one: 'Birlikte kayıtlı olduğun {event} etkinliğindeki {count} kişi buraya da kayıtlı.',
        coAttendanceAttended: '{event} etkinliğine seninle birlikte gelen {count} kişi buraya da kayıtlı.',
        coAttendanceAttended_one: '{event} etkinliğine seninle birlikte gelen {count} kişi buraya da kayıtlı.',
        relatedTags: '"{sample}", ilgilendiğin "{relatedTo}" konusuna yakın.',
        peerProfileBoth: 'Katılımcılardan {count} kişi senin gibi {sector} alanında ve {seniority} kıdeminde.',
        peerProfileBoth_one: 'Katılımcılardan {count} kişi senin gibi {sector} alanında ve {seniority} kıdeminde.',
        peerProfileSector: 'Katılımcılardan {count} kişi senin gibi {sector} alanında.',
        peerProfileSector_one: 'Katılımcılardan {count} kişi senin gibi {sector} alanında.',
        peerProfileSeniority: 'Katılımcılardan {count} kişi senin gibi {seniority} kıdeminde.',
        peerProfileSeniority_one: 'Katılımcılardan {count} kişi senin gibi {seniority} kıdeminde.',
        popularAmongPeers: 'Bu hafta en çok kayıt alan etkinliklerden biri. Şimdiden {count} kişi kayıtlı.',
        sharedHistory: 'Daha önce {count} etkinlikte onunla birlikte kayıtlıydın.',
        sharedHistory_one: 'Daha önce {count} etkinlikte onunla birlikte kayıtlıydın.',
        sharedHistoryNamed: '{event} etkinliğinde onunla birlikte kayıtlıydın.',
        roleSpeaker: 'Bu etkinlikte konuşmacı ve seninle ortak ilgi alanları var.',
        roleStaff: 'Bu etkinliği yürüten ekipte.',
        // --- Web: kayıtsız kişi katılımcı sayısını görmez (kullanıcı kararı 29.10.2026) ---
        // Kişi sayısı taşıyan gerekçelerin sayısız hâli. Mobil yukarıdaki anahtarları
        // okumaya devam eder; bunlar yalnız `reasonToTextWithoutCount` içindir.
        countless: {
            coAttendance: 'Birlikte kayıtlı olduğun {event} etkinliğinin katılımcıları buraya da kayıtlı.',
            coAttendanceAttended: '{event} etkinliğine seninle birlikte gelen kişiler buraya da kayıtlı.',
            peerProfileBoth: 'Senin gibi {sector} alanında ve {seniority} kıdemindeki kişilerin ilgisini çekiyor.',
            peerProfileSector: 'Senin gibi {sector} alanındaki kişilerin ilgisini çekiyor.',
            peerProfileSeniority: 'Senin gibi {seniority} kıdemindeki kişilerin ilgisini çekiyor.',
            popularAmongPeers: 'Bu hafta en çok kayıt alan etkinliklerden biri.',
        },
        // --- Blok 9-2: öneri yüzeyi kopyası (ekran 4 · 3 · 7) --------------------
        // `source` arayüz kopyasını DEĞİŞTİRİR: soğuk başlangıçta "sana özel"
        // iddiası kurulmaz — liste içerik + popülerlik geri düşüşüdür.
        kickerEvent: 'Neden bu etkinlik',
        kickerPerson: 'Neden bu kişi',
        sectionTitle: 'Sana önerilen etkinlikler',
        sectionLead: 'Katıldığın etkinliklere ve benzer katılımcıların tercihlerine göre.',
        // Katılım geçmişi OLMAYAN ama etiketi olan kullanıcı: iddia etiket/profille sınırlı kalır.
        sectionLeadTags: 'Seçtiğin ilgi alanlarına ve profiline göre seçildi. Etkinliklere katıldıkça bu liste geçmişinle de şekillenir.',
        coldStartTitle: 'Şimdilik öne çıkanlar',
        coldStartLead: 'Henüz bir etkinliğe katılmadın. Bunları konusuna ve ilgi görmesine göre seçtik. Katıldıkça liste sana göre şekillenir.',
        peopleTitle: 'Senin için önerilen kişiler',
        peopleLead: 'Ortak geçmişine ve ilgi alanlarına göre seçilen katılımcılar.',
        peopleLeadTags: 'İlgi alanlarına ve profiline göre seçilen katılımcılar.',
        peopleColdStartLead: 'Henüz ortak geçmişin yok. Bunlar profiline yakın katılımcılar. Tanıştıkça liste sana daha iyi uyar.',
        peopleEmptyTitle: 'Şimdilik önerilecek kişi yok',
        peopleEmptyBody: 'Bu etkinlikte sana önerilecek katılımcı henüz yok. İlgi alanlarını tamamlarsan öneriler daha isabetli olur.',
        openEvent: 'Detay',
        openPerson: 'Gör',
        onlyRecommended: 'Yalnızca bana önerilenler',
        resultCount: '{count} öneri',
        resultCount_one: '{count} öneri',
        emptyTitle: 'Henüz sana özel bir öneri yok',
        emptyBody: 'Bir etkinliğe kaydolduğunda ve ilgi alanlarını seçtiğinde öneriler gerekçesiyle burada listelenir.',
        emptyStepInterests: 'İlgi alanlarını seç',
        emptyStepInterestsBody: 'İlk gerekçeler seçtiğin etiketlerden çıkar.',
        emptyStepAttend: 'Bir etkinliğe kaydol',
        emptyStepAttendBody: 'Katılım geçmişi, "seninle birlikte gelenler" gerekçesinin kaynağıdır.',
        previewLabel: 'Bir öneri böyle görünür',
        previewTitle: 'Veri Mühendisliği Buluşması',
        previewMeta: 'İstanbul · Yüz yüze',
        loadError: 'Öneriler yüklenemedi.',
    },
    mobile: {
        /*
         * ÜRÜN ŞİFRESİ — YALNIZ MOBİLİN OKUDUĞU CÜMLELER (Blok C).
         * `auth.password.*` altına konmadı: webin envanter kapısı o ad alanında
         * web tarafından kullanılmayan anahtarı "ölü anahtar" sayıp kırılır.
         * Web karşılıkları "bu tarayıcıda" der; mobilde bellek cihazdadır.
         */
        auth: {
            /** İtilmiş sıfırlama ekranlarının ÜST ŞERİT etiketi (referans `AUTH` 82 deseni). */
            resetStep: 'Sıfırlama',
            confirmLost: 'Kayıt bilgilerin kayboldu. Aynı e-postayla yeniden kaydol, sana yeni bir kod gönderelim.',
            resetLost: 'Sıfırlama bilgilerin kayboldu. Yeni bir kod iste.',
            /** Boş gönderimde ekran okuyucuya tek cümle: kaç alan eksik. */
            missingFields: '{count} alan eksik. Seni ilk eksik alana götürdük.',
            missingFields_one: '{count} alan eksik. Seni o alana götürdük.',
            /** Gönderim ağ yokken denendi (statusCode 0): şerit zaten ekranda, cümle gönderime özgü. */
            offlineSubmit: 'İnternet bağlantısı yok, gönderilemedi. Bağlanınca tekrar dene.',
            /** İstek gitti ama süresinde yanıt gelmedi (sıra 66b): sunucu işliyor olabilir. */
            timeoutSubmit: 'Sunucudan yanıt gelmedi. Tekrar dene.',
            /** Kod gönderen uçta zaman aşımı: kod yine de gelmiş olabilir. */
            timeoutCodeSent: 'Sunucudan yanıt gelmedi. Kod yine de gelmiş olabilir, gelen kutuna bak.',
            rateLimitedOver: 'Bekleme süresi doldu. Şimdi tekrar deneyebilirsin.',
        },
        /**
         * KARŞILAMA — giriş ekranından ÖNCE gösterilen üç kart
         * (`docs/design/karsilama/Ekran.dc.html`). Kartlar sırayla etkinlik
         * öncesini, etkinlik gününü ve etkinlik sonrasını anlatır; üst etiket
         * taşımaz (kullanıcı kararı 03.11.2026). Bir kez gösterilir; "Başla" ile
         * geçildikten sonra cihazda bir daha çıkmaz.
         */
        welcome: {
            skip: 'Atla',
            next: 'Devam',
            start: 'Başla',
            dotA11y: '{total} karttan {position}. kart',
            beforeTitle: 'Etkinliği önceden planla',
            beforeBody: 'Katılımcıları, konuşmacıları ve ajandayı etkinlikten önce incele. İş görüşmelerini etkinlik başlamadan planla.',
            beforeArtA11y: 'Katılımcı listesi ve görüşme talebi',
            duringTitle: 'Etkinliğin tamamı tek uygulamada',
            duringBody: 'Ajanda, konuşmacılar ve giriş karekodun burada. Kartvizitini karekodla paylaşırsın. İki taraf da onaylamadan hiçbir bilgi paylaşılmaz.',
            duringArtA11y: 'Ajanda ve karekodla tanışma',
            afterTitle: 'Etkinlik sonrası da iletişimde kal',
            afterBody: 'Paylaştığın kartvizitler cüzdanında saklanır. Kiminle hangi etkinlikte görüştüğünü not edersin, bağlantın kaybolmaz.',
            afterArtA11y: 'Kartvizit cüzdanı',
        },
        home: {
            // Geri sayım anahtarları `dashboard.*` altına taşındı: aynı cümleyi web
            // ana sayfası da kullanıyor, tek kaynak (`countdownText`) ikisini besler.
            myEventsTitle: 'Kayıtlı olduğun etkinlikler',
            manageTitle: 'Yönettiğin etkinlikler',
            /*
             * ANA SAYFADAKİ ORGANİZATÖR GİRİŞİ (kullanıcı kararı 31.08 · §1 ·
             * bulgu 5). Kart listesi artık Etkinlikler sekmesinin "Yönettiklerim"
             * yarımında yaşıyor; ana sayfada yalnızca KOMPAKT giriş satırı kalır:
             * kaç etkinlik + kaç hazırlık uyarısı. Sayılar sunucudan gelir,
             * uydurulmaz; uyarı ucu düşerse satır bunu SÖYLER (`managedWarnLoadError`).
             */
            manageWarnCount: '{count} uyarı',
            manageWarnCount_one: '{count} uyarı',
            manageMetaWarn: '{countLabel} · {warnLabel}',
            recommendedTitle: 'Sana önerilen etkinlikler',
        },
        checkin: {
            title: 'Check-in',
            openCta: 'Check-in yap',
            notOpenNote: 'Check-in etkinlik günü açılır.',
            gateDefault: 'Giriş 1',
            frameKicker: 'Kodu çerçeveye getir',
            scanHint: 'Yaka kartını ya da uygulamadaki karekodu okut.',
            manualCta: 'İsimle ara',
            manualTitle: 'İsimle ara',
            manualSearchLabel: 'Ad ya da soyad',
            manualSearchPlaceholder: 'En az iki harf yaz',
            manualEmpty: 'Bu isimle kayıtlı katılımcı bulunamadı. Yazımı kontrol et ya da bilet numarasını sor.',
            manualPrivacyNote: 'Kapı listesi yalnızca bu ekranda görünür ve iletişim bilgisi taşımaz.',
            backToScan: 'Taramaya dön',
            okKicker: 'Giriş onaylandı',
            dupKicker: 'Bu kart daha önce okutuldu',
            dupBody: 'Aynı yaka kartı ikinci kez okutuldu. Kart paylaşımı olabilir. Kimliği görevliye sor.',
            forceCta: 'Yine de içeri al',
            rejectCta: 'Reddet ve devam et',
            nextCta: 'Sıradaki kişi',
            forcedNote: 'Görevli kararıyla içeri alındı. Kayıt tutuldu, ilk giriş saati değişmedi.',
            rowTicket: 'Bilet',
            rowTicketNone: 'Tanımsız',
            rowGate: 'Kapı',
            rowTime: 'Saat',
            alreadyBadge: 'Zaten içeride',
            replayedNote: 'Bu okutma daha önce gönderilmişti. Yeni bir giriş oluşturulmadı.',
            queuedKicker: 'Kuyruğa alındı',
            queuedBody: 'Bağlantı yok. Kayıt cihazda tutuluyor ve bağlantı gelince otomatik gönderilecek.',
            queuedUnknownPerson: 'Okutulan kart',
            queueNote: 'Kuyrukta {count} giriş var. Bağlantı gelince otomatik gönderilir.',
            queueNote_one: 'Kuyrukta {count} giriş var. Bağlantı gelince otomatik gönderilir.',
            queueSendCta: 'Kuyruğu şimdi gönder',
            queueSyncing: 'Gönderiliyor…',
            permissionKicker: 'Kamera izni kapalı',
            permissionBody: 'Karekod okutmak için kamera izni gerekir. İzin vermeden de isimle arayarak giriş alabilirsin.',
            permissionCta: 'Kameraya izin ver',
            permissionSettingsCta: 'Sistem ayarlarını aç',
            scannerUnavailable: 'Bu derlemede kamera okuyucu modülü yok. Giriş isimle aramayla alınır.',
            cameraUnavailable: 'Bu cihazda kullanılabilir arka kamera bulunamadı. Giriş isimle aramayla alınır.',
            cameraError: 'Kamera açılamadı. Uygulamayı kapatıp aç ya da girişi isimle arayarak al.',
            foreignCode: 'Bu kod bize ait bir yaka kartı değil. Katılımcının uygulamadaki karekodunu ya da yaka kartını okut.',
            torchOnCta: 'Fener',
            torchOffCta: 'Feneri kapat',
            cameraPrivacyNote: 'Kamera görüntüsü cihazda çözülür. Görüntü kaydedilmez ve sunucuya gönderilmez.',
            privacyNote: 'Kapıda görünen bilgi ad, ünvan ve bilet türüdür. E-posta ve telefon hiçbir koşulda gösterilmez.',
        },
        /**
         * MOBİL YÖNETİM EKRANI (kullanıcı kararı 31.08 · §1 · bulgu 6).
         *
         * Kavram adları WEB PANELİYLE ORTAKTIR ve `manage.*` altından gelir
         * (Başvurular / Onayla / Reddet / durum rozetleri). Burada YALNIZCA mobil
         * kabuğun kendi cümleleri durur: bölümlü tek sayfanın başlığı, kayıt
         * sayacı ve check-in girişinin gerekçesi.
         *
         * `listTruncated` ("ilk N satır; tamamı web panelinde") KALDIRILDI
         * (kullanıcı kararı 14.09): liste artık `mobile.common.loadMore` ile
         * devam ediyor, kesilmiş liste beyan edilmiyor.
         */
        manage: {
            title: 'Yönetim',
            lead: 'Etkinliğinin bütün yönetim bölümleri burada. İşaretli olanlar şimdilik yalnız web panelinde açılır.',
            /*
             * ORGANİZATÖR DUYURULARI (Story 12, T4c · tasarım M1-M7). Ortak metinler
             * `announcements.*` altındadır; burada yalnız mobil ekranlara özgü olanlar.
             */
            announcements: {
                emptyBody: 'Etkinlik günü değişiklikleri katılımcılara buradan duyurursun. Kurum alıcıların yalnız sayısını görür.',
                loadErrorTitle: 'Duyurular yüklenemedi.',
                composeNewTitle: 'Yeni duyuru',
                previewStep: 'Önizle',
                composeEditTitle: 'Duyuruyu düzenle',
                subjectPlaceholder: 'Örn. Oturum gecikmeli',
                bodyPlaceholder: 'Katılımcılara ne söylemek istiyorsun?',
                bodyHint: 'Kısa ve net yaz. Bildirimde ilk iki satır görünür.',
                countLoading: 'Kişi sayıları hesaplanıyor…',
                countPick: 'Alıcı kümesi seç',
                channelRequired: 'En az bir kanal seç',
                audienceRequired: 'Bir alıcı kümesi seç',
                inAppIncluded: 'Her duyuru uygulama içi bildirim merkezine de yazılır.',
                kindKicker: 'İçerik türü',
                saveNote: 'Önizlemeye geçince taslağın kaydedilir. Gönderene kadar düzenleyebilirsin.',
                emailFrom: 'Kimden',
                emailSubject: 'Konu',
                pushLockScreen: 'Kilit ekranında böyle görünür',
                pushHint: 'Metin cihazda iki satırdan sonra kısalır.',
                notSelectedTitle: 'Bu kanal seçili değil',
                notSelectedAddable: 'Bu kanaldan da göndermek istersen düzenlemeye dönüp kanalı ekleyebilirsin.',
                sendClosed: 'Duyuru gönderimi henüz açık değil. Taslağını şimdiden hazırlayabilirsin.',
                previewError: 'Önizleme oluşturulamadı.',
                sendSheetTitle: 'Şimdi gönderilsin mi?',
                factAudience: 'Alıcılar',
                factChannels: 'Kanallar',
                factKind: 'İçerik türü',
                sendEmpty: 'Seçtiğin kümede şu an kimse yok. Başka bir küme seçebilir ya da daha sonra gönderebilirsin.',
                sendError: 'Gönderim başlatılamadı. Duyurun taslak olarak duruyor, yeniden deneyebilirsin.',
                sending: 'Gönderiliyor…',
                sendingLive: 'Gönderim başlatılıyor',
                datePlaceholder: 'Tarih seç',
                timePlaceholder: 'Saat seç',
                zoneLine: 'Saat dilimi: {zone}',
                scheduleBounds: 'En erken 10 dakika sonrası, en geç {date} (etkinlik bitişinden 30 gün sonra).',
                scheduleTooSoon: 'En erken {time} seçebilirsin. Zamanlama şu andan en az 10 dakika sonra olmalı.',
                scheduleTooLate: 'En geç {date} seçebilirsin. Zamanlama etkinlik bitişinden en çok 30 gün sonra olabilir.',
                scheduling: 'Zamanlanıyor…',
                statusTitle: 'Duyuru durumu',
                whenScheduled: 'Zamanlandı: {date}',
                whenSending: 'Başladı: {date}',
                whenSent: 'Gönderildi: {date}',
                whenCancelled: 'İptal edildi: {date}',
                whenFailed: 'Denendi: {date}',
                stripTarget: 'Hedef',
                stripQueued: 'Kuyrukta',
                stripSent: 'Gönderildi',
                stripFailed: 'Başarısız',
                liveScheduled: 'Gönderim {date} itibarıyla başlar.',
                liveSending: 'Gönderim sürüyor. Sayılar kendiliğinden güncellenir.',
                liveSent: 'Gönderim tamamlandı.',
                liveCancelled: 'Duyuru iptal edildi.',
                liveFailed: 'Gönderim tamamlanamadı.',
                breakdownNote: 'Dağılım ileti sayar. Bir kişiye birden çok kanaldan gidebilir.',
                breakdownPending: 'Kanallara göre dağılım gönderim başlayınca görünür.',
                breakdownFew: 'Kanallara göre dağılım az sayıda iletide gösterilmez.',
                cancelledBeforeSend: 'Gönderim başlamadan iptal edildi. Hiçbir ileti gitmedi.',
                failedNote: 'Gönderim tamamlanamadı. Bu duyuru yeniden gönderilemez, gerekirse yeni bir duyuru yaz.',
                statusForbidden: 'Bu duyurunun durumunu görme yetkin yok.',
                statusNotFound: 'Duyuru bulunamadı.',
                cancelBodyScheduled: 'Gönderim daha başlamadı. Hiçbir ileti gitmez, duyuru İptal edildi olarak kalır.',
                cancelBodyQueued: 'Kuyrukta bekleyen {count} ileti gönderilmez.',
                cancelBodyQueued_one: 'Kuyrukta bekleyen {count} ileti gönderilmez.',
                cancelBodySent: 'Gönderilmiş {count} ileti geri alınamaz.',
                cancelBodySent_one: 'Gönderilmiş {count} ileti geri alınamaz.',
                cancelTooLateTitle: 'Bu duyuru artık iptal edilemez',
                cancelTooLateBody: 'Gönderim tamamlandı. Giden iletiler geri alınamaz.',
                cancelling: 'İptal ediliyor…',
            },
            /*
             * HUB (Tur T1 · referans "Kabuk ve bölüm haritası"). Künye + KPI şeridi +
             * tavan şeridi + bölüm listesi. Cümleler sayı UYDURMAZ.
             */
            sectionsHeading: 'Bölümler',
            sectionCount: '{count} bölüm',
            sectionCount_one: '{count} bölüm',
            sectionOnWebBadge: 'Webde',
            sectionOnWebHint: 'Bu bölüm şimdilik yalnız web panelinde açılıyor.',
            noAccessTitle: 'Bu panele erişimin yok',
            noAccessBody: 'Etkinliği yöneten kurum sana yetki vermemiş ya da etkinlik kaldırılmış. Yetki istiyorsan kurum sahibine başvur. Panel bilgileri yetki verilene kadar görünmez.',
            kpiLoadError: 'Sayılar yüklenemedi.',
            attendeeRows: '{count} kayıt satırı',
            attendeeRows_one: '{count} kayıt satırı',
            checkedInAt: 'Giriş: {time}',
            notCheckedIn: 'Girişi yok',
            applicationsOnlyApprovalNote: 'Başvuru kuyruğu yalnızca onaylı etkinliklerde vardır. Bu etkinlikte kayıt doğrudan açılır.',
            decideError: 'Karar kaydedilemedi. Bağlantını kontrol edip tekrar dene.',
            /*
             * DAVETLER (Tur T2 · referans "Davetler", ekran 04). Ortak cümleler
             * `manage.invite*` altındadır ve web paneliyle PAYLAŞILIR; burada
             * yalnızca mobilin KENDİ cümleleri durur: ayrı gönderme ekranı, yıkıcı
             * iptal diyaloğu, çevrimdışı kapısı ve satırın tarih kuyruğu.
             */
            invite: {
                newCta: 'Davet gönder',
                newA11y: 'Yeni davet gönder',
                emptyTitle: 'Henüz davet göndermedin',
                /*
                 * BOŞ DURUM CÜMLESİ MODA GÖRE SEÇİLİR (bakım turu · P3-1).
                 * Tek cümle vardı ve `invite_only` anlatıyordu: `approval` etkinlikte
                 * "kimse kendi başına kaydolamaz" yazıyor, oysa o modda herkes
                 * BAŞVURABİLİR; ekran etkinliğin kendi ayarıyla çelişiyordu.
                 * Seçim `invitationEmptyBodyKey` (i18n/access-mode-text) üzerinden
                 * yapılır; `Record<EventAccessMode, …>` olduğu için dördüncü bir mod
                 * eklenirse DERLEME kırılır.
                 */
                emptyBodyInviteOnly: 'Bu etkinlik yalnızca davetlilere açık. Kimse kendi başına kaydolamaz. İlk daveti göndererek başla.',
                emptyBodyApproval: 'Bu etkinliğe herkes başvurabilir. Davet ettiğin kişi başvuru sırasına girmeden doğrudan katılır. İlk daveti göndererek başla.',
                filterEmptyTitle: 'Bu filtrede davet yok',
                filterEmptyBody: 'Başka bir çipe dokunup diğer davetlere bakabilirsin.',
                sentTotal: '{count} davet gönderildi',
                sentTotal_one: '{count} davet gönderildi',
                countsPartial: 'Çip sayıları, davetlerin tamamı yüklenince yazılır.',
                dateSent: '{date} gönderildi',
                dateExpires: '{date} son',
                dateAccepted: '{date} kabul',
                dateRejected: '{date} red',
                dateExpired: '{date} doldu',
                dateRevoked: '{date} iptal',
                csvOnWeb: 'Dosyadan toplu davet web panelinde yapılır. Mobilde adresleri elle yapıştırırsın. Bir gönderimde en çok {limit} adres işlenir.',
                invalidBlocks: 'Geçersiz adresleri düzeltmeden gönderemezsin.',
                revokeTitle: 'Daveti iptal et',
                revokeBody: 'Bağlantı çalışmaz hâle gelir ve geri alınamaz. Davet edilen kişiye iptal bildirimi gitmez. Aynı adrese yeniden davet gönderebilirsin ve kontenjan bir kişilik boşalır.',
                offlineNote: 'Bağlantı yok. Listeyi okuyabilirsin ama davet gönderilemez. Davet e-postasını sunucu gönderir.',
                sendError: 'Davet gönderilemedi. Bağlantını kontrol edip tekrar dene.',
                listError: 'Davetler yüklenemedi.',
                ticketRemaining: '{count} kaldı',
                ticketRemaining_one: '{count} kaldı',
            },
            /*
             * KAYITLAR (Tur T3 · referans "Kayıtlar", ekran 02). Ortak kavramlar
             * `manage.*` altındadır ve web paneliyle PAYLAŞILIR (durum rozetleri,
             * toplu işlem cümleleri, özet satırı, gerekçe etiketi); burada yalnızca
             * mobilin KENDİ cümleleri durur: seçim kipi, detay yaprağı, filtre
             * sonucu boş hâli ve çevrimdışı kapısı.
             */
            reg: {
                searchLabel: 'Ad veya şirket ara',
                filteredRows: 'Filtrede {count} kayıt satırı',
                filteredRows_one: 'Filtrede {count} kayıt satırı',
                emptyTitle: 'Henüz kayıt yok',
                emptyBody: 'Etkinlik yayında. İlk kayıt geldiğinde burada listelenir. Etkinlik sayfasının bağlantısını paylaşarak başlayabilirsin.',
                emptyCta: 'Etkinlik sayfasını aç',
                filterEmptyTitle: 'Bu filtrede kayıt yok',
                filterEmptyBody: 'Filtreyi kaldırırsan kayıtların tamamı yeniden görünür.',
                filterClear: 'Filtreyi kaldır',
                selectMode: 'Seç',
                selectModeExit: 'Seçimi kapat',
                bulkOpen: 'Toplu işlem',
                detailA11y: '{name} kaydının ayrıntıları',
                detailClose: 'Yaprağı kapat',
                sheetRegisteredAt: 'Kayıt zamanı',
                sheetCheckIn: 'Check-in',
                ticketNone: 'Bilet türü yok',
                ticketPickLabel: 'Yeni bilet türü',
                ticketPickEmpty: 'Bu etkinlikte açık bilet türü yok. Tür değiştirilemez.',
                changeTicket: 'Bilet türünü değiştir',
                rowError: 'İşlem tamamlanamadı. Bağlantını kontrol edip tekrar dene.',
                offlineNote: 'Bağlantı yok. Listeyi okuyabilirsin ama kayıt üzerinde işlem yapılamaz. Değişikliği sunucu işler.',
            },
            /*
             * BAŞVURULAR (Tur T4 · referans "Başvurular", ekran 03). Ortak kavramlar
             * `manage.*` altındadır ve web paneliyle PAYLAŞILIR (durum rozetleri,
             * özet satırı, ret gerekçesi notu, toplu karar düğmeleri); burada
             * yalnızca mobilin KENDİ cümleleri durur: seçim kipi, detay yaprağı,
             * filtre sonucu boş hâli ve çevrimdışı kapısı.
             */
            app: {
                chipCount: '{label} · {count}',
                chipCount_one: '{label} · {count}',
                selectMode: 'Seç',
                selectModeExit: 'Seçimi kapat',
                selectedCount: '{count} başvuru seçili',
                selectedCount_one: '{count} başvuru seçili',
                selectRow: '{name} başvurusunu seç',
                detailA11y: '{name} başvurusunun ayrıntıları',
                detailClose: 'Yaprağı kapat',
                noteHeading: 'Başvuru notu, tamamı',
                noteNone: 'Başvuru notu yazılmamış.',
                sheetSubmittedAt: 'Başvuru',
                queueRows: 'Kuyrukta {count} başvuru',
                queueRows_one: 'Kuyrukta {count} başvuru',
                filteredRows: 'Filtrede {count} başvuru',
                filteredRows_one: 'Filtrede {count} başvuru',
                emptyTitle: 'Henüz başvuru yok',
                emptyBody: 'Etkinlik sayfan yayında ve ziyaretçiler başvuru düğmesini görüyor. İlk başvurular geldiğinde bu kuyruk dolmaya başlar.',
                emptyCta: 'Etkinlik sayfasını aç',
                filterEmptyTitle: 'Bu filtrede başvuru yok',
                filterEmptyBody: 'Filtreyi kaldırırsan başvuruların tamamı yeniden görünür.',
                filterClear: 'Filtreyi kaldır',
                listError: 'Başvurular yüklenemedi.',
                offlineNote: 'Bağlantı yok. Kuyruğu okuyabilirsin ama karar verilemez. Kararı sunucu işler.',
                bulkApproveTitle: '{count} başvuruyu onayla?',
                bulkApproveTitle_one: '{count} başvuruyu onayla?',
                bulkRejectTitle: '{count} başvuruyu reddet?',
                bulkRejectTitle_one: '{count} başvuruyu reddet?',
                bulkApproveConfirm: 'Onayla',
                bulkRejectConfirm: 'Reddet',
            },
            /*
             * PROGRAM (Tur T5 · referans "Program", ekran 05). Ortak kavramlar
             * `program.*` altındadır ve web paneliyle PAYLAŞILIR (alan etiketleri,
             * oturum türleri, bağlama cümleleri, silme diyalogları, çakışma onayı);
             * burada yalnızca mobilin KENDİ cümleleri durur: iki yarımlı şerit,
             * gün ayırıcısı, eylem yaprağı, çevrimdışı kapısı ve bitmiş etkinlik
             * bildirimi.
             */
            prog: {
                tabAgenda: 'Ajanda',
                tabSpeakers: 'Konuşmacılar · {count}',
                tabSpeakers_one: 'Konuşmacılar · {count}',
                newSessionA11y: 'Yeni oturum ekle',
                newSpeakerA11y: 'Yeni konuşmacı ekle',
                daySessions: '{count} oturum',
                daySessions_one: '{count} oturum',
                agendaEmptyTitle: 'Program henüz kurulmadı',
                agendaEmptyBody: 'Etkinlik {count} gün sürüyor ve henüz hiç oturum eklenmemiş. Etkinlik sayfasındaki program bölümü boş duruyor. İlk oturumu eklediğinde orası dolar.',
                agendaEmptyBody_one: 'Etkinlik {count} gün sürüyor ve henüz hiç oturum eklenmemiş. Etkinlik sayfasındaki program bölümü boş duruyor. İlk oturumu eklediğinde orası dolar.',
                agendaEmptyCta: 'İlk oturumu ekle',
                speakersEmptyTitle: 'Henüz konuşmacı yok',
                speakersEmptyBody: 'Konuşmacı eklemek onay gerektirmez. Girdiğin bilgiler etkinlik sayfasında görünür. Kişinin kendi hesabına bağlamak istersen ayrı bir onay isteği gider.',
                speakersEmptyCta: 'İlk konuşmacıyı ekle',
                conflictTitle: 'İki oturum aynı salonda çakışıyor',
                conflictCount: '{count} çakışma var',
                conflictCount_one: '{count} çakışma var',
                linkNone: 'Bağlanmadı',
                linkedProfileNote: 'Bağlantı kurulunca kişinin kendi profili (ad, unvan, biyografi, fotoğraf) etkinlik sayfasındaki bilgilerin yerine geçer.',
                photoOnWeb: 'Konuşmacı fotoğrafı şimdilik web panelinden yüklenir. Mobilde monogram görünür.',
                endedNotice: 'Bu etkinlik sona erdi. Programı yine de düzeltebilirsin. Kayıt etkinlik sayfasında durur ve katılımcılara bildirim gitmez.',
                listError: 'Program yüklenemedi.',
                mutationError: 'İşlem tamamlanamadı. Bağlantını kontrol edip tekrar dene.',
                offlineNote: 'Bağlantı yok. Programı okuyabilirsin ama oturum ve konuşmacı kaydedilemez. Değişikliği sunucu işler.',
                sessionNewTitle: 'Oturum ekle',
                sessionEditTitle: 'Oturumu düzenle',
                speakerNewTitle: 'Konuşmacı ekle',
                speakerEditTitle: 'Konuşmacıyı düzenle',
                sessionSpeakersEmpty: 'Önce konuşmacı ekle. Oturuma burada bağlarsın.',
                speakerSessionsNone: 'Henüz bir oturuma bağlı değil.',
                sessionSpeakersNone: 'Bu oturuma konuşmacı bağlanmadı.',
                sessionActionsA11y: '{title} oturumu için işlemler',
                speakerActionsA11y: '{name} için işlemler',
                sheetClose: 'Yaprağı kapat',
                moveUpA11y: 'Yukarı taşı: {name}',
                moveDownA11y: 'Aşağı taşı: {name}',
                linkDialogTitle: 'Hesabına bağla',
                linkDialogSend: 'Talebi gönder',
            },
            /*
             * BİLETLER (Tur T6 · referans "Biletler", ekran 06). Ortak kavramlar
             * `manage.*` altındadır ve web paneliyle PAYLAŞILIR (tür etiketi, satış
             * durumları, kontenjan alanı, varsayılan rozeti, silme onayı); burada
             * yalnızca mobilin KENDİ cümleleri durur: kontenjan tabanı, sınırsız
             * ayrımı, silme kilidinin gerekçesi ve çevrimdışı kapısı.
             */
            tick: {
                newA11y: 'Yeni bilet türü ekle',
                newTitle: 'Bilet türü ekle',
                editTitle: 'Bilet türünü düzenle',
                rowActionsA11y: '{name} bilet türü için işlemler',
                sheetClose: 'Yaprağı kapat',
                emptyTitle: 'Bilet türü tanımlanmadı',
                emptyBody: 'Bilet türü olmadan kayıt açılamaz. En az bir tür ekle. Ücretsiz bırakabilirsin.',
                floorNote: '{count} kayıt bu türde, kontenjan bu sayının altına inemez.',
                floorNote_one: '{count} kayıt bu türde, kontenjan bu sayının altına inemez.',
                floorNoneNote: 'Bu türde henüz kayıt yok, kontenjanı serbestçe değiştirebilirsin.',
                priceNote: 'Bilet ücreti ve ödeme akışı üründe henüz yok. Türlerin tamamı ücretsiz kaydolur.',
                defaultNote: 'Varsayılan tür, katılımcı tür seçmeden kaydolduğunda bağlanan türdür.',
                deleteBlockedNote: 'Bu türde {count} kayıt var, tür silinemez. Yeni kaydı durdurmak için satış durumunu "Kapalı" yap.',
                deleteBlockedNote_one: 'Bu türde {count} kayıt var, tür silinemez. Yeni kaydı durdurmak için satış durumunu "Kapalı" yap.',
                deleteReservedError: 'Bu bilet türünde kayıt var, tür silinemez. Yeni kaydı durdurmak için satış durumunu "Kapalı" yap.',
                quotaFloorError: 'Kontenjan {count} mevcut kaydın altına inemez. En düşük değer {count}, kayıt iptal edilmeden düşürülemez.',
                quotaFloorError_one: 'Kontenjan {count} mevcut kaydın altına inemez. En düşük değer {count}, kayıt iptal edilmeden düşürülemez.',
                quotaInvalid: 'Kontenjan tam sayı olmalı.',
                quotaHint: 'Bu türde {count} kayıt var. "0" yazarsan tür fiilen kapanır.',
                quotaHint_one: 'Bu türde {count} kayıt var. "0" yazarsan tür fiilen kapanır.',
                quotaUnlimitedHint: 'Boş bırakırsan kontenjan sınırsız olur. "0" sınırsız demek değildir, tür fiilen kapanır.',
                quotaDecrease: 'Kontenjanı bir azalt',
                quotaIncrease: 'Kontenjanı bir artır',
                statusNote: 'Satışta olan türü herkes seçebilir, gizli tür yalnız davetle bağlanır, kapalı türe yeni kayıt alınmaz.',
                offlineNote: 'Bağlantı yok. Bilet türlerini okuyabilirsin ama kontenjan kaydedilemez. Değişikliği sunucu işler.',
            },
            /*
             * ANALİTİK (Tur T8 · referans ekran 08 + web `event-analytics.tsx`).
             * Bölümün KAVRAM cümleleri web paneliyle ORTAKTIR ve `analytics.*`
             * altından gelir (KPI adları, dağılım başlıkları, bastırma gerekçesi,
             * gizlilik notu). Burada yalnız mobilin KENDİ cümleleri durur.
             */
            /*
             * GÖRÜŞME ALANLARI (Tur T9). Bölümün KAVRAM cümleleri web paneliyle
             * ORTAKTIR ve `meetingAreas.*` altından gelir (başlık, kürasyon notu,
             * kapasite/uygunluk etiketleri, doluluk, silme uyarısı, boş durum).
             * Burada yalnız mobilin KENDİ cümleleri durur: ayrı form ekranı, eylem
             * yaprağı, çevrimdışı kapısı ve dokunma hedeflerinin erişilebilir adları.
             */
            area: {
                newA11y: 'Yeni görüşme alanı ekle',
                rowActionsA11y: '{name} alanı için işlemler',
                sheetClose: 'Yaprağı kapat',
                offlineNote: 'Bağlantı yok. Alanları okuyabilirsin ama ekleme, düzenleme ve silme kapalı. Üçü de sunucuda karara bağlanır.',
                noFilterNote: 'Alan listesi filtrelenmez. Bu etkinlikte tanımlı bütün alanlar burada.',
                linkedNote: 'Bu alana {count} kabul edilmiş görüşme bağlı. Silmeden önce ne olacağını onay adımında görürsün.',
                linkedNote_one: 'Bu alana {count} kabul edilmiş görüşme bağlı. Silmeden önce ne olacağını onay adımında görürsün.',
                linkedNoneNote: 'Bu alana bağlı kabul edilmiş görüşme yok. Silmek kimseyi etkilemez.',
                capacityDecrease: 'Kapasiteyi bir azalt',
                capacityIncrease: 'Kapasiteyi bir artır',
                capacityRangeHint: 'Kapasite en az {min}, en çok {max} olabilir.',
                hoursFromLabel: 'Başlangıç saati',
                hoursToLabel: 'Bitiş saati',
                hoursClear: 'Saatleri temizle',
                hoursAllHint: 'Saat seçmezsen alan etkinlik boyunca açık kalır.',
                daysHint: 'Hiçbir gün seçmezsen alan etkinliğin bütün günlerinde açık olur.',
                daysSingleNote: 'Etkinlik tek gün sürüyor. Ayrıca gün seçmene gerek yok.',
                impactUnknown: 'Etkilenen görüşmeler şu an okunamıyor. Kaç görüşmenin etkileneceğini görmeden alan silinmez.',
                impactRetry: 'Etkiyi tekrar oku',
                deleteBlockedOffline: 'Bağlantı yok. Silme sunucuda işlenir.',
            },
            stats: {
                offlineNote: 'Bağlantı yok. Ekrandaki sayılar son yüklendikleri andan kalma. Yeni kayıtlar bağlantı gelince yansır.',
                chartA11y: 'Saatlik kayıt dağılımı çubukları',
                hourlyPeak: 'En yoğun saat {hour} · {count} kayıt',
                hourlyPeak_one: 'En yoğun saat {hour} · {count} kayıt',
                ticketEmpty: 'Bu etkinlikte bilet türü tanımlanmadığı için dağılım da yok.',
                emptyCtaShare: 'Etkinlik sayfasını aç',
                rangeNote: 'Sayılar etkinliğin tamamını kapsar. Tarih aralığı filtresi üründe henüz yok.',
            },
            setup: {
                stepBarA11y: 'Kurulum adımları',
                savingStep: 'Adım kaydediliyor…',
                offlineNote: 'Bağlantı yok. Kurulumu okuyabilirsin ama kaydetme ve yayın kapalı. İkisi de sunucuda karara bağlanır.',
                recoveryTitle: 'Yarım kalmış kurulum var',
                recoveryBody: '{date} tarihinde {step}. adımda bırakılmış bir taslak bulundu. Kaldığın yerden devam edebilir ya da baştan başlayabilirsin.',
                recoveryContinue: 'Devam et',
                recoveryRestart: 'Baştan',
                recoveryRestored: 'Yarım kalan kurulum geri yüklendi. Kaydetmeden çıkarsan yine burada bekler.',
                publishBlocked: 'Yayın için eksik: {fields}',
                publishWarning: 'Yayınladığında etkinlik sayfası arama motorlarına açılır ve kayıt bağlantısı çalışmaya başlar. Erişim modunu sonradan değiştirmek sayfanın görünürlüğünü de değiştirir.',
                keepDraft: 'Taslakta tut',
                alreadyPublished: 'Etkinlik yayında. Yayınlama eylemi bir kez çalışır.',
                ticketsCta: 'Biletler bölümüne git',
            },
            /*
             * MARKA AYARLARI VE GÖRSEL YÜKLEME (Tur T10 · referans ekran 09).
             *
             * Ortak cümleler `organizer.brand.*` altındadır ve web paneliyle
             * PAYLAŞILIR (başlık, açıklama, devralım/ezme durumu, renk ipucu, AA
             * uyarısı, kaydetme). Burada yalnız mobilin KENDİ cümleleri durur:
             * kapak kartı, beş adımlı yükleme akışı ve izin reddi.
             */
            brand: {
                offlineNote: 'Bağlantı yok. Markanı okuyabilirsin ama görsel yükleme ve kaydetme kapalı. İkisi de sunucuda karara bağlanır.',
                logoOwn: 'Bu etkinliğin kendi logosu.',
                logoInherited: '{organization} kurumunun logosu kullanılıyor.',
                logoNone: 'Logo yok. Kurum adının baş harfleri kullanılıyor.',
                logoLimits: '{formats} · en az {minWidth}×{minHeight} px · en çok {megabytes} MB',
                logoUpload: 'Logo yükle',
                logoReplace: 'Logoyu değiştir',
                coverKicker: 'Kapak görseli',
                coverNote: 'Kapak yüklemezsen marka tonlarından türeyen bir kapak üretilir. Gri boş kutu göstermeyiz.',
                coverLimits: '{formats} · 16:9 · en çok {megabytes} MB',
                coverUpload: 'Kapak yükle',
                coverReplace: 'Kapağı değiştir',
                coverClear: 'Kapağı kaldır',
                colorNote: 'Marka rengi yalnız etkinliğin herkese açık sayfasının içerik alanında ve yaka kartında kullanılır. Uygulamanın kendi çerçevesi değişmez.',
                orgBrandOnWeb: 'Kurumun logosunu ve rengini web panelinden ayarlarsın. Burada yalnız bu etkinliğin kendi markası yönetilir.',
                savedPreviewNote: 'Yüklediğin görsel kaydedene kadar yalnız burada görünür.',
                pickTitle: 'Görsel yükleme',
                pickCamera: 'Kamerayla çek',
                pickLibrary: 'Galeriden seç',
                pickSourceKicker: 'Kaynak seçimi',
                pickClose: 'Yaprağı kapat',
                cropTitle: 'Kırp',
                cropChoose: 'Kırp',
                cropCancel: 'Vazgeç',
                preparing: 'Görsel hazırlanıyor',
                preparingBody: 'Seçici açık. Kareyi seçip kırptığında yükleme buradan sürer.',
                uploading: 'Yükleniyor',
                uploadMeta: '{size} · %{percent}',
                uploadMetaUnknown: '{size}',
                uploadCancel: 'Yüklemeyi durdur',
                errorTitle: 'Görsel yüklenemedi',
                errorType: 'Bu dosya türünü kabul etmiyoruz. {formats} biçimlerinden birini seç.',
                errorSize: 'Dosya {megabytes} MB sınırını aşıyor. Daha küçük bir görsel seç ya da kırparak boyutu düşür.',
                errorDimensions: 'Görsel en az {minWidth}×{minHeight} piksel olmalı. Daha büyük bir kare seç.',
                errorTransport: 'Yükleme yarıda kaldı. Bağlantını kontrol edip tekrar dene.',
                errorProcessing: 'Görsel yüklendi ama hazırlanamadı. Biraz sonra tekrar dene. Sorun sürerse başka bir görsel seç.',
                errorUnavailable: 'Görsel seçici bu sürümde açılamıyor. Uygulamayı güncelledikten sonra tekrar dene. Şimdilik web panelinden yükleyebilirsin.',
                errorUnreadable: 'Bu fotoğraf açılamadı. Başka bir fotoğraf dene.',
                errorPickAnother: 'Başka görsel',
                permissionCameraTitle: 'Kamera izni verilmedi',
                permissionCameraBody: 'Kamerayla çekmek için izin gerekiyor. Dilersen galeriden de seçebilirsin. O izin ayrı istenir. Görüntü cihazdan çıkmadan kırpılır.',
                permissionLibraryTitle: 'Galeri izni verilmedi',
                permissionLibraryBody: 'Galeriden seçmek için izin gerekiyor. Dilersen kamerayla çekebilirsin. O izin ayrı istenir. Görüntü cihazdan çıkmadan kırpılır.',
                permissionSettingsCta: 'Ayarları aç',
                permissionAskCta: 'İzin iste',
            },
        },
        comingSoon: {
            kicker: 'Yakında',
            qrTitle: 'Karekodla tanışma yakında',
            qrBody: 'Kartvizit değişimi çift taraflı onayla çalışır ve yakında açılır. Bu sekme yerinde duruyor ki alışkanlığın bozulmasın.',
            action: 'Kimler geliyor, bak',
        },
        /* "İndir" dosyayı Android'de İndirilenler klasörüne yazar (27.10.2026). */
        fileSave: {
            savedToast: '{name} İndirilenler klasörüne kaydedildi.',
        },
        push: {
            channelName: 'Etkinlik bildirimleri',
            channelPeopleName: 'Görüşme talepleri ve kartvizitler',
            permissionTitle: 'Bildirim izni',
            permissionGranted: 'Açık',
            permissionDenied: 'Kapalı',
            permissionUnknown: 'Henüz sorulmadı',
            permissionBody: 'Kayıtlı olduğun etkinliklerde tarih ya da yer değişirse, etkinlik iptal olursa hemen haberin olur.',
            /* Kurum hesabı katılımcı olamaz (02.10): katılım cümlesi ona yazılmaz (sıra 41d). */
            permissionBodyOrganization: 'Kurum hesabını ilgilendiren haberler bu cihaza anında düşer. Katılımcı bildirimleri bu hesaba gelmez.',
            deniedBody: 'İzin sistem tarafında kapalı. E-posta bildirimlerin açık kalmayı sürdürür ve değişiklikleri Ajandam ekranından da görebilirsin.',
            // Kurum hesabında Ajandam yoktur (katılımcı ekranı).
            deniedBodyOrganization: 'İzin sistem tarafında kapalı. E-posta bildirimlerin açık kalmayı sürdürür.',
            assurance: 'Yalnız kayıtlı olduğun etkinlikler için bildirim alırsın. Bildirimlerde başkalarının bilgisi yer almaz.',
            assuranceOrganization: 'Bildirimler yalnızca bu kurum hesabıyla ilgilidir. Başka kullanıcının verisi bu kanalda taşınmaz.',
            allowCta: 'Bildirimlere izin ver',
            openSettingsCta: 'Sistem ayarlarını aç',
            registeredMeta: 'Cihaz kaydı aktif.',
            registeredDevMeta: 'Cihaz kaydı aktif (geliştirme jetonu, gerçek FCM anahtarı yok).',
            notRegisteredMeta: 'Cihaz kaydı yok.',
            /* Kart hazır: izin verildi, cihaz kaydı düştü (sıra 47). İzin yeniden istenmez. */
            registrationFailed: 'İzin verdin ama bu cihazı bildirimler için kaydedemedik, bu yüzden bildirim gelmeyecek. Yeniden dene. Ayarlar içindeki Bildirimler ekranını açtığında da yeniden denenir.',
            registrationRetryCta: 'Kaydı tekrar dene',
            devProbeCta: 'Test bildirimi göster (yalnızca geliştirme)',
            devProbeFollowCta: 'Takip bildirimi göster (yalnızca geliştirme)',
            devProbeAnnouncementCta: 'Duyuru bildirimi göster (yalnızca geliştirme)',
            devProbePostEventCta: 'Etkinlik sonrası bildirimi göster (yalnızca geliştirme)',
            /*
             * İlk giriş bildirim adımı (kullanıcı kararı 15.10.2026, referans
             * `docs/design/bildirim-izni`). Örnek bildirim kurgusaldır ve dekoratiftir.
             */
            stepTitle: 'Tanışma fırsatlarını kaçırma',
            stepLead: 'Şu durumlarda haber veririz:',
            stepReasonMeeting: 'Görüşme talebi geldiğinde ya da yanıtlandığında',
            stepReasonCard: 'Kartvizit değişimin onaylandığında',
            stepReasonEvent: 'Kayıtlı olduğun etkinlik yaklaştığında',
            stepReasonFollow: 'Takip ettiğin kurum yeni etkinlik açtığında',
            stepNoAds: 'Reklam ya da kampanya bildirimi göndermeyiz.',
            stepLater: 'Şimdi değil',
            stepFootnote: 'İstediğin zaman Ayarlar › Bildirimler’den değiştirebilirsin.',
            stepSampleName: 'Ayşe Y.',
            stepSampleTime: 'şimdi',
            stepSampleTitle: 'Ayşe Y. seninle görüşmek istiyor',
            stepSampleMeta: 'Açık Bankacılık Zirvesi · 24 Ekim, 10:30',
            /* İzin verildi: ana sayfada 3 sn kısa bildirim. */
            enabledToast: 'Bildirimler açık. Görüşme talebi gelince haber veririz.',
            /* Adımda reddetti: ana sayfada bir kerelik kart. */
            deniedCardTitle: 'Bildirimler kapalı',
            deniedCardBody: 'Görüşme taleplerini uygulamayı açınca görürsün. İstediğin zaman Ayarlar’dan açabilirsin.',
            deniedCardCta: 'Ayarları aç',
            /* "Şimdi değil" sonrası: ilk talep ya da ilk kayıtta bir kez. */
            contextualTitle: 'Yanıt gelince haber verelim mi?',
            contextualBody: 'Görüşme talebin yanıtlandığında hemen haber veririz.',
            contextualRegistrationTitle: 'Etkinlik yaklaşınca haber verelim mi?',
            contextualRegistrationBody: 'Kayıtlı olduğun etkinlik yaklaştığında, organizatör duyuru gönderdiğinde ve sana görüşme talebi geldiğinde haber veririz.',
            contextualCta: 'Bildirimleri aç',
            cardClose: 'Kapat',
        },
        agenda: {
            title: 'Ajandam',
            subtitle: 'Kayıtlı olduğun etkinliklerin programı',
            emptyTitle: 'Ajandan şimdilik boş',
            emptyBody: 'Bir etkinliğe kaydolduğunda oturumlar burada gün gün listelenir. Program yayınlanmadıysa etkinlik yine görünür.',
            noSessions: 'Program henüz yayınlanmadı.',
            dayLabel: '{day}. gün',
        },
        person: {
            title: 'Katılımcı profili',
            interestsTitle: 'İlgi alanları',
            aboutTitle: 'Hakkında',
            cardNote: 'Kartvizit yalnız iki taraf da onaylarsa paylaşılır. Profili görmek kartvizit paylaşmak demek değil.',
            contactHidden: 'İletişim bilgisi gösterilmez.',
            speakerBadge: 'Konuşmacı',
            organizerBadge: 'Organizatör',
            contextTitle: 'Nerede görünüyor',
            contextEventRole: 'Bu kişiyi {event} katılımcı listesinde görüyorsun.',
            contextSpeaker: 'Bu etkinlikte konuşmacı.',
            contextSector: 'Sektör: {sector}',
            contextSeniority: 'Kıdem: {seniority}',
            similarTitle: 'Benzer kişiler',
            similarLead: 'Bu etkinlikte seninle ortak ilgi alanları olan kişiler.',
            similarAllCta: 'Tümünü gör',
        },
        /* Konuşmacı detayı (27.10.2026): web ekran 29'un mobil eşi, metinlerin çoğu `speakerPage`ten. */
        speaker: {
            title: 'Konuşmacı',
            openA11y: '{name}, konuşmacı sayfasını aç',
            /* Cüzdandaki "Kişiyi paylaş" kararıyla aynı (19.10.2026): vCard paylaşım sayfasına gider, rehbere yazılmaz. */
            shareCard: 'Kişiyi paylaş',
            shareFailed: 'Kartvizit paylaşılamadı. Yeniden dene.',
            notFoundBody: 'Konuşmacı kaldırılmış ya da etkinlik artık yayında olmayabilir.',
            loading: 'Yükleniyor',
            offline: 'Çevrimdışısın. Son görülen bilgiler gösteriliyor.',
        },
        event: {
            tabGeneral: 'Genel',
            tabSpeakers: 'Konuşmacılar',
            tabAgenda: 'Ajanda',
            tabAttendees: 'Katılımcılar',
            attendeesLocked: 'Katılımcı listesini yalnız kaydolanlar görür.',
            inviteOnlyNotice: 'Bu etkinliğe yalnız organizatörün davet ettiği kişiler katılabilir.',
            openInvite: 'Davet kodum var',
            onlyRecommended: 'Yalnızca bana önerilenler',
            onlyRecommendedHint: 'Ortak ilgi alanı bulunan katılımcıları gösterir. Gerekçesi olmayanlar gizlenir.',
            // HK-2: referans SEKMESİZDİR — tek kaydırılabilir sayfa + 2 hücreli ızgara.
            navAttendees: 'Katılımcılar',
            // Referansın "412 kişi · filtrele" satırındaki SAYININ ucu yok:
            // `EventDto` katılımcı sayacı taşımaz (denetim raporunda ⊘ API boşluğu).
            // Uydurma sayı yazmak yerine eylem yazılır (CLAUDE.md md. 9).
            navAttendeesOpen: 'Ara ve filtrele',
            navAttendeesLocked: 'Kayıt sonrası açılır',
            navCellA11y: '{title}, {meta}',
            navAgenda: 'Ajanda',
            navAgendaMeta: '{count} oturum',
            navAgendaMeta_one: '{count} oturum',
            navAgendaEmpty: 'Program yayınlanmadı',
            speakersKicker: 'Konuşmacılar',
            agendaKicker: 'Program',
            openProfile: 'Profil',
        },
        invite: {
            title: 'Daveti aç',
            tokenLabel: 'Davet bağlantısındaki kod',
            tokenHint: 'Davet e-postasındaki bağlantının sonundaki kodu yapıştır. Davet yalnız sana özel.',
            lookupCta: 'Daveti getir',
        },
        settings: {
            title: 'Ayarlar',
            appearanceTitle: 'Görünüm',
            appearanceHint: 'Açık temayla başlar. İstediğin zaman değiştirebilirsin, seçimin kalıcıdır.',
            languageTitle: 'Dil',
            accountTitle: 'Hesap',
            signOut: 'Çıkış yap',
            signedInAs: '{email} olarak giriş yaptın',
            dataTitle: 'Verin',
            /*
             * DÜĞME NE YAPIYORSA ONU YAZAR (mobil elle test · bulgu 12). Eski metin
             * "talebi buradan oluştur" diyordu ama uygulama hiçbir talep açmıyor,
             * tarayıcıyı açıyordu.
             */
            exportOnWeb: 'Dışa aktarma tarayıcıda yapılır. Kimliğini orada bir kez daha doğrularsın, hazır olunca bağlantı e-postana gelir.',
            exportOpenWebCta: 'Tarayıcıda aç',
            exportOpenWebHint: 'Bağlantı {domain} adresinde açılır.',
            /* KVKK başvurusu webdeki formda yapılır; mobil formu tarayıcıda açar (12.10.2026 kararı). */
            kvkkRequestTitle: 'KVKK başvurusu',
            kvkkRequestBody: 'Başvurunu webdeki formdan yaparsın. Düğme formu tarayıcıda açar, orada hesabınla giriş yapman istenebilir.',
            kvkkRequestCta: 'KVKK başvurusu yap',
            deletionConfirmHint: 'Bu anahtarı açtığında e-postana bir doğrulama kodu isteyebilirsin. Kod olmadan hesap silinmez.',
            deletionGraceDays: 'Talebini {days} gün içinde geri alabilirsin. Bu süre dolmadan hiçbir veri kalıcı olarak silinmez.',
            profileTitle: 'Profil ve kartvizit',
            profileHint: 'Adın, kartvizitin, kıdem ve sektör bilgin ve ilgi etiketlerin.',
            speakerLinksHint: 'Konuşmacı olarak gösterildiğin etkinlikler ve bekleyen onaylar.',
            teamInvitationHint: 'Bir kuruma ekip daveti aldıysan kodu buradan girersin.',
            organizationsHint: 'Kurumlarını gör, doğrulama başvurunu buradan yürüt.',
        },
        common: {
            backA11y: 'Geri dön',
            tabsA11y: 'Ekran bölümleri',
            pullToRefresh: 'Yenilemek için aşağı çek',
            loadMore: 'Daha fazla göster',
            resultsLoading: 'Liste yükleniyor',
            previewPersonName: 'Ada Yılmaz',
            previewPersonRole: 'Ürün Yöneticisi · Örnek Teknoloji',
            previewEventTitle: 'Örnek Etkinlik',
            previewEventMeta: 'İstanbul · Yüz yüze',
            // Kurumlarım boş hâlinin soluk önizlemesi (ürünün kendi kartı).
            previewOrganizationName: 'Örnek Kurum',
        },
        /**
         * Ekran AUTH 3.6 "Kart hazır" — kurulum bitişi ile ana ekran ARASINDA.
         * KÇ #14 (satır 222) bu ekranda yazılıdır: "Profiliniz şimdilik gizli."
         */
        cardReady: {
            kicker: 'Kurulum tamamlandı',
            poster: 'Kartın hazır.',
            assurance: 'Artık karekodla tanışabilir, etkinlik öncesi görüşme talebi gönderebilirsin. Profilin yalnız kaydolduğun etkinliklerin katılımcılarına görünür.',
            cardKicker: 'Kartın',
            qrHint: 'Karekodun kısa süre geçerlidir, her tanışmada Karekod sekmesinde yenisi oluşur. Kod burada saklanmaz.',
            showCardCta: 'Kartımı göster',
            nextTitle: 'Sıradaki adım',
            nextBody: 'Bir etkinliğe kaydol. Katılımcı listesi ve öneriler o zaman açılır.',
            nextCta: 'Etkinlik bul',
            visibilityCta: 'Gizlilik ayarlarını gözden geçir',
        },
        /**
         * KURUM SATIŞLA AÇILIR · MOBİL (T6 · M1-M8). Web ile ortak metinler
         * `salesInquiry`, `orgEntry`, `credits`, `publishDialog` ve `ceiling`
         * bölümlerinden okunur. Burada yalnız mobil referansın kendine özgü
         * cümleleri durur (çevrimdışı şeridi, alt sayfa notları, sahip daveti).
         * Fiyat, para birimi ve satın alma metni YOKTUR (V10, `no-price.guard`).
         */
        salesInquiry: {
            offlineNotice: 'Çevrimdışısın. Bilgilerin cihazda korunuyor.',
            offlineNote: 'Bağlantı gelince gönderebilirsin.',
            rateLimitedNote: 'Düğme birkaç dakika sonra açılır.',
            sentBack: 'Kurumlarıma dön',
            noticeOpen: 'Aydınlatma metnini oku',
        },
        orgEntry: {
            listOfflineNotice: 'Çevrimdışısın. Son görülen liste gösteriliyor.',
            listOfflineNote: 'Liste bağlantı gelince yenilenir.',
            listError: 'Kurumlar okunamadı.',
            contactLink: 'Yeni bir etkinlik için bize ulaş',
            boxTitle: 'Etkinliğini {brandName} ile düzenlemek ister misin?',
            boxBody: 'Kurumunu biz açalım.',
            askRole: 'Etkinlik açmak için kurum yöneticinden yetki iste.',
            askRoleHint: 'Bir kurumun ekibindeysen yöneticinden yetki iste.',
            createOfflineNotice: 'Çevrimdışısın. Yeni etkinlik için bağlantı gerekiyor.',
            organizerPlaceholder: 'Kurum seç',
            organizerSingle: 'Yönetebildiğin tek kurum bu.',
            organizerLocked: 'Taslak {organizationName} adına kaydedildi. Düzenleyen kurum sonradan değişmez.',
            organizerNone: 'Etkinlik açabileceğin bir kurum yok. Kurumunu açmamız için bize ulaş.',
            organizerLoadFailed: 'Seçilemedi',
            organizerLoadError: 'Kurumlar okunamadı.',
            organizerOfflineNotice: 'Çevrimdışısın. Kurum listesi bağlantı gelince yenilenir.',
        },
        credits: {
            offlineNotice: 'Çevrimdışısın. Kredi bilgisi son görülen hâliyle gösteriliyor.',
            eventsTitle: 'Etkinlikler',
            teamTitle: 'Ekip',
            eventRegistrations: '{count} kayıt',
            eventRegistrations_one: '{count} kayıt',
            kickerExhausted: 'Kredi bitti',
            unitPublish: 'yayın',
        },
        publish: {
            infoCredit: 'Yayınlarken 1 kredi kullanılır. {count} kredin var.',
            infoCredit_one: 'Yayınlarken 1 kredi kullanılır. {count} kredin var.',
            infoTrial: 'Yayınlarken hoş geldin kredin kullanılır. Katılımcı sınırı {ceiling}.',
            infoContract: 'Kurumsal sözleşme kapsamında yayınlanır. Kredi düşmez.',
            infoExhausted: 'Kurumunun kredisi bitti. Etkinliğin taslak olarak kalır.',
            offlineNotice: 'Çevrimdışısın. Yayın için bağlantı gerekiyor.',
        },
        ownerInvite: {
            title: '{organizationName} kurumunun sahibi olarak davet edildin',
            body: 'Kurumunu {brandName} ekibi açtı. Kabul edince etkinlik açabilir, ekibini davet edebilir ve kredi durumunu görebilirsin.',
            notMine: 'Bu davet bana ait değil',
            acceptedTitle: 'Artık {organizationName} kurumunun sahibisin',
            acceptedBody: 'Etkinlik açabilir, ekibini davet edebilir ve kredi durumunu görebilirsin.',
            acceptError: 'Davet kabul edilemedi. Yeniden dene.',
            expired: 'Bu davetin süresi doldu. Yeni davet için bize ulaş.',
            expiredTitle: 'Süresi doldu',
            expiredCta: 'Bize ulaş',
            offlineNotice: 'Çevrimdışısın. Daveti kabul etmek için bağlantı gerekiyor.',
        },
        ceiling: {
            contractNote: 'Kurumsal sözleşme · katılımcı sınırı yok',
            offlineNotice: 'Çevrimdışısın. Kayıt sayısı son görülen hâliyle gösteriliyor.',
            lockBreakdownAction: 'Sektör/kıdem',
        },
        /**
         * KURUM HESABI MOBİL YÜZEYLERİ (K6 · H12, H14 · TM1, TM2, TM4, TM5, TM6).
         * Web ile ortak metinler `orgAccount` altındadır; burada yalnız mobil
         * çizimin kendi cümleleri durur (sekme adları, "ekran" sözcüğü, kurum
         * sekmesi ve hesap sekmesi satırları). Hesap değiştirici (TM3, K7) metinleri
         * `mobile.accounts` altındadır.
         */
        orgAccount: {
            tabOrganization: 'Kurum',
            tabEvents: 'Etkinlikler',
            tabAccount: 'Hesap',
            upcoming: 'Yaklaşan',
            allEvents: 'Tüm etkinlikler (geçmiş dahil)',
            todayAt: 'Bugün · {time}',
            eventsEmptyTitle: 'Henüz yönettiğin etkinlik yok',
            eventsEmptyBody: 'Etkinlik açtığında ya da bir etkinliğe editör olarak eklendiğinde burada görünür.',
            offlineSeen: 'Çevrimdışısın. Son görülen bilgiler gösteriliyor.',
            offlineSaved: 'Çevrimdışısın. Değişiklikler bağlantı gelince kaydedilir.',
            switchOrganization: 'Kurum değiştir',
            teamMembers: '{count} üye',
            teamMembers_one: '{count} üye',
            teamPending: '{count} bekleyen davet',
            teamPending_one: '{count} bekleyen davet',
            teamManage: 'Ekibi yönet ›',
            teamManageLabel: 'Ekibi yönet',
            orphanBody: 'Bu kurum hesabı yalnız kurum işi içindir. Bir kurum seni davet edince yeniden kullanabilirsin.',
            toPersonal: 'Kişisel hesabına geç',
            gateTitle: 'Bu ekran kişisel hesaplar için',
            gateWanted: 'Açmak istediğin ekran: {page}',
            gateWhy: 'Kartvizit, cüzdan, görüşme talebi ve kişisel ajanda kişisel hesabınla kullanılır. Şu an {organizationName} kurum hesabındasın.',
            gateWhyNoOrganization: 'Kartvizit, cüzdan, görüşme talebi ve kişisel ajanda kişisel hesabınla kullanılır. Şu an kurum hesabındasın.',
            gateBack: 'Kurum sekmesine dön',
            /*
             * TM5 durum 4 mobil (K7): oturum KAPANMAZ, hesap ekleme açılır. Web'de
             * hesap değiştirici yok (KH13), ortak `orgAccount.otherCta/otherNote` web içindir.
             */
            otherCta: 'Bu adresle kurum hesabı ekle',
            otherNote: 'Hesap ekleme açılır. Kişisel hesabın cihazda kalır.',
            otherNoteOrganization: 'Hesap ekleme açılır. Bu hesap cihazda kalır.',
            pageHome: 'Ana sayfa',
            pageDiscover: 'Etkinlik keşfi',
            pageCard: 'Kartvizit',
            pageWallet: 'Cüzdan',
            pageMeetingRequest: 'Görüşme talebi',
            pageMeetingRequests: 'Görüşme talepleri',
            pageAgenda: 'Ajanda',
            pageAttendees: 'Katılımcı listesi',
            pagePerson: 'Kişi profili',
            pageBadge: 'Yaka kartı',
            pageProfile: 'Kartvizit profili',
            pageSettings: 'Kişisel ayarlar',
            pageVisibility: 'Gizlilik ayarları',
            pageBlocked: 'Engellenenler',
            pageSpeakerLinks: 'Konuşmacı bağlantıları',
            pageEncounterNote: 'Tanışma notu',
            pageEventSurvey: 'Etkinlik anketi',
            blockJoin: 'Kurum hesabıyla katılamazsın.',
            blockJoinBody: 'Katılmak için kişisel hesabına geç.',
            blockApply: 'Kurum hesabıyla başvuramazsın.',
            blockApplyBody: 'Başvurmak için kişisel hesabına geç.',
            blockOwnBody: 'Bu etkinlik {organizationName} kurumunun. Katılmak için kişisel hesabına geç.',
            blockInviteBody: 'Bu davet kurum adresine geldi. Kişisel adresine davet iste.',
            accountTitle: 'Hesap',
            sectionAccounts: 'Hesaplar',
            switchAccount: 'Hesap değiştir',
            transferLink: 'Sahipliği devret ›',
            dataNote: 'Kurumun katılımcı verisi bu dosyada yoktur.',
            signOutThis: 'Bu hesaptan çıkış yap',
            accountLoadError: 'Hesap bilgileri okunamadı.',
            /** TM6 profil notu, MK3 `idNote` metni (web `orgAccount.identityNote` ayrı kalır). */
            identityNote: 'Logo kurumun markasıdır, Kurum › Marka’dan değişir.',
            inviteEntry: 'Kurum davetin mi var?',
            inviteEntryTitle: 'Kurum daveti',
            managementTitle: 'Kurum işi ayrı bir hesapla yapılır',
            managementBody: 'Etkinlik yönetimi ve kapı kurum hesabıyla yapılır. Kurumun yoksa kurumunu biz açalım.',
        },
        /**
         * KURUM MARKA EKRANI (mobil kurum ayarları · Story M1 · referans MK1).
         * Kurum adı, açıklama ve site alanı YOK (K2). Fiyat, kredi ve ödeme YOK.
         */
        orgBrand: {
            title: 'Marka',
            desc: 'Logon ve rengin etkinlik sayfalarında ve yaka kartlarında görünür.',
            logoKicker: 'Logo',
            limits: '{formats} · en çok {megabytes} MB · en az {minWidth}×{minHeight}',
            noLogo: 'Logo yok. Kurum adının baş harfleri kullanılıyor.',
            hasLogo: 'Bu logo hesap simgesinde, kurum künyesinde, ekip listesinde ve yaka kartında görünür.',
            pick: 'Logo seç',
            change: 'Değiştir',
            remove: 'Logoyu kaldır',
            uploading: 'Logo yükleniyor · %{percent}',
            uploadingNoPercent: 'Logo yükleniyor',
            colorKicker: 'Renk',
            colorNone: 'Renk yok',
            colorRed: 'Kırmızı',
            colorBlue: 'Mavi',
            colorGreen: 'Yeşil',
            colorPurple: 'Mor',
            colorBlack: 'Siyah',
            contrast: 'Okunabilirlik için renk gerekirse koyulaştırılır.',
            darkened: 'Kontrast için renk koyulaştırıldı.',
            inherit: 'Etkinlik kendi markasını seçmezse kurumun markasını kullanır.',
            badgeKicker: 'Yaka kartı önizlemesi',
            sampleEvent: 'Ürün Günleri 2026',
            samplePerson: 'Deniz Arslan',
            sampleMeta: 'Ürün Yöneticisi · Atlas',
            sampleTag: 'Örnek katılımcı',
            save: 'Kaydet',
            saving: 'Kaydediliyor…',
            saved: 'Marka kaydedildi.',
            saveError: 'Marka kaydedilemedi. Seçimlerin yerinde, yeniden deneyebilirsin.',
            saveForbidden: 'Markayı yalnız sahip ve yöneticiler değiştirebilir. Rolün değişmiş olabilir, bilgiler yenilendi.',
            loadError: 'Marka bilgisi okunamadı.',
            offline: 'Çevrimdışısın. Marka okunabilir, değişiklik yapılamaz.',
            offlineWhy: 'Logo seçmek, renk değiştirmek ve kaydetmek için bağlantı gerekiyor.',
            coverPickerUnavailable: 'Görsel seçici bu sürümde açılamıyor. Uygulamayı güncelledikten sonra tekrar dene.',
            readOnly: 'Marka yalnız sahip ve yöneticiler tarafından değiştirilebilir. Senin rolün {role}.',
            settingsKicker: 'Kurum ayarları',
            entryNoLogo: 'Logo yok',
        },
        /**
         * KURUM EKİBİ (mobil kurum ayarları Tur B1 · MK2). Rol adları, yetki
         * cümleleri, "Sen" ve "Davet bekliyor" rozetleri, özet sayıları web ile
         * ORTAKTIR (`orgTeam.*`, `ROLE_*_KEYS`); burada yalnız mobil çizimin kendi
         * cümleleri durur.
         */
        orgTeam: {
            title: 'Ekip',
            intro: 'Ekibin etkinliklerini birlikte yönetir. Roller ne yapabileceklerini belirler.',
            inviteCta: 'Üye davet et',
            readOnly: 'Ekibi yalnız sahip ve yöneticiler değiştirebilir.',
            offlineSeen: 'Çevrimdışısın. Son görülen liste gösteriliyor.',
            offlineWhy: 'Davet göndermek, rol değiştirmek ve sahipliği devretmek için bağlantı gerekiyor.',
            loadError: 'Ekip listesi okunamadı.',
            refreshError: 'Liste yenilenemedi. Son görülen liste gösteriliyor.',
            soloTitle: 'Ekibin şimdilik yalnız sensin',
            soloBody: 'Davet ettiğin kişiler kabul edince burada listelenir.',
            ownerNote: 'Sahip rolü değiştirilemez, yalnız devredilir.',
            inviteSent: 'Davet gönderildi.',
            memberOptions: '{name} için seçenekler',
            sheetRole: 'Rol',
            sheetValidity: 'Geçerlilik',
            sheetExpired: 'Süresi doldu',
            cancelOffline: 'Daveti iptal etmek için bağlantı gerekiyor.',
            cancelTitle: 'Davet iptal edilsin mi?',
            cancelBody: '{email} adresine giden davet bağlantısı geçersiz olur. İstersen sonra yeniden davet edebilirsin.',
            actionError: 'İşlem tamamlanamadı. Bağlantını kontrol edip yeniden dene.',
            inviteGone: 'Bu davet artık listede yok. Liste yenilendi.',
            inviteAccepted: 'Bu davet az önce kabul edildi, kişi artık ekipte. Liste yenilendi. Ekipten çıkarmak istersen satırına dokun.',
            inviteTitle: 'Üye davet et',
            emailLabel: 'E-posta',
            emailPlaceholder: 'ad@{domain}',
            /** `ad@{domain}` alana sığmazsa (büyük yazı) kırpılmış alan adı yerine örnek. */
            emailPlaceholderShort: 'ad@example.com',
            emailHint: 'Tek adres yaz.',
            emailInvalid: 'Geçerli bir e-posta adresi yaz.',
            domainNote: 'Kurum alan adı dışındaki adres de davet edilebilir.',
            roleSection: 'Rol',
            contentOrganization: 'Kurum',
            contentInviter: 'Davet eden',
            contentRole: 'Rol',
            contentValidity: 'Geçerlilik',
            validityDays: '{count} gün',
            validityDays_one: '{count} gün',
            scopeNote: 'Davet edilen kişinin e-posta adresi yalnız bu ekip listesinde görünür. Katılımcı listelerinde yer almaz.',
            already: 'Bu adres zaten ekipte.',
            tooMany: 'Çok fazla deneme yaptın. Biraz bekleyip yeniden dene.',
            sendError: 'Davet gönderilemedi. Bağlantını kontrol edip yeniden dene.',
            backToTeam: 'Ekibe dön',
            // --- Tur B2 · aktif üye yaprağı, çıkarma ve sahiplik devri (MK2) ---
            inviteOffline: 'Davet göndermek için bağlantı gerekiyor.',
            actionsOffline: 'Rol değiştirmek ve ekipten çıkarmak için bağlantı gerekiyor.',
            removeCta: 'Ekipten çıkar',
            roleError: 'Rol değiştirilemedi. Önceki rol geçerli, yeniden dene.',
            roleChanging: 'Rol değişiyor',
            removeTitle: 'Ekipten çıkarılsın mı?',
            removeBody: '{email} adresinin erişimi hemen sona erer.',
            memberGone: 'Bu üye başka bir yerden değiştirildi ya da ekipten çıktı. Liste yenilendi.',
            transferHeading: 'Sahiplik devri',
            transferIntro: 'Sahipliği ekipteki aktif bir üyeye devredebilirsin. Devirden sonra sen Yönetici olursun.',
            transferPick: 'Yeni sahip',
            transferChoose: 'Seç',
            transferNone: 'Devredebileceğin başka aktif üye yok. Önce birini davet et.',
            transferSheetTitle: 'Yeni sahibi seç',
            transferSheetNote: 'Davet bekleyen kişiye sahiplik devredilemez.',
            transferSheetConfirm: 'Seç',
            transferTitle: 'Sahiplik devredilsin mi?',
            transferBody: '{email} sahip olur, sen Yönetici olursun. Geri almak için yeni sahibin sahipliği sana devretmesi gerekir.',
            transferring: 'Devrediliyor…',
            transferDone: 'Sahiplik devredildi.',
            transferOffline: 'Sahipliği devretmek için bağlantı gerekiyor.',
            transferGone: 'Seçtiğin üyeye artık devredilemiyor. Liste yenilendi.',
            notOwner: 'Artık bu kurumun sahibi değilsin. Liste yenilendi.',
        },
        /**
         * HESAP DEĞİŞTİRİCİ (K7 · Story H13 · TM3). Aynı cihazda en fazla üç hesap;
         * bildirim YALNIZ etkin hesaba gelir (KH11), pasif satır bunu tek cümleyle söyler.
         */
        accounts: {
            title: 'Hesaplar',
            active: 'Etkin',
            personal: 'Kişisel',
            /** Geçiş şeridinin tür adı: "Artık Meridyen · Kurum hesabındasın" ("hesabı hesabındasın" değil). */
            noticeOrganization: 'Kurum',
            bellOn: 'Bildirimler bu hesaba geliyor',
            bellOff: 'Bu hesaba bildirim gelmez, geçince gelir.',
            bellDevice: 'Bu cihaz bildirim almıyor. Bildirim ayarlarından açabilirsin.',
            signOut: 'Çıkış',
            signOutA11y: '{name} hesabından çıkış yap',
            switchA11y: '{name} hesabına geç',
            add: 'Hesap ekle',
            full: 'En fazla 3 hesap. Yeni hesap eklemek için birinden çıkış yap.',
            expired: 'Yeniden giriş gerekli',
            offlineAdd: 'Hesap eklemek için bağlantı gerekiyor. Kayıtlı hesaplar arasında geçebilirsin.',
            switchingPersonal: 'Kişisel hesaba geçiliyor…',
            switchingOrganization: 'Kurum hesabına geçiliyor…',
            done: 'Artık {account} hesabındasın. Bildirimler bu hesaba gelecek.',
            failed: 'Hesaba geçilemedi. Tekrar dene.',
            addTitle: 'Hesap ekle',
            addLastSlot: 'Bu cihaza ekleyebileceğin son hesap bu.',
            reauthSubtitle: '{email} için yeniden giriş yap. Diğer hesapların etkilenmez.',
            close: 'Kapat',
            hasPersonal: 'Kişisel hesabın bu cihazda kayıtlı ({email}). Doğrudan geçilir.',
            noPersonal: 'Cihazda kişisel hesap yok. Hesap ekleme açılır.',
        },
    },
    /**
     * ALAN ADLARI — sunucunun `fieldErrors[].path` değerinin kullanıcı karşılığı.
     *
     * `validation.*` cümleleri `{field}` parametresi bekler; parametre BURADAN
     * gelir. Yolu burada karşılığı olmayan hata ADSIZ kalır ve ekran jenerik
     * koda düşer — uydurma etiket üretilmez (CLAUDE.md md. 9).
     */
    /* İndirilen CSV dosyalarının sütun başlıkları (cüzdan + katılımcı listesi). */
    /* Katılım belgesi ve anket (Story 1): hazır soruların metni; özel soru organizatörün dilindedir. */
    eventSurvey: {
        presets: {
            overall_satisfaction: 'Etkinliği genel olarak nasıl buldun?',
            recommend: 'Bu etkinliği bir tanıdığına önerir misin?',
            liked_most: 'En çok neyi beğendin?',
            improve: 'Neyi daha iyi yapabiliriz?',
        },
        certificate: {
            title: 'Katılım Belgesi',
            kicker: 'KATILIM BELGESİ',
            intro: 'Bu belge ile',
            eventSentence: '{eventTitle} etkinliğine katıldığı onaylanır.',
            dateLabel: 'TARİH',
            placeLabel: 'YER',
            issuer: 'Düzenleyen kurum',
            codeLabel: 'Doğrulama kodu',
            issuedVia: 'Bu belge {brandName} üzerinden düzenlenmiştir.',
            online: 'Çevrimiçi',
        },
        participant: {
            sectionTitle: 'Etkinlik sonrası',
            certTitle: 'Katılım belgesi',
            certBody: 'Bu etkinliğe katıldığını gösteren belge. PDF, A4.',
            certLanguage: 'Belge dili',
            languageTr: 'Türkçe',
            languageEn: 'English',
            download: 'Belgeyi indir',
            downloading: 'İndiriliyor…',
            downloadError: 'Belge indirilemedi.',
            retry: 'Yeniden dene',
            surveyTitle: 'Etkinlik anketi',
            questionCount: '{count} soru',
            questionCount_one: '{count} soru',
            closesIn: 'Kapanmasına {count} gün kaldı',
            closesIn_one: 'Kapanmasına {count} gün kaldı',
            anonymous: 'Cevapların anonimdir. Organizatör yalnız toplu sonucu görür.',
            fill: 'Anketi doldur',
            sentTag: 'Anket gönderildi',
            sentBody: 'Teşekkürler. Cevapların toplu sonuca eklendi.',
            closedTag: 'Anket kapandı',
            closedBody: 'Anket {date} tarihinde kapandı. Belgeni indirmeye devam edebilirsin.',
            closedBodyNoCert: 'Anket {date} tarihinde kapandı.',
            sectionLoadError: 'Bu bölüm yüklenemedi.',
            closesInSentence: 'Anketin kapanmasına {count} gün kaldı.',
            closesInSentence_one: 'Anketin kapanmasına {count} gün kaldı.',
            ratingLow: '1 · Çok kötü',
            ratingHigh: '5 · Çok iyi',
            npsLow: '0 · Hiç önermem',
            npsHigh: '10 · Kesinlikle öneririm',
            scaleAria: '{value} / {scaleMax}',
            multiHint: 'Birden çok seçebilirsin.',
            textWarning: 'Bu metni organizatör görür. Kimliğini belirten bilgi yazma.',
            textPlaceholder: 'Buraya yazabilirsin',
            textMax: 'En çok 500 karakter yazabilirsin.',
            submit: 'Anketi gönder',
            submitting: 'Gönderiliyor…',
            submitError: 'Anket gönderilemedi. Cevapların bu sayfada duruyor, yeniden gönderebilirsin.',
            answerRequired: 'Göndermek için en az bir soruyu cevapla.',
            optionalNote: 'Cevaplamak istemediğin soruyu boş bırakabilirsin.',
            backToEvent: 'Etkinlik sayfasına dön',
            thanksTitle: 'Teşekkürler',
            thanksBody: 'Cevapların anonim olarak toplu sonuca eklendi. Organizatör kimin ne cevap verdiğini görmez.',
            closedTitle: 'Anket kapandı',
            closedScreenBody: 'Anket {date} tarihinde kapandı ve artık cevap almıyor.',
            deniedTitle: 'Bu anket sana açık değil',
            deniedBody: 'Anket yalnız etkinliğe check-in yapan katılımcılara açıktır.',
            surveyLoadError: 'Anket yüklenemedi.',
            rowCertificate: 'Belge',
            rowSurvey: 'Anket',
            rowCertificateAria: '{title} katılım belgesini indir',
            rowSurveyAria: '{title} anketini doldur',
            share: 'Paylaş',
            sharing: 'Hazırlanıyor…',
            screenTitle: 'Anket',
        },
        results: {
            title: 'Anket sonuçları',
            openTag: 'Açık · {date} tarihinde kapanır',
            responses: 'Cevap',
            responsesSub: '5’in katlarında güncellenir',
            rate: 'Cevap oranı',
            rateSub: '{responses} / {checkedIn} check-in',
            closes: 'Kapanış',
            closesValue: '{count} gün',
            closesValue_one: '{count} gün',
            closedValue: 'Kapandı',
            note: 'Sonuçlar her 5 yeni cevapta bir güncellenir. 1-4 arası değerler “5’ten az” yazar, 0 değeri gösterilir. 5’ten az cevaplı sorunun sonucu gösterilmez. Kimin ne cevap verdiği ve cevap zamanı görünmez.',
            answerCount: '{count} cevap',
            answerCount_one: '{count} cevap',
            textCount: '{count} cevap · karışık sırada, tarihsiz',
            textCount_one: '{count} cevap · karışık sırada, tarihsiz',
            belowThresholdCount: '5’ten az cevap',
            belowThreshold: 'En az 5 cevap gelince görünür.',
            averageLabel: 'Ortalama {value} / 5',
            npsLabel: 'Tavsiye skoru {value}',
            averageHidden: 'Ortalama gösterilmez',
            npsHidden: 'Tavsiye skoru gösterilmez',
            promoters: 'Önerir (9-10)',
            passives: 'Kararsız (7-8)',
            detractors: 'Önermez (0-6)',
            npsFoot: 'Skor, önerenlerin oranından önermeyenlerin oranı çıkarılarak hesaplanır.',
            multiFoot: 'Birden çok seçilebildiği için oranların toplamı %100’ü geçer.',
            seeAll: '{count} cevabın tümünü gör',
            seeAll_one: '{count} cevabın tümünü gör',
            emptyNoSurveyTitle: 'Anket yok',
            emptyNoSurveyBody: 'Bu etkinlik için anket kurulmadı. Anket kurucuda soruları hazırlayıp yayınlayabilirsin.',
            setUpSurvey: 'Anketi kur',
            emptyUnderTitle: 'Henüz 5 cevap yok',
            emptyUnderBody: 'Katılımcıların gizliliği için sonuçlar 5 cevap gelince görünür. Anket {date} tarihine kadar açık.',
            emptyUnderBodyClosed: 'Katılımcıların gizliliği için sonuçlar 5 cevap gelince görünür.',
            loadError: 'Sonuçlar yüklenemedi.',
        },
        manage: {
            subCertificate: 'Belge ayarları',
            subBuilder: 'Anket kurucu',
            subResults: 'Anket sonuçları',
            subNavLabel: 'Belge ve anket bölümleri',
            certTitle: 'Katılım belgesi',
            certOnBody: 'Check-in yapan katılımcılar etkinlik bitince belgelerini indirebilir.',
            certOffBody: 'Belge kapalı. Katılımcılar belge göremez. Açtığında etkinlik bitmişse belge hemen görünür.',
            signerName: 'İmza adı',
            signerTitle: 'İmza unvanı',
            optional: '(isteğe bağlı)',
            signerNamePlaceholder: 'Örn. Deniz Arslan',
            signerTitlePlaceholder: 'Örn. Genel Sekreter',
            signerHelp: 'İkisi de boşsa belgede imza yerine kurum adı yazar.',
            logoNoteTitle: 'Belgede kurum logon kullanılır.',
            logoNoteBody: 'Logo yoksa kurum adının baş harfleri. Logoyu Kurum ayarları › Marka’dan değiştirirsin.',
            signerMax: 'En çok 80 karakter yazabilirsin.',
            charCount: '{used} / {max}',
            save: 'Kaydet',
            saved: 'Ayarlar kaydedildi.',
            saveError: 'Ayarlar kaydedilemedi. Yeniden dene.',
            previewLabel: 'Canlı önizleme',
            previewSample: 'Örnek katılımcıyla',
            sampleName: 'Örnek Katılımcı',
            certLoadError: 'Belge ayarları yüklenemedi.',
            certViewerNote: 'Belge ayarlarını yalnız sahip, yönetici ve düzenleyici değiştirebilir.',
            retry: 'Yeniden dene',
            builderTitle: 'Etkinlik anketi',
            status: {
                draft: 'Taslak',
                published: 'Yayında',
                closed: 'Kapandı',
                disabled_by_staff: 'Kapatıldı',
            },
            questionCount: '{used} / {max} soru',
            audienceNote: 'Anket yalnız etkinliğe check-in yapan katılımcılara açıktır.',
            sensitiveWarning: 'Sağlık, din, siyasi görüş, sendika üyeliği gibi özel nitelikli bilgi sorma.',
            builderIntro: 'Dört hazır soruyla başlar. Kaldırabilir, sırasını değiştirebilir, kendi sorunu ekleyebilirsin. Sırayı tutamaçla sürükle ya da tutamaçtayken ok tuşlarını kullan.',
            publishedIntro: 'Sorular sırasıyla. Düzenleme kapalı.',
            kind: {
                rating_5: '1-5 puan',
                nps_10: '0-10 tavsiye',
                single_choice: 'Tek seçim',
                multi_choice: 'Çoklu seçim',
                short_text: 'Kısa metin',
            },
            presetTag: 'Hazır soru',
            edit: 'Düzenle',
            remove: 'Kaldır',
            editAria: '{index}. soruyu düzenle',
            removeAria: '{index}. soruyu kaldır',
            moveAria: '{index}. soruyu taşı',
            addQuestion: 'Soru ekle',
            limitNote: 'En çok 10 soru ekleyebilirsin.',
            newQuestion: 'Yeni soru',
            editQuestion: 'Soruyu düzenle',
            questionText: 'Soru metni',
            questionKind: 'Tür',
            options: 'Seçenekler',
            optionLabel: 'Seçenek {index}',
            addOption: 'Seçenek ekle',
            removeOption: 'Seçeneği kaldır',
            questionTextMax: 'En çok 200 karakter yazabilirsin.',
            optionsRange: 'Seçenekli soruda 2 ile 8 arası seçenek olmalı.',
            optionsEmpty: 'Boş seçenek bırakma.',
            questionTextRequired: 'Soru metnini yaz.',
            addThisQuestion: 'Soruyu ekle',
            saveQuestion: 'Kaydet',
            cancel: 'Vazgeç',
            publish: 'Yayınla',
            publishNote: 'Yayınladıktan sonra sorular değiştirilemez. Anket etkinlik bitince açılır, 14 gün sonra kapanır.',
            publishedNote: 'Anket yayında. Sorular değiştirilemez. Anket {date} tarihinde kapanır.',
            confirmTitle: 'Anket yayınlansın mı?',
            confirmBody: '{count} soru yayınlanacak. Yayından sonra sorular değiştirilemez. Anket etkinlik bitince check-in yapan katılımcılara açılır.',
            confirmBody_one: '{count} soru yayınlanacak. Yayından sonra sorular değiştirilemez. Anket etkinlik bitince check-in yapan katılımcılara açılır.',
            emptyTitle: 'Ankette soru yok',
            emptyBody: 'Hazır soruları geri ekleyebilir ya da kendi sorunu yazabilirsin.',
            restorePresets: 'Hazır soruları geri ekle',
            builderLoadError: 'Anket yüklenemedi.',
            publishError: 'Anket yayınlanamadı. Yeniden dene.',
            mutationError: 'Değişiklik kaydedilemedi. Yeniden dene.',
            builderViewerNote: 'Anketi yalnız sahip, yönetici ve düzenleyici değiştirebilir.',
            noSurveyViewer: 'Bu etkinlik için anket henüz kurulmadı.',
            disabledNote: 'Anket destek ekibi tarafından kapatıldı. Katılımcılar anketi göremez.',
        },
    },
    csvExport: {
        colName: 'Ad Soyad',
        colJobTitle: 'Unvan',
        colCompany: 'Şirket',
        colEmail: 'E-posta',
        colEvent: 'Etkinlik',
        colMetAt: 'Tanışma zamanı',
        colMeetingArea: 'Tanışma alanı',
        colMeetingCount: 'Buluşma sayısı',
        colNote: 'Not',
        colTags: 'Etiketler',
        colStatus: 'Durum',
        colRegisteredAt: 'Kayıt zamanı',
        colCheckedInAt: 'Check-in zamanı',
        colId: 'Kimlik',
        colHeadline: 'Kısa tanıtım',
        colLocale: 'Dil',
        colTimezone: 'Saat dilimi',
        colCreatedAt: 'Oluşturulma zamanı',
        colSlug: 'Kod',
        colLabelTr: 'Ad (Türkçe)',
        colLabelEn: 'Ad (İngilizce)',
        colCardLabel: 'Kart adı',
        colBio: 'Hakkında',
        colPhone: 'Telefon',
        colWebsite: 'Web sitesi',
        colLinkedin: 'LinkedIn',
        colX: 'X',
        colGithub: 'GitHub',
        colIsDefault: 'Varsayılan kart',
        colEventSlug: 'Etkinlik adresi',
        colEventStartsAt: 'Etkinlik başlangıcı',
        colSource: 'Kaynak',
        colTicketKind: 'Bilet türü',
        colQuestion: 'Soru',
        colAnswer: 'Cevap',
        colCertificateCode: 'Belge kodu',
        colIssuedAt: 'Düzenlenme zamanı',
        /** Veri kopyasında kaydın geldiği yer (sıra 153): ham değer yerine okunur metin. */
        attendanceSource: {
            discovery: 'Keşif',
            direct_link: 'Doğrudan bağlantı',
            invitation: 'Davet',
            search: 'Arama',
            organizer_auto: 'Düzenleyen olarak otomatik',
        },
        /**
         * Veri kopyasının öbür bölümlerindeki değerler (sıra 159b). Yalnız var olan
         * metinde karşılığı olmayanlar buradadır, gerisi kendi ekranının metninden okunur.
         */
        values: {
            direction: { outgoing: 'Giden', incoming: 'Gelen' },
            consentChannel: { signup: 'Kayıt sırasında', api: 'Uygulama içinde' },
            encounterConfirmed: 'Onaylandı',
            encounterChannel: { link: 'Bağlantı', manual: 'Elle', nfc: 'NFC' },
            memberStatus: { active: 'Etkin üye', removed: 'Çıkarıldı' },
            followSource: { organization_page: 'Kurum sayfası', event_page: 'Etkinlik sayfası' },
            followEndReason: { unfollowed: 'Takibi bıraktın', organization_deleted: 'Kurum kaldırıldı' },
            announcementOptOutAction: { opted_out: 'Kapattın', opted_in: 'Yeniden açtın' },
            announcementOptOutSource: { message: 'E-postadaki bağlantı', settings: 'Uygulama' },
            announcementAllChannels: 'Tüm kanallar',
            announcementInApp: 'Uygulama içi',
            recommendationKind: { event: 'Etkinlik önerisi', person: 'Kişi önerisi' },
            recommendationSource: { precomputed: 'Önceden hesaplanmış', cold_start: 'Anlık' },
            recommendationOutcome: {
                delivered: 'Listeye girdi',
                viewed: 'Görüldü',
                opened: 'Açıldı',
                converted: 'Kayıtla sonuçlandı',
            },
            recommendationSurface: {
                web_home: 'Web ana sayfa',
                web_home_empty: 'Web ana sayfa, boş hâl',
                web_discovery: 'Web keşif',
                web_event_directory: 'Web katılımcı listesi',
                mobile_home: 'Mobil ana sayfa',
                mobile_discovery: 'Mobil keşif',
                mobile_event_directory: 'Mobil katılımcı listesi',
                mobile_person_profile: 'Mobil kişi profili',
                email_reminder: 'Hatırlatma e-postası',
                push_reminder: 'Hatırlatma bildirimi',
            },
            recommendationReason: {
                sharedTags: 'Ortak ilgi alanı',
                relatedTags: 'Yakın ilgi alanı',
                coAttendance: 'Ortak katılım',
                peerProfile: 'Benzer profiller',
                sameCity: 'Aynı şehir',
                popularAmongPeers: 'Benzerlerin arasında ilgi görüyor',
                startingSoon: 'Yakında başlıyor',
                sharedHistory: 'Ortak geçmiş',
                complementaryRole: 'Tamamlayıcı rol',
                none: 'Gerekçe yok',
            },
            candidateArm: {
                content: 'İçerik benzerliği',
                collaborative: 'Benzer kullanıcılar',
                trend: 'Yükselen ilgi',
                context: 'Bağlam',
                unknown: 'Bilinmiyor',
            },
            sessionRevokeReason: {
                logout: 'Oturum kapatıldı',
                user_revoked: 'Elle sonlandırıldı',
                revoked_all: 'Tüm oturumlar kapatıldı',
                reuse_detected: 'Güvenlik nedeniyle kapatıldı',
                account_deleted: 'Hesap silindi',
            },
            devicePlatform: { ios: 'iOS', android: 'Android' },
        },
        colCancelledAt: 'İptal zamanı',
        colSentAt: 'Gönderilme zamanı',
        colRespondedAt: 'Yanıt zamanı',
        colSubmittedAt: 'Başvuru zamanı',
        colConsentType: 'Rıza türü',
        colDocumentVersion: 'Metin sürümü',
        colChannel: 'Kanal',
        colGrantedAt: 'Verilme zamanı',
        colWithdrawnAt: 'Geri çekilme zamanı',
        colDirection: 'Yön',
        colDurationMinutes: 'Süre (dakika)',
        colMessage: 'Mesaj',
        colCounterpart: 'Karşı taraf',
        colProposedSlots: 'Önerilen zamanlar',
        colAcceptedStartsAt: 'Kabul edilen zaman',
        colStartsAt: 'Başlangıç',
        colEndsAt: 'Bitiş',
        colBlockedAt: 'Engelleme zamanı',
        colCounterpartCompany: 'Karşı tarafın şirketi',
        colCounterpartEmail: 'Karşı tarafın e-postası',
        colFollowUpDueAt: 'Takip hatırlatması',
        colOrganization: 'Kurum',
        colRole: 'Rol',
        colJoinedAt: 'Katılma zamanı',
        colLeftAt: 'Ayrılma zamanı',
        colFollowedAt: 'Takip başlangıcı',
        colUnfollowedAt: 'Takibin bitişi',
        colEndReason: 'Bitiş nedeni',
        colSubject: 'Konu',
        colAction: 'İşlem',
        colNotificationType: 'Bildirim türü',
        colEnabled: 'Açık',
        colDate: 'Tarih',
        colSurface: 'Gösterildiği yer',
        colKind: 'Tür',
        colRank: 'Sıra',
        colReasonKind: 'Gerekçe türü',
        colCandidateArm: 'Aday grubu',
        colOutcome: 'Sonuç',
        colTargetEventId: 'Önerilen etkinlik kimliği',
        colContextEventId: 'Bağlam etkinliği kimliği',
        colEngineVersion: 'Öneri sürümü',
        colOccurrences: 'Tekrar sayısı',
        colEventType: 'Etkinlik türü',
        colTopic: 'Konu',
        colCreditPackage: 'Kredi paketi',
        colReferralCode: 'Referans kodu',
        colEstimatedAttendees: 'Tahmini katılımcı',
        colEstimatedDate: 'Tahmini tarih',
        colContactName: 'İletişim kişisi',
        colNoticeVersion: 'Aydınlatma metni sürümü',
        colClient: 'Uygulama',
        colUserAgent: 'Tarayıcı bilgisi',
        colLastUsedAt: 'Son kullanım',
        colExpiresAt: 'Geçerlilik sonu',
        colRevokedAt: 'Kapatılma zamanı',
        colRevokeReason: 'Kapatılma nedeni',
        colPlatform: 'Platform',
        colLastSeenAt: 'Son görülme',
        colAcceptedAt: 'Kabul zamanı',
    },
    /* KVKK veri kopyası ZIP'i (B-23 B): bölüm dosyaları ve özet metni. */
    dataCopy: {
        summaryFile: 'OKUBENI.txt',
        jsonFile: 'veri-kopyasi.json',
        summaryTitle: 'Kişisel veri kopyan',
        summaryIntro: 'Bu dosyalar KVKK madde 11 kapsamında hesabına ait kişisel verilerin kopyasıdır.',
        summaryAccount: 'Bu kopya {name} ({email}) hesabına aittir.',
        summaryPreparedAt: 'Hazırlanma zamanı: {time}',
        summaryTimezone: 'Bütün saatler {timezone} saat dilimindedir.',
        summaryCards: 'Kartvizit sayısı: {value}',
        summaryEvents: 'Etkinlik kaydı sayısı: {value}',
        summaryConnections: 'Bağlantı sayısı: {value}',
        summaryFilesTitle: 'Dosyalar',
        summaryFileLine: '{file}. {description} {count} satır.',
        summaryFileLine_one: '{file}. {description} {count} satır.',
        summaryJsonLine: '{file}. Bütün verinin makine okunur hâli. Verini başka bir hizmete taşımak için kullanılır.',
        summaryCsvHint: 'CSV dosyaları Excel, Numbers ve Google E-Tablolar ile açılır.',
        sections: {
            profile: { title: 'Profil', description: 'Hesap bilgilerin.' },
            interests: { title: 'İlgi alanları', description: 'Seçtiğin ilgi etiketleri.' },
            cards: { title: 'Kartvizitler', description: 'Kartvizitinde yazan bilgiler.' },
            attendances: {
                title: 'Etkinlik kayıtları',
                description: 'Kaydolduğun etkinlikler ve kayıt durumun.',
            },
            invitations: {
                title: 'Etkinlik davetleri',
                description: 'Sana gelen etkinlik davetleri ve yanıtların.',
            },
            applications: {
                title: 'Etkinlik başvuruları',
                description: 'Başvurulu etkinliklere yaptığın başvurular.',
            },
            consents: {
                title: 'Rıza kayıtları',
                description: 'Verdiğin ve geri çektiğin rızalar.',
            },
            meetingRequests: {
                title: 'Görüşme talepleri',
                description: 'Gönderdiğin ve sana gelen görüşme talepleri.',
            },
            agenda: { title: 'Ajanda', description: 'Kabul edilmiş görüşmelerinin zamanları.' },
            blockedUsers: { title: 'Engellenen kişiler', description: 'Engellediğin kişiler.' },
            encounters: {
                title: 'Bağlantılar',
                description: 'Tanıştığın kişiler, notların ve etiketlerin.',
            },
            organizationMemberships: {
                title: 'Kurum üyelikleri',
                description: 'Üyesi olduğun kurumlar ve rolün.',
            },
            organizationFollows: {
                title: 'Takip ettiğin kurumlar',
                description: 'Takip ettiğin ve bıraktığın kurumlar, tarih ve yer.',
            },
            announcementsReceived: {
                title: 'Aldığın duyurular',
                description: 'Etkinlik organizatörlerinin sana gönderdiği duyurular ve kanalı.',
            },
            announcementOptOuts: {
                title: 'Duyuru tercih kayıtları',
                description: 'Organizatör duyurularını kapattığın ve yeniden açtığın kayıtlar.',
            },
            surveyResponses: {
                title: 'Anket cevapların',
                description: 'Etkinlik sonrası anketlere verdiğin cevaplar. Cevap ile hesabın arasındaki bağ anket kapanışından 30 gün sonra koparılır.',
            },
            certificates: {
                title: 'Katılım belgelerin',
                description: 'Aldığın katılım belgelerinin kodu ve düzenlenme zamanı.',
            },
            notificationPreferences: {
                title: 'Bildirim tercihleri',
                description: 'Hangi bildirimleri hangi kanaldan aldığın.',
            },
            recommendationEvents: {
                title: 'Öneri kayıtları',
                description: 'Sana gösterilen etkinlik önerileri ve ne yaptığın.',
            },
            salesInquiries: {
                title: 'Satış başvuruları',
                description: 'Etkinlik düzenlemek için gönderdiğin başvurular.',
            },
            sessions: { title: 'Oturumlar', description: 'Hesabına giriş yapılan oturumlar.' },
            devices: { title: 'Cihazlar', description: 'Bildirim için kayıtlı cihazların.' },
            teamInvitations: {
                title: 'Ekip davetleri',
                description: 'Sana gelen kurum ekibi davetleri.',
            },
        },
    },
    fields: {
        eventTitle: 'Etkinlik adı',
        eventSummary: 'Özet',
        eventDescription: 'Açıklama',
        eventFormat: 'Etkinlik biçimi',
        eventStartsAt: 'Başlangıç',
        eventEndsAt: 'Bitiş',
        eventTimezone: 'Saat dilimi',
        eventOnlineUrl: 'Çevrimiçi bağlantı',
        eventCapacity: 'Kapasite',
        eventWebsiteUrl: 'Web sitesi',
        eventTagIds: 'İlgi etiketleri',
        venueName: 'Yer',
        venueAddressLine: 'Adres',
        name: 'Ad',
        contactEmail: 'İletişim e-postası',
        venueCity: 'Şehir',
        venueCountry: 'Ülke',
        venueGeo: 'Haritadaki konum',
        city: 'Şehir',
        currentPassword: 'Mevcut şifre',
        newPassword: 'Yeni şifre',
        salesCompanyName: 'Firma adı',
        salesEventType: 'Etkinlik türü',
        salesEstimatedAttendees: 'Tahmini katılımcı',
        salesEstimatedDate: 'Tahmini tarih',
        salesContactName: 'İletişim kişisi',
        salesEmail: 'E-posta',
        salesPhone: 'Telefon',
        salesNote: 'Not',
        salesNoticeAcknowledged: 'Aydınlatma metni onayı',
        token: 'Kod',
        displayName: 'Görünen ad',
        role: 'Rol',
        startDay: 'Başlangıç günü',
        endDay: 'Bitiş günü',
        reference: 'Referans',
        reason: 'Gerekçe',
        purchaseDay: 'Satın alma tarihi',
        salesInquiry: 'Satış adayı',
        ownerEmail: 'İş e-postası',
        amount: 'Miktar',
        linkedinUrl: 'LinkedIn bağlantısı',
        xUrl: 'X bağlantısı',
        githubUrl: 'GitHub bağlantısı',
        verificationCode: 'Doğrulama kodu',
        password: 'Şifre',
        announcementSubject: 'Başlık',
        announcementBody: 'Metin',
        announcementChannels: 'Kanallar',
        surveyAnswer: 'Cevap',
    },
    validation: {
        'announcement.tooManyLinks': 'Metinde en fazla {limit} bağlantı olabilir.',
        'any.required': '{field} zorunludur.',
        'any.only': '{field} geçerli bir seçenek değil.',
        'any.custom': '{field} geçerli değil.',
        'string.empty': '{field} boş bırakılamaz.',
        'string.email': 'Geçerli bir e-posta adresi gir.',
        'string.uri': 'Geçerli bir bağlantı gir.',
        // `httpUrlSchema` şemayı (`uri({ scheme })`) sınırladığı için Joi bu adı üretir (Tur V3).
        'string.uriCustomScheme': 'Geçerli bir bağlantı gir.',
        // Ağ bağlantısı alanı başka ana makineyi gösteriyor (güvenlik sertleştirme 20.10.2026, madde 2.4).
        // Alan adı cümlede: örnek tek ağa bağlı kalınca X/GitHub alanında LinkedIn öneriyordu (tech-lead 20.10).
        'string.socialHost': '{field} bu ağın kendi sitesine ait olmalı.',
        'string.min': '{field} en az {limit} karakter olmalı.',
        'string.max': '{field} en fazla {limit} karakter olabilir.',
        'string.guid': '{field} geçersiz.',
        'string.pattern.base': '{field} beklenen biçimde değil.',
        'number.base': '{field} sayı olmalı.',
        'number.min': '{field} en az {limit} olmalı.',
        'number.max': '{field} en fazla {limit} olabilir.',
        'number.integer': '{field} tam sayı olmalı.',
        'array.min': 'En az {limit} seçim yapmalısın.',
        'array.max': 'En fazla {limit} seçim yapabilirsin.',
        'array.unique': 'Aynı değeri iki kez ekleyemezsin.',
        'object.unknown': '{field} tanınmayan bir alan. Kaldırıp tekrar dene.',
        'date.base': 'Geçerli bir tarih gir.',
        'string.isoDate': 'Geçerli bir tarih gir.',
        'event.onlineUrlRequired': 'Çevrimiçi etkinlikler için bağlantı zorunludur.',
        'event.venueCityRequired': 'Yüz yüze etkinlikler için şehir zorunludur.',
        'event.venueNameRequired': 'Yüz yüze ve hibrit etkinliklerde mekan adı zorunludur.',
        'event.venueAddressRequired': 'Yüz yüze ve hibrit etkinliklerde açık adres zorunludur.',
        'event.venueGeoRequired': 'Haritada konumu seç.',
        'event.capacityBelowTicketQuota': 'Kapasite, tanımlı bilet kontenjanlarının toplamından ({limit}) küçük olamaz.',
        'event.capacityAboveCeiling': 'Kapasite bu etkinliğin katılımcı sınırını ({limit}) aşamaz.',
        'ticket.quotaAboveCeiling': 'Bilet kontenjanı bu etkinliğin katılımcı sınırını ({limit}) aşamaz.',
        'announcement.linkShortener': 'Kısaltılmış bağlantı kullanılamaz. Bağlantının tam adresini yaz.',
        'event.endsAfterStarts': 'Bitiş zamanı başlangıçtan sonra olmalı.',
        'consent.required': 'Bu onay devam etmek için zorunludur.',
        'consent.documentVersion': 'Onay metni güncellendi. Yeni metni onayla.',
        'consent.retired': 'Bu onay artık alınmıyor.',
        'card.limit': 'En fazla {limit} kartvizit oluşturabilirsin.',
        'string.unsafeChars': '{field} geçersiz karakter içeriyor.',
        'string.notPrintable': '{field} en az bir görünür karakter içermeli.',
        'string.timezone': 'Geçerli bir saat dilimi seç.',
        'string.length': '{field} tam {limit} karakter olmalı.',
        'date.calendar': 'Takvimde olmayan bir tarih girdin.',
        'date.window': '{field} bugün ile {years} yıl sonrası arasında olmalı.',
    },
    catalog: {
        // Şehir kataloğu (Story 19.1) — kodlar `domain/city-catalog.ts`'tedir.
        city: {
            'TR-01': 'Adana',
            'TR-02': 'Adıyaman',
            'TR-03': 'Afyonkarahisar',
            'TR-04': 'Ağrı',
            'TR-05': 'Amasya',
            'TR-06': 'Ankara',
            'TR-07': 'Antalya',
            'TR-08': 'Artvin',
            'TR-09': 'Aydın',
            'TR-10': 'Balıkesir',
            'TR-11': 'Bilecik',
            'TR-12': 'Bingöl',
            'TR-13': 'Bitlis',
            'TR-14': 'Bolu',
            'TR-15': 'Burdur',
            'TR-16': 'Bursa',
            'TR-17': 'Çanakkale',
            'TR-18': 'Çankırı',
            'TR-19': 'Çorum',
            'TR-20': 'Denizli',
            'TR-21': 'Diyarbakır',
            'TR-22': 'Edirne',
            'TR-23': 'Elazığ',
            'TR-24': 'Erzincan',
            'TR-25': 'Erzurum',
            'TR-26': 'Eskişehir',
            'TR-27': 'Gaziantep',
            'TR-28': 'Giresun',
            'TR-29': 'Gümüşhane',
            'TR-30': 'Hakkâri',
            'TR-31': 'Hatay',
            'TR-32': 'Isparta',
            'TR-33': 'Mersin',
            'TR-34': 'İstanbul',
            'TR-35': 'İzmir',
            'TR-36': 'Kars',
            'TR-37': 'Kastamonu',
            'TR-38': 'Kayseri',
            'TR-39': 'Kırklareli',
            'TR-40': 'Kırşehir',
            'TR-41': 'Kocaeli',
            'TR-42': 'Konya',
            'TR-43': 'Kütahya',
            'TR-44': 'Malatya',
            'TR-45': 'Manisa',
            'TR-46': 'Kahramanmaraş',
            'TR-47': 'Mardin',
            'TR-48': 'Muğla',
            'TR-49': 'Muş',
            'TR-50': 'Nevşehir',
            'TR-51': 'Niğde',
            'TR-52': 'Ordu',
            'TR-53': 'Rize',
            'TR-54': 'Sakarya',
            'TR-55': 'Samsun',
            'TR-56': 'Siirt',
            'TR-57': 'Sinop',
            'TR-58': 'Sivas',
            'TR-59': 'Tekirdağ',
            'TR-60': 'Tokat',
            'TR-61': 'Trabzon',
            'TR-62': 'Tunceli',
            'TR-63': 'Şanlıurfa',
            'TR-64': 'Uşak',
            'TR-65': 'Van',
            'TR-66': 'Yozgat',
            'TR-67': 'Zonguldak',
            'TR-68': 'Aksaray',
            'TR-69': 'Bayburt',
            'TR-70': 'Karaman',
            'TR-71': 'Kırıkkale',
            'TR-72': 'Batman',
            'TR-73': 'Şırnak',
            'TR-74': 'Bartın',
            'TR-75': 'Ardahan',
            'TR-76': 'Iğdır',
            'TR-77': 'Yalova',
            'TR-78': 'Karabük',
            'TR-79': 'Kilis',
            'TR-80': 'Osmaniye',
            'TR-81': 'Düzce',
            ABROAD: 'Yurt dışı',
        },
        ticketKind: {
            free: 'Ücretsiz',
            paid: 'Ücretli',
            invite: 'Davetli',
            student: 'Öğrenci',
            sponsor: 'Sponsor',
            speaker: 'Konuşmacı',
            press: 'Basın',
        },
    },
    /**
     * FAZ 3 — QR ile kartvizit değişimi (Akış C) ve cüzdan (Akış D/E).
     *
     * AYRI BÖLÜM, DOSYANIN SONUNDA: Faz 2 hâlâ açıkken paralel yürüyen bir dalda
     * yazıldı; mevcut bölümlerin arasına girmemek birleştirme çatışması yüzeyini
     * en aza indirir. Faz 2 kapanınca `mobile` altına taşınabilir.
     */
    faz3: {
        exchange: {
            title: 'Kart değişimi',
            checkedIn: 'Check-in yapıldı',
            notCheckedIn: 'Check-in yapılmadı',
            modeShow: 'Kartımı göster',
            modeScan: 'Tara',
            modeLabel: 'Kart göster veya tara',
            qrA11y: 'Kartvizitinin karekodu',
            cardCodeLabel: 'Kod {code}',
            mutualNotice: 'Karşındaki kişi de onaylamadan hiçbir bilgin paylaşılmaz.',
            walletCta: 'Cüzdan',
            scanHint: 'Karşındaki kişinin kodunu çerçeveye al. Işık azsa flaşı aç.',
            torchOn: 'Flaşı aç',
            torchOff: 'Flaşı kapat',
            manualCta: 'Kodu elle gir',
            cameraPrivacy: 'Kamera görüntüsü hiçbir zaman kaydedilmez, sunucuya gönderilmez.',
            cameraUnavailable: 'Bu cihazda arka kamera bulunamadı. Kodu elle girebilirsin.',
            cameraError: 'Kamera açılamadı. Kodu elle girebilirsin.',
            foreignCode: 'Bu kod bir {brandName} kartviziti değil.',
            approvalKicker: 'Kart değişimi · onayın gerekiyor',
            approvalTitle: '{name} kartını paylaşmak istiyor',
            stampTitle: 'Nerede tanıştın',
            approvalMutual: 'Onayladığında senin kartın da ona gider. Paylaşım her zaman iki taraflıdır.',
            approveCta: 'Kartımı paylaş ve al',
            declineCta: 'Vazgeç',
            pendingKicker: 'Bekleniyor',
            pendingTitle: 'Onayını verdin',
            pendingBody: '{name} onaylayınca kayıt cüzdanına eklenir. Ekranı kapatabilirsin, işlem kendiliğinden tamamlanır.',
            pendingSpinner: 'Onay bekleniyor, genelde birkaç saniye sürer.',
            pendingMineTitle: 'Senin onayın',
            pendingMineMeta: '{time} · kartın hazır',
            pendingPeerTitle: '{name} onayı',
            pendingPeerMeta: 'Bekleniyor',
            pendingBackCta: 'Karekod ekranına dön',
            successKicker: 'İki taraf da onayladı',
            successPoster: 'Tanışma tamamlandı.',
            successBody: '{name} cüzdanına eklendi. Etkinlik ve tarih kendiliğinden kaydedildi.',
            /*
             * CANLI ETKİNLİK PENCERESİ YOKKEN damga `eventId: null` üretir; ekran
             * "etkinlik damgalandı" DİYEMEZ (mobil elle test · bulgu 4).
             */
            successBodyNoEvent: '{name} cüzdanına eklendi. Tanışma tarihi kendiliğinden kaydedildi.',
            successWalletCta: 'Cüzdana git',
            noteCta: 'Not ekle',
            continueCta: 'Devam',
            successHint: 'Şimdi yazacağın iki kelime, altı ay sonra bu kişiyi bulmanı sağlar.',
            noteTitle: 'Tanışma notu',
            noteFieldLabel: 'Bu kişiyle ne konuştun?',
            notePlaceholder: 'Ne konuştuğunu iki cümleyle özetle',
            noteTagsTitle: 'Etiket',
            noteReminderTitle: 'Takip hatırlatması',
            reminderNone: 'Hatırlatma yok',
            reminderWeek: '1 hafta sonra',
            reminderMonth: '1 ay sonra',
            noteSaveCta: 'Kaydet ve cüzdana git',
            tagPilot: 'Pilot',
            tagFollowUp: 'Takip',
            tagInvestor: 'Yatırımcı',
            tagSupplier: 'Tedarikçi',
            deniedKicker: 'Kamera izni yok',
            deniedTitle: 'Tarama için kameraya izin gerekiyor',
            deniedBody: 'İzin kapalı olduğu için kod okunamıyor. İzni ayarlardan açabilir ya da kodu elle girebilirsin. Karşı taraf senin kartını okutarak da değişimi başlatabilir.',
            deniedPrivacy: 'Kamera görüntüsü hiçbir zaman kaydedilmez, sunucuya gönderilmez.',
            deniedSettingsCta: 'Ayarları aç',
            deniedShowCardCta: 'Kartımı göstererek devam et',
            permissionAskCta: 'Kameraya izin ver',
            manualTitle: 'Kodu elle gir',
            manualBody: 'Karşı tarafın kart ekranındaki altı haneli kodu yaz. Aynı işi görür, kamera gerekmez.',
            manualFieldLabel: 'Kart kodu',
            manualPlaceholder: 'örn. 4K7-92B',
            manualFindCta: 'Kişiyi bul',
            manualNotFound: 'Kod bulunamadı. Harfleri ve çizgiyi kontrol et.',
            offlineQueued: 'İnternet bağlantın yok. Değişimi telefonunda tutuyoruz, bağlanınca göndereceğiz.',
            offlineApproval: 'İnternet bağlantın yok, onayın şu an gönderilemiyor. Kart değişimi iki taraf da onaylayınca tamamlanır. Bağlanınca bu ekrandan onayla.',
            loadingA11y: 'Kartın hazırlanıyor',
            queueCount: 'Gönderilmeyi bekleyen {count} değişim var. Bağlanınca gönderilecek.',
            queueCount_one: 'Gönderilmeyi bekleyen {count} değişim var. Bağlanınca gönderilecek.',
            queueExpired: 'Bekleyen {count} değişimin süresi dolduğu için gönderilemedi. Kodu yeniden okut.',
            queueExpired_one: 'Bekleyen {count} değişimin süresi dolduğu için gönderilemedi. Kodu yeniden okut.',
            pendingBandTitle: 'Seni bekleyen değişim',
            pendingBandOpen: '{name} ile değişimi aç',
            pendingBandMineTitle: 'Onayını verdin, karşı taraf bekleniyor',
            pendingBandMineMeta: 'Onayın gönderildi. Karşı taraf onaylayınca tanışma tamamlanır.',
            pendingBandResume: '{name} ile bekleyen değişime dön',
            codeExpiredTitle: 'Kodun süresi doldu',
            codeExpiredBody: 'Kart kodun güvenlik için kısa süre geçerli ve kendiliğinden yenilenir. İnternet olmadığı için şu an yenilenemedi. Bağlanınca kodu yenile, yoksa karşındaki kişi okutamaz.',
            codeRefreshCta: 'Kodu yenile',
            /*
             * GERİ SAYIM BİRİMLİDİR (mobil elle test · bulgu 3). Çıplak `mm:ss`
             * duvar saati sanılıyordu: cihaz saati 13:05 iken "Teklifin süresi:
             * 13:35" okunuyordu.
             */
            expiresIn: 'Teklifin bitmesine {time} var',
            countdownMinutes: '{minutes} dk {seconds} sn',
            countdownSeconds: '{seconds} sn',
            countdownLeft: '{time} kaldı',
            withdrawCta: 'Onayımı geri çek',
            lockoutGuidance: 'Kod üst üste tutmadı, bir süre yeni deneme yapamazsın. En kolayı kendi kartını göstermek. Karşındaki kişi senin kodunu okutursa değişim aynı şekilde olur.',
        },
        wallet: {
            title: 'Cüzdan',
            /* EN tarafında sayı + isim parçaları ayrı çekimlenir; TR aynı cümlede kalır. */
            peopleCount: '{count} kişi',
            peopleCount_one: '{count} kişi',
            eventCount: '{count} etkinlik',
            eventCount_one: '{count} etkinlik',
            recordCount: '{count} kayıt',
            recordCount_one: '{count} kayıt',
            countMeta: '{peopleLabel} · {eventsLabel}',
            countMetaOldest: '{peopleLabel} · {eventsLabel} · en eski kayıt {since}',
            emptyMeta: 'Henüz kayıt yok',
            searchPlaceholder: 'İsim, şirket, etkinlik veya not',
            searchLabel: 'Cüzdanda ara',
            filterCta: 'Filtre',
            filterCtaWithCount: 'Filtre ({count})',
            exportCta: 'Kişilerimi dışa aktar',
            resultLabel: '{recordsLabel} · cüzdanda {peopleLabel}',
            /* "Zaten tanıştıkların" kulvarı (backlog §6 md. 1). */
            laneKicker: 'Zaten tanıştıkların',
            laneBody: 'Cüzdanındaki {count} kişi bu etkinliğe kayıtlı',
            laneBody_one: 'Cüzdanındaki {count} kişi bu etkinliğe kayıtlı',
            laneReasonKicker: 'Bu liste neden var',
            laneReason: 'Bu kişiler cüzdanında ve bu etkinliğe kayıtlı. Tanıdıkların yeni tanışmaların önüne geçmesin diye öneri listesinden ayrı duruyorlar.',
            laneMore: '+{count} kişi daha',
            laneMore_one: '+{count} kişi daha',
            /*
             * KULVAR SÖZLÜĞÜ CÜZDAN SÖZLÜĞÜNDEN AYRIDIR (mobil elle test · bulgu 1).
             * Başlıktaki "{count} etkinlik" cüzdanın KAYIT sayısıdır (karşılaşmanın
             * damgalandığı etkinlik); kulvardaki sayı YAKLAŞAN etkinliktir. Aynı
             * kelime iki anlamda kullanılınca ekran "1 kişi · 0 etkinlik" ile
             * "1 kişi · 1 etkinlik"i 12 px arayla yan yana yazıyordu.
             */
            laneEventCount: '{count} yaklaşan etkinlik',
            laneEventCount_one: '{count} yaklaşan etkinlik',
            lanePeopleCount: '{count} tanıdık',
            lanePeopleCount_one: '{count} tanıdık',
            laneSummary: '{peopleLabel} · {eventsLabel}',
            laneExpand: 'Göster',
            laneCollapse: 'Gizle',
            laneToggleLabel: 'Zaten tanıştıkların listesini göster veya gizle',
            newlyAdded: 'Yeni eklendi',
            removeFilter: '{label} filtresini kaldır',
            noResultTitle: 'Bu filtrelerle kayıt yok',
            noResultBody: 'Tarih aralığını genişlet ya da yalnızca etkinlik filtresini bırak.',
            clearFiltersCta: 'Filtreleri temizle',
            emptyTitle: 'Tanıştıkların burada kalır.',
            emptyBody: 'Etkinlikte tanıştığın kişiyi karekodla eklediğinde burada nerede, ne zaman tanıştığın ve ne konuştuğunla birlikte durur. Altı ay sonra adını unutsan da onu bulursun.',
            emptyPreviewLabel: 'Bir kayıt böyle görünür',
            emptyPreviewName: 'Kerem Doğan',
            emptyPreviewRole: 'Kurucu · Tera Analitik',
            emptyPreviewContext: 'AI & Fintech İstanbul · 18 Ağustos · “risk skorlama, ekimde pilot”',
            firstStepsTitle: 'İlk kaydını oluşturmanın üç yolu',
            firstStep1Title: 'Karekodla tanış',
            firstStep1Body: 'Kartını göster ya da karşındakinin kodunu tara. İki taraf da onaylayınca kayıt oluşur.',
            firstStep2Title: 'Etkinlik öncesi görüşme ayarla',
            firstStep2Body: 'Katılımcı listesinden talep gönder. Kabul edilen görüşme ajandana eklenir.',
            firstStep3Title: 'Kart bağlantını paylaş',
            firstStep3Body: 'Uygulaması olmayan kişi bile bu bağlantıdan kartını alabilir.',
            emptyPrimaryCta: 'Karekodla tanış',
            emptySecondaryCta: 'Kayıtlı olduğum etkinliği aç',
            emptyDiscoverCta: 'Etkinlikleri keşfet',
            emptyMineCta: 'Etkinliklerime bak',
            filterTitle: 'Cüzdan filtresi',
            filterClear: 'Temizle',
            filterEvents: 'Etkinlik',
            filterSectors: 'Sektör',
            filterPeriod: 'Ne zaman tanıştın',
            periodAll: 'Tüm zamanlar',
            periodRecent: 'Son 3 ay',
            periodMid: '6–18 ay önce',
            periodOld: '18 aydan eski',
            filterApplyCta: '{count} kaydı göster',
            filterApplyCta_one: '{count} kaydı göster',
            detailHeader: 'Cüzdan kaydı',
            detailStampTitle: 'Nerede, ne zaman tanıştın',
            detailNoteTitle: 'Notun',
            detailNotePlaceholder: 'Bu kişiyle ne konuştun?',
            detailFollowTitle: 'Takip',
            detailReminderActive: '{date} tarihinde hatırlat · “{text}”',
            detailReminderRemove: 'Kaldır',
            detailReminderAdd: 'Takip hatırlatması ekle',
            detailHistoryTitle: 'Ortak geçmiş',
            detailMessageCta: 'Mesaj gönder',
            detailMessageLocked: 'Mesajlaşma bu sürümde yok. Kart değişiminden sonra e-postayla ulaş.',
            detailShareCta: 'Kartı paylaş',
            exportTitle: 'Dışa aktarım',
            exportIntro: 'Verilerin senin. Cüzdanın tamamını ya da yalnızca filtrelediğin kayıtları indir.',
            exportScopeTitle: 'Kapsam',
            exportScopeFiltered: 'Filtrelenen {count} kayıt',
            exportScopeFiltered_one: 'Filtrelenen {count} kayıt',
            exportScopeAll: 'Cüzdanın tamamı · {count} kayıt',
            exportScopeAll_one: 'Cüzdanın tamamı · {count} kayıt',
            exportScopeFilteredUncounted: 'Filtrelenen kayıtlar',
            exportScopeAllUncounted: 'Cüzdanın tamamı',
            exportFormatTitle: 'Biçim',
            exportCsv: 'CSV',
            exportCsvDesc: 'Excel, CRM içe aktarımı',
            exportVcard: 'vCard',
            exportVcardDesc: 'Telefon rehberi',
            exportWithNotes: 'Notlarım da dahil olsun',
            exportSummary: '{count} kayıt · {format} · {notes}',
            exportSummary_one: '{count} kayıt · {format} · {notes}',
            exportNotesIncluded: 'notlar dahil',
            exportNotesExcluded: 'notlar hariç',
            exportSummaryBody: 'Karşı tarafın kartı, tanıştığın etkinlik ve tarih her satırda yer alır.',
            exportDownloadCta: 'İndir',
            exportShareTitle: 'Cüzdan dışa aktarımı',
            exportEmpty: 'Seçilen kapsamda kayıt yok.',
            loadingA11y: 'Cüzdan yükleniyor',
            detailMeetingCount: 'Onunla {count} kez buluştun',
            detailMeetingCount_one: 'Onunla {count} kez buluştun',
            detailRemoveCta: 'Bu kaydı cüzdanımdan kaldır',
            removeDialogTitle: 'Kayıt cüzdanından kalksın mı?',
            removeDialogBody: 'Kayıt yalnız senin cüzdanından kalkar. Karşı tarafın kaydı ve kendi notu durur. Bu işlem geri alınamaz.',
            removeDialogConfirm: 'Kaldır',
            removedNotice: 'Kayıt cüzdanından kaldırıldı.',
            savedToast: 'Kaydedildi. Cüzdanındaki kayıt güncellendi.',
            historyExchange: '{event} etkinliğinde onunla kartvizit değiştin',
            historySameEvent: '{event} etkinliğinde onunla birlikte kayıtlıydın',
            historyMeeting: '{event} etkinliğinde görüşme talebin kabul edildi',
            /*
             * ETKİNLİKSİZ KARŞILAŞMANIN KENDİ CÜMLESİ VAR (mobil elle test · bulgu 2).
             * `historyHiddenEvent` ADI OKUNAMAYAN etkinliğin yer tutucusudur; etkinliğe
             * hiç bağlı OLMAYAN kayıtta şablona konunca "Bir etkinlik etkinliğinde…"
             * çıkıyordu.
             */
            historyExchangeNoEvent: 'Onunla kartvizit değiştin',
            historyMeetingNoEvent: 'Görüşme talebin kabul edildi',
            historyHiddenEvent: 'Bir etkinlik',
            historyEmpty: 'Bu kişiyle başka ortak geçmişin yok.',
            loadMoreCta: 'Daha fazla göster',
            exportDone: '{count} kayıt dışa aktarıldı.',
            exportDone_one: '{count} kayıt dışa aktarıldı.',
        },
        cardLink: {
            pageTitle: 'Dijital kartvizit',
            wallTitle: 'Bu kartı görmek için giriş yap.',
            wallBody: 'Kartvizit bilgileri yalnızca üyelere açıktır. Ücretsiz hesap aç ya da giriş yap. Bağlantı seni doğrudan karta geri getirir.',
            wallSignInCta: 'Giriş yap veya kaydol',
            wallPromiseTitle: 'Kartvizit kaybolmaz.',
            wallPromiseBody: 'Tanıştığın kişiler etkinlik geçmişinle birlikte tek cüzdanda kalır.',
            metTitle: 'Nerede tanıştın',
            addToWalletCta: 'Cüzdanıma ekle',
            inWalletNotice: 'Bu kişi zaten cüzdanında.',
            vcardCta: 'Telefona kaydet (vCard)',
            mutualNotice: 'Cüzdana ekleme çift taraflı onayla olur. Kart sahibi onaylamadan hiçbir kayıt oluşmaz.',
            visibilityNotice: 'Bu sayfa yalnızca kart sahibi paylaşmayı seçtiği için görünüyor. Görünürlük her zaman kişinin kendi kararı.',
            notFoundTitle: 'Bu bağlantı artık geçerli değil',
            notFoundBody: 'Bağlantı kapatılmış ya da hiç var olmamış olabilir. Kart sahibinden yeni bir bağlantı iste.',
            settingsTitle: 'Kart bağlantım',
            settingsBody: 'Kartını tek bir adresle paylaş. İstediğin an kapatabilirsin.',
            settingsOpenCta: 'Bağlantıyı aç',
            settingsRevokeCta: 'Bağlantıyı kapat',
            settingsCopyCta: 'Bağlantıyı kopyala',
            settingsCopied: 'Kopyalandı',
            settingsClosed: 'Bağlantı kapalı.',
            settingsViews: '{count} kez açıldı',
            settingsViews_one: '{count} kez açıldı',
            settingsAnonymousCounter: 'Sayaç kimlik tutmaz. Bağlantıyı kimin açtığı kaydedilmez.',
            settingsAddressUnavailable: 'Adres şu an gösterilemiyor. Bağlantı açık ve kapatılabilir.',
            shareRequiresSignIn: 'Bağlantıyı açan kişi giriş yapmalıdır.',
        },
        /*
         * Kartvizit karekodu yönlendirme sayfası (`/kart/<jeton>`, karekod kapsamı
         * 02.11.2026 Story 4, tasarım SiteKartYonlendirme). Kişi verisi yok: sayfa
         * kimin karekodu olduğunu bilmez. Metin kapsam belgesi 3.8, onaylı.
         */
        cardShareRedirect: {
            pageTitle: 'Uygulamayı indir',
            title: 'Kartvizit paylaşmak için {brandName}’i indir',
            body: 'Uygulamayı kurduktan sonra karekodu uygulamanın içinden tekrar okut. Kartlar iki taraf da onaylayınca paylaşılır.',
            appStoreCta: 'App Store’dan indir',
            googlePlayCta: 'Google Play’den indir',
            installedHint: 'Uygulama yüklü mü?',
            openInAppCta: 'Uygulamada aç',
            webSignUpLink: 'Web’de hesap aç',
        },
        exchangeWeb: {
            pageKicker: 'Tarayıcı kamerasıyla',
            allowCta: 'Kameraya izin ver',
            showCardCta: 'Kartımı göster',
            scanKicker: 'Bekleniyor',
            scanSideBody: 'Kod okunduğunda çift taraflı onay ekranı açılır.',
            scanHint: 'Kodu çerçeveye al. Dizüstü kamerasında kartı ekrandan göstermek de işe yarar.',
            stopScanCta: 'İzni geri al',
            deniedTitle: 'Kamera açılamadı',
            deniedBody: 'Tarayıcı kameraya izin vermedi ya da cihazda kamera yok. Karşı tarafın kodunu aşağıya elle gir ya da kartını göster. Karşı taraf senin kodunu okutarak da aynı değişimi başlatır.',
            myCardTitle: 'Kartın',
            /* Yeni görünüm 3d (KatilimciWebKartvizit): kamera alanı ve kart kodu etiketi. */
            cameraPrompt: 'Karşındakinin kart karekodunu okut',
            cameraPrivacy: 'Görüntü cihazından çıkmaz. Kod tarayıcıda çözülür.',
            myCodeLabel: 'Kart kodun',
            waitingTitle: 'Onayını verdin',
            waitingBody: '{name} onaylayınca karşılaşma kaydı oluşur. Sayfayı kapatabilirsin. İşlem sunucuda tamamlanır.',
            waitingCountdown: 'Teklifin süresi: {time}',
            successNoteTitle: 'Not (isteğe bağlı)',
            newExchangeCta: 'Yeni değişim',
            pageTitle: 'Kart değişimi',
            /* Elle kod (12.10.2026): yanıt sınıfı `manualCodeErrorKind`ten gelir. */
            manualInvalid: 'Kod altı karakterden oluşur, örneğin 4K7-92B. Eksik karakteri tamamla.',
            manualUnavailable: 'Kod bulunamadı ya da süresi doldu. Karşı taraftan ekranındaki güncel kodu iste.',
            manualSelf: 'Bu senin kendi kodun. Karşındaki kişinin ekranındaki kodu gir.',
            manualRateLimited: 'Çok fazla deneme yaptın. Biraz bekleyip yeniden dene ya da kartını göster.',
            manualNetwork: 'Sunucuya ulaşılamadı. Bağlantını kontrol edip yeniden dene.',
        },
        walletWeb: {
            pageKicker: 'Masaüstü görünümü',
            pageTitle: 'Cüzdan',
            filterTitle: 'Filtre',
            /* Yeni görünüm 3d: Cüzdan ve Kart değişimi sayfa başının alt satırı. */
            pageSub: 'Kart değiştirdiğin kişiler. Değişim her zaman iki tarafın onayıyla olur.',
            scenarioCta: 'Hatırlama senaryosu',
            scenarioHint: 'Adını hatırlamıyorsan etkinliği, sektörü ve kabaca ne zaman tanıştığını seç.',
            searchPlaceholder: 'İsim, şirket, etkinlik veya not içinde ara',
            colPerson: 'Kişi',
            colContext: 'Tanışma bağlamı',
            colNote: 'Not',
            colTags: 'Etiket',
            noNote: 'Not yok',
            noTags: 'Etiket yok',
            filterSummaryNone: 'Filtre yok',
            filterSummaryActive: '{count} filtre etkin',
            filterSummaryActive_one: '{count} filtre etkin',
            detailContextTitle: 'Nerede tanıştın',
            detailEmptyTitle: 'Bir kayıt seç',
            detailEmptyBody: 'Ortadaki listeden bir kişiye tıkla. Notu ve ortak geçmişi burada açılır.',
            noteSaveCta: 'Notu kaydet',
            noteSaved: 'Not kaydedildi.',
            tableLabel: 'Cüzdan kayıtları',
            openRow: '{name} kaydını aç',
            exportDialogTitle: 'Cüzdanı dışa aktar',
            exportCloseCta: 'Vazgeç',
        },
        /**
         * BAĞLANTI DETAYI "İLETİŞİM" BÖLÜMÜ (Claude Design, 19.10.2026). Web ve
         * mobil aynı anahtarları okur; alan ve eylem eşlemesi
         * `domain/wallet-contact-actions.ts`te.
         */
        walletContact: {
            title: 'İletişim',
            saveToContacts: 'Rehbere kaydet',
            /* Mobil eşi: vCard paylaşım sayfasına gider, rehbere yazılmaz (19.10 kararı). */
            shareContact: 'Kişiyi paylaş',
            listLabel: 'İletişim bilgileri',
            fieldEmail: 'E-posta',
            fieldPhone: 'Telefon',
            fieldWebsite: 'Web sitesi',
            fieldLinkedin: 'LinkedIn',
            fieldX: 'X',
            fieldGithub: 'GitHub',
            actionEmail: 'E-posta gönder',
            actionCall: 'Ara',
            actionSms: 'Mesaj',
            actionOpen: 'Aç',
            copy: 'Kopyala',
            copyEmail: 'E-postayı kopyala',
            copyPhone: 'Telefonu kopyala',
            copyWebsite: 'Web sitesini kopyala',
            copyLinkedin: 'LinkedIn bağlantısını kopyala',
            copyX: 'X bağlantısını kopyala',
            copyGithub: 'GitHub bağlantısını kopyala',
            copiedEmail: 'E-posta adresi kopyalandı',
            copiedPhone: 'Telefon numarası kopyalandı',
            copiedWebsite: 'Web sitesi kopyalandı',
            copiedLinkedin: 'LinkedIn bağlantısı kopyalandı',
            copiedX: 'X bağlantısı kopyalandı',
            copiedGithub: 'GitHub bağlantısı kopyalandı',
            copyFailed: 'Kopyalanamadı. Değeri seçip elle kopyalayabilirsin.',
            empty: 'Bu kişi kartına iletişim bilgisi eklememiş.',
            loadingA11y: 'İletişim bilgileri yükleniyor',
            error: 'İletişim bilgileri yüklenemedi.',
            retry: 'Yeniden dene',
            rowEmail: '{name} adlı kişiye e-posta gönder',
            rowPhone: '{name} adlı kişiyi ara ya da mesaj gönder',
            rowWebsite: '{name} adlı kişinin web sitesini aç',
            rowLinkedin: '{name} adlı kişinin LinkedIn profilini aç',
            rowX: '{name} adlı kişinin X profilini aç',
            rowGithub: '{name} adlı kişinin GitHub profilini aç',
            mineTitle: 'Karşı tarafın göreceği bilgiler',
            mineEdit: 'Düzenle',
            mineEditA11y: 'İletişim bilgilerini düzenle',
            mineEmpty: 'Kartında iletişim bilgisi yok. Eklediğin bilgiler yalnız kart değişimi yaptığın kişilere görünür.',
            mineAdd: 'İletişim bilgisi ekle',
            mineVisibility: 'Bu bilgileri yalnız kart değişimini birlikte onayladığın kişiler görür.',
        },
    },
    /**
     * HUKUKİ BELGE KABUĞU (Blok "hukuki sayfalar" · referans `Main.dc.html`).
     * Belgenin GÖVDESİ burada değil: metinler `packages/shared/src/domain/legal/content`
     * altında yaşar ve iki dilde ayrı dosyadır. Burada yalnız KABUK durur —
     * başlık şeridi, içindekiler, sürüm rozeti, komşu belge listesi.
     */
    legal: {
        kicker: 'Hukuki belgeler',
        breadcrumbRoot: 'Ana sayfa',
        breadcrumbSection: 'Hukuki',
        tocTitle: 'Bu sayfada',
        /* Mobil belge yüzeyinin katlanır satırı (referans `MobilBelge.dc.html` `.toc`). */
        tocSheetTitle: 'İçindekiler',
        sectionCount: '{count} bölüm',
        sectionCount_one: '{count} bölüm',
        tocProgressLabel: 'Okuma ilerlemesi',
        version: 'Sürüm {version}',
        effective: 'Yürürlük: {date}',
        lastUpdated: 'Son güncelleme: {date}',
        print: 'Yazdır',
        siblingTitle: 'Diğer belgeler',
        publicBadge: 'Giriş yapmadan okunabilir',
        footerHeading: 'Hukuki',
        docTitles: {
            kvkkAydinlatma: 'KVKK Aydınlatma Metni',
            gizlilikPolitikasi: 'Gizlilik Politikası',
            kullanimKosullari: 'Kullanım Koşulları',
            acikRiza: 'Açık Rıza Metni',
            cerezPolitikasi: 'Çerez Politikası',
            satisBasvurusu: 'Satış Başvurusu Aydınlatma Metni',
            kurumHesabiAydinlatma: 'Kurum Hesabı Aydınlatma Metni',
            kvkkBasvuru: 'KVKK Başvuru Formu',
            hesapSilme: 'Hesap Silme',
        },
        /* Mobil belge yüzeyinin alt şeridi: haklar Rızalarım ekranından kullanılır. */
        rightsCta: 'Haklarımı kullan',
        errorTitle: 'Belge açılamadı',
        errorBody: 'Metni şu an getiremedik. Sayfayı yenile. Sorun sürerse destek ekibine yaz.',
    },
    /** Hesap silme sayfası — referans `HesapSilme.dc.html`. Girişsiz okunur. */
    legalDeletion: {
        kicker: 'Hesabın senin',
        title: 'Hesabını ve verilerini silme',
        lede: 'Hesabını istediğin an silebilirsin. Bizden izin istemene, destekle yazışmana veya sebep yazmana gerek yok. Bu sayfa silme işleminin tam olarak neyi kaldırdığını ve ne kadar sürdüğünü anlatır.',
        waysTitle: 'Nasıl silinir',
        way1Badge: 'Yol 1',
        way1Title: 'Uygulama içinden',
        way1Body: 'En hızlı yol. Kimliğin oturumundan doğrulanır, ek belge istenmez.',
        way1Step1: 'Ayarlar › Verin ve hesabın',
        way1Step2: 'Hesabımı sil',
        way1Step3: 'E-postana gelen kodla onayla',
        way1Cta: 'Verin ve hesabın ekranına git',
        way2Badge: 'Yol 2',
        way2Title: 'Uygulamaya erişemiyorsan',
        way2Body: 'Telefonun elinde değilse veya uygulamayı kaldırdıysan, e-posta ile talep edebilirsin.',
        way2MailboxHint: 'Talebini şu adrese gönder',
        way2MailboxNote: 'Hesabının e-posta adresinden gönderilmelidir. Kimlik teyidi için bu adrese bir doğrulama bağlantısı iletilir.',
        way2Cta: 'KVKK Başvuru Formu',
        timelineTitle: 'Silme talebinden sonra ne oluyor',
        timelineStep1Day: '0. gün',
        timelineStep1Title: 'Talep alındı',
        timelineStep1Body: 'Hesabın askıya alınır. Giriş yapamazsın, profilin katılımcı listelerinden ve aramadan çıkar, kimse sana görüşme talebi gönderemez.',
        timelineStep2Day: '0–{days}. gün',
        timelineStep2Title: 'Geri alma penceresi',
        timelineStep2Body: 'Fikrini değiştirirsen e-postandaki bağlantıdan tek tıkla iptal edebilirsin. Bu süre, hesabının kazayla veya kötü niyetle silinmesine karşı korumadır.',
        timelineStep2Chip: 'İptal edilebilir',
        timelineStep3Day: '{days}. gün',
        timelineStep3Title: 'Kalıcı silme',
        timelineStep3Body: 'Veriler geri döndürülemez biçimde silinir veya anonimleştirilir. Bu adımdan sonra geri alınamaz. Aynı e-posta ile yeniden kaydolabilirsin ama eski verilerin gelmez.',
        timelineStep3Chip: 'Geri alınamaz',
        scopeTitle: 'Ne siliniyor, ne kalıyor',
        deletedTitle: 'Silinir',
        deletedItem1: 'Ad soyad, e-posta adresin, şifren',
        deletedItem2: 'Kartvizitlerin ve bunlardaki telefon, unvan, kurum, sektör, eğitim ve sosyal medya adreslerin',
        deletedItem3: 'Profil fotoğrafın ve yüklediğin görseller',
        deletedItem4: 'Kişiler hakkında yazdığın notlar',
        deletedItem5: 'Görüşme taleplerin ve mesajların',
        deletedItem6: 'Oturumların ve cihaz bildirim jetonların',
        deletedItem7: 'Kayıtlı kartvizit cüzdanın',
        anonymisedTitle: 'Anonimleşir',
        anonymisedBody: 'Kimliğinle bağı koparılır, sayı olarak kalır ve hiçbir şekilde sana geri bağlanamaz.',
        anonymisedItem1: 'Etkinlik katılım sayıları, organizatörün raporu bozulmasın diye',
        anonymisedItem2: 'Karşılaşma istatistikleri',
        anonymisedItem3: 'Denetim kayıtlarındaki eylemler',
        keptTitle: 'Kalır',
        keptBody: 'Yalnızca kanunun saklamamızı zorunlu kıldığı kayıtlar, kanunun verdiği süre boyunca.',
        keptItem1: 'Rıza kayıtları, KVKK ispat yükümlülüğü gereği',
        keptItem2: 'Fatura ve muhasebe kaydı varsa, VUK md. 253 uyarınca 5 yıl',
        keptItem3: 'Trafik ve işlem güvenliği kayıtları, 5651 sayılı Kanun uyarınca 2 yıl',
        keptNote: 'Bu kayıtlar başka hiçbir amaçla kullanılmaz ve süre dolduğunda otomatik olarak silinir.',
        exportTitle: 'Silmeden önce verilerini indir',
        exportBody: 'Kartvizitlerin, karşılaşmaların ve etkinlik geçmişin CSV ve vCard olarak indirilebilir. Verin rehin alınmaz. Bu, ürünün kırmızı çizgilerinden biridir.',
        exportCta: 'Verilerimi indir',
        faqTitle: 'Sık sorulanlar',
        faq1Q: 'Uygulamayı kaldırırsam hesabım silinir mi?',
        faq1A: 'Hayır. Uygulamayı kaldırmak veriyi silmez. Silme talebini bu sayfadaki yollardan biriyle iletmen gerekir.',
        faq2Q: 'Değiştirdiğim kartvizitler karşı tarafta kalır mı?',
        faq2A: 'Karşı tarafın cüzdanında, paylaştığın andaki kart görüntüsü kalır ve o kopya artık onların verisidir. Kartın güncellenmeyi durdurur, profilin bağlantısızlaşır.',
        faq3Q: 'Organizatörsem etkinliklerime ne olur?',
        faq3A: 'Kurumun tek yöneticisiysen silme öncesinde devretmen istenir. Böylece katılımcıların etkinliği sahipsiz kalmaz.',
        faq4Q: 'Bekleme süresi dolmadan silinsin istiyorum.',
        faq4A: 'KVKK md. 11 kapsamında başvur. Kimlik teyidinin ardından bekleme süresi olmadan sileriz.',
    },
    /** KVKK başvuru formu — referans `KvkkBasvuru.dc.html`. Oturum ister. */
    legalRequest: {
        kicker: 'Veri sorumlusuna başvuru',
        title: 'KVKK Başvuru Formu',
        lede: '6698 sayılı Kanun’un 11. maddesindeki haklarını bu formla kullanabilirsin. Oturum açtığın için kimliğin doğrulanmış sayılır, ayrıca belge göndermene gerek yok.',
        step1Title: 'Başvuran',
        step1Hint: 'Bu alanlar hesabından geldi. Yanlışsa profilinden düzeltebilirsin.',
        fieldName: 'Ad soyad',
        fieldEmail: 'E-posta',
        fromSession: 'oturumdan',
        step2Title: 'Talebin',
        step2Hint: 'Birden fazla hak seçebilirsin. Bazı talepler formu beklemeden anında karşılanır.',
        instantChip: 'hemen yapılabilir',
        requestA: 'Verilerimin işlenip işlenmediğini öğrenmek istiyorum',
        requestB: 'İşlenen verilerimin bir kopyasını istiyorum',
        requestC: 'Verilerimin hangi amaçla işlendiğini öğrenmek istiyorum',
        requestD: 'Verilerimin aktarıldığı üçüncü kişileri öğrenmek istiyorum',
        requestE: 'Eksik veya yanlış verimin düzeltilmesini istiyorum',
        requestF: 'Verilerimin silinmesini istiyorum',
        requestG: 'Otomatik analiz sonucuna itiraz ediyorum',
        requestH: 'Zararımın giderilmesini talep ediyorum',
        articleLabel: 'md. 11/{letter}',
        instantExportHint: 'Ayarlar › Verin ve hesabın ekranından anında yapabilirsin',
        instantDeleteHint: 'Ayarlar › Verin ve hesabın ekranından anında yapabilirsin',
        step3Title: 'Açıklama',
        step3Hint: 'Talebini somutlaştır. Hangi veri, hangi tarih, hangi etkinlik?',
        explanationPlaceholder: 'Örnek: 12 Ağustos tarihli etkinlikteki katılım kaydımda kurum adım yanlış görünüyor, düzeltilmesini talep ediyorum.',
        explanationCounter: '{count} / {max} karakter',
        attachmentNote: 'Belge eklemek istersen e-posta taslağına ekleyebilirsin.',
        step4Title: 'Yanıtı nasıl alacaksın?',
        step4Hint: 'Tebliğ gereği yanıt kanalını sen seçersin.',
        channelEmail: 'E-posta',
        channelPost: 'Posta',
        channelPostHint: 'yazacağın adrese',
        submitNote: 'Başvurun kayıt altına alınır ve en geç 30 gün içinde yanıtlanır. Talebin ayrı bir maliyet gerektiriyorsa Kurul’un belirlediği tarifedeki ücret önceden bildirilir.',
        submitCta: 'Başvuruyu gönder',
        submitDraftNote: 'Gönder düğmesi, seçtiğin maddeleri ve açıklamanı hazır bir e-posta taslağına aktarır. Taslağı kendi e-posta uygulamandan gönderirsin. Adresin hesabınla eşleştiği için kimliğin doğrulanmış olur.',
        slaValue: '30',
        slaLabel: 'gün içinde yanıtlanır',
        instantTitle: 'Beklemeden yapabileceklerin',
        instant1: 'Verini indir',
        instant2: 'Rızalarını geri al',
        instant3: 'Hesabını sil',
        instant4: 'Profil bilgilerini düzelt',
        otherChannelsTitle: 'Diğer başvuru yolları',
        otherChannelMail: 'E-posta',
        otherChannelPetition: 'Islak imzalı dilekçe',
        otherChannelPetitionBody: 'Şirket adresine şahsen veya noter aracılığıyla.',
        relatedTitle: 'İlgili belgeler',
        mailSubject: 'KVKK başvurusu',
        mailIntro: 'Aşağıdaki taleplerimi 6698 sayılı Kanun md. 11 kapsamında iletiyorum.',
        mailRequestsHeading: 'Talepler',
        mailExplanationHeading: 'Açıklama',
        mailChannelHeading: 'Yanıt kanalı',
        selectionRequired: 'En az bir talep seç.',
    },
    /**
     * "Metinlerimiz güncellendi" bilgilendirmesi (kullanıcı kararı 02.11.2026,
     * kapsam `docs/riza-surumu-kapsam-2026-11-02.md` Story 3). Belge adları
     * cümlenin içinde, belirtme hâlinde ve bağlantı olarak dizilir.
     */
    consentUpdate: {
        title: 'Metinlerimiz güncellendi',
        body: '{documents} güncelledik. Değişiklikleri buradan okuyabilirsin.',
        orgBody: '{documents} güncelledik. Değişiklikleri buradan okuyabilirsiniz.',
        documents: {
            terms_of_service: 'kullanım koşullarını',
            privacy_policy: 'gizlilik politikasını',
            kvkk_clarification: 'KVKK aydınlatma metnini',
            organization_account_notice: 'kurum hesabı aydınlatma metnini',
        },
        /** Zorunlu metinlerle birlikte değiştiyse ("de"); bilgilendirmeyi yalnız zorunlu metin açar. */
        optionalAlso: {
            analytics: 'Analitik rızanın metni de değişti. Yeniden onay vermezsen kapalı kalır.',
            marketing_email: 'Kampanya e-postası rızanın metni de değişti. Yeniden onay vermezsen kapalı kalır.',
        },
        consentsLink: 'Rızalarıma git',
        acknowledgeCta: 'Okudum',
        // Belge adları dizisinin son bağlacı; `Intl.ListFormat` olmayan mobil JS motoru için.
        listAnd: 've',
        failed: 'Okuduğunu kaydedemedik. Bağlantını kontrol edip tekrar dene.',
        orgFailed: 'Okuduğunuzu kaydedemedik. Bağlantınızı kontrol edip tekrar deneyin.',
    },
    /** Rızalarım ekranı — referans `RizaMerkezi.dc.html`. */
    consentCenter: {
        title: 'Rızalarım',
        lede: 'Hangi metne, hangi sürümüyle ve ne zaman onay verdiğini burada görürsün. İsteğe bağlı rızaları istediğin an geri alabilirsin. Geri almak hesabını kapatmaz.',
        orgLede: 'Hangi metne, hangi sürümüyle ve ne zaman onay verdiğini burada görürsün. Kurum hesabında pazarlama ve analitik işlemesi yapılmadığı için isteğe bağlı rıza yoktur.',
        exportCta: 'Kaydı indir',
        requiredGroupTitle: 'Hizmetin şartı olan onaylar',
        requiredGroupHint: 'Bunlar olmadan hesap açılamaz. Geri alınmaları hesabın kapatılması anlamına gelir.',
        optionalGroupTitle: 'İsteğe bağlı rızalar',
        optionalGroupHint: 'Kapatman hiçbir özelliği kilitlemez. Açık rıza her zaman geri alınabilir (KVKK md. 7).',
        grantedBadge: 'Onaylandı',
        readBadge: 'Okundu',
        notGrantedBadge: 'Verilmedi',
        readDoc: 'Metni oku',
        versionChip: 'sürüm {version}',
        withdrawnAt: '{time} tarihinde geri alındı',
        neverGranted: 'Henüz verilmedi',
        newVersionTitle: '{document} için {version} sürümü yayımlandı',
        newVersionBody: 'Onayladığın sürüm {granted}. Yeni metni okuyup onayını tazeleyebilirsin.',
        newVersionCta: 'Yeni metni oku',
        renewHint: 'Metin yenilendi, tercihini yeniden ver.',
        historyTitle: 'Rıza geçmişi',
        historyHint: 'Denetlenebilirlik kaydı, her değişiklik zaman damgalı',
        historyLabel: 'Rıza geçmişi tablosu',
        colDate: 'Tarih',
        colDocument: 'Metin',
        colVersion: 'Sürüm',
        colAction: 'Eylem',
        colSource: 'Kaynak',
        actionGranted: 'Verildi',
        actionWithdrawn: 'Geri alındı',
        sourceUnknown: 'Bilinmiyor',
        historyNote: 'Kayıt, KVKK’daki ispat yükümlülüğü gereği hesabın silinse bile saklanır ve başka hiçbir amaçla kullanılmaz. IP adresin karılmış olarak tutulur, açık hâliyle değil.',
        emptyTitle: 'Henüz rıza kaydın yok',
        emptyStep1: 'Kayıt sırasında verdiğin onaylar buraya düşer.',
        emptyStep2: 'İsteğe bağlı rızaları aşağıdaki anahtarlardan açabilirsin.',
        emptyStep3: 'Her değişiklik zaman damgasıyla kaydedilir.',
        updateFailed: 'Rıza güncellenemedi. Bağlantını kontrol edip tekrar dene.',
        retiredNote: 'Bu rıza artık hiçbir işlemeye dayanak değil. Katılımcı listesinde görünmek etkinlik kaydına bağlıdır. Geri çektiğinde yalnız rıza geçmişinde kalır.',
        withdrawCta: 'Geri çek',
        /** KatilimciAyarlarRizalar tablosu: tür sütunu ve onay tarihi. */
        colType: 'Tür',
        colGrantedAt: 'Onay tarihi',
        colActions: 'Eylemler',
        kindRequired: 'Zorunlu',
        kindOptional: 'İsteğe bağlı',
    },
    /** Rıza satırlarının açıklamaları — anahtarın yanında, kapatmadan ÖNCE. */
    consentDescriptions: {
        terms_of_service: 'Platformu kullanma kuralların, sorumluluklar ve hesabın hangi hâllerde askıya alınabileceği.',
        privacy_policy: 'Verinin nasıl işlendiği, nerede saklandığı ve kimlerle paylaşıldığı.',
        kvkk_clarification: 'KVKK md. 10 kapsamındaki bilgilendirme. Bu bir rıza değil, okuduğunun kaydıdır.',
        marketing_email: 'Yeni etkinlik duyuruları ve ürün haberleri. Giriş kodu ve talep bildirimi gibi işlemsel e-postalar bundan bağımsızdır ve durmaz.',
        analytics: 'Hangi ekranların kullanıldığını ve sana gösterilen önerilere ne olduğunu (görüldü, açıldı, kayda dönüştü) hesabına bağlı olarak ölçeriz. Kapalıyken analitik olay gönderilmez, hesabına bağlı öneri kaydı tutulmaz ve hiçbir özellik kapanmaz.',
        attendee_visibility: 'Eski isteğe bağlı katılımcı listesi rızası. Artık alınmıyor, çünkü etkinliğe kaydolan katılımcı listesinde görünür. Eski kayıtların denetim için saklanır.',
        organization_account_notice: 'Kurum hesabının kurum adına yaptığın işlemlerde verini nasıl işlediği. Bu bir rıza değil, okuduğunun kaydıdır.',
    },
    /**
     * ETKİNLİK HARİTASI (harita kapsamı 14.10.2026, Story 4 + 6). Referans:
     * `docs/design/harita/WarmBreak Konum ve Ulaşım - Harita ve Haritada Bul.dc.html`
     * (E1-E9 etkinlik sayfası, F1-F10 organizatör formu).
     *
     * "OpenStreetMap" ÇEVRİLMEZ: OSM kaynak gösterme kılavuzu kaynağı bu ada bağlar
     * (`docs/harita-kapsam-2026-10-14.md` bölüm 2).
     */
    venueMap: {
        osmName: 'OpenStreetMap',
        attributionBefore: '©',
        attributionAfter: 'katkıda bulunanlar',
        searchAttributionBefore: 'Arama sonuçları ©',
        directions: 'Yol tarifi al',
        newTabNote: '(yeni sekmede açılır)',
        tilesFailedTitle: 'Harita şu an yüklenemedi.',
        tilesFailedBody: 'Adres ve yol tarifi çalışıyor.',
        onlineTitle: 'Katılım',
        onlineLead: 'Bu etkinlik çevrim içi.',
        hybridLead: 'Çevrim içi de katılabilirsin.',
        /** Web etkinlik kartı (15.10): hibrit etkinlikte Konum satırının altındaki satırın etiketi. */
        hybridLabel: 'Çevrim içi katılım',
        fieldLabel: 'Haritadaki konum',
        fieldHint: 'Katılımcılar etkinlik sayfasında bu konumu haritada görür. Arama düğmeye basınca yapılır.',
        findCta: 'Haritada bul',
        searching: 'Aranıyor…',
        addressFirst: 'Önce açık adresi yaz',
        addressPlaceholder: 'Örn. Sütlüce Mah. Karaağaç Cad. No:1, Beyoğlu',
        resultsCount: '{count} sonuç · birini seç',
        resultsCount_one: '{count} sonuç · seç',
        noResult: 'Bu adres bulunamadı. Mahalle ve ilçe ile tekrar dene.',
        busyTitle: 'Şu an aranamıyor, biraz sonra tekrar dene.',
        busyBody: 'Etkinliği taslak olarak kaydedebilirsin. Konumu sonra eklersin.',
        selected: 'Konum seçildi',
        remove: 'Konumu kaldır',
        addressChanged: 'Adres değişti, konumu yeniden bul. Kayıtlı konum kaldırıldı.',
        publishBlockedNote: 'Etkinlik yayınlanmadı. Taslak konumsuz da kaydedilir.',
        /* Mobil (harita Tur C): çevrimdışı karo hâli (E8), harita dokunuşu ve çevrimdışı arama. */
        offlineTitle: 'Harita bağlantı gelince görünür.',
        offlineBody: 'Yol tarifi harita uygulamasında açılır.',
        openInMapsA11y: '{name} konumunu harita uygulamasında aç',
        openInMapsA11yNoName: 'Konumu harita uygulamasında aç',
        offlineSearch: 'Bağlantı yok. Arama bağlantı gelince yapılır.',
        /** Mobil: `addressPlaceholder` dar alana (375 px, büyük yazı) sığmazsa kırpılmış adres yerine kısa örnek. */
        addressPlaceholderShort: 'Örn. Karaağaç Cad. No:1',
        /** Kullanıcı kararı 16.10.2026: arama sokak düzeyinde kaldıysa haritadaki iğnenin yanındaki not. */
        approximate: 'Yaklaşık konum',
        /** Organizatör formu: "Haritada bul" sonucu sokak düzeyindeyse alanın altındaki bilgi. */
        approximateHint: 'Tam adres bulunamadı, konum sokak düzeyinde gösterilecek.',
    },
};
//# sourceMappingURL=tr.js.map